import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {environment} from 'environments/environment';
import {FlatpickrOptions, Ng2FlatpickrComponent} from 'ng2-flatpickr';
import * as feather from 'feather-icons';
import {HeaderService} from 'app/services/header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Address, Client, Email, Telephone} from '../../../../models/client';
import {Fournisseur} from '../../../../models/fournisseur';
import {Item} from '../../../../models/Item';
import {TvaSummary} from '../../../../models/TvaSummary';
import {ProjetService} from '../../../../services/projet.service';
import {AjoutProjetComponent} from '../../../parametre/project-parametre/ajout-projet/ajout-projet.component';
import {FournisseurService} from '../../../../services/Fournisseur/fournisseur.service';
import {AddFournissComponent} from '../add-fourniss/add-fourniss.component';
import {ProductsService} from '../../../../services/products/products.service';
import {Product} from '../../../../models/Product';
import {Tva, TvaService} from '../../../parametre/taxe-tva/parametre-tva/tva.service';
import {CategorieService} from '../../../../services/categorie-unite-marque/categorie.service';
import {MarqueService} from '../../../../services/categorie-unite-marque/marque.service';
import {UniteService} from '../../../../services/categorie-unite-marque/unite.service';
import {Categorie} from '../../../../models/categorie';
import {Marque} from '../../../../models/marque';
import {Unite} from '../../../../models/Unite';
import {ClientService} from '../../../../services/Client/client.service';
import {AddClientModalComponent} from '../add-client-modal/add-client-modal.component';
import {DocumentService} from '../../../../services/document/document.service';
import {ConversionStateService} from '../../../../services/document/conversion-state.service';
import {LogicielCaisseTicketService} from '../../../../services/logiciel-caisse/logiciel-caisse-ticket.service';
import {DocumentPayload, ProjetPivot} from '../../../../models/document';
import {EMPTY, forkJoin, from, Observable, of, throwError} from 'rxjs';
import {catchError, switchMap, map, concatMap, toArray, finalize, tap, take, expand, reduce} from 'rxjs/operators';
import {DocumentPreviewService} from '../../../../services/document/document-preview.service';
import {Taxe, TaxeService} from '../../../parametre/taxe-tva/parametre-taxe/taxe.service';
import {EditWarehouseComponent} from '../../stock/gestionStock/edit-warehouse/edit-warehouse.component';
import {WarehouseService} from '../../../../services/warehouse/warehouse.service';
import {AddProductModalComponent} from './add-product-modal/add-product-modal.component';
import {Eye, EyeOff} from 'angular-feather/icons';
import {FeatherModule} from 'angular-feather';
import {StationService} from '../../../../services/station.service';
import {BanqueService} from '../../../../services/Banque/banque.service';
import {Banque} from '../../../../models/banque.model';
import {
    ParametreDocumentPutBody,
    ParametreDocumentSettingsService,
    VenteAchatParametreRow
} from '../../../../services/parametre-document/parametre-document-settings.service';
import {
    BaseCalculPrixAchat,
    isTruthyTinyInt,
    normalizeBaseCalculPrixAchat,
    normalizeVenteAchatRow
} from '../../../../services/parametre-document/parametre-doc-api-normalize';
import { resolveDocumentProductMatrixDisplay } from '../../../../services/parametre-document/document-product-line-display.util';
import { resolveModeleReferenceForType } from '../../../../services/parametre-document/parametre-document-type-ids';
import {getStationIdFromLocalStorage} from '../../../../services/parametre-document/parametre-document-state.service';
import {
    computeCmupWeightedAverage,
    resolvePrixEntreeUnitaireForCmup,
} from '../../../../services/document/achat-cmup.util';
import {
    getEnterpriseNameFromStation,
    listUserStationsFromLocalStorage,
    resolveEnterpriseDisplayName,
    setConnectedEnterpriseStationId,
    UserStationLike,
} from '../../../../services/enterprise-context';
import {StockService} from '../../../../services/stock/stock.service';
import {formatPlainStockQuantity} from '../../../../services/stock/format-plain-stock-qty.util';
import {
    normalizeNonNegativeIntegerQuantity,
    preventNonNegativeQuantityKeydown,
} from '../../../../services/stock/normalize-non-negative-quantity.util';
import {
    normalizeDocumentTypeTitreRaw,
    pdfIsStockLcDocumentType,
    pickLcGlobaleStockQtyForDocumentType,
} from '../../../../services/document/document-pdf-totals.util';
import { getLcEntrepotIdFromDocument } from '../../../../services/document/document-lc-stock-disponible.util';
import {
    BonSortieTransportInfo,
    BON_SORTIE_TRANSPORT_FIELD_DEFS,
    emptyBonSortieTransportInfo,
    mergeBonSortieTransportIntoHiddenFournisseur,
    parseBonSortieTransportInfoFromDoc,
} from '../../../../services/document/bon-sortie-transport-info.util';
import { isBonReceptionDocumentFromLogicielCaisse } from '../../../../services/document/bon-reception-lc-origin.util';
import {AppNotificationsService} from '../../../../services/app-notifications/app-notifications.service';
import {EmailComposeComponent} from '../../Vente/devis/parametre-bar/email-compose/email-compose.component';
import {ReferenceModel} from '../../../parametre/parametre-document/parametre-document.component';
import {
    applyDocumentImportProductApiShape,
    normalizeImportHeaderLabel,
    parseProductXlsxImportSheet,
    parseTvaImportValue,
    readImportCellTrimmed
} from './document-product-xlsx-import.helper';
import {
    EtablissementEntrepotLink,
    EtablissementRow,
    LogicielCaisseParametreAssociationsService,
} from '../../../../services/logiciel-caisse/logiciel-caisse-parametre-associations.service';
import {LogicielCaisseAuthService} from '../../../../services/logiciel-caisse/logiciel-caisse-auth.service';
import {
    CaisseClient,
    LogicielCaisseClientService
} from '../../../../services/logiciel-caisse/logiciel-caisse-client.service';
import {
    EntrepotApiRecord,
    LogicielCaisseEntrepotService,
} from '../../../../services/logiciel-caisse/logiciel-caisse-entrepot.service';
import {LogicielCaisseStockGestionService} from '../../../../services/logiciel-caisse/logiciel-caisse-stock-gestion.service';
import {
    LcBonReceptionEntreeLigne,
    LogicielCaisseStockReceptionService
} from '../../../../services/logiciel-caisse/logiciel-caisse-stock-reception.service';
import {
    LogicielCaisseStockTransfertService,
    StockTransfertCreateBody,
    StockTransfertDetail,
} from '../../../../services/logiciel-caisse/logiciel-caisse-stock-transfert.service';
import { readLcTransfertBarcodeQuantites } from '../../../../services/logiciel-caisse/logiciel-caisse-stock-transfert-detail-document-map.util';
import {UsersCoordinationService} from '../../../../services/logiciel-caisse/users-coordination.service';
import {resolveErpProductPrixUnitaireAchat} from '../../../../services/products/erp-product-prix-unitaire.util';
import { extractLogicielCaisseTransfertId } from '../../../../services/document/bon-reception-lc-origin.util';
import { STOCK_TRANSFER_WORKFLOW_TYPE_IDS } from '../../../../services/document/stock-transfer-workflow.constants';
import {
    isBonTransfertDocumentFromPvEcart,
    resolveTransferWorkflowRootId,
} from '../../../../services/document/stock-transfer-workflow.util';
import { convertPvEcartToBonTransfert$ } from '../../../../services/document/pv-ecart-bon-transfert-conversion.util';
import {
    buildLcPvEcartTransfertBody,
    buildLcPvEcartTransfertBodyFromUiFullBreakdown,
    buildPvEcartApprouveDisponiblePayloadFromEcartBreakdown,
    flattenLcStockTransfertBodyToPvApproveDetailLignes,
    buildPvEcartTransfertEntrepotNouveauQueryParams,
    findPvEcartWithRegularisationApplied,
    mapPvEcartErpLignesToTransfertUiLines,
    mapUiItemsToPvRegularisationItems,
    resolvePvEcartItemsForLcTransfertFromErpDoc,
    readPvEcartLcTransfertIdFromDoc,
    readPvEcartLignesFromErpDoc,
} from '../../../../services/document/pv-ecart-regularisation-flow.util';
import {
    buildPvEcartQtyBreakdownFromErpLigne,
    formatPvEcartQtyDisplay,
    PvEcartQtyBreakdownRow,
} from '../../../../services/document/pv-ecart-qty-breakdown.util';
import { parseConvertedChildrenFromApiResponse } from '../../../../services/document/document-conversion-lock.util';
import {
    bonSortieLinkedTransfertToLcInlineLinks,
    loadBonSortieLinkedStockTransfertRow$,
    loadPvEcartLinkedDocuments$,
    mergePvEcartLinkedDocumentsFromSourcesAndClient,
    openPvEcartLinkedDocInNewTab,
    PvEcartLinkedDocRow,
    PvEcartLinkedDocumentsView,
    resolvePvEcartLinkedLcTransfertId,
    resolvePvEcartLinkedLcTransfertId$,
    resolvePvEcartLinkedTransfertHeaderReference,
    resolvePvEcartLinkedErpDocumentIdForEntrepots,
    PvEcartLinkedSourcesItem,
} from '../../../../services/document/pv-ecart-linked-documents.util';
import { LcReceptionErpWorkflowLinkRow } from '../../../../services/document/stock-transfert-erp-linked-refs.util';
import { resolvePvEcartStockReference$ } from '../../../../services/document/pv-ecart-from-document.util';
import {
    ErpEntrepotRowLike,
    LcEntrepotRowLike,
    mapErpEntrepotIdToLcSelectId,
    mapLcSelectIdToErpEntrepotId,
    resolveLcEntrepotIdFromErpOrHidden,
    resolvePvEcartDestinationLcId,
} from '../../../../services/warehouse/erp-lc-entrepot-id-map.util';
import { getWorkflowStatutId } from '../../../../services/document/document-type-statut-workflow.util';

/** Option unifiée station ERP + établissement LC pour le select document. */
export interface DocumentOrgSelectOption {
    key: string;
    type: 'station' | 'etablissement';
    id: number;
    label: string;
}

/** Clé JSON (hidden_fournisseur_fields) pour l'entrepôt logiciel-caisse — hors FK erp_main.entrepots. */
const LC_ENTREPOT_HIDDEN_KEY = 'logiciel_caisse_entrepot_id';
const LC_ENTREPOT_DEST_HIDDEN_KEY = 'logiciel_caisse_entrepot_dest_id';
const LC_ETABLISSEMENT_DEST_HIDDEN_KEY = 'logiciel_caisse_etablissement_dest_id';

/** Console : comparer id ng-select vs id affiché (panneau destination). */
const DEBUG_ENTREPOT_DESTINATION_PANEL = false;

/** Trace chargement entrepôts PV d'écart (document édition / validation). */
const DEBUG_PV_ECART_ENTREPOT = false;

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
})
export class DocumentComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('warningModal') warningModal!: TemplateRef<any>;
    @ViewChild('referenceModal') referenceModal!: TemplateRef<any>;
    @ViewChild('margeModal') margeModal!: TemplateRef<any>;
    @ViewChild('depotWarningModal') depotWarningModal!: TemplateRef<any>;
    @ViewChild('stockRuptureModal', { static: true, read: TemplateRef }) stockRuptureModal!: TemplateRef<any>;
    @ViewChild('variantSelectionModal') variantSelectionModalTpl!: TemplateRef<any>;
    @ViewChild('ajout') ajoutComponent!: AjoutProjetComponent;
    @ViewChild('ajoutFournisseur') ajoutFournisseurComponent!: AddFournissComponent;
    @ViewChild('ajoutClient') ajoutClientComponent!: AddClientModalComponent;
    @ViewChild(EditWarehouseComponent) editWarehouseModal!: EditWarehouseComponent;
    @ViewChild(AddProductModalComponent) addProductModal!: AddProductModalComponent;
    @ViewChild('emailModal') emailComposeComponent!: EmailComposeComponent;
    @ViewChild('documentProductImportInput') documentProductImportInput?: ElementRef<HTMLInputElement>;
    @ViewChild('documentDateFlatpickr') documentDateFlatpickr?: Ng2FlatpickrComponent;
    @ViewChild('dateLivraisonFlatpickr') dateLivraisonFlatpickr?: Ng2FlatpickrComponent;
    private modalRef: NgbModalRef | null = null;
    private stockRuptureModalRef: NgbModalRef | null = null;
    private variantSelectionModalRef: NgbModalRef | null = null;
    variantModalRows: { product: Product; selected: boolean; quantity: number }[] = [];
    /** Lignes i = couleurs, colonnes j = tailles (matrice variantes). */
    variantModalCouleurs: string[] = [];
    variantModalTailles: string[] = [];
    private variantModalCellKeyToRowIndex = new Map<string, number>();
    variantModalPrimary: Product | null = null;
    variantModalBulkQuantity = 0;
    variantModalTableLoading = false;
    variantModalFullGroup: Product[] = [];
    private variantModalStockByProductId = new Map<number, number>();
    private variantModalStockDisponibleByProductId = new Map<number, number>();
    private variantModalLineIndex: number | null = null;
    private variantModalLineSnapshot: Item | null = null;
    /** Groupes désignation : codes-barres repliés par défaut, chargés au toggle. */
    private expandedBarcodeGroups = new Set<string>();
    /** Sous-groupes couleur (clé = désignationKey|c:couleur) ouverts sous une désignation. */
    private expandedCouleurGroups = new Set<string>();
    private barcodeGroupLoaded = new Set<string>();
    barcodeGroupLoading: { [groupKey: string]: boolean } = {};
    stockRuptureModalLines: { designation: string; qty: number }[] = [];
    margeModalDesignation = '';
    margeModalPercentDisplay: number | null = null;
    margeModalMontantDisplay: number | null = null;
    margeModalHint = '';
    private stockRupturePopupTimer: ReturnType<typeof setTimeout> | null = null;
    documentSettings: any = {
        remise: false,
        unite: false,
    };
    primaryColor: string = '#134AD3';
    documentLabel: string = '';
    dateFrequency: string = 'jours';
    nbrDate: number = 1;
    tvaRates: Tva[] = [];
    isLoadingTvaRates = false;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    clientId = this.currentUser?.id;
    stationId = getStationIdFromLocalStorage();

    /** Paramètres document : reporter le prix d'achat ligne sur la fiche produit (facture fournisseur). */
    private paramDocMajPrixAchatProduit = false;

    /** Base du prix unitaire d'entrée pour le CMUP (fiche produit vs ligne document). */
    private paramDocBaseCalculPrixAchat: BaseCalculPrixAchat = 'document_achat';

    /** Paramètre station : affichage matriciel des lignes produit (défaut true). */
    private paramDocAffProduitMatriciel = true;
    file: string = environment.file_url;
    urlImages: string = environment.url_images;
    private static readonly DEFAULT_STATION_LOGO = 'assets/images/logo/logo.svg';
    stationLogo: string | null = null;
    /** True si l’URL logo a échoué au chargement (on garde quand même l’emplacement). */
    documentLogoBroken = false;
    stationName: string = resolveEnterpriseDisplayName();
    /** Stations ERP + établissements LC (select unifié). */
    orgSelectOptions: DocumentOrgSelectOption[] = [];
    selectedOrgKey: string | null = null;
    /** Bon de sortie — établissement récepteur (Origine / Destination). */
    selectedOrgKeyRecepteur: string | null = null;
    availableEtablissements: EtablissementRow[] = [];
    selectedEtablissementId: number | null = null;
    selectedEtablissementDestId: number | null = null;
    loadingEtablissements = false;
    private enterpriseBrandName = resolveEnterpriseDisplayName();
    documentCachetUrl: string | null = null;
    venteAchatRowForDoc: VenteAchatParametreRow | null = null;
    img: string = (environment as { image_url?: string }).image_url ?? 'assets/images/logo/';
    barcodeColumnIconUrl: string = `${String(this.img).replace(/\/?$/, '/')}barcode.png`;
    isTitleVisible = true;
    isDateVisible = true;
    isProjectVisible = true;
    isEntrepotVisible = true;
    isEntrepotInitialReadonly = false;
    isEntrepotDestinationReadonly = false;
    isNoteVisible = true;
    isCategorieVisible = true;
    documentType: string = 'DEVIS';
    documentReference: string = '';
    documentReferenceHeaderPending = false;
    private documentReferencePrefetchGen = 0;
    referenceModelType: number | null = null;
    referenceModelDetail: ReferenceModel | null = null;
    currentStatutId: number | null = null;
    private currentDocumentUserId: number | null = null;
    private currentTypeDocumentId: number | null = null;
    /** type_initial ERP (ex. PV ECART = 20 pour un BT issu d'un PV validé). */
    private documentTypeInitialId: number | null = null;
    pvEcartLinkedDocsLoading = false;
    pvEcartLinkedDocsView: PvEcartLinkedDocumentsView | null = null;
    bonSortieLinkedDocsLoading = false;
    bonSortieLinkedTransfertLinks: LcReceptionErpWorkflowLinkRow[] = [];
    pvEcartDocumentOriginalFromSources: PvEcartLinkedDocRow | null = null;
    /** Dernière réponse POST pv-ecart/linked-sources (entrepôt destination). */
    private pvEcartLinkedSourcesEntry: PvEcartLinkedSourcesItem | null = null;
    /** Tableau PV alimenté par le détail LC (affichage) ; sauvegarde ERP inchangée. */
    private pvEcartLineViewFromLcDetail = false;
    private pvEcartErpLignesForSave: Array<Record<string, unknown>> | null = null;
    /** Colonnes qty envoyée / reçue / écart (PV d'écart). */
    pvEcartQtyBreakdownByItemIndex = new Map<number, PvEcartQtyBreakdownRow>();
    /** Dernier doc PV chargé — réapplication entrepôts après enrich LC↔ERP. */
    private lastLoadedPvEcartDoc: Record<string, unknown> | null = null;
    private loadedDocumentNote = '';
    isDateReadonly = false;
    isEntrepotReadonly = false;
    isProjectReadonly = false;
    isNoteReadonly = false;
    isNameClientReadonly = false;
    isIdentifiantReadonly = false;
    isAdressReadonly = false;
    isTelephoneReadonly = false;
    isEmailReadonly = false;
    private originalProjectId: number | null = null;
    private pendingClientId: number | undefined = undefined;
    fournisseurs: Fournisseur[] = [];
    clients: Client[] = [];
    /** Liste filtrée pour ng-select (propriété stable, pas un getter). */
    clientsForSelect: Client[] = [];
    /** Filtre recherche client : professionnel (entreprise), particulier, ou négoce (vente négoce). */
    clientSearchMode: 'patente' | 'particulier' | 'negoce' = 'patente';

    /** Route /vente-negoce/** : uniquement clients type Négoce. */
    get isVenteNegoceContext(): boolean {
        return (this.router.url || '').includes('/vente-negoce/');
    }
    projects: any[] = [];
    private clientSelectLoading = false;
    items: Item[] = [];
    /** Réédition transfert LC (/transfert-entrepot/nouveau?lcTransfertId=). */
    private logicielCaisseTransfertEditId: number | null = null;
    /** Transfert LC ouvert depuis validation d'un PV d'écart (quantités signées). */
    private logicielCaisseTransfertFromPvEcart = false;
    /** PV ERP source (query pv_ecart_id), distinct du bon de transfert ERP lié. */
    private pvEcartSourceDocumentId: number | null = null;
    /** En-tête : ref. document de transfert lié (pas num_document LC interne). */
    private pvEcartLinkedTransfertRefDisplay = '';
    private pvEcartLinkedTransfertRefPending = false;
    /** Debounce double émission queryParams (même navigation). */
    private lcTransfertEditLoadTimer: ReturnType<typeof setTimeout> | null = null;
    private lcTransfertStockRefreshTimer: ReturnType<typeof setTimeout> | null = null;
    private linkedErpBonTransfertDocumentId: number | null = null;
    /** Transfert LC créé à l’approbation d’un BT issu PV d’écart (navigation validation). */
    private pvEcartApprovedLcTransfertId: number | null = null;
    private pendingLcTransfertWarehouseDepId: number | null = null;
    private pendingLcTransfertWarehouseDestId: number | null = null;
    private isSavingDraft = false;
    tvaSummary: TvaSummary[] = [];
    documentColumnSettings: any = {
        reference: true,
        quantite: true,
        unite: false,
        prixUnitaire: true,
        tva: true,
        remise: false,
        totalHt: true,
        afficherMontantsTTC: false,
        afficherCoordonneesClients: true,
        afficherCodeBarres: true,
        afficherDateEcheance: false,
        afficherDateLivraison: true,
        afficherMontantTotal: true,
        aff_montant_ttc: false,
        aff_code_bar: true,
        aff_date_echeance: false,
        aff_date_liv: true,
        aff_montant_total: true,
        aff_coordonnees: true,
        prix_unitaire: true

    };
    private taxes: any[] = [];
    documentTaxStatutOverrides: { [taxId: number]: boolean } = {};
    private fodecRate = 1;
    totals: {
        totalHT: number;
        totalRemise: number;
        totalTaxesAvantTVA: number;
        totalBaseTVA: number;
        totalTVA: number;
        totalTaxesApresTVA: number;
        totalTTC: number;
        retenueSource: number;
        netAPayer: number;
        timbreFiscal: number;
        Base_RS: number;
        Taux_RS: string;
        RS: number;
        Net_à_payer: number;
        documentLevelTaxLines: { label: string; amount: number }[];
        documentLevelTaxesTotal: number;
        taxesAfterHT: { label: string; amount: number }[];
        taxesAfterTTC: { label: string; amount: number }[];
        taxesAfterTimbre: { label: string; amount: number }[];
    } =
        {
            totalHT: 0,
            totalRemise: 0,
            totalTaxesAvantTVA: 0,
            totalBaseTVA: 0,
            totalTVA: 0,
            totalTaxesApresTVA: 0,
            totalTTC: 0,
            retenueSource: 0,
            netAPayer: 0,
            timbreFiscal: 0,
            Base_RS: 0,
            Taux_RS: '0',
            RS: 0,
            Net_à_payer: 0,
            documentLevelTaxLines: [],
            documentLevelTaxesTotal: 0,
            taxesAfterHT: [],
            taxesAfterTTC: [],
            taxesAfterTimbre: []
        };
    entreprise: any = {};
    banque: any = { nom_banque: '--', rib: '--' };
    /** Comptes bancaires actifs de la station (footer document). */
    availableBanques: Banque[] = [];
    selectedBanqueId: number | null = null;
    stationFooterCoordName = '--';
    stationFooterCoordEmail = '--';
    stationFooterCoordPhones = '--';
    selectedClient: Client | null = null;
    selectedFournisseur: Fournisseur | null = null;
    selectedCategorie: string | null = null;
    selectedProject: string = '';
    documentDate = this.getTodayLocal();
    note: string = '';
    /** Bon de livraison : transport (persisté dans hidden_fournisseur_fields.informations_transport). */
    bonSortieTransport: BonSortieTransportInfo = emptyBonSortieTransportInfo();
    readonly bonSortieTransportFieldDefs = BON_SORTIE_TRANSPORT_FIELD_DEFS;
    refExterne: string = '';
    nomClient: string = '';
    identifiant: string = '';
    adresse: string = '';
    telephone: string = '';
    email: string = '';
    entrepot: string = '';
    dateLivraison?: string = null;
    documentId: number | null = null;
    documentOriginalId: number | null = null;
    numericReference = 1;
    isApproveButtonDisabled = true;
    isLoadingProjects = false;
    isLoadingFournisseurs = false;
    isLoadingClients = false;
    isLoadingEdit = false;
    isEditing = false;
    isLoadingProducts = false;
    isLoadingCategories = false;
    isLoadingWarehouses = false;
    /** Règle générale : la référence document n’est jamais éditable (même en brouillon). */
    isReferenceReadonly = true;
    /** True quand la ref a été saisie/modifiée dans le popup (doit être envoyée à la création). */
    private referenceSeedFromPopup = false;
    isDateLivReadonly = false;
    isCategorieReadonly = false;
    products: Product[] = [];
    productsForDocumentSelect: Product[] = [];
    categories: Categorie[] = [];
    selectedClientId: number | null = null;
    editMode = {
        nomClient: false,
        identifiant: false,
        numeroIdentification: false,
        adresse: false,
        email: false
    };
    editModeFournisseur = {
        nomEntreprise: false,
        numeroIdentification: false,
        responsable: false,
        telephone: false,
        adresse: false
    };
    modifiedClientFields: { [key: string]: boolean } = {
        nomClient: false,
        identifiant: false,
        numeroIdentification: false,
        adresse: false,
        email: false
    };
    modifiedFournisseurFields: { [key: string]: boolean } = {
        nomEntreprise: false,
        numeroIdentification: false,
        responsable: false,
        telephone: false,
        adresse: false
    };
    mode: 'add' | 'edit' | 'validation' = 'add';
    tvaMapping: { [key: number]: string } = {};
    selectedFournisseurId: number | null = null;
    public basicDateOptions: FlatpickrOptions = {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        defaultDate: new Date().toISOString().split('T')[0],
        allowInput: true,
        altInputClass: 'form-control flatpickr-input'
    };
    public basicDateLivraisonOptions: FlatpickrOptions = {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        defaultDate: new Date().toISOString().split('T')[0],
        allowInput: true,
        altInputClass: 'form-control flatpickr-input'
    };
    @Input() min: number = 0;
    @Input() max: number = 100;
    @Input() step: number = 1;
    value: number = 0;
    private isModalOpen = false;
    isSubmitting = false;

    /** Désactive tous les boutons d'en-tête pendant les requêtes (évite double clic). */
    private isDocumentHeaderActionsLocked(): boolean {
        return this.isSubmitting || this.isSavingDraft;
    }

    private setDocumentSubmitting(active: boolean): void {
        if (this.isSubmitting === active) {
            return;
        }
        this.isSubmitting = active;
        this.updateHeaderConfig();
        this.cdr.markForCheck();
    }

    private applyHeaderButtonsSubmitGuard(buttons: any[]): any[] {
        if (!this.isDocumentHeaderActionsLocked()) {
            return buttons;
        }
        return buttons.map((b) => ({ ...b, disabled: true }));
    }

    private setSavingDraft(active: boolean): void {
        if (this.isSavingDraft === active) {
            return;
        }
        this.isSavingDraft = active;
        this.updateHeaderConfig();
        this.cdr.markForCheck();
    }
    warehouses: any[] = [];
    /** Liste complète des entrepôts LC (avant filtrage par établissement). */
    allWarehouses: any[] = [];
    /** Tous les entrepôts LC (sans filtre is_globale) — sélecteur destination BT. */
    allWarehousesEnrichedFull: any[] = [];
    /** Liste ERP stock (GET /api/entrepots) pour valider les FK documents. */
    private cachedErpWarehouseRows: ErpEntrepotRowLike[] = [];
    warehousesDestination: any[] = [];
    /** Liens établissement ↔ entrepôt (API logiciel caisse). */
    private etablissementEntrepotLinks: EtablissementEntrepotLink[] = [];
    private etablissementLinksLoaded = false;
    private warehouseModalTarget: 'single' | 'initial' | 'destination' = 'single';
    selectedWarehouseId: number | null = null;
    /** Libellé figé (avoir) : entrepôt de la facture / BR source. */
    lockedWarehouseName: string | null = null;
    selectedWarehouseInitialId: number | null = null;
    selectedWarehouseDestinationId: number | null = null;
    /** Détail entrepôt destination (colonne gauche — dual entrepôt). */
    warehouseDestinationDetail: Record<string, unknown> | null = null;
    warehouseDestinationEtablissement: EtablissementRow | null = null;
    isLoadingWarehouseDestinationDetail = false;
    tempAdresse: string = '';
    tempEmail: string = '';
    tempAdresseFournisseur: string = '';
    tempTelephoneFournisseur: string = '';
    showProductDescription: { [index: number]: boolean } = {};
    productDescriptions: { [index: number]: string } = {};
    productLineBarcodeQuery: { [index: number]: string } = {};
    productLineBarcodeApiHits: { [index: number]: Product[] | undefined } = {};
    productLineBarcodeSearchLoading: { [index: number]: boolean } = {};
    private barcodeLineDebounceTimers: { [index: number]: ReturnType<typeof setTimeout> } = {};
    barcodePickerModel: { [index: number]: Product | undefined } = {};
    barcodePickerUnlockEdit: { [index: number]: boolean } = {};
    private barcodePickerProductsVersion = 0;
    private barcodePickerBaseCache: Product[] | null = null;
    private barcodePickerBaseCacheFingerprint = '';
    private barcodePickerMergedByLine: { [lineIndex: number]: Product[] } = {};
    private barcodePickerMergedKeyByLine: { [lineIndex: number]: string } = {};

    private invalidateBarcodePickerItemsCache(): void {
        this.barcodePickerProductsVersion++;
        this.barcodePickerBaseCache = null;
        this.barcodePickerBaseCacheFingerprint = '';
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private getBarcodePickerBaseFingerprint(): string {
        return `${this.barcodePickerProductsVersion}_${(this.products || []).length}`;
    }

    private getCachedBarcodePickerBaseList(): Product[] {
        const fp = this.getBarcodePickerBaseFingerprint();
        if (
            this.barcodePickerBaseCache != null &&
            this.barcodePickerBaseCacheFingerprint === fp
        ) {
            return this.barcodePickerBaseCache;
        }
        this.barcodePickerBaseCache = this.getProductsWithRealBarcodeSortedForPicker();
        this.barcodePickerBaseCacheFingerprint = fp;
        return this.barcodePickerBaseCache;
    }

    trackBarcodePickerById = (_index: number, item: any): number | string =>
        item?.id != null ? Number(item.id) : _index;

    compareBarcodePickerProduct = (a: any, b: any): boolean =>
        a != null && b != null && Number(a?.id) === Number(b?.id);
    searchBarcodePickerFn = (term: string, item: any): boolean => {
        if (term == null || String(term).trim() === '') {
            return true;
        }
        const t = term.toLowerCase().trim().replace(/\s/g, '');
        const cb = String(item?.code_barre ?? item?.code_bar ?? '')
            .replace(/\s/g, '')
            .toLowerCase();
        const nom = String(item?.nom ?? '')
            .toLowerCase()
            .replace(/\s/g, '');
        const c = String(item?.couleur ?? '')
            .trim()
            .toLowerCase();
        const tl = String(item?.taille ?? '')
            .trim()
            .toLowerCase();
        const attrs = `${c} / ${tl}`.replace(/\s/g, '').toLowerCase();
        return (
            cb.includes(t) ||
            nom.includes(t) ||
            c.replace(/\s/g, '').includes(t) ||
            tl.replace(/\s/g, '').includes(t) ||
            attrs.includes(t)
        );
    };

    /** Désignation : recherche par nom, réf. fabricant ou réf. interne. */
    searchDesignationProductFn = (term: string, item: any): boolean => {
        if (term == null || String(term).trim() === '') {
            return true;
        }
        const t = String(term).toLowerCase().trim();
        const tNoSpace = t.replace(/\s/g, '');
        const nom = String(item?.nom ?? '').toLowerCase();
        const refFab = this.getProductSelectRefFabricantDisplay(item).toLowerCase();
        const refInt = String(item?.ref_interne ?? item?.reference ?? '')
            .toLowerCase()
            .trim();
        const matchRef = (ref: string) =>
            ref !== '' && ref !== '—' && ref !== '-' && (ref.includes(t) || ref.replace(/\s/g, '').includes(tNoSpace));
        return (
            nom.includes(t) ||
            nom.replace(/\s/g, '').includes(tNoSpace) ||
            matchRef(refFab) ||
            matchRef(refInt)
        );
    };

    /** Réf. fabricant affichée dans le ng-select désignation (nom / ref_fabricant). */
    getProductSelectRefFabricantDisplay(product: any): string {
        if (!product) {
            return '—';
        }
        let ref = this.normalizeRefFabricantForSelect(
            product?.ref_fabricant ?? product?.ref_fabriquant
        );
        if (!ref && product?.id != null) {
            const fromCatalog = (this.products || []).find(
                (p) => Number(p.id) === Number(product.id)
            );
            ref = this.normalizeRefFabricantForSelect(
                (fromCatalog as any)?.ref_fabricant ?? (fromCatalog as any)?.ref_fabriquant
            );
        }
        if (!ref && product?.nom) {
            const byNom = (this.products || []).find(
                (p) => String(p.nom || '').trim() === String(product.nom || '').trim()
            );
            ref = this.normalizeRefFabricantForSelect(
                (byNom as any)?.ref_fabricant ?? (byNom as any)?.ref_fabriquant
            );
        }
        return ref || '—';
    }

    /**
     * Libellé affiché dans ng-select désignation (bindValue = nom → l’item label peut être string ou Product).
     */
    resolveDesignationSelectLabel(
        lineIndex: number,
        selected: unknown
    ): { nom: string; ref: string } | null {
        const row = this.items[lineIndex];
        const designation = String(row?.designation ?? '').trim();
        if (!designation && (selected == null || selected === '')) {
            return null;
        }
        let productLike: { nom?: string; id?: number } | null = null;
        if (selected != null && typeof selected === 'object' && (selected as { nom?: string }).nom) {
            productLike = selected as { nom?: string; id?: number };
        } else if (typeof selected === 'string' && selected.trim()) {
            productLike = { nom: selected.trim() };
        } else if (designation) {
            productLike = { nom: designation };
        }
        const nom = String(productLike?.nom ?? '').trim();
        if (!nom) {
            return null;
        }
        const fromItems = (this.getProductSelectItemsForLine(lineIndex) || []).find(
            (p) => String(p.nom || '').trim() === nom
        );
        const full = fromItems ?? productLike;
        return {
            nom,
            ref: this.getProductSelectRefFabricantDisplay(full),
        };
    }

    compareClients(c1: any, c2: any): boolean {
        const getId = (item: any): number | null => {
            if (!item) return null;
            if (typeof item === 'object' && item.id !== undefined) return item.id;
            if (typeof item === 'number') return item;
            return null;
        };

        const id1 = getId(c1);
        const id2 = getId(c2);

        return id1 === id2;
    }

    compareFournisseurs(c1: any, c2: any): boolean {
        const getId = (item: any): number | null => {
            if (!item) return null;
            if (typeof item === 'object' && item.id !== undefined) return item.id;
            if (typeof item === 'number') return item;
            return null;
        };

        const id1 = getId(c1);
        const id2 = getId(c2);

        return id1 === id2;
    }

    trackByFournisseurId = (index: number, item: any) => {
        return item?.id;
    };
    conversionFromRef: {
        sourceId: number;
        newType: string;
        typeDocumentId: number;
        statutId: number;
        isAvoir?: boolean;
        totalsAvoir?: any;
        documentOriginalId?: number;
        workflowStep?: string;
    } | null = null;
    /** Formulaire add prérempli depuis « Convertir » (avant Approuver). */
    private isPendingConversion = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private headerService: HeaderService,
        private router: Router,
        private modalService: NgbModal,
        private toastr: ToastrService,
        private projetService: ProjetService,
        private fournisseurService: FournisseurService,
        private productsService: ProductsService,
        private categorieService: CategorieService,
        private clientService: ClientService,
        private zone: NgZone,
        private tvaService: TvaService,
        private documentService: DocumentService,
        private conversionStateService: ConversionStateService,
        private lcTicketService: LogicielCaisseTicketService,
        private route: ActivatedRoute,
        public documentPreviewService: DocumentPreviewService,
        public taxeService: TaxeService,
        private warehouseService: WarehouseService,
        private stationService: StationService,
        private banqueService: BanqueService,
        private parametreDocumentSettingsService: ParametreDocumentSettingsService,
        private stockService: StockService,
        private appNotifications: AppNotificationsService,
        private marqueService: MarqueService,
        private uniteService: UniteService,
        private lcAssociations: LogicielCaisseParametreAssociationsService,
        private lcAuth: LogicielCaisseAuthService,
        private lcEntrepotService: LogicielCaisseEntrepotService,
        private lcStockGestion: LogicielCaisseStockGestionService,
        private lcStockReception: LogicielCaisseStockReceptionService,
        private lcStockTransfert: LogicielCaisseStockTransfertService,
        private coordinationService: UsersCoordinationService,
        private lcClientService: LogicielCaisseClientService
    ) {
        const nav = this.router.getCurrentNavigation();
        this.conversionFromState =
            nav?.extras?.state?.['conversionFrom'] ?? this.conversionStateService.get();
    }
    private conversionFromState: any = null;
    /** Liaison tickets caisse → facture ERP à enregistrer après sauvegarde. */
    private ticketFactureLink: { ticketIds: number[]; ticketCodes: string[]; markConsolide: boolean } | null = null;

    typeDocumentIdMap: { [key: string]: number } = {
        'DEVIS': 7,
        'COMMANDE CLIENT': 8,
        'BON DE SORTIE': 9,
        'BON DE LIVRAISON': 10,
        'FACTURE': 11,
        'COMMANDE FOURNISSEUR': 12,
        'BON RECEPTION': 13,
        'FACTURE FOURNISSEUR': 14,
        'AVOIR': 15,
        'BON TRANSFERT': 16,
        'INVENTAIRE': 17,
        'RETOUR FOURNISSEUR': 18,
        'AVOIR FOURNISSEUR': 19,
        'PV ECART': 20
    };

    private documentTypeToRefPrefix: { [key: string]: string } = {
        'DEVIS': 'DEV',
        'COMMANDE CLIENT': 'CC',
        'BON DE SORTIE': 'BS',
        'BON DE LIVRAISON': 'BL',
        'FACTURE': 'FAC',
        'COMMANDE FOURNISSEUR': 'CF',
        'BON RECEPTION': 'BR',
        'FACTURE FOURNISSEUR': 'FF',
        'AVOIR': 'AVR',
        'INVENTAIRE': 'INV',
        'BON TRANSFERT': 'BT',
        'AVOIR FOURNISSEUR': 'AF',
        'PV ECART': 'PVE'
    };


    private typeDocumentsMeta: {
        [docType: string]: { id: number; prefix: string; refCounter: number | null };
    } = {};

    private typeIdToDocumentTypeFromApi: { [id: number]: string } = {};


    private typeDocumentPrefixRawFromApi: string | null = null;

    statutIdMap: { [key: string]: number } = {
        'Brouillon': 1,
        'Accepté': 3,
        'Payé': 5,
        'Annulé': 6,
        'Négociation': 8,
        'Crée': 9,
        'Créé': 9,
        'Valide': 10,
        'Livré': 11,
        'Non payé': 12,
        'Non Payé': 12,
        'Fermé': 13,
        'Reçu': 14,
        'Partiellement payé': 15,
        'En cours': 16,
        'Transféré': 17,
        'Non utilisé': 19,
        'Partiellement utilisé': 20,
        'Utilisé': 18,
        'À réceptionner': 21,
        'En contrôle': 22,
        'Réceptionné': 23,
        'Réception partielle': 24,
        'Avec écart': 25,
        Retourné: 25,
        'Clôturé': 26,
        'Soumis': 27,
        'En traitement': 28,
        'Validé': 29,
        'Rejeté': 30,
    };


    ngOnInit(): void {
        this.documentService
            .mergeStatutIdMapFromApi(this.statutIdMap)
            .pipe(take(1))
            .subscribe((merged) => {
                this.statutIdMap = merged;
            });

        const previewData = this.documentPreviewService.getCurrentPreview();
        const defaultSettings = {
            reference: true,
            quantite: true,
            unite: false,
            prixUnitaire: true,
            tva: true,
            remise: false,
            afficherMontantsTTC: false,
            afficherCodeBarres: true,
            afficherDateEcheance: false,
            afficherDateLivraison: true,
            afficherMontantTotal: true,
            afficherCoordonneesClients: true,
            aff_montant_ttc: false,
            aff_code_bar: true,
            aff_date_échéance: false,
            aff_date_liv: true,
            aff_montant_total: true,
            aff_coordonnees: true,
            prix_unitaire: true
        };

        const saved = localStorage.getItem('documentColumnSettings');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                this.documentColumnSettings = {
                    ...defaultSettings,
                    ...parsed,
                    aff_montant_ttc: parsed.aff_montant_ttc ?? parsed.afficherMontantsTTC ?? false,
                    aff_code_bar: parsed.aff_code_bar ?? parsed.afficherCodeBarres ?? true,
                    aff_date_echeance: parsed.aff_date_echeance ?? parsed.aff_date_échéance ?? parsed.afficherDateEcheance ?? false,
                    aff_date_liv: parsed.aff_date_liv ?? parsed.afficherDateLivraison ?? true,
                    aff_montant_total: parsed.aff_montant_total ?? parsed.afficherMontantTotal ?? true,
                    aff_coordonnees: parsed.aff_coordonnees ?? parsed.aff_coordonnées ?? parsed.afficherCoordonneesClients ?? true,
                    reference: parsed.reference ?? parsed.référence ?? true,
                    quantite: parsed.quantite ?? parsed.quantité ?? true,
                    unite: parsed.unite ?? parsed.unité ?? false,
                    prix_unitaire: parsed.prix_unitaire ?? parsed.prixUnitaire ?? true,
                    tva: parsed.tva ?? true,
                    remise: parsed.remise ?? false
                };
            } catch (e) {
                this.documentColumnSettings = defaultSettings;
            }
        } else {
            this.documentColumnSettings = defaultSettings;
        }

        // Exigence métier: la colonne Quantité doit être affichée par défaut sur tous les documents.
        this.documentColumnSettings.quantite = true;
        this.documentColumnSettings.quantité = true;
        // Colonne « Code à barre » en tête du tableau (aligné front-achat / front-vente).
        this.documentColumnSettings.reference = true;
        this.documentColumnSettings.référence = true;
        localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
        this.documentColumnSettings = {...this.documentColumnSettings};

        this.loadTypeDocumentsMetadata();

        if (previewData?.isDraft && previewData?.previewData) {
            this.documentType = previewData.documentType || 'DEVIS';
            this.loadCurrentTypeDocumentPrefixFromApi();
        } else {
            this.checkRoute();
        }
        this.loadReferenceModelFromParametreDocument();
        if (!this.dateLivraison) {
            this.dateLivraison = this.getTodayLocal();
        }
        this.updateHeaderConfig();
        const currentUrl = this.router.url.toLowerCase();
        if (currentUrl.includes('/vente-negoce/')) {
            this.clientSearchMode = 'negoce';
        }
        if (currentUrl.includes('/edit-')) {
            this.mode = 'edit';
        } else if (currentUrl.includes('/action/validation')) {
            this.mode = 'validation';
        } else {
            this.mode = 'add';
        }
        const initUrl = (this.router.url || '').toLowerCase();
        const initLcTransfertId = Number(this.route.snapshot.queryParams['lcTransfertId']);
        const initFromPvEcart = String(
            this.route.snapshot.queryParams['from_pv_ecart'] ?? ''
        ).toLowerCase();
        const skipInitReferencePrefetch =
            initUrl.includes('/transfert-entrepot/nouveau') &&
            ((Number.isFinite(initLcTransfertId) && initLcTransfertId > 0) ||
                initFromPvEcart === '1' ||
                initFromPvEcart === 'true');
        if (
            this.mode === 'add' &&
            !this.route.snapshot.queryParams['id'] &&
            !previewData?.isDraft &&
            !skipInitReferencePrefetch
        ) {
            this.beginDocumentReferenceHeaderLoad();
        }
        this.updateHeaderConfig();
        this.route.queryParams.subscribe(params => {
            const id = params['id'];
            const duplicate = params['duplicate'] === 'true';
            const sourceId = params['sourceId'];
            const lcTransfertIdParam = params['lcTransfertId'];
            const erpDocumentIdParam = params['erpDocumentId'];
            const pvEcartIdParam = params['pv_ecart_id'] ?? params['pvEcartId'];
            const fromPvEcartParam = String(params['from_pv_ecart'] ?? '').toLowerCase();
            this.logicielCaisseTransfertFromPvEcart =
                fromPvEcartParam === '1' ||
                fromPvEcartParam === 'true' ||
                params['from_pv_ecart'] === true;
            if (String(this.router.url || '').toLowerCase().includes('/transfert-entrepot/nouveau')) {
                this.checkRoute();
            }
            if (lcTransfertIdParam && this.isLogicielCaisseEntrepotTransfert()) {
                const lcN = Number(lcTransfertIdParam);
                if (Number.isFinite(lcN) && lcN > 0) {
                    this.logicielCaisseTransfertEditId = lcN;
                    if (this.logicielCaisseTransfertFromPvEcart) {
                        this.documentReferencePrefetchGen++;
                        this.documentReferenceHeaderPending = false;
                        this.pvEcartLinkedTransfertRefPending = true;
                    }
                    this.scheduleLogicielCaisseTransfertDocumentEditLoad(lcN);
                }
                const pvFromQuery = Number(pvEcartIdParam);
                const pvId =
                    Number.isFinite(pvFromQuery) && pvFromQuery > 0 ? pvFromQuery : null;
                this.pvEcartSourceDocumentId = pvId;
                if (this.logicielCaisseTransfertFromPvEcart && pvId != null) {
                    this.loadTransfertEntrepotsFromPvEcartSource();
                }
                const erpN = Number(erpDocumentIdParam);
                if (
                    !this.logicielCaisseTransfertFromPvEcart &&
                    Number.isFinite(erpN) &&
                    erpN > 0
                ) {
                    this.linkedErpBonTransfertDocumentId = erpN;
                    this.loadErpBonTransfertHiddenEntrepotsForLcEdit(erpN);
                } else {
                    this.linkedErpBonTransfertDocumentId = null;
                }
            }
            if (duplicate && sourceId) {
                this.mode = 'add';
                this.isEditing = false;
                this.documentId = null;
                this.loadDocumentForDuplicate(+sourceId);
            } else if (id && this.mode === 'add') {
                this.documentId = +id;
                this.mode = 'edit';
                this.isEditing = true;
                if (this.tryRestoreFromPreviewData(+id)) return;
                this.loadDocumentForEdit(+id);
            } else if (id && this.mode === 'edit') {
                if (this.tryRestoreFromPreviewData(+id)) return;
                this.loadDocumentForEdit(+id);
            } else if (this.mode === 'add') {
                const conversionData =
                    this.conversionFromState ?? this.conversionStateService.get();
                if (conversionData?.sourceType === 'ticket_caisse_batch') {
                    this.conversionStateService.consume();
                    this.conversionFromState = null;
                    // refresh établissements une seule fois dans loadFormFromTicketFacture
                    this.loadFormFromTicketFacture(conversionData);
                } else if (conversionData?.sourceId != null && conversionData?.sourceDocument) {
                    this.conversionStateService.consume();
                    this.conversionFromState = null;
                    this.refreshAvailableEtablissements();
                    this.loadFormFromConversion(conversionData);
                } else {
                    this.refreshAvailableEtablissements();
                    this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
                    this.loadTaxes();
                    // checkForPreviewData ne recharge plus les listes si pas de brouillon
                    // (évite le double chargement clients/produits/entrepôts…).
                    this.checkForPreviewData();
                    if (!this.documentPreviewService.getCurrentPreview()?.isDraft) {
                        this.loadProjects();
                        this.loadClients();
                        this.loadFournisseurs();
                        this.loadProducts();
                        this.loadWarehouses();
                        this.loadTvaRates();
                        this.loadCategories();
                    }
                    this.loadStationData();
                    this.calculateTotals();
                    this.updateApproveButtonState();
                    this.maybePrefetchNextDocumentReference();
                }
            } else {
                this.refreshAvailableEtablissements();
                this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
                this.loadTaxes();
                this.checkForPreviewData();
                if (!this.documentPreviewService.getCurrentPreview()?.isDraft) {
                    this.loadProjects();
                    this.loadClients();
                    this.loadFournisseurs();
                    this.loadProducts();
                    this.loadWarehouses();
                    this.loadTvaRates();
                    this.loadCategories();
                }
                this.loadStationData();
                this.calculateTotals();
                this.updateApproveButtonState();
                this.maybePrefetchNextDocumentReference();
            }
            this.updateHeaderConfig();
            this.loadVenteAchatParamForCurrentDocumentType();
        });
    }

    private loadVenteAchatParamForCurrentDocumentType(): void {
        if (!this.stationId) {
            this.venteAchatRowForDoc = null;
            return;
        }
        const typeId =
            this.currentTypeDocumentId != null && !Number.isNaN(Number(this.currentTypeDocumentId))
                ? Number(this.currentTypeDocumentId)
                : this.typeDocumentIdMap[this.documentType];
        if (typeId == null || Number.isNaN(typeId) || typeId <= 0) {
            this.venteAchatRowForDoc = null;
            return;
        }
        this.parametreDocumentSettingsService.getVenteAchatByStationAndType(this.stationId, typeId).subscribe({
            next: (row) => {
                this.venteAchatRowForDoc = row;
                this.applyVenteAchatProductDescriptionDefaults();
                this.cdr.markForCheck();
            },
            error: () => {
                this.venteAchatRowForDoc = null;
                this.cdr.markForCheck();
            }
        });
    }

    private applyVenteAchatProductDescriptionDefaults(): void {
        if (!this.venteAchatRowForDoc || !isTruthyTinyInt(this.venteAchatRowForDoc.aff_courte_desp)) {
            return;
        }
        this.items.forEach((item, i) => {
            if (item.type === 'product' && item.designation?.trim()) {
                this.showProductDescription[i] = true;
            }
        });
    }

    showVenteAchatTotalsSection(): boolean {
        if (this.venteAchatRowForDoc == null) {
            return true;
        }
        return isTruthyTinyInt(this.venteAchatRowForDoc.aff_montant_totaux);
    }

    /** Section Entreprise du footer document : toujours affichée (obligatoire). */
    showFooterEntrepriseBlock(): boolean {
        return true;
    }

    showFooterCoordonneesBlock(): boolean {
        if (this.venteAchatRowForDoc == null) {
            return true;
        }
        return isTruthyTinyInt(this.venteAchatRowForDoc.aff_inf_contact);
    }

    private isVenteAchatAffCourteDesp(): boolean {
        return this.venteAchatRowForDoc != null && isTruthyTinyInt(this.venteAchatRowForDoc.aff_courte_desp);
    }

    private getTodayLocal(): string {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private formatDateToLocalString(date: Date | string | null): string {
        if (!date) {
            return this.getTodayLocal();
        }
        let d: Date;
        if (typeof date === 'string') {
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date;
            }
            d = new Date(date);
        } else {
            d = date;
        }
        if (isNaN(d.getTime())) {
            return this.getTodayLocal();
        }
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private applyPreviewDateFields(previewData: any): void {
        const rawDoc =
            previewData?.date ??
            previewData?.date_document ??
            null;
        const rawLiv = previewData?.date_livraison ?? null;

        const hasStr = (v: unknown) => v != null && String(v).trim() !== '';

        if (hasStr(rawDoc)) {
            this.documentDate = this.formatDateToLocalString(rawDoc as string);
        } else if (hasStr(rawLiv)) {
            this.documentDate = this.formatDateToLocalString(rawLiv as string);
        } else {
            this.documentDate = this.getTodayLocal();
        }

        if (hasStr(rawLiv)) {
            this.dateLivraison = this.formatDateToLocalString(rawLiv as string);
        } else {
            this.dateLivraison = this.documentDate;
        }

        this.syncFlatpickrDateConfigs();
        this.syncFlatpickrReadonlyOnInstances();
    }

    private syncFlatpickrDateConfigs(): void {
        this.basicDateOptions = {
            ...this.basicDateOptions,
            defaultDate: this.documentDate,
            clickOpens: !this.isDateReadonly,
            allowInput: !this.isDateReadonly
        };
        this.basicDateLivraisonOptions = {
            ...this.basicDateLivraisonOptions,
            defaultDate: this.dateLivraison || this.documentDate,
            clickOpens: !this.isDateLivReadonly,
            allowInput: !this.isDateLivReadonly
        };
    }

    private applyFlatpickrReadonlyState(fpComp: Ng2FlatpickrComponent | undefined | null, readonly: boolean): void {
        const fp = fpComp?.flatpickr as {
            set?: (k: string, v: unknown) => void;
            close?: () => void;
            altInput?: HTMLInputElement;
            input?: HTMLInputElement;
        } | undefined;
        if (!fp || typeof fp.set !== 'function') {
            return;
        }
        if (readonly && typeof fp.close === 'function') {
            fp.close();
        }
        fp.set('clickOpens', !readonly);
        fp.set('allowInput', !readonly);
        if (fp.altInput) {
            fp.altInput.disabled = readonly;
            fp.altInput.readOnly = readonly;
        }
        if (fp.input) {
            fp.input.disabled = readonly;
            fp.input.readOnly = readonly;
        }
    }

    private syncFlatpickrReadonlyOnInstances(): void {
        setTimeout(() => {
            this.applyFlatpickrReadonlyState(this.documentDateFlatpickr, this.isDateReadonly);
            this.applyFlatpickrReadonlyState(this.dateLivraisonFlatpickr, this.isDateLivReadonly);
        }, 0);
    }

    private tryRestoreFromPreviewData(documentId: number): boolean {
        const preview = this.documentPreviewService.getCurrentPreview();
        if (!preview?.isDraft || !preview?.previewData) return false;
        const data = preview.previewData;
        const previewId = data.id ?? data.document_id;
        if (previewId == null || Number(previewId) !== documentId) return false;
        this.documentId = documentId;
        this.isEditing = true;
        if (preview.documentType) this.documentType = preview.documentType;
        this.loadCurrentTypeDocumentPrefixFromApi();
        this.loadVenteAchatParamForCurrentDocumentType();
        this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
        this.loadTaxes();
        this.loadProjects();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadTvaRates();
        this.loadCategories();
        this.loadStationData();
        // Date tout de suite (évite flatpickr sur « aujourd'hui » pendant le délai du reste du formulaire)
        this.applyPreviewDateFields(data);
        this.cdr.detectChanges();
        setTimeout(() => {
            this.applyPreviewData(data);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }, 500);
        this.updateApproveButtonState();
        this.updateHeaderConfig();
        return true;
    }

    private checkForPreviewData(): void {
        const previewData = this.documentPreviewService.getCurrentPreview();
        if (previewData?.isDraft && previewData?.previewData) {
            if (previewData.documentType) {
                this.documentType = previewData.documentType;
            }
            this.loadCurrentTypeDocumentPrefixFromApi();
            this.loadVenteAchatParamForCurrentDocumentType();
            this.loadDataFromPreview(previewData.previewData);
        }
        // Pas de brouillon : les listes sont chargées une seule fois par l’appelant.
    }

    private loadDataFromPreview(previewData: any): void {
        const previewDocType = previewData.typeDocument?.titre || previewData.documentType;
        if (previewDocType && previewDocType !== this.documentType) {
            const norm = String(previewDocType).trim().toUpperCase();
            const keepTransfertEntrepot =
                this.isLogicielCaisseEntrepotTransfert() &&
                (norm === 'BON TRANSFERT' || norm === 'TRANSFERT');
            if (!keepTransfertEntrepot) {
            this.documentType = previewDocType;
        }
        }
        if (!this.usesLcTransfertNumDocumentReference()) {
        this.loadCurrentTypeDocumentPrefixFromApi();
        }
        this.loadProjects();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadTvaRates();
        this.loadCategories();
        this.applyPreviewDateFields(previewData);
        this.cdr.detectChanges();
        setTimeout(() => {
            this.applyPreviewData(previewData);
            this.cdr.detectChanges();
        }, 1500);
    }

    private applyPreviewData(previewData: any): void {
        try {
            this.refExterne = previewData.ref_externe || previewData.reference || this.documentReference;
            this.documentReference = previewData.reference || previewData.ref_externe || '';
            this.applyPreviewDateFields(previewData);
            this.note = previewData.note || '';
            const isAchat = this.isAchatDocument();
            if (!isAchat && previewData.client_data) {
                this.applyClientData(previewData.client_data);
            } else if (isAchat && previewData.fournisseur_data) {
                this.applyFournisseurData(previewData.fournisseur_data);
            }

            if (previewData.projets && previewData.projets.length > 0) {
                this.selectedProject = previewData.projets[0].titre || previewData.projets[0].libelle || '';
            }
            this.applyItemsData(previewData.lignesDocument || previewData.lignes_document || []);
            this.applyTotalsData(previewData);
            this.applyPreviewEntrepotAndCategorie(previewData);
            setTimeout(() => {
                this.reloadStockQuantitiesForAllProducts();
            }, 1000);
            if (previewData.id) {
                this.documentId = previewData.id;
            }
            this.loadModifiedFields();
            this.updateApproveButtonState();
            this.calculateTotals();
            this.updateHeaderConfig();
            setTimeout(() => {
                this.cdr.detectChanges();
            }, 100);

        } catch (error) {
            this.toastr.error('Erreur lors du chargement des données de l\'aperçu');
        }
    }


    private applyPreviewEntrepotAndCategorie(previewData: any): void {
        if (!previewData || typeof previewData !== 'object') {
            return;
        }
        const type = this.documentType;

        if (type === 'BON TRANSFERT' || type === 'TRANSFERT') {
            const initial = previewData.entrepot_id;
            const dest = previewData.entrepot_dest_id ?? previewData.entrepot_destination_id;
            if (initial != null && initial !== '') {
                const n = Number(initial);
                if (!Number.isNaN(n)) {
                    this.selectedWarehouseInitialId = n;
                }
            }
            if (dest != null && dest !== '') {
                const nd = Number(dest);
                if (!Number.isNaN(nd)) {
                    this.selectedWarehouseDestinationId = nd;
                }
            }
        } else {
            const wid = previewData.entrepot_id;
            if (wid != null && wid !== undefined && wid !== '') {
                const n = Number(wid);
                if (!Number.isNaN(n)) {
                    this.selectedWarehouseId = n;
                }
            }
        }

        if (type === 'FACTURE FOURNISSEUR') {
            let lib: string | null = null;
            const cats = previewData.categories;
            if (Array.isArray(cats) && cats.length > 0) {
                const c0 = cats[0];
                const raw = c0?.libelle ?? c0?.nom ?? c0?.titre;
                lib = raw != null && String(raw).trim() !== '' ? String(raw).trim() : null;
            }
            if (!lib && previewData.categorie_libelle != null && String(previewData.categorie_libelle).trim() !== '') {
                lib = String(previewData.categorie_libelle).trim();
            }
            if (lib) {
                this.selectedCategorie = lib;
            }
        }
    }

    private applyClientData(clientData: any): void {
        if (clientData.id) {
            const foundClient = this.clients.find(c => c.id === clientData.id);
            if (foundClient) {
                this.selectedClient = foundClient;
                this.clientId = foundClient.id;
            } else {
                const foundByName = this.clients.find(c =>
                    this.normalizeString(c.nom_prenom) === this.normalizeString(clientData.nom_client || clientData.nom_prenom)
                );
                if (foundByName) {
                    this.selectedClient = foundByName;
                    this.clientId = foundByName.id;
                } else {
                    this.toastr.warning('Client non trouvé dans la liste. Veuillez le sélectionner à nouveau.');
                    this.selectedClient = null;
                    this.clientId = null;
                }
            }
        } else {
            this.selectedClient = null;
            this.clientId = null;
        }
        this.cdr.detectChanges();
        if (this.selectedClient) {
            setTimeout(() => {
                this.initializeFeatherIcons();
            }, 200);
        }
    }

    private applyFournisseurData(fournisseurData: any): void {
        if (fournisseurData.id) {
            const foundFournisseur = this.fournisseurs.find(f => f.id === fournisseurData.id);
            if (foundFournisseur) {
                this.selectedFournisseur = foundFournisseur;
                this.selectedFournisseurId = foundFournisseur.id;
                this.clientId = foundFournisseur.id;
            } else {
                const foundByName = this.fournisseurs.find(f =>
                    this.normalizeString(f.nom_entreprise) === this.normalizeString(fournisseurData.nom_entreprise)
                );
                if (foundByName) {
                    this.selectedFournisseur = foundByName;
                    this.selectedFournisseurId = foundByName.id;
                    this.clientId = foundByName.id;
                } else {
                    this.toastr.warning('Fournisseur non trouvé dans la liste. Veuillez le sélectionner à nouveau.');
                    this.selectedFournisseur = null;
                    this.selectedFournisseurId = null;
                    this.clientId = null;
                }
            }
        } else {
            this.selectedFournisseur = null;
            this.selectedFournisseurId = null;
            this.clientId = null;
        }
        this.cdr.detectChanges();
    }
    private getTvaValueFromLigne(ligne: any): string {
        if (ligne == null) return '0';
        if (typeof ligne.tva === 'object' && ligne.tva !== null && ligne.tva.valeur != null) {
            const v = Number(ligne.tva.valeur);
            return isNaN(v) ? '0' : String(v);
        }
        if (ligne.tva !== null && ligne.tva !== undefined && ligne.tva !== '') {
            const v = Number(ligne.tva);
            if (!isNaN(v)) return String(v);
        }
        if (ligne.taux_tva !== null && ligne.taux_tva !== undefined && ligne.taux_tva !== '') {
            const v = Number(ligne.taux_tva);
            if (!isNaN(v)) return String(v);
        }
        const tvaId = ligne.tva_id ?? ligne.tvaId;
        if (tvaId != null && this.tvaRates?.length > 0) {
            const found = this.tvaRates.find((t: any) => Number(t.id) === Number(tvaId));
            if (found && found.valeur != null) return String(Number(found.valeur));
        }
        return '0';
    }
    private getTaxIdForPayload(taxe: any): number | null {
        if (!taxe || (taxe.id == null && taxe.taxes_id == null)) return null;
        const rawId = taxe.id ?? taxe.taxes_id;
        if (this.taxes?.length) {
            const found = this.taxes.find((t: any) =>
                t.id === rawId || t.id === Number(rawId) || t.id === String(rawId)
            );
            if (found) return typeof found.id === 'number' ? found.id : Number(found.id);
        }
        const num = Number(rawId);
        return Number.isNaN(num) ? null : num;
    }
    private getTaxObjectForPayload(taxe: any): { id: number; taxes_id: number; nom: string; label: string } | null {
        const taxId = this.getTaxIdForPayload(taxe);
        if (taxId == null) return null;
        const fromList = this.taxes?.find((t: any) => t.id === taxId || t.id === Number(taxId));
        const nom = fromList?.nom ?? taxe.nom ?? '';
        const label = fromList?.label ?? taxe.label ?? taxe.nom ?? '';
        return {
            id: fromList?.id ?? taxId,
            taxes_id: taxId,
            nom: String(nom),
            label: String(label)
        };
    }

    private normalizeTaxFromLigne(taxeApi: any): any {
        if (!taxeApi || typeof taxeApi !== 'object') return null;
        const id = taxeApi.taxes_id != null ? taxeApi.taxes_id : taxeApi.id;
        return {
            id: id,
            taxes_id: taxeApi.taxes_id ?? taxeApi.id,
            nom: taxeApi.nom,
            label: taxeApi.label,
            valeur: taxeApi.valeur,
            valeur_fixe: taxeApi.valeur_fixe,
            valeur_pourcentage: taxeApi.valeur_pourcentage,
            type: taxeApi.type,
            statut: taxeApi.statut,
            applique_avant_tva: taxeApi.applique_avant_tva,
            appliquee_avant_tva: taxeApi.appliquee_avant_tva,
            applique_tva: taxeApi.applique_tva ?? taxeApi.applique_a_la_tva,
            applique_a_la_tva: taxeApi.applique_tva ?? taxeApi.applique_a_la_tva,
            appliquee_a_la_tva: taxeApi.appliquee_a_la_tva,
            taxe_applique_sur_produits: taxeApi.taxe_applique_sur_produits
        };
    }

    private applyItemsData(lignes: any[]): void {
        this.items = [];
        this.pvEcartQtyBreakdownByItemIndex.clear();
        if (this.documentType === 'PV ECART') {
            this.pvEcartLineViewFromLcDetail = false;
            this.pvEcartErpLignesForSave = null;
        }

        lignes.forEach((ligne: any, index: number) => {
            let qntValue: number | undefined;
            if (ligne.qnt === null || ligne.qnt === undefined) {
                qntValue = undefined;
            } else if (typeof ligne.qnt === 'number') {
                qntValue = ligne.qnt;
            } else {
                const parsed = parseFloat(ligne.qnt.toString());
                qntValue = isNaN(parsed) ? undefined : parsed;
            }
            const isStockDoc = this.isStockLcDocumentType();
            const isAchat = this.isAchatDocument();
            const unitPrice = this.documentUsesErpPrixUnitairesCatalog()
                ? parseFloat(ligne.prix_achat) ||
                  parseFloat(ligne.prix_ht) ||
                  parseFloat(ligne.valeur_unitaire) ||
                  0
                : isStockDoc
                  ? this.resolveStockLcUnitPriceFromLigne(ligne)
                : isAchat
                    ? (parseFloat(ligne.prix_achat) || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0)
                    : (parseFloat(ligne.prix_vente) || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0);
            const qte = (qntValue !== null && qntValue !== undefined ? qntValue : 0);
            const remisePct = parseFloat(ligne.remise) || 0;
            const htBrutLigne = qte * unitPrice;
            const montantRemiseLigne = remisePct > 0 ? htBrutLigne * (remisePct / 100) : 0;
            const htNetLigne = (parseFloat(ligne.total_ht) != null && !isNaN(parseFloat(ligne.total_ht)))
                ? parseFloat(ligne.total_ht)
                : (htBrutLigne - montantRemiseLigne);

            const prixHtFromApi = parseFloat(ligne.prix_ht);
            const valeurUnitaireFromLigne = parseFloat(ligne.valeur_unitaire);
            const ligneVariantCt = this.extractCouleurTailleFromProductLike(ligne);
            const productItem: Item = {
            type: 'product' as const,
            designation: ligne.libelle || '',
            quantity: qntValue,
            priceHT: unitPrice,
            prixUnitaireRef: !isStockDoc && !isNaN(prixHtFromApi) ? prixHtFromApi : undefined,
            valeur_unitaire: isStockDoc ? unitPrice : (valeurUnitaireFromLigne || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0),
            tva: this.getTvaValueFromLigne(ligne),
                totalHT: +(htNetLigne.toFixed(3)),
                htNet: +(htNetLigne.toFixed(3)),
                product_id: ligne.product_id || null,
                reference: ligne.ref_interne || ligne.reference || '-',
                code_barre:
                    ligne.code_barre != null && String(ligne.code_barre).trim() !== ''
                        ? String(ligne.code_barre).trim()
                        : ligne.code_bar != null && String(ligne.code_bar).trim() !== ''
                          ? String(ligne.code_bar).trim()
                          : '',
                remise: ligne.remise || 0,
                couleur: ligneVariantCt.couleur,
                taille: ligneVariantCt.taille,
                ajout_ligne: ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne) ? ligne.ajout_ligne.map((al: any) => ({
                    contenu_text: al.contenu_text || '',
                    rubrique: al.rubrique || '',
                    separateur: al.separateur || false,
                    sous_total: Number(al.sous_total) || 0,
                    order: Number(al.order) || 0
                })) : []
            };
            (productItem as any).ref_interne = ligne.ref_interne ?? ligne.reference ?? null;
            (productItem as any).ref_fabricant = ligne.ref_fabricant ?? ligne.ref_fabriquant ?? null;
            
            const itemIndex = this.items.length;
            this.items.push(productItem);
            if (this.documentType === 'PV ECART') {
                const breakdown = buildPvEcartQtyBreakdownFromErpLigne(ligne);
                if (breakdown) {
                    this.pvEcartQtyBreakdownByItemIndex.set(itemIndex, breakdown);
                }
            }
            if (ligne.taxe != null && typeof ligne.taxe === 'object') {
                const taxArray = Array.isArray(ligne.taxe) ? ligne.taxe : [ligne.taxe];
                const normalized = taxArray
                    .map((t: any) => this.normalizeTaxFromLigne(t))
                    .filter((t: any) => t != null);
                productItem['taxesProduit'] = normalized;
                productItem['fodecApplique'] = normalized.some((t: any) =>
                    t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')
                );
            } else if (ligne.taxe_id != null && this.taxes?.length) {
                const tid = Array.isArray(ligne.taxe_id) ? ligne.taxe_id[0] : ligne.taxe_id;
                const found = this.taxes.find((t: any) => t.id === tid || t.id === Number(tid));
                productItem['taxesProduit'] = found ? [found] : [];
                productItem['fodecApplique'] = found ? (found.nom?.toLowerCase().includes('fodec') || found.label?.toLowerCase().includes('fodec')) : false;
            } else {
                productItem['taxesProduit'] = [];
                productItem['fodecApplique'] = false;
            }
            if (ligne.description) {
                this.productDescriptions[itemIndex] = ligne.description;
            } else {

                this.productDescriptions[itemIndex] = '';
            }

            this.showProductDescription[itemIndex] = this.isVenteAchatAffCourteDesp();

            if (ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne) && ligne.ajout_ligne.length > 0) {
                const sortedAjoutLignes = [...ligne.ajout_ligne].sort((a: any, b: any) => 
                    (Number(a.order) || 0) - (Number(b.order) || 0)
                );
                
                sortedAjoutLignes.forEach((al: any) => {

                    if (al.separateur === true || al.separateur === 1) {
                        this.items.push({ type: 'separator' });
                    }
                    else if (al.sous_total !== null && al.sous_total !== undefined && Number(al.sous_total) > 0) {
                        this.items.push({ 
                            type: 'subtotal', 
                            subTotal: Number(al.sous_total) 
                        });
                    }
                    else if (al.rubrique !== null && al.rubrique !== undefined && String(al.rubrique).trim()) {
                        this.items.push({ 
                            type: 'heading', 
                            content: String(al.rubrique) 
                        });
                    }
                    else if (al.contenu_text !== null && al.contenu_text !== undefined && String(al.contenu_text).trim()) {
                        this.items.push({ 
                            type: 'text', 
                            content: String(al.contenu_text) 
                        });
                    }
                });

                productItem.ajout_ligne = [];
            }
        });
        this.rebuildProductsForDocumentSelect();
        this.expandedBarcodeGroups.clear();
        this.expandedCouleurGroups.clear();
        this.barcodeGroupLoaded.clear();
        this.barcodeGroupLoading = {};
        this.syncBarcodePickerModelForVisibleProductLines();
        this.items.forEach((it, idx) => {
            if (it?.type !== 'product' || !it.product_id || !this.isProductLineVisible(idx)) {
                return;
            }
            if (!this.showQuantiteDisponibleColumn()) {
                return;
            }
            setTimeout(() => {
                this.ensureStockLoadedForProductLineAggregate(idx);
            }, 100 * (idx + 1));
        });
    }
    
    private ensureAvoirLinesNegated(): void {
        const productItems = this.items.filter(i => i.type === 'product');
        const hasPositiveLines = productItems.some(i => (Number(i.quantity) || 0) > 0 || (Number(i.priceHT) || 0) > 0);
        const needLoadOriginal = this.documentOriginalId && (productItems.length === 0 || hasPositiveLines);

        if (needLoadOriginal && this.documentOriginalId) {
            this.documentService.getDocumentById(this.documentOriginalId).subscribe({
                next: (res: any) => {
                    const originalDoc = res?.data?.document ?? res?.data ?? res;
                    const lignes = Array.isArray(originalDoc.lignesDocument) ? originalDoc.lignesDocument : [];
                    const negatedLignes = lignes.map((l: any) => ({
                        ...l,
                        qnt: -(Number(l.qnt) || 0),
                        prix_ht: -(Number(l.prix_ht) || Number(l.result_ht) || 0),
                        result_ht: -(Number(l.result_ht) || Number(l.prix_ht) || 0),
                        valeur_unitaire: -(Number(l.valeur_unitaire) || Number(l.result_ht) || Number(l.prix_ht) || 0),
                        prix_vente: -(Number(l.prix_vente) || Number(l.prix_ht) || Number(l.result_ht) || 0),
                        prix_achat: -(Number(l.prix_achat) || Number(l.prix_ht) || Number(l.result_ht) || 0)
                    }));
                    this.applyItemsData(negatedLignes);
                    this.calculateTotals();
                    this.cdr.detectChanges();
                },
                error: () => { this.negateAvoirLinesInPlace(); }
            });
        } else {
            this.negateAvoirLinesInPlace();
        }
    }
    private negateAvoirLinesInPlace(): void {
        this.items.forEach((item, i) => {
            if (item.type !== 'product') return;
            const q = Number(item.quantity);
            const p = Number(item.priceHT) || 0;
            const v = Number(item.valeur_unitaire) || 0;
            if (q > 0) item.quantity = -q;
            if (p > 0) {
                item.priceHT = -p;
                item.valeur_unitaire = item.valeur_unitaire != null && Number(item.valeur_unitaire) > 0 ? -Number(item.valeur_unitaire) : -p;
            } else if (v > 0) item.valeur_unitaire = -v;
        });
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    private applyTotalsData(previewData: any): void {
        const Total_TTC = Number(previewData.total_ttc) || 0;
        const Base_RS = Total_TTC;
        const Taux_RS = previewData.Taux_RS || '0';
        const tauxRSDecimal = parseFloat(Taux_RS) / 100;
        const RS = Base_RS * tauxRSDecimal;
        const Net_à_payer = Total_TTC - RS;
        const timbreFiscal = this.isAvoirDocument() ? 0 : (Number(previewData.timbre_fiscal) || 0);
        
        this.totals = {
            totalHT: Number(previewData.total_ht) || 0,
            totalTVA: Number(previewData.total_tva) || 0,
            totalTTC: Total_TTC,
            totalRemise: Number(previewData.total_remise) || 0,
            totalTaxesAvantTVA: 0,
            totalBaseTVA: Number(previewData.total_ht) || 0,
            totalTaxesApresTVA: 0,
            retenueSource: RS,
            netAPayer: Net_à_payer + timbreFiscal,
            timbreFiscal: timbreFiscal,
            Base_RS: Base_RS,
            Taux_RS: Taux_RS,
            RS: RS,
            Net_à_payer: Net_à_payer,
            documentLevelTaxLines: [],
            documentLevelTaxesTotal: 0,
            taxesAfterHT: [],
            taxesAfterTTC: [],
            taxesAfterTimbre: []
        };
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            feather.replace();
            this.cdr.detectChanges();
            this.syncFlatpickrReadonlyOnInstances();
            setTimeout(() => {
                this.initializeFeatherIcons();
            }, 100);
        }, 300);
    }

    private initializeFeatherIcons(): void {
        if (this.iconInitializationTimeout) {
            clearTimeout(this.iconInitializationTimeout);
        }

        this.iconInitializationTimeout = setTimeout(() => {
            requestAnimationFrame(() => {
                const container = document.querySelector('app-document');
                if (!container) {
                    setTimeout(() => this.initializeFeatherIcons(), 100);
                    return;
                }

                if (container.querySelector('i[data-feather]')) {
                    feather.replace();
                }

                this.cdr.markForCheck();
                this.cdr.detectChanges();
            });
        }, 50);
    }

    private replaceFeatherIconsNow(): void {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const container = document.querySelector('app-document') as HTMLElement | null;
                if (container?.querySelector('i[data-feather], span[data-feather]')) {
                    feather.replace({}, container);
                }
                this.cdr.markForCheck();
            });
        });
    }

    loadFournisseurs(fournisseurIdToSelect?: number): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingFournisseurs = false;
            this.fournisseurs = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingFournisseurs = true;
        this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.fournisseurs = response.data || [];
                this.isLoadingFournisseurs = false;

                if (fournisseurIdToSelect !== undefined) {
                    const fournisseurToSelect = this.fournisseurs.find(f => f.id === fournisseurIdToSelect);
                    if (fournisseurToSelect) {
                        this.selectedFournisseur = fournisseurToSelect;
                        this.selectedFournisseurId = fournisseurIdToSelect;
                        this.clientId = fournisseurIdToSelect;

                        if (this.mode === 'add' || !this.documentId) {
                            this.modifiedClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            this.modifiedFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                        } else {
                            this.loadModifiedFields();
                        }
                        
                        this.loadProjects();
                        this.updateApproveButtonState();
                    }
                }

                this.cdr.detectChanges();
            },
            error: (err) => {
                this.isLoadingFournisseurs = false;
                this.fournisseurs = [];
                this.toastr.error('Erreur lors du chargement des fournisseurs.', 'Erreur');
                this.cdr.detectChanges();
            }
        });
    }

    loadProjects(): void {
        if (!this.stationId) {
            this.toastr.warning('Station non trouvée pour charger les projets.');
            this.projects = [];
            this.isLoadingProjects = false;
            return;
        }

        this.isLoadingProjects = true;
        this.projetService.getProjectsByIdStation(this.stationId).subscribe({
            next: (response: any) => {
                this.zone.run(() => {
                    const rawProjects = Array.isArray(response)
                        ? response
                        : (response?.projectsListe || response?.data || []);

                    this.projects = rawProjects.filter((p: any) => p.statut === true);
                    this.isLoadingProjects = false;
                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.zone.run(() => {
                    this.isLoadingProjects = false;
                    this.projects = [];
                    this.toastr.error('Erreur lors du chargement des projets.');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    loadWarehouses(selectWarehouseIdAfterLoad?: number | null): void {
        // Entrepôts depuis backend-logiciel-caisse (pas ERP).
        // BON TRANSFERT : entrepôts station LC avec is_globale = true
        //   GET /api/entrepots/entrepot/:station_id
        // Autres docs : is_globale + user/station
        //   GET /api/entrepots/entrepot/all?user_id=&station_id=
        const isBonTransfert = this.usesStationGlobaleEntrepotList();
        this.isLoadingWarehouses = true;
        console.log('[Document][loadWarehouses] start', {
            documentType: this.documentType,
            isBonTransfert,
            selectWarehouseIdAfterLoad,
            isReady: this.lcAuth.isReadyForNavigation?.(),
            lcUserId: this.lcAuth.getBackUserId?.(),
            lcStationId: this.lcAuth.getBackStationId?.(),
            erpContext: this.lcAuth.getErpContext?.() ?? null,
        });

        const applyList = (warehouses: any[]) => {
            console.log('[Document][loadWarehouses] applyList reçu', {
                count: Array.isArray(warehouses) ? warehouses.length : null,
                sample: (warehouses || []).slice(0, 5),
            });
            this.enrichLcWarehousesWithErpMapping(warehouses || []).subscribe({
                next: (enriched) => {
                    const enrichedList = enriched || [];
                    if (isBonTransfert) {
                        this.allWarehousesEnrichedFull = enrichedList;
                        this.allWarehouses = this.filterWarehousesIsGlobaleOnly(enrichedList);
                    } else {
                        this.allWarehousesEnrichedFull = [];
                        this.allWarehouses = this.filterWarehousesIsGlobaleOnly(enrichedList);
                    }
                    this.isLoadingWarehouses = false;
                    this.applyEntrepotEstablishmentFilter();
                    this.afterWarehousesEnriched(selectWarehouseIdAfterLoad);
                },
                error: () => {
                    const list = warehouses || [];
                    if (isBonTransfert) {
                        this.allWarehousesEnrichedFull = list;
                        this.allWarehouses = this.filterWarehousesIsGlobaleOnly(list);
                    } else {
                        this.allWarehousesEnrichedFull = [];
                        this.allWarehouses = this.filterWarehousesIsGlobaleOnly(list);
                    }
                    this.isLoadingWarehouses = false;
                    this.applyEntrepotEstablishmentFilter();
                    this.afterWarehousesEnriched(selectWarehouseIdAfterLoad);
                }
            });
        };

        const onFetchError = (err: any) => {
                        console.error('[Document][loadWarehouses] erreur subscribe', err);
                        this.allWarehouses = [];
                        this.warehouses = [];
                        this.isLoadingWarehouses = false;
                        this.toastr.error(
                            err?.message || 'Erreur lors du chargement des entrepôts',
                            'Erreur'
                        );
                        this.cdr.detectChanges();
        };

        const fetchLcWarehouses = () => {
            if (isBonTransfert) {
                console.log(
                    '[Document][loadWarehouses] BON TRANSFERT → station LC filtrée is_globale'
                );
                this.lcEntrepotService.listForDocumentSelectByStation().subscribe({
                    next: (warehouses) => applyList(warehouses),
                    error: onFetchError,
                });
                return;
            }

            const fetchWithLcIds = (userId: number, stationId: number) => {
                console.log('[Document][loadWarehouses] fetchWithLcIds', {
                    userId,
                    stationId,
                    source: 'back_logiciel_caisse',
                });
                this.lcEntrepotService.listForDocumentSelectByUserAndStation(userId, stationId).subscribe({
                    next: (warehouses) => applyList(warehouses),
                    error: onFetchError,
                });
            };

            // IDs back caisse uniquement — jamais erpUserId / erpStationId en query
            const lcUserId = this.lcAuth.getBackUserId();
            const lcStationId = this.lcAuth.getBackStationId();
            if (lcUserId && lcStationId) {
                fetchWithLcIds(lcUserId, lcStationId);
                return;
            }

            const erp = this.lcAuth.getErpContext?.() ?? null;
            if (!erp?.erpUserId || !(erp.erpStationId > 0)) {
                console.warn('[Document][loadWarehouses] aucun user_id/station_id back caisse → liste vide');
                this.allWarehouses = [];
                this.warehouses = [];
                this.isLoadingWarehouses = false;
                this.toastr.warning(
                    'Impossible de résoudre user_id / station_id back caisse pour les entrepôts.',
                    'Entrepôts'
                );
                this.cdr.detectChanges();
                return;
            }

            this.coordinationService.resolve(erp.erpUserId, erp.erpStationId).subscribe({
                next: (coord) => {
                    if (coord?.user_id_logiciel && coord?.station_id_logiciel) {
                        fetchWithLcIds(coord.user_id_logiciel, coord.station_id_logiciel);
                        return;
                    }
                    console.warn('[Document][loadWarehouses] coordination sans mapping LC → liste vide');
                    this.allWarehouses = [];
                    this.warehouses = [];
                    this.isLoadingWarehouses = false;
                    this.toastr.warning(
                        'Impossible de résoudre user_id / station_id back caisse pour les entrepôts.',
                        'Entrepôts'
                    );
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.error('[Document][loadWarehouses] coordination erreur', err);
                    this.allWarehouses = [];
                    this.warehouses = [];
                    this.isLoadingWarehouses = false;
                    this.cdr.detectChanges();
                }
            });
        };

        if (this.lcAuth.getBackUserId() && this.lcAuth.getBackStationId()) {
            console.log('[Document][loadWarehouses] IDs back caisse disponibles → fetch direct');
            fetchLcWarehouses();
            return;
        }

        console.log('[Document][loadWarehouses] bootstrap LC puis fetch');
        this.lcAuth.bootstrap().pipe(catchError(() => of(null as any))).subscribe({
            next: (status) => {
                console.log('[Document][loadWarehouses] bootstrap next', status);
                fetchLcWarehouses();
            },
            error: (err) => {
                console.error('[Document][loadWarehouses] bootstrap error', err);
                fetchLcWarehouses();
            }
        });
    }

    /**
     * Persiste l'ID ERP dans documents.entrepot_id et l'ID LC dans hidden_fournisseur_fields.
     */
    /** ID établissement logiciel caisse pour `documents.etablissement_id` (POST ERP). */
    private resolvePayloadEtablissementId(): number | null {
        const n = Number(this.selectedEtablissementId);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    private applyLogicielCaisseEntrepotToPayload(payload: any): void {
        if (!payload || typeof payload !== 'object') {
            return;
        }
        const etabId = this.resolvePayloadEtablissementId();
        if (etabId != null) {
            payload.etablissement_id = etabId;
        }
        const selected = this.usesDualEntrepotSelection()
                ? this.selectedWarehouseInitialId
                : this.selectedWarehouseId;
        const erpId = this.resolveErpEntrepotIdFromSelection(selected);
        const lcId = this.resolveLcEntrepotIdFromSelection(selected);

        if (this.usesDualEntrepotSelection()) {
            const erpSrc = this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseInitialId);
            const erpDst = this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
            payload.entrepot_id = erpSrc;
            payload.entrepot_dest_id = erpDst;
        } else if (erpId != null) {
            payload.entrepot_id = erpId;
        } else if (this.selectedWarehouseId != null) {
            payload.entrepot_id = null;
        }

        let hidden: any = payload.hidden_fournisseur_fields;
        if (typeof hidden === 'string') {
            try {
                hidden = JSON.parse(hidden);
            } catch {
                hidden = {};
            }
        }
        if (!hidden || typeof hidden !== 'object') {
            hidden = {};
        }
        if (lcId != null) {
            hidden[LC_ENTREPOT_HIDDEN_KEY] = lcId;
        }
        if (this.usesDualEntrepotSelection()) {
            const lcDest = this.resolveLcEntrepotIdFromSelection(
                this.selectedWarehouseDestinationId
            );
            if (lcDest != null) {
                hidden[LC_ENTREPOT_DEST_HIDDEN_KEY] = lcDest;
            }
        }
        if (this.isBonSortieDocument() && this.selectedEtablissementDestId != null) {
            hidden[LC_ETABLISSEMENT_DEST_HIDDEN_KEY] = Number(this.selectedEtablissementDestId);
        }
        if (this.isBonLivraisonDocument()) {
            payload.hidden_fournisseur_fields = mergeBonSortieTransportIntoHiddenFournisseur(
                hidden,
                this.bonSortieTransport
            );
        } else {
        payload.hidden_fournisseur_fields = hidden;
        }
    }

    private applyBonSortieTransportFromDoc(doc: any): void {
        if (!this.isBonLivraisonDocument()) {
            this.bonSortieTransport = emptyBonSortieTransportInfo();
            return;
        }
        this.bonSortieTransport = parseBonSortieTransportInfoFromDoc(doc);
    }

    /**
     * Charge les liens établissement ↔ entrepôt depuis l'API logiciel caisse
     * (GET /api/entrepots/etablissement-entrepots/station/:station_id) puis applique le filtrage.
     * Mis en cache : un seul appel réseau, sauf `force`.
     */
    private loadEtablissementEntrepotLinks(force = false): void {
        if (!this.lcAuth.getBackStationId()) {
            this.etablissementEntrepotLinks = [];
            this.etablissementLinksLoaded = true;
            this.applyEntrepotEstablishmentFilter();
            return;
        }
        if (this.etablissementLinksLoaded && !force) {
            this.applyEntrepotEstablishmentFilter();
            return;
        }
        this.lcAssociations.listEtablissementEntrepotLinks().subscribe({
            next: (links) => {
                this.etablissementEntrepotLinks = Array.isArray(links) ? links : [];
                this.etablissementLinksLoaded = true;
                this.applyEntrepotEstablishmentFilter();
                if (this.usesPvEcartEntrepotLcDisplayLogic()) {
                    this.reapplyPvEcartEntrepotDisplayAfterFilter();
                    this.logPvEcartEntrepot('liens établissement chargés — réapplication entrepôts', {
                        linksCount: this.etablissementEntrepotLinks?.length ?? 0,
                    });
                } else if (this.selectedWarehouseDestinationId != null) {
                    this.refreshWarehouseDestinationPanel();
                }
            },
            error: () => {
                this.etablissementEntrepotLinks = [];
                this.etablissementLinksLoaded = true;
                this.applyEntrepotEstablishmentFilter();
                this.logPvEcartEntrepot('liens établissement — erreur, filtre appliqué', {});
            },
        });
    }

    /**
     * Documents : n’afficher que les entrepôts marqués is_globale.
     */
    private isWarehouseIsGlobale(w: any): boolean {
        return w?.is_globale === true || Number(w?.is_globale) === 1;
    }

    private filterWarehousesIsGlobaleOnly(list: any[]): any[] {
        return (list || []).filter((w) => this.isWarehouseIsGlobale(w));
    }

    /** ID établissement LC pour filtrer les entrepôts (header station / établissement). */
    private resolveEtablissementIdForEntrepotFilter(): number | null {
        const fromField = Number(this.selectedEtablissementId);
        if (Number.isFinite(fromField) && fromField > 0) {
            return fromField;
        }
        const key = String(this.selectedOrgKey ?? '');
        if (key.startsWith('etab:')) {
            const fromKey = Number(key.slice(5));
            if (Number.isFinite(fromKey) && fromKey > 0) {
                return fromKey;
            }
        }
        const opt =
            this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) ?? null;
        if (opt?.type === 'etablissement') {
            const fromOpt = Number(opt.id);
            if (Number.isFinite(fromOpt) && fromOpt > 0) {
                return fromOpt;
            }
        }
        return null;
    }

    private warehouseMatchesLinkedEntrepotIds(w: any, linkedLcEntrepotIds: Set<number>): boolean {
        if (!linkedLcEntrepotIds.size) {
            return false;
        }
        const candidates = [
            Number(w?.lc_id),
            Number(w?.id),
            Number(w?.erp_id),
            Number(w?.erp_entrepot_id),
        ].filter((n) => Number.isFinite(n) && n > 0);
        return candidates.some((n) => linkedLcEntrepotIds.has(n));
    }

    /**
     * Restreint la liste `warehouses` aux entrepôts reliés à l'établissement sélectionné
     * (`selectedEtablissementId`). Sans établissement LC (station ERP) ou tant que les liens
     * ne sont pas chargés, la liste (déjà filtrée is_globale) est affichée.
     */
    private filterWarehousesByLinkedEtablissement(
        etabId: number | null | undefined,
        options?: { pool?: any[]; fallbackAll?: any[]; noFallbackWhenEtabSelected?: boolean }
    ): any[] {
        const pool = options?.pool ?? this.allWarehouses;
        const etab = etabId != null ? Number(etabId) : NaN;
        if (!Number.isFinite(etab) || etab <= 0 || !this.etablissementLinksLoaded) {
            return [...pool];
        }
        const linkedIds = new Set(
            (this.etablissementEntrepotLinks || [])
                .filter((l) => Number(l.etablissement_id) === etab)
                .map((l) => Number(l.entrepot_id))
                .filter((n) => Number.isFinite(n) && n > 0)
        );
        const filtered = pool.filter((w: any) =>
            this.warehouseMatchesLinkedEntrepotIds(w, linkedIds)
        );
        if (filtered.length > 0) {
            return filtered;
        }
        if (options?.noFallbackWhenEtabSelected) {
            return [];
        }
        if (options?.fallbackAll?.length) {
            return [...options.fallbackAll];
        }
        return [...pool];
    }

    /** Pool entrepôts pour le ng-select destination (dual entrepôt). */
    private getDestinationWarehousePool(): any[] {
        return this.allWarehousesEnrichedFull.length > 0
            ? [...this.allWarehousesEnrichedFull]
            : [...this.allWarehouses];
    }

    /** Entrepôt destination : entrepôts liés à l'établissement du header (station ou établissement LC). */
    private applyFilteredDestinationWarehouses(): void {
        if (!this.usesDualEntrepotSelection()) {
            return;
        }
        const destPool = this.getDestinationWarehousePool();
        const etabId = this.resolveEtablissementIdForEntrepotFilter();
        this.warehousesDestination = this.filterWarehousesByLinkedEtablissement(etabId, {
            pool: destPool,
            fallbackAll: etabId == null ? destPool : undefined,
            noFallbackWhenEtabSelected: etabId != null,
        });
    }

    private applyEntrepotEstablishmentFilter(): void {
        if (this.isBonSortieDocument()) {
            this.warehouses = [...this.allWarehouses];
            this.applyFilteredDestinationWarehouses();
            this.ensureSelectedWarehouseValid();
            return;
        }
        // BON TRANSFERT : initial = is_globale ; destination filtrée par établissement header
        if (this.isBonTransfertOrEntrepotTransfert()) {
            this.warehouses = [...this.allWarehouses];
            this.applyFilteredDestinationWarehouses();
            this.ensureSelectedWarehouseValid();
            return;
        }
        if (this.usesPvEcartEntrepotLcDisplayLogic()) {
            this.warehouses = [...this.allWarehouses];
            this.applyFilteredDestinationWarehouses();
            this.ensureSelectedWarehouseValid();
            this.reapplyPvEcartEntrepotDisplayAfterFilter();
            return;
        }
        const etabId = this.resolveEtablissementIdForEntrepotFilter();
        if (!etabId || etabId <= 0 || !this.etablissementLinksLoaded) {
            this.warehouses = [...this.allWarehouses];
            this.applyFilteredDestinationWarehouses();
            this.ensureSelectedWarehouseValid();
            return;
        }
        const filtered = this.filterWarehousesByLinkedEtablissement(etabId, {
            pool: this.allWarehouses,
            fallbackAll: this.allWarehouses,
        });
        this.warehouses = filtered;
        this.applyFilteredDestinationWarehouses();
        this.ensureSelectedWarehouseValid();
    }

    private logPvEcartEntrepot(phase: string, detail: Record<string, unknown>): void {
        if (!DEBUG_PV_ECART_ENTREPOT || this.documentType !== 'PV ECART') {
            return;
        }
        console.info(`[Document][PV ECART][Entrepôt] ${phase}`, {
            documentId: this.documentId,
            selectedWarehouseInitialId: this.selectedWarehouseInitialId,
            selectedWarehouseDestinationId: this.selectedWarehouseDestinationId,
            warehousesCount: this.warehouses?.length ?? 0,
            warehousesDestinationCount: this.warehousesDestination?.length ?? 0,
            lcReady: this.lcAuth.isReadyForNavigation?.() ?? false,
            warehouseDestinationDetailId:
                this.warehouseDestinationDetail?.['id'] ??
                this.warehouseDestinationDetail?.['lc_id'] ??
                null,
            ...detail,
        });
    }

    /** Réinitialise l'entrepôt sélectionné s'il ne fait plus partie de la liste filtrée. */
    private ensureSelectedWarehouseValid(): void {
        if (this.isAvoirWarehouseLocked()) {
            this.cdr.detectChanges();
            return;
        }
        if (
            this.logicielCaisseTransfertEditId &&
            (this.isLoadingWarehouses ||
                (this.warehouses.length === 0 && this.pendingLcTransfertWarehouseDepId != null))
        ) {
            return;
        }
        const inList = (id: number | null | undefined) =>
            id != null &&
            this.warehouses.some(
                (w: any) =>
                    Number(w?.id) === Number(id) ||
                    Number(w?.lc_id) === Number(id) ||
                    Number(w?.erp_id) === Number(id)
            );
        if (this.usesDualEntrepotSelection()) {
            // PV / transfert depuis PV : ids LC hors listes filtrées (affichage via GET LC).
            if (this.usesPvEcartEntrepotLcDisplayLogic()) {
                this.cdr.detectChanges();
                return;
            }
            const inDestList = (id: number | null | undefined) =>
                id != null &&
                this.warehousesDestination.some(
                    (w: any) =>
                        Number(w?.id) === Number(id) ||
                        Number(w?.lc_id) === Number(id) ||
                        Number(w?.erp_id) === Number(id)
                );
            let changed = false;
            if (this.selectedWarehouseInitialId != null && !inList(this.selectedWarehouseInitialId)) {
                this.logPvEcartEntrepot('ensureSelectedWarehouseValid — initial retiré (hors liste filtrée)', {
                    idRetire: this.selectedWarehouseInitialId,
                });
                this.selectedWarehouseInitialId = null;
                changed = true;
            }
            if (
                this.selectedWarehouseDestinationId != null &&
                !inDestList(this.selectedWarehouseDestinationId)
            ) {
                this.logPvEcartEntrepot(
                    'ensureSelectedWarehouseValid — destination retirée (hors liste filtrée)',
                    {
                        idRetire: this.selectedWarehouseDestinationId,
                        idsListeDestination: (this.warehousesDestination || []).map((w: any) => ({
                            id: w?.id,
                            lc_id: w?.lc_id,
                            erp_id: w?.erp_id,
                        })),
                    }
                );
                this.selectedWarehouseDestinationId = null;
                changed = true;
            }
            if (changed) {
                this.refreshWarehouseDestinationPanel();
                this.onWarehouseChange();
            }
            this.cdr.detectChanges();
            return;
        }
        if (
            this.selectedWarehouseId != null &&
            !this.warehouses.some((w: any) => Number(w?.id) === Number(this.selectedWarehouseId))
        ) {
            this.selectedWarehouseId = null;
            this.onWarehouseChange();
        }
        this.cdr.detectChanges();
    }

    private afterWarehousesEnriched(selectWarehouseIdAfterLoad?: number | null): void {
        console.log('[Document][loadWarehouses] après mapping LC↔ERP', {
            allWarehouses: this.allWarehouses?.length,
            warehouses: this.warehouses?.length,
            mapped: (this.allWarehouses || []).filter((w: any) => w?.erp_id).length,
            selectedEtablissementId: this.selectedEtablissementId,
        });
        const wid = selectWarehouseIdAfterLoad != null ? Number(selectWarehouseIdAfterLoad) : null;
        if (wid != null && !Number.isNaN(wid)) {
            const exists = this.warehouses.some(
                (w: any) =>
                    Number(w?.id) === wid ||
                    Number(w?.lc_id) === wid ||
                    Number(w?.erp_id) === wid
            );
            if (exists) {
                const row = this.warehouses.find(
                    (w: any) =>
                        Number(w?.id) === wid ||
                        Number(w?.lc_id) === wid ||
                        Number(w?.erp_id) === wid
                );
                const selectId = Number(row?.lc_id ?? row?.id ?? wid);
                if (this.usesDualEntrepotSelection()) {
                    if (this.warehouseModalTarget === 'destination') {
                        this.selectedWarehouseDestinationId = selectId;
                        this.refreshWarehouseDestinationPanel();
                    } else {
                        this.selectedWarehouseInitialId = selectId;
                    }
                } else {
                    this.selectedWarehouseId = selectId;
                }
                this.onWarehouseChange();
            }
        }
        if (
            !(
                this.logicielCaisseTransfertFromPvEcart &&
                this.pvEcartSourceDocumentId &&
                !this.logicielCaisseTransfertEditId
            )
        ) {
            this.applyPendingLcTransfertWarehouseSelection();
        }
        if (this.usesPvEcartEntrepotLcDisplayLogic()) {
            this.reapplyPvEcartEntrepotDisplayAfterFilter();
        } else {
            this.refreshWarehouseDestinationPanel();
        }
        this.loadEtablissementEntrepotLinks();
        this.cdr.detectChanges();
    }

    private resolveWarehouseSelectIdFromLists(
        rawId: number | null | undefined,
        lists: any[][]
    ): number | null {
        const id = Number(rawId);
        if (!Number.isFinite(id) || id <= 0) {
            return null;
        }
        for (const list of lists) {
            const row = (list || []).find(
                (w: any) =>
                    Number(w?.id) === id ||
                    Number(w?.lc_id) === id ||
                    Number(w?.erp_id) === id
            );
            if (row) {
                const resolved = Number(row.lc_id ?? row.id ?? id);
                return Number.isFinite(resolved) && resolved > 0 ? resolved : id;
            }
        }
        return id;
    }

    /** Réapplique départ / destination après chargement liste entrepôts (réédition LC). */
    private applyPendingLcTransfertWarehouseSelection(): void {
        if (
            this.logicielCaisseTransfertFromPvEcart &&
            this.pvEcartSourceDocumentId != null &&
            this.pvEcartSourceDocumentId > 0 &&
            !this.logicielCaisseTransfertEditId
        ) {
            return;
        }
        if (!this.logicielCaisseTransfertEditId) {
            return;
        }
        const depRaw = this.pendingLcTransfertWarehouseDepId ?? this.selectedWarehouseInitialId;
        const destRaw = this.pendingLcTransfertWarehouseDestId ?? this.selectedWarehouseDestinationId;
        const dep = this.resolveWarehouseSelectIdFromLists(depRaw, [
            this.warehouses,
            this.allWarehouses,
            this.allWarehousesEnrichedFull,
        ]);
        const dest = this.resolveWarehouseSelectIdFromLists(destRaw, [
            this.warehousesDestination,
            this.allWarehousesEnrichedFull,
            this.allWarehouses,
        ]);
        let changed = false;
        if (dep != null && this.selectedWarehouseInitialId !== dep) {
            this.selectedWarehouseInitialId = dep;
            changed = true;
        }
        if (dest != null && this.selectedWarehouseDestinationId !== dest) {
            this.selectedWarehouseDestinationId = dest;
            changed = true;
        }
        if (changed) {
            this.onWarehouseChange();
        } else if (this.logicielCaisseTransfertEditId) {
            this.scheduleLcTransfertEditStockRefresh(0);
        }
    }

    private scheduleLogicielCaisseTransfertDocumentEditLoad(lcId: number): void {
        if (this.lcTransfertEditLoadTimer != null) {
            clearTimeout(this.lcTransfertEditLoadTimer);
        }
        this.lcTransfertEditLoadTimer = setTimeout(() => {
            this.lcTransfertEditLoadTimer = null;
            this.loadLogicielCaisseTransfertForDocumentEdit(lcId);
        }, 0);
    }

    /** Regroupe les rafraîchissements stock (entrepôts + produits + lignes LC). */
    private scheduleLcTransfertEditStockRefresh(delayMs = 80): void {
        if (!this.logicielCaisseTransfertEditId || !this.isLogicielCaisseEntrepotTransfert()) {
            return;
        }
        if (this.lcTransfertStockRefreshTimer != null) {
            clearTimeout(this.lcTransfertStockRefreshTimer);
        }
        this.lcTransfertStockRefreshTimer = setTimeout(() => {
            this.lcTransfertStockRefreshTimer = null;
            this.refreshStockAfterLcTransfertEdit(0);
        }, delayMs);
    }

    private loadErpBonTransfertHiddenEntrepotsForLcEdit(erpDocId: number): void {
        this.documentService.getDocumentById(erpDocId).subscribe({
            next: (res) => {
                const doc = res?.data?.document ?? res?.data ?? res;
                if (!doc) {
                    return;
                }
                let hidden: any = doc.hidden_fournisseur_fields;
                if (typeof hidden === 'string') {
                    try {
                        hidden = JSON.parse(hidden);
                    } catch {
                        hidden = null;
                    }
                }
                if (hidden && typeof hidden === 'object') {
                    const hDep = Number(hidden[LC_ENTREPOT_HIDDEN_KEY]);
                    const hDest = Number(hidden[LC_ENTREPOT_DEST_HIDDEN_KEY]);
                    if (Number.isFinite(hDep) && hDep > 0 && this.pendingLcTransfertWarehouseDepId == null) {
                        this.pendingLcTransfertWarehouseDepId = hDep;
                    }
                    if (Number.isFinite(hDest) && hDest > 0 && this.pendingLcTransfertWarehouseDestId == null) {
                        this.pendingLcTransfertWarehouseDestId = hDest;
                    }
                }
                const erpDep = Number(doc.entrepot_id);
                const erpDest = Number(doc.entrepot_dest_id ?? doc.entrepot_destination_id);
                if (Number.isFinite(erpDep) && erpDep > 0 && this.pendingLcTransfertWarehouseDepId == null) {
                    this.pendingLcTransfertWarehouseDepId = erpDep;
                }
                if (Number.isFinite(erpDest) && erpDest > 0 && this.pendingLcTransfertWarehouseDestId == null) {
                    this.pendingLcTransfertWarehouseDestId = erpDest;
                }
                this.applyPendingLcTransfertWarehouseSelection();
                this.cdr.detectChanges();
            },
            error: () => {},
        });
    }

    private extractWarehouseIdFromSaveResponse(res: any): number | null {
        if (res == null || typeof res !== 'object') {
            return null;
        }
        // Création duale : préférer l'id LC pour le select (liste = LC).
        const raw =
            res.lc_entrepot?.id ??
            res.id ??
            res.data?.id ??
            res.entrepot?.id ??
            res.warehouse?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    }

    /**
     * Charge tous les produits actifs de la station (pagination), pour le ng-select désignation.
     * Évite le plafond page=1&limit=100 qui masquait une partie du catalogue.
     */
    private fetchAllActiveProductsByStation(stationId: number, pageSize: number = 1000): Observable<any[]> {
        const fetchPage = (page: number, acc: any[]): Observable<any[]> =>
            this.productsService.getActiveProductsByStationId(stationId, page, pageSize).pipe(
                switchMap((response: any) => {
                    const pageRows: any[] = Array.isArray(response?.data)
                        ? response.data
                        : Array.isArray(response?.products)
                            ? response.products
                            : [];
                    const nextAcc = pageRows.length ? [...acc, ...pageRows] : acc;
                    const totalPages =
                        response?.meta?.pages ??
                        response?.meta?.nb_total_pages ??
                        Math.max(
                            1,
                            Math.ceil(((response?.meta?.total ?? nextAcc.length) || 1) / pageSize)
                        );
                    if (pageRows.length > 0 && page < totalPages) {
                        return fetchPage(page + 1, nextAcc);
                    }
                    return of(nextAcc);
                })
            );
        return fetchPage(1, []);
    }

    private mapApiProductForDocumentSelect(apiProduct: any): any {
        const prixUnitairesParse = parseFloat(apiProduct.prix_unitaires) || 0;
        const valeurUnitaireParse = parseFloat(apiProduct.valeur_unitaire) || 0;
        const venteHtParse = parseFloat(apiProduct.vente_ht) || 0;
        const prixVenteParse = parseFloat(apiProduct.prix_vente) || venteHtParse || 0;
        const refFab = this.extractRefFabricantFromProductLike(apiProduct);
        return {
            ...apiProduct,
            ref_fabricant: refFab || apiProduct.ref_fabricant,
            prix_unitaires: prixUnitairesParse,
            valeur_unitaire: valeurUnitaireParse,
            vente_ht: venteHtParse,
            prix_vente: prixVenteParse,
            liste_prix: Array.isArray(apiProduct.liste_prix) && apiProduct.liste_prix.length > 0
                ? apiProduct.liste_prix[0]
                : null,
            informations_logistique: apiProduct.informations_logistique || []
        };
    }

    private extractRefFabricantFromProductLike(p: any): string {
        return this.normalizeRefFabricantForSelect(
            p?.ref_fabricant ??
                p?.ref_fabriquant ??
                p?.reference_fabricant ??
                p?.reference_fabriquant ??
                p?.ref_fabricant_fournisseur
        );
    }

    loadProducts(): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingProducts = false;
            this.products = [];
            this.invalidateBarcodePickerItemsCache();
            this.rebuildProductsForDocumentSelect();
            this.cdr.markForCheck();
            return;
        }

        this.isLoadingProducts = true;
        this.fetchAllActiveProductsByStation(this.stationId).subscribe({
            next: (allProducts) => {
                this.zone.run(() => {
                    this.products = (allProducts || []).map((p) => this.mapApiProductForDocumentSelect(p));
                    this.invalidateBarcodePickerItemsCache();
                    this.rebuildProductsForDocumentSelect();
                    this.syncBarcodePickerModelForVisibleProductLines();
                    this.isLoadingProducts = false;
                    this.cdr.markForCheck();
                    this.preloadStockQuantitiesForAllProducts();
                    if (this.logicielCaisseTransfertEditId) {
                        this.enrichStockLcDocumentLinesAfterLoad();
                        this.scheduleLcTransfertEditStockRefresh(120);
                    }
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingProducts = false;
                    this.products = [];
                    this.invalidateBarcodePickerItemsCache();
                    this.rebuildProductsForDocumentSelect();
                    this.toastr.error('Erreur lors du chargement des produits.', 'Erreur');
                    this.cdr.markForCheck();
                });
            }
        });

    }

    private isBarcodeEmptyOrZeroForSelect(p: any): boolean {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return true;
        }
        const s = String(c).trim();
        if (s === '' || s === '0') {
            return true;
        }
        const n = Number(s.replace(',', '.'));
        return !Number.isNaN(n) && n === 0;
    }

    private normalizeRefFabricantForSelect(raw: any): string {
        if (raw == null) {
            return '';
        }
        return String(raw).trim();
    }

    /** Comparaison ref. fabricant (insensible à la casse / espaces). */
    private refFabricantKeyForGrouping(raw: any): string {
        return this.normalizeRefFabricantForSelect(raw).toLowerCase();
    }

    private refFabricantKeysMatch(refA: string, refB: string): boolean {
        const a = this.refFabricantKeyForGrouping(refA);
        const b = this.refFabricantKeyForGrouping(refB);
        return a !== '' && a === b;
    }

    private mergeVariantGroupProducts(...groups: Array<Product[] | undefined | null>): Product[] {
        const byId = new Map<number, Product>();
        for (const group of groups) {
            for (const p of group || []) {
                const id = p?.id != null ? Number(p.id) : NaN;
                if (Number.isFinite(id) && id > 0) {
                    byId.set(id, p);
                }
            }
        }
        return Array.from(byId.values());
    }


    /** Liste ng-select désignation : uniquement produits avec ref. fabricant renseignée. */
    private productHasRefFabricantForSelect(p: Product | any): boolean {
        return !!this.extractRefFabricantFromProductLike(p);
    }

    compareDesignationProductById = (a: unknown, b: unknown): boolean => {
        const na = a != null && a !== '' ? Number(a) : NaN;
        const nb = b != null && b !== '' ? Number(b) : NaN;
        return Number.isFinite(na) && Number.isFinite(nb) && na === nb;
    };

    private filterProductsWithRefFabricantForSelect(list: Product[]): Product[] {
        return (list || []).filter((p) => this.productHasRefFabricantForSelect(p));
    }

    private pickPrimaryInRefFabGroupForSelect(group: Product[]): Product {
        const zeros = group.filter((p) => this.isBarcodeEmptyOrZeroForSelect(p));
        if (zeros.length > 0) {
            return zeros[0];
        }
        return group[0];
    }

    private computePrimaryRefFabProductList(products: Product[]): Product[] {
        if (!products?.length) {
            return [];
        }
        const byRef = new Map<string, Product[]>();
        for (const p of products) {
            const ref = this.refFabricantKeyForGrouping(this.extractRefFabricantFromProductLike(p));
            if (!ref) {
                continue;
            }
            if (!byRef.has(ref)) {
                byRef.set(ref, []);
            }
            byRef.get(ref)!.push(p);
        }
        const primaryIds = new Set<number>();
        for (const [, group] of byRef) {
            const primary = this.pickPrimaryInRefFabGroupForSelect(group);
            if (primary?.id != null) {
                primaryIds.add(Number(primary.id));
            }
        }
        return products.filter(
            (p) =>
                p.id != null &&
                primaryIds.has(Number(p.id)) &&
                this.productHasRefFabricantForSelect(p)
        );
    }

    rebuildProductsForDocumentSelect(): void {
        const base = this.computePrimaryRefFabProductList(this.products);
        const ids = new Set(
            base.map((p) => p.id).filter((id): id is number => id != null && !Number.isNaN(Number(id)))
        );
        const extra: Product[] = [];
        for (const it of this.items) {
            if (it.type !== 'product' || !it.product_id) {
                continue;
            }
            const pid = Number(it.product_id);
            if (ids.has(pid)) {
                continue;
            }
            const p = this.products.find((pr) => Number(pr.id) === pid);
            if (p && this.productHasRefFabricantForSelect(p)) {
                extra.push(p);
                ids.add(pid);
            }
        }
        this.productsForDocumentSelect = this.filterProductsWithRefFabricantForSelect([
            ...base,
            ...extra,
        ]);
        this.preloadSelectStockTotalsForDocumentOptions();
    }

    private getRefFabGroupProductsForStock(p: Product | null | undefined): Product[] {
        if (!p) {
            return [];
        }
        const ref = this.normalizeRefFabricantForSelect(
            (p as any).ref_fabricant ?? (p as any).ref_fabriquant
        );
        if (!ref) {
            return p.id != null ? [p] : [];
        }
        const fromCatalog = (this.products || []).filter(
            (x) =>
                this.normalizeRefFabricantForSelect(
                    (x as any).ref_fabricant ?? (x as any).ref_fabriquant
                ) === ref
        );
        if (
            p.id != null &&
            !fromCatalog.some((x) => x?.id != null && Number(x.id) === Number(p.id))
        ) {
            return [...fromCatalog, p];
        }
        return fromCatalog.length > 0 ? fromCatalog : p.id != null ? [p] : [];
    }

    private selectOptionStockByCacheKey = new Map<string, number>();
    private selectOptionStockLoadingKeys = new Set<string>();

    /**
     * Entrepôts LC pour filtrer gestion-globale.
     * Entrepôt sélectionné → stock de cet entrepôt ; sinon → stock global (tous entrepôts).
     */
    private getLcEntrepotIdsForGestionGlobale(): number[] | undefined {
        if (!this.shouldFilterStockByEntrepot()) {
            return undefined;
        }
        const selected = this.isBonTransfertOrEntrepotTransfert()
                ? this.selectedWarehouseInitialId
                : this.selectedWarehouseId;
        const fromDoc = getLcEntrepotIdFromDocument({
            hidden_fournisseur_fields: this.modifiedFournisseurFields,
            entrepot_id: selected,
        });
        if (fromDoc != null) {
            return [fromDoc];
        }
        const lcId = this.resolveLcEntrepotIdFromSelection(selected);
        return lcId != null ? [lcId] : undefined;
    }

    private buildLcStockMetaFromProduct(
        product: Product | any | null | undefined,
        fallbackId?: number,
        fallbackRef?: string
    ): {
        id: number;
        code_barre?: string | null;
        ref_interne?: string | null;
        ref_fabricant?: string | null;
    } | null {
        const id = Number(product?.id ?? fallbackId);
        if (!Number.isFinite(id) || id <= 0) {
            return null;
        }
        const p = product as any;
        return {
            id,
            code_barre: p?.code_barre ?? p?.code_bar ?? null,
            ref_interne: p?.ref_interne ?? p?.reference ?? fallbackRef ?? null,
            ref_fabricant: p?.ref_fabricant ?? p?.ref_fabriquant ?? null,
        };
    }

    private findProductForLcStockMeta(productId: number, refInterne?: string): Product | any | null {
        const pools = [this.products, this.productsForDocumentSelect, this.variantModalFullGroup];
        for (const pool of pools) {
            const hit = (pool || []).find((p: any) => p?.id != null && Number(p.id) === Number(productId));
            if (hit) {
                return hit;
            }
        }
        if (refInterne) {
            return { id: productId, ref_interne: refInterne } as any;
        }
        return { id: productId } as any;
    }

    private getSelectOptionStockCacheKey(productId: number): string {
        return this.getStockCacheKey(productId, this.getEntrepotIdForStockQuantityCache());
    }

    private fetchSelectOptionStockQuantity(productId: number): Observable<number> {
        const product = this.findProductForLcStockMeta(productId);
        const meta = this.buildLcStockMetaFromProduct(product, productId);
        if (!meta) {
            return of(0);
        }
        return this.lcStockGestion
            .getStockGlobaleByErpProducts([meta], {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .pipe(
                map((rec) =>
                    pickLcGlobaleStockQtyForDocumentType(this.documentType, rec[productId])
                ),
                catchError(() => of(0))
            );
    }

    /** Id entrepôt pour la clé de cache stock (LC pour transfert / inventaire). */
    private getEntrepotIdForStockQuantityCache(): number | null {
        if (!this.shouldFilterStockByEntrepot()) {
            return null;
        }
        if (
            this.isBonTransfertOrEntrepotTransfert() ||
            this.documentType === 'INVENTAIRE' ||
            this.documentType === 'BON DE SORTIE'
        ) {
            const ids = this.getLcEntrepotIdsForGestionGlobale();
            return ids?.length ? ids[0] : null;
        }
        return this.getEntrepotIdForStockQuantity();
    }

    private usesLogicielCaisseStockApi(): boolean {
        return (
            this.isStockLcDocumentType() ||
            (environment as { currentModule?: string }).currentModule === 'gestion_stock'
            );
    }

    private ensureSelectOptionStockTotalLoaded(productId: number): void {
        const cacheKey = this.getSelectOptionStockCacheKey(productId);
        if (this.selectOptionStockByCacheKey.has(cacheKey)) {
            return;
        }
        if (this.selectOptionStockLoadingKeys.has(cacheKey)) {
            return;
        }
        this.selectOptionStockLoadingKeys.add(cacheKey);
        this.fetchSelectOptionStockQuantity(productId).subscribe({
            next: (q) => {
                const n = Number.isFinite(q) ? q : 0;
                this.selectOptionStockByCacheKey.set(cacheKey, n);
                this.selectOptionStockLoadingKeys.delete(cacheKey);
                this.cdr.detectChanges();
            },
            error: () => {
                this.selectOptionStockByCacheKey.set(cacheKey, 0);
                this.selectOptionStockLoadingKeys.delete(cacheKey);
                this.cdr.detectChanges();
            }
        });
    }

    getSelectOptionTotalStockDisplay(item: Product | null | undefined): number {
        if (item == null) {
            return 0;
        }
        const group = this.getRefFabGroupProductsForStock(item);
        let sum = 0;
        for (const pr of group) {
            if (pr?.id == null || this.isBarcodeEmptyOrZeroForSelect(pr)) {
                continue;
            }
            const id = Number(pr.id);
            if (!Number.isFinite(id)) {
                continue;
            }
            this.ensureSelectOptionStockTotalLoaded(id);
            const key = this.getSelectOptionStockCacheKey(id);
            const q = this.selectOptionStockByCacheKey.get(key);
            if (q !== undefined) {
                sum += q;
            }
        }
        // Produit simple sans code-barres : charger quand même via réf. interne.
        if (sum === 0 && group.length === 1 && item.id != null) {
            const id = Number(item.id);
            if (Number.isFinite(id)) {
                this.ensureSelectOptionStockTotalLoaded(id);
                const key = this.getSelectOptionStockCacheKey(id);
                const q = this.selectOptionStockByCacheKey.get(key);
                if (q !== undefined) {
                    return q;
                }
            }
        }
        return sum;
    }

    getSelectOptionStockStatus(item: Product | null | undefined): string {
        return this.getSelectOptionTotalStockDisplay(item) > 0 ? 'En stock' : 'En rupture';
    }

    private preloadSelectStockTotalsForDocumentOptions(): void {
        const ids = new Set<number>();
        const metas: Array<{
            id: number;
            code_barre?: string | null;
            ref_interne?: string | null;
            ref_fabricant?: string | null;
        }> = [];
        for (const item of this.productsForDocumentSelect || []) {
            for (const p of this.getRefFabGroupProductsForStock(item)) {
                if (p?.id == null || !Number.isFinite(Number(p.id))) {
                    continue;
                }
                const id = Number(p.id);
                if (ids.has(id)) {
                    continue;
                }
                const key = this.getSelectOptionStockCacheKey(id);
                if (
                    this.selectOptionStockByCacheKey.has(key) ||
                    this.selectOptionStockLoadingKeys.has(key)
                ) {
                    continue;
                }
                ids.add(id);
                const meta = this.buildLcStockMetaFromProduct(p, id);
                if (meta) {
                    metas.push(meta);
                    this.selectOptionStockLoadingKeys.add(key);
                }
            }
        }
        if (!metas.length) {
            return;
        }
        this.lcStockGestion
            .getStockGlobaleByErpProducts(metas, {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .subscribe({
                next: (rec) => {
                    for (const meta of metas) {
                        const key = this.getSelectOptionStockCacheKey(meta.id);
                        const qty = pickLcGlobaleStockQtyForDocumentType(
                            this.documentType,
                            rec[meta.id]
                        );
                        this.selectOptionStockByCacheKey.set(key, qty);
                        this.selectOptionStockLoadingKeys.delete(key);
                    }
                    this.cdr.detectChanges();
                },
                error: () => {
                    for (const meta of metas) {
                        const key = this.getSelectOptionStockCacheKey(meta.id);
                        this.selectOptionStockByCacheKey.set(key, 0);
                        this.selectOptionStockLoadingKeys.delete(key);
                    }
                    this.cdr.detectChanges();
                },
            });
    }

    private preloadStockQuantitiesForAllProducts(): void {
        const productsToLoad = this.products.filter(
            (p) => p.id !== undefined && p.id !== null
        );
        if (!productsToLoad.length) {
            return;
        }

        // BON TRANSFERT / inventaire / module gestion stock → back logiciel-caisse uniquement
        if (this.usesLogicielCaisseStockApi()) {
            const metas: Array<{
                id: number;
                code_barre?: string | null;
                ref_interne?: string | null;
                ref_fabricant?: string | null;
            }> = [];
            for (const product of productsToLoad) {
                const meta = this.buildLcStockMetaFromProduct(product, Number(product.id));
                if (meta) {
                    metas.push(meta);
                }
            }
            if (!metas.length) {
                return;
            }
            const entrepotId = this.getEntrepotIdForStockQuantityCache();
            this.lcStockGestion
                .getStockGlobaleByErpProducts(metas, {
                    entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
                })
                .subscribe({
                    next: (rec) => {
                        for (const meta of metas) {
                            const quantity = pickLcGlobaleStockQtyForDocumentType(
                                this.documentType,
                                rec[meta.id]
                            );
                            const cacheKey = this.getStockCacheKey(meta.id, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, quantity);
                            const prod = this.products.find((p) => Number(p.id) === meta.id);
                            if (prod) {
                                (prod as any).availableQuantity = quantity;
                            }
                        }
                        this.cdr.detectChanges();
                    },
                    error: () => {
                        for (const meta of metas) {
                            const cacheKey = this.getStockCacheKey(meta.id, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            const prod = this.products.find((p) => Number(p.id) === meta.id);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                        }
                        this.cdr.detectChanges();
                    },
                });
            return;
        }

        const shouldFilterByEntrepot = this.shouldFilterStockByEntrepot();
        const entrepotId = shouldFilterByEntrepot ? this.getEntrepotIdForStockQuantity() : null;
        
        let loadedCount = 0;
        productsToLoad.forEach((product, index) => {
            const productId = product.id!;
            setTimeout(() => {
                this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                    next: (stockDetails: any) => {
                        if (!stockDetails) {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            const prod = this.products.find((p) => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            loadedCount++;
                            if (loadedCount === productsToLoad.length) {
                                this.cdr.detectChanges();
                            }
                            return;
                        }
                        
                        let quantity = 0;
                        
                        if (shouldFilterByEntrepot && entrepotId) {
                            const stockByEntrepot = stockDetails.stocks_by_entrepot?.find(
                                (stock: any) => stock.entrepot_id === entrepotId
                            );
                            if (stockByEntrepot) {
                                quantity = Number(stockByEntrepot.quantity || 0);
                            } else {
                                quantity = 0;
                            }
                        } else {
                            quantity = Number(stockDetails.total_quantity || 0);
                        }
                        
                        const cacheKey = this.getStockCacheKey(productId, entrepotId);
                        this.stockQuantitiesCache.set(cacheKey, quantity);
                        const prod = this.products.find((p) => p.id === productId);
                        if (prod) {
                            (prod as any).availableQuantity = quantity;
                        }
                        loadedCount++;
                        
                        if (loadedCount === productsToLoad.length) {
                            this.cdr.detectChanges();
                        }
                    },
                    error: () => {
                        loadedCount++;
                        const cacheKey = this.getStockCacheKey(productId, entrepotId);
                        this.stockQuantitiesCache.set(cacheKey, 0);
                        const prod = this.products.find((p) => p.id === productId);
                        if (prod) {
                            (prod as any).availableQuantity = 0;
                        }
                        if (loadedCount === productsToLoad.length) {
                            this.cdr.detectChanges();
                        }
                    },
                });
            }, index * 50);
        });
    }

    private isAppliqueSurTousDocumentsTax(tax: any): boolean {
        const v = tax?.applique_sur_tous_document;
        if (v === false || v === 0 || v === '0') {
            return false;
        }
        return true;
    }

    private readonly documentTypesVente = new Set([
        'DEVIS',
        'COMMANDE CLIENT',
        'FACTURE',
        'BON DE LIVRAISON',
        'AVOIR'
    ]);

    private readonly documentTypesAchat = new Set([
        'COMMANDE FOURNISSEUR',
        'BON RECEPTION',
        'FACTURE FOURNISSEUR',
        'AVOIR FOURNISSEUR',
        'RETOUR FOURNISSEUR',
    ]);

    private getNormalizedDocumentTypeForTax(): string {
        return (this.documentType || '').toString().trim().toUpperCase();
    }

    /** Nouveau transfert entrepôt (logiciel caisse), distinct du bon de transfert ERP. */
    isLogicielCaisseEntrepotTransfert(): boolean {
        if (this.documentType === 'TRANSFERT') {
            return true;
        }
        const url = String(this.router.url || '').toLowerCase();
        return url.includes('/transfert-entrepot/nouveau');
    }

    /** Entrepôts LC via GET API (PV d'écart ou transfert ouvert depuis un PV validé). */
    private usesPvEcartEntrepotLcDisplayLogic(): boolean {
        return (
            this.documentType === 'PV ECART' ||
            (this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert())
        );
    }

    isBonTransfertOrEntrepotTransfert(): boolean {
        if (this.documentType === 'BON TRANSFERT' || this.documentType === 'TRANSFERT') {
            return true;
        }
        const url = String(this.router.url || '').toLowerCase();
        return (
            url.includes('/stock/bon-transfert/') ||
            url.includes('/bon-transfert/') ||
            url.includes('/transfert-entrepot/nouveau')
        );
    }

    /** Entrepôt initial + destination (bon transfert, transfert entrepôt, bon de sortie, PV d'écart). */
    usesDualEntrepotSelection(): boolean {
        return (
            this.isBonTransfertOrEntrepotTransfert() ||
            this.isBonSortieDocument() ||
            this.documentType === 'PV ECART'
        );
    }

    /** Bon de transfert ERP (type 16) — distinct du transfert entrepôt logiciel caisse. */
    isErpBonTransfertDocument(): boolean {
        return this.documentType === 'BON TRANSFERT';
    }

    /** Bon transfert ERP : PU catalogue LC local (pas d’API ERP calculate-valeur-unitaire). */
    private erpBonTransfertUsesLocalUnitPriceOnly(): boolean {
        return this.isErpBonTransfertDocument() && !this.isLogicielCaisseEntrepotTransfert();
    }

    isStockLcDocumentType(): boolean {
        if (this.isLogicielCaisseEntrepotTransfert()) {
            return true;
        }
        return pdfIsStockLcDocumentType(normalizeDocumentTypeTitreRaw(this.documentType));
    }

    /** Bon réception / PV d’écart : PU catalogue ERP (prix_unitaires → achat_ht). */
    private documentUsesErpPrixUnitairesCatalog(): boolean {
        return this.documentType === 'BON RECEPTION' || this.documentType === 'PV ECART';
    }

    /** PU HT stock LC — aligné LogicielCaisseTransfertDetailComponent (catalogue prix_vente). */
    private parseStockLcUnitPrice(raw: unknown): number {
        if (raw == null || raw === '') {
            return 0;
        }
        const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'));
        return Number.isFinite(n) && n > 0 ? n : 0;
    }

    private resolveStockLcUnitPriceFromProductLike(product: any): number {
        if (!product || typeof product !== 'object') {
            return 0;
        }
        const directKeys = [
            'prix_vente',
            'vente_ht',
            'prix_unitaires',
            'result_ht',
            'prix_ht',
            'valeur_unitaire',
        ];
        for (const key of directKeys) {
            const n = this.parseStockLcUnitPrice(product[key]);
            if (n > 0) {
                return n;
            }
        }
        const liste = product.liste_prix;
        const listeHt =
            Array.isArray(liste) && liste.length > 0
                ? liste[0]?.result_ht
                : liste?.result_ht;
        const fromListe = this.parseStockLcUnitPrice(listeHt);
        if (fromListe > 0) {
            return fromListe;
        }
        return 0;
    }

    private resolveStockLcUnitPriceFromLigne(ligne: any): number {
        if (!ligne) {
            return 0;
        }
        const keys = ['valeur_unitaire', 'prix_vente', 'vente_ht', 'prix_ht', 'result_ht', 'prix_unitaires'];
        for (const key of keys) {
            const n = this.parseStockLcUnitPrice(ligne[key]);
            if (n > 0) {
                return n;
            }
        }
        const qnt = parseFloat(String(ligne?.qnt ?? 0)) || 0;
        if (qnt > 0) {
            const lineHt = this.parseStockLcUnitPrice(ligne?.total_ht);
            if (lineHt > 0) {
                return lineHt / qnt;
            }
        }
        return 0;
    }

    private applyStockLcUnitPriceToItemFromProduct(index: number, product: any): void {
        if (!this.isStockLcDocumentType()) {
            return;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        let unit = 0;
        if (this.documentUsesErpPrixUnitairesCatalog()) {
            unit = resolveErpProductPrixUnitaireAchat(product);
        } else {
            const current = Number(item.valeur_unitaire) || 0;
            unit = current > 0 ? current : this.resolveStockLcUnitPriceFromProductLike(product);
        }
        if (unit <= 0) {
            return;
        }
        item.valeur_unitaire = unit;
        item.priceHT = unit;
        item.prixUnitaireRef = unit;
        this.calculateLine(index);
    }

    private backfillStockLcUnitPricesFromCatalog(): void {
        if (!this.isStockLcDocumentType()) {
            return;
        }
        this.items.forEach((item, index) => {
            if (item.type !== 'product' || !item.product_id) {
                return;
            }
            if ((Number(item.valeur_unitaire) || 0) > 0) {
                return;
            }
            const fromList = this.products.find((p) => Number(p.id) === Number(item.product_id));
            if (fromList) {
                this.applyStockLcUnitPriceToItemFromProduct(index, fromList);
            }
        });
        this.calculateTotals();
    }

    /** Complète le PU depuis la fiche produit si le catalogue liste / ligne sont vides. */
    private hydrateStockLcUnitPricesFromProductDetails(): void {
        if (!this.isStockLcDocumentType()) {
            return;
        }
        this.items.forEach((item, index) => {
            if (item.type !== 'product' || !item.product_id) {
                return;
            }
            if (
                !this.documentUsesErpPrixUnitairesCatalog() &&
                (Number(item.valeur_unitaire) || 0) > 0
            ) {
                return;
            }
            this.productsService.getDetailsProduct(item.product_id).subscribe({
                next: (p: any) => {
                    this.applyStockLcUnitPriceToItemFromProduct(index, p.data || p);
                    this.calculateTotals();
                    this.cdr.markForCheck();
                },
                error: () => {},
            });
        });
    }

    private findProductIdForStockLineItem(item: any): number | null {
        if (!item) {
            return null;
        }
        const cb = String(item.code_barre ?? '').trim();
        if (cb && cb !== '0' && cb !== '--') {
            const byCb = (this.products || []).find((p: any) => {
                const xcb = String(p?.code_barre ?? p?.code_bar ?? '').trim();
                return xcb === cb;
            });
            if (byCb?.id != null) {
                return Number(byCb.id);
            }
        }
        const ref = String(item.reference ?? item.ref_interne ?? '').trim();
        if (ref && ref !== '-' && ref !== '--') {
            const refL = ref.toLowerCase();
            const byRef = (this.products || []).find((p: any) => {
                const ri = String(p?.ref_interne ?? p?.reference ?? p?.sku ?? p?.code_article ?? '')
                    .trim()
                    .toLowerCase();
                return ri !== '' && ri === refL;
            });
            if (byRef?.id != null) {
                return Number(byRef.id);
            }
        }
        return null;
    }

    /** Aligne product_id catalogue / code-barres (lignes chargées depuis un transfert LC). */
    private reconcileStockLcLineProductIdsFromCatalog(): void {
        if (!this.isStockLcDocumentType()) {
            return;
        }
        this.items.forEach((item) => {
            if (item.type !== 'product') {
                return;
            }
            const fromCatalog = this.findProductIdForStockLineItem(item);
            if (fromCatalog) {
                item.product_id = fromCatalog;
                return;
            }
            const pid = Number(item.product_id);
            if (!Number.isFinite(pid) || pid <= 0) {
                item.product_id = null;
                return;
            }
            const cb = String(item.code_barre ?? '').trim();
            if (!cb || cb === '0') {
                return;
            }
            const inCatalog = (this.products || []).some((p: any) => Number(p?.id) === pid);
            if (!inCatalog) {
                item.product_id = null;
            }
        });
    }

    private lineNeedsBarcodeProductIdHydrate(item: Item): boolean {
        if (item.type !== 'product') {
            return false;
        }
        const cb = String(item.code_barre ?? '').trim();
        if (!cb || cb === '0') {
            return false;
        }
        if (!item.product_id) {
            return true;
        }
        const pid = Number(item.product_id);
        const p = (this.products || []).find((x: any) => Number(x?.id) === pid);
        if (!p) {
            return true;
        }
        const prodLike = p as { code_barre?: string | null; code_bar?: string | null };
        const pcb = String(prodLike.code_barre ?? prodLike.code_bar ?? '').trim();
        return pcb !== cb;
    }

    /** Résout product_id via API code-barres (lignes issues d’un transfert LC → bon transfert). */
    private hydrateStockLcLineProductIdsByBarcode(): Observable<void> {
        if (!this.isStockLcDocumentType()) {
            return of(undefined);
        }
        const userId = this.readUserIdFromLocalStorage();
        if (!userId || !this.stationId) {
            return of(undefined);
        }
        const tasks: Observable<{ index: number; product: any } | null>[] = [];
        this.items.forEach((item, index) => {
            if (item.type !== 'product' || !this.lineNeedsBarcodeProductIdHydrate(item)) {
                return;
            }
            const cb = String(item.code_barre ?? '').trim();
            if (!cb || cb === '0') {
                return;
            }
            tasks.push(
                this.productsService.getProductsByCodeBarre(cb, this.stationId, userId).pipe(
                    map((res: any) => {
                        const raw = Array.isArray(res) ? res : res?.data ?? res?.products ?? res?.items ?? [];
                        const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
                        const first = list[0];
                        const p = first?.data ?? first?.product ?? first;
                        if (!p?.id) {
                            return null;
                        }
                        return { index, product: p };
                    }),
                    catchError(() => of(null))
                )
            );
        });
        if (!tasks.length) {
            return of(undefined);
        }
        return forkJoin(tasks).pipe(
            map((results) => {
                for (const row of results) {
                    if (!row?.product?.id) {
                        continue;
                    }
                    const mapped = this.mapApiProductForDocumentSelect(row.product);
                    const item = this.items[row.index];
                    if (!item || item.type !== 'product') {
                        continue;
                    }
                    item.product_id = mapped.id;
                    this.applyStockLcUnitPriceToItemFromProduct(row.index, mapped);
                }
                this.calculateTotals();
            }),
            map(() => undefined)
        );
    }

    /**
     * Après chargement / conversion (ex. transfert entrepôt → bon transfert → bon de sortie) :
     * entrepôt LC, product_id, prix HT, quantités dispo.
     */
    private enrichStockLcDocumentLinesAfterLoad(sourceDoc?: any): void {
        if (!this.isStockLcDocumentType()) {
            return;
        }
        if (sourceDoc) {
            this.applySourceWarehouseFromDoc(sourceDoc);
        }
        this.reconcileStockLcLineProductIdsFromCatalog();
        this.items.forEach((item, index) => {
            if (item.type !== 'product') {
                return;
            }
            if (!item.product_id) {
                const pid = this.findProductIdForStockLineItem(item);
                if (pid) {
                    item.product_id = pid;
                }
            }
            const pu = Number(item.priceHT) || Number(item.valeur_unitaire) || 0;
            if (item.product_id && pu <= 0) {
                const prod = this.products.find((p) => Number(p.id) === Number(item.product_id));
                if (prod) {
                    this.applyStockLcUnitPriceToItemFromProduct(index, prod);
                }
            }
        });
        this.backfillStockLcUnitPricesFromCatalog();
        this.hydrateStockLcUnitPricesFromProductDetails();
        this.lcAuth
            .ensureAuthenticatedSession()
            .pipe(
                switchMap(() => this.hydrateStockLcLineProductIdsByBarcode()),
                catchError(() => this.hydrateStockLcLineProductIdsByBarcode())
            )
            .subscribe(() => {
                this.scheduleLcTransfertEditStockRefresh(0);
                this.calculateTotals();
                this.cdr.markForCheck();
            });
    }

    /**
     * Réédition transfert (remise en brouillon) : recharge les quantités dispo dès que
     * entrepôt départ + product_id lignes sont prêts (sans supprimer/réajouter les lignes).
     */
    private refreshStockAfterLcTransfertEdit(retry = 0): void {
        if (!this.logicielCaisseTransfertEditId || !this.isLogicielCaisseEntrepotTransfert()) {
            return;
        }
        const dep = Number(this.selectedWarehouseInitialId);
        if (!Number.isFinite(dep) || dep <= 0) {
            if (retry < 30) {
                setTimeout(() => this.refreshStockAfterLcTransfertEdit(retry + 1), 150);
            }
            return;
        }

        this.reconcileStockLcLineProductIdsFromCatalog();
        let needsBarcodeHydrate = false;
        this.items.forEach((item) => {
            if (item.type !== 'product') {
                return;
            }
            item.stockResolved = false;
            item.availableQuantity = undefined;
            if (!item.product_id) {
                const pid = this.findProductIdForStockLineItem(item);
                if (pid) {
                    item.product_id = pid;
                } else if (this.lineNeedsBarcodeProductIdHydrate(item)) {
                    needsBarcodeHydrate = true;
                }
            } else if (this.lineNeedsBarcodeProductIdHydrate(item)) {
                needsBarcodeHydrate = true;
            }
        });

        const runReload = () => {
            this.stockQuantitiesCache.clear();
            this.stockQuantitiesLoadingKeys.clear();
            this.selectOptionStockByCacheKey.clear();
            this.selectOptionStockLoadingKeys.clear();
            this.reloadStockQuantitiesForAllProducts();
            this.items.forEach((it, idx) => {
                if (it?.type === 'product' && it.product_id && this.isProductLineVisible(idx)) {
                    this.ensureStockLoadedForProductLineAggregate(idx);
                }
            });
            this.cdr.detectChanges();
        };

        if (needsBarcodeHydrate && retry < 12) {
            this.lcAuth
                .ensureAuthenticatedSession()
                .pipe(
                    switchMap(() => this.hydrateStockLcLineProductIdsByBarcode()),
                    catchError(() => this.hydrateStockLcLineProductIdsByBarcode())
                )
                .subscribe({
                    next: () => {
                        runReload();
                        const stillMissing = this.items.some(
                            (it) =>
                                it.type === 'product' &&
                                !it.product_id &&
                                String(it.code_barre ?? '').trim()
                        );
                        if (stillMissing) {
                            setTimeout(() => this.refreshStockAfterLcTransfertEdit(retry + 1), 250);
                        }
                    },
                    error: () => runReload(),
                });
            return;
        }

        runReload();
        const missingAfter = this.items.some(
            (it) => it.type === 'product' && !it.product_id && String(it.code_barre ?? '').trim()
        );
        if (missingAfter && retry < 12) {
            setTimeout(() => this.refreshStockAfterLcTransfertEdit(retry + 1), 300);
        }
    }

    /** Liste entrepôts LC « globale » (bon transfert, bon de sortie). */
    private usesStationGlobaleEntrepotList(): boolean {
        return this.isBonTransfertOrEntrepotTransfert() || this.documentType === 'BON DE SORTIE';
    }

    /** Colonne code à barres (réglage `reference` / `référence` du paramétrage document). */
    showDocumentBarcodeColumn(): boolean {
        if (this.isStockLcDocumentType()) {
            return true;
        }
        const v = this.documentColumnSettings?.reference ?? this.documentColumnSettings?.référence;
        return v === true || v === 1 || v === '1' || v === 'true';
    }

    getHeaderDocumentTypeLabel(): string {
        if (this.documentType === 'BON RECEPTION') {
            return 'Bon de réception';
        }
        if (this.isLogicielCaisseEntrepotTransfert()) {
            return 'Bon transfert';
        }
        if (this.documentType === 'PV ECART') {
            return "PV d'écart";
        }
        return this.documentType;
    }

    showPvEcartQtyBreakdownColumns(): boolean {
        return (
            this.documentType === 'PV ECART' ||
            (this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert())
        );
    }

    getPvEcartQteEnvoyeeDisplay(index: number): string {
        const row = this.getPvEcartBreakdownForDisplay(index);
        return formatPvEcartQtyDisplay(row?.qteEnvoyee);
    }

    getPvEcartQteRecueDisplay(index: number): string {
        const row = this.getPvEcartBreakdownForDisplay(index);
        return formatPvEcartQtyDisplay(row?.qteRecue);
    }

    getPvEcartEcartSignedDisplay(index: number): string {
        const row = this.getPvEcartBreakdownForDisplay(index);
        if (!row || !Number.isFinite(row.ecartSigned)) {
            return '—';
        }
        const n = Math.trunc(row.ecartSigned);
        const signed = n > 0 ? `+${n}` : String(n);
        if (this.showPvEcartQtyBreakdownColumns()) {
            if (n > 0) {
                return `${signed} (excédent)`;
            }
            if (n < 0) {
                return `${signed} (manquant)`;
            }
            return `${signed} (conforme)`;
        }
        return signed;
    }

    /** Qté envoyée / reçue / écart : totaux du groupe si regroupement replié (comme la colonne Quantité). */
    private getPvEcartBreakdownForDisplay(index: number): PvEcartQtyBreakdownRow | undefined {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return undefined;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return this.pvEcartQtyBreakdownByItemIndex.get(index);
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return this.aggregatePvEcartBreakdownForIndices(
                this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
            );
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.aggregatePvEcartBreakdownForIndices(this.getProductLineCouleurMemberIndices(index));
        }
        return this.pvEcartQtyBreakdownByItemIndex.get(index);
    }

    private aggregatePvEcartBreakdownForIndices(indices: number[]): PvEcartQtyBreakdownRow | undefined {
        let hasRow = false;
        let sumEnvoyee = 0;
        let hasEnvoyee = false;
        let sumRecue = 0;
        let hasRecue = false;
        let sumEcart = 0;
        let hasEcart = false;
        for (const i of indices || []) {
            const row = this.pvEcartQtyBreakdownByItemIndex.get(i);
            if (!row) {
                continue;
            }
            hasRow = true;
            if (row.qteEnvoyee != null && Number.isFinite(Number(row.qteEnvoyee))) {
                sumEnvoyee += Math.trunc(Number(row.qteEnvoyee));
                hasEnvoyee = true;
            }
            if (row.qteRecue != null && Number.isFinite(Number(row.qteRecue))) {
                sumRecue += Math.trunc(Number(row.qteRecue));
                hasRecue = true;
            }
            if (Number.isFinite(row.ecartSigned)) {
                sumEcart += Math.trunc(row.ecartSigned);
                hasEcart = true;
            }
        }
        if (!hasRow) {
            return undefined;
        }
        let ecartSigned: number;
        if (hasEcart) {
            ecartSigned = sumEcart;
        } else if (hasEnvoyee && hasRecue) {
            ecartSigned = sumRecue - sumEnvoyee;
        } else {
            ecartSigned = NaN;
        }
        return {
            qteEnvoyee: hasEnvoyee ? sumEnvoyee : null,
            qteRecue: hasRecue ? sumRecue : null,
            ecartSigned,
        };
    }

    /** PV d’écart : lignes issues du transfert LC (lecture seule, même vue que transfert entrepôt). */
    isPvEcartLcLinkedLineView(): boolean {
        return this.documentType === 'PV ECART' && this.pvEcartLineViewFromLcDetail;
    }

    openPvEcartLinkedDocLink(row: PvEcartLinkedDocRow): void {
        if (!row.link) {
            return;
        }
        openPvEcartLinkedDocInNewTab(this.router, row.link);
    }

    openBonSortieLinkedDoc(row: LcReceptionErpWorkflowLinkRow): void {
        if (!row.link) {
            return;
        }
        openPvEcartLinkedDocInNewTab(this.router, row.link);
    }

    private refreshBonSortieLinkedDocuments(doc: unknown): void {
        if (!this.isBonSortieDocument() || !this.documentId) {
            this.bonSortieLinkedTransfertLinks = [];
            this.bonSortieLinkedDocsLoading = false;
            return;
        }
        this.bonSortieLinkedDocsLoading = true;
        this.bonSortieLinkedTransfertLinks = [];
        loadBonSortieLinkedStockTransfertRow$(
            this.documentService,
            doc,
            this.lcStockTransfert,
            { stationId: this.stationId }
        )
            .pipe(take(1))
            .subscribe({
                next: (row) => {
                    this.bonSortieLinkedTransfertLinks = bonSortieLinkedTransfertToLcInlineLinks(row);
                    this.bonSortieLinkedDocsLoading = false;
                    this.cdr.detectChanges();
                },
                error: () => {
                    this.bonSortieLinkedTransfertLinks = [];
                    this.bonSortieLinkedDocsLoading = false;
                    this.cdr.detectChanges();
                },
            });
    }

    getPvEcartEcartSignedCssClass(index: number): string {
        const row = this.getPvEcartBreakdownForDisplay(index);
        if (!row || !Number.isFinite(row.ecartSigned)) {
            return '';
        }
        const n = Math.trunc(row.ecartSigned);
        if (n > 0) {
            return 'text-success';
        }
        if (n < 0) {
            return 'text-danger';
        }
        return 'text-muted';
    }

    private isCurrentDocumentVenteType(): boolean {
        return this.documentTypesVente.has(this.getNormalizedDocumentTypeForTax());
    }

    private isCurrentDocumentAchatType(): boolean {
        return this.documentTypesAchat.has(this.getNormalizedDocumentTypeForTax());
    }

    private isTaxUtilisationAllowedForDocument(tax: any): boolean {
        if (!tax || typeof tax !== 'object') {
            return false;
        }
        const rawTous = tax.utilisation_tous;
        const rawVente = tax.utilisation_vente;
        const rawAchat = tax.utilisation_achat;
        const hasAnyUtilisationFlag =
            rawTous !== undefined || rawVente !== undefined || rawAchat !== undefined;
        if (!hasAnyUtilisationFlag) {
            return true;
        }
        const isTruthy = (v: any): boolean =>
            v === true || v === 1 || v === '1' || v === 'true';
        if (isTruthy(rawTous)) {
            return true;
        }
        const vente = isTruthy(rawVente);
        const achat = isTruthy(rawAchat);
        if (!vente && !achat) {
            return true;
        }
        if (vente && achat) {
            return this.isCurrentDocumentVenteType() || this.isCurrentDocumentAchatType();
        }
        if (vente) {
            return this.isCurrentDocumentVenteType();
        }
        return this.isCurrentDocumentAchatType();
    }

    isTaxActiveForDocument(tax: any): boolean {
        if (!tax) {
            return false;
        }
        if (!this.isTaxUtilisationAllowedForDocument(tax)) {
            return false;
        }
        const base =
            tax.statut === true ||
            tax.statut === 1 ||
            tax.statut === '1' ||
            tax.statut === 'true';
        if (this.isAppliqueSurTousDocumentsTax(tax)) {
            return base;
        }
        const id = tax.id != null ? Number(tax.id) : null;
        if (id != null && this.documentTaxStatutOverrides[id] !== undefined) {
            return !!this.documentTaxStatutOverrides[id];
        }
        return base;
    }

    onDocumentTaxStatutChange(ev: { taxId: number; statut: boolean }): void {
        this.documentTaxStatutOverrides = {
            ...this.documentTaxStatutOverrides,
            [ev.taxId]: ev.statut
        };
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    private applyTaxStatutDocumentFromParametrage(raw: any): void {
        if (!raw || typeof raw !== 'object') {
            this.documentTaxStatutOverrides = {};
            return;
        }
        const keys = Object.keys(raw);
        if (keys.length === 0) {
            this.documentTaxStatutOverrides = {};
            return;
        }
        const out: { [id: number]: boolean } = {};
        keys.forEach(k => {
            const id = Number(k);
            if (!Number.isNaN(id)) {
                out[id] = !!raw[k];
            }
        });
        this.documentTaxStatutOverrides = out;
    }

    private loadTaxes(): void {
        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (res: any) => {
                const taxList = res?.taxes || res?.data || res?.tvaListe || [];
                if (!Array.isArray(taxList)) {
                    this.taxes = [];
                    return;
                }
                this.taxes = taxList;
                const fodecTax = this.taxes.find((t: any) =>
                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                    this.isTaxActiveForDocument(t)
                );
                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                this.items.forEach((item, i) => {
                    if (item.product_id) {
                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                            next: (p: any) => this.applyProductTaxes(p.data || p, i),
                            error: () => {
                            }
                        });
                    }
                });
                this.calculateTotals();
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.taxes = [];
                this.fodecRate = 0;
            }
        });
    }

    private updateTvaSummary(): void {
        this.tvaSummary = [];

        const tauxUtilises = new Set(
            this.items
                .filter(i => i.type === 'product' && i.tva != null && i.tva !== '')
                .map(i => i.tva!)
        );

        tauxUtilises.forEach(tauxStr => {
            const taux = Number(tauxStr);
            if (taux <= 0 || isNaN(taux)) return;
            const base = this.items
                .filter(i => i.type === 'product' && i.tva === tauxStr)
                .reduce((sum, i) => sum + (i.totalHT || 0), 0);
            if (base <= 0) return;
            const montantTva = base * (taux / 100);
            this.tvaSummary.push({
                rate: taux,
                base: Number(base.toFixed(3)),
                amount: Number(montantTva.toFixed(3))
            });
        });
    }

    loadCategories(): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingCategories = false;
            this.categories = [];
            this.cdr.markForCheck();
            return;
        }

        this.isLoadingCategories = true;
        this.categorieService.getCategoriePerStation(this.stationId).subscribe({
            next: (categories) => {
                this.zone.run(() => {
                    this.categories = categories || [];
                    this.isLoadingCategories = false;
                    this.cdr.markForCheck();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingCategories = false;
                    this.categories = [];
                    this.toastr.error('Erreur lors du chargement des catégories.', 'Erreur');
                    this.cdr.markForCheck();
                });
            }
        });
    }

    private syncSessionFromStorage(): void {
        try {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        } catch {
            this.currentUser = {};
        }
        this.clientId = this.currentUser?.id;
        this.stationId = getStationIdFromLocalStorage();
    }

    loadStationData(): void {
        if (!this.stationId) {
            this.stationId = getStationIdFromLocalStorage();
        }

        if (!this.stationId) {
            return;
        }
        this.loadParametreDocumentCachet();
        this.loadBanquesForDocument();
        this.stationService.getStation(this.stationId).subscribe({
            next: (response) => {
                if (response && response.success && response.station) {
                    const station = response.station;
                    let adresseFormatee = '--';
                    let ville = '';
                    let pays = '';
                    
                    if (station.adresses && station.adresses.length > 0) {
                        const adresse = station.adresses[0];
                        const parts = [];
                        if (adresse.adresse) parts.push(adresse.adresse);
                        if (adresse.code_postal) parts.push(adresse.code_postal);
                        adresseFormatee = parts.join(', ') || '--';
                        ville = adresse.region || '';
                        pays = adresse.pays || '';
                    }
                    this.enterpriseBrandName = resolveEnterpriseDisplayName(
                        station.nom_entreprise || station.label
                    );
                    const selectedOrg =
                        this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) || null;
                    const displayName = selectedOrg?.label || this.enterpriseBrandName;
                    this.entreprise = {
                        nom: displayName || '--',
                        adresse: adresseFormatee,
                        ville: ville,
                        pays: pays,
                        matricule_fiscal: station.matricule_fiscale || '--'
                    };
                    if (station.logo) {
                        this.documentLogoBroken = false;
                        this.stationLogo = this.resolveStationLogoUrl(station.logo);
                    } else {
                        this.documentLogoBroken = false;
                        this.stationLogo = null;
                    }
                    this.stationName = displayName;
                    this.applyStationFooterContact(station);
                    this.stationEntrepriseSnapshot = { ...this.entreprise };
                    this.applyFooterForSelectedOrg();
                    this.cdr.markForCheck();
                }
            },
            error: (error) => {
                this.stationFooterCoordName = '--';
                this.stationFooterCoordEmail = '--';
                this.stationFooterCoordPhones = '--';
            }
        });
    }

    /** Recherche libre dans le select station / établissement. */
    searchOrgSelectFn = (term: string, item: DocumentOrgSelectOption): boolean => {
        const t = String(term ?? '').trim().toLowerCase();
        if (!t) {
            return true;
        }
        const label = String(item?.label ?? '').toLowerCase();
        const typeLabel = item?.type === 'station' ? 'station' : 'établissement etablissement';
        return label.includes(t) || typeLabel.includes(t) || String(item?.id ?? '').includes(t);
    };

    private stationOptionId(station: UserStationLike): number {
        const n = Number(station['station_id'] ?? station['id']);
        return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    }

    private etablissementOptionLabel(etab: EtablissementRow): string {
        const libelle = String(etab?.libelle || '').trim();
        const code = String(etab?.code_etablissement || '').trim();
        if (libelle && code) {
            return `${libelle} (${code})`;
        }
        return libelle || code || `Établissement #${etab?.id}`;
    }

    private buildOrgSelectOptions(etabs: EtablissementRow[]): DocumentOrgSelectOption[] {
        const options: DocumentOrgSelectOption[] = [];
        for (const s of listUserStationsFromLocalStorage()) {
            const id = this.stationOptionId(s);
            if (id <= 0) {
                continue;
            }
            const label =
                getEnterpriseNameFromStation(s) ||
                String(s['label'] || '').trim() ||
                `Station #${id}`;
            options.push({ key: `station:${id}`, type: 'station', id, label });
        }
        for (const e of etabs || []) {
            const id = Math.floor(Number(e.id));
            if (!Number.isFinite(id) || id <= 0) {
                continue;
            }
            options.push({
                key: `etab:${id}`,
                type: 'etablissement',
                id,
                label: this.etablissementOptionLabel(e),
            });
        }
        return options;
    }

    private applySelectedOrgDisplay(): void {
        const opt = this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) || null;
        if (!opt) {
            return;
        }
        this.stationName = opt.label;
        if (opt.type === 'etablissement') {
            this.selectedEtablissementId = opt.id;
        } else {
            this.selectedEtablissementId = null;
        }
        this.applyFooterForSelectedOrg(opt);
    }

    private applyOrgSelection(preferId?: number | null): void {
        const preferredEtab = Number(preferId);
        const preferredEtabKey =
            Number.isFinite(preferredEtab) && preferredEtab > 0 ? `etab:${preferredEtab}` : null;
        const currentStationKey = `station:${Number(this.stationId) || 0}`;

        if (preferredEtabKey && this.orgSelectOptions.some((o) => o.key === preferredEtabKey)) {
            this.selectedOrgKey = preferredEtabKey;
            this.selectedEtablissementId = preferredEtab;
        } else if (
            this.selectedOrgKey &&
            this.orgSelectOptions.some((o) => o.key === this.selectedOrgKey)
        ) {
            // conserve
        } else if (this.orgSelectOptions.some((o) => o.key === currentStationKey)) {
            this.selectedOrgKey = currentStationKey;
        } else {
            this.selectedOrgKey = this.orgSelectOptions[0]?.key ?? null;
        }
        this.applySelectedOrgDisplay();
        // Aligne le filtre entrepôt sur l'établissement (pré)sélectionné (ex. depuis le POS).
        this.loadEtablissementEntrepotLinks();
    }

    private fetchEtablissementsRows(): Observable<EtablissementRow[]> {
        if (!this.lcAuth.getBackStationId()) {
            return of([] as EtablissementRow[]);
        }
        try {
            return this.lcAssociations.listEtablissements().pipe(
                catchError(() => of([] as EtablissementRow[]))
            );
        } catch {
            return of([] as EtablissementRow[]);
        }
    }

    /** Stations locales tout d’suite, établissements LC en arrière-plan (cache + skip bootstrap si prêt). */
    private refreshAvailableEtablissements(preferId?: number | null): void {
        // 1) Peindre les stations immédiatement (pas d’attente réseau).
        this.orgSelectOptions = this.buildOrgSelectOptions(this.availableEtablissements);
        this.applyOrgSelection(preferId);
        this.loadingEtablissements = true;
        this.cdr.detectChanges();

        const applyRows = (rows: EtablissementRow[]) => {
            this.availableEtablissements = Array.isArray(rows) ? rows : [];
            this.orgSelectOptions = this.buildOrgSelectOptions(this.availableEtablissements);
            this.applyOrgSelection(preferId);
            this.loadingEtablissements = false;
            if (this.selectedWarehouseDestinationId != null) {
                this.applyWarehouseDestinationEtablissementFromDetail(this.warehouseDestinationDetail);
            }
            this.cdr.detectChanges();
        };

        const load$ = this.lcAuth.isReadyForNavigation()
            ? this.fetchEtablissementsRows()
            : this.lcAuth.bootstrap().pipe(
                  catchError(() => of('needs_setup' as const)),
                  switchMap(() => this.fetchEtablissementsRows())
              );

        load$
            .pipe(
                finalize(() => {
                    if (!this.orgSelectOptions.length) {
                        this.orgSelectOptions = this.buildOrgSelectOptions([]);
                        this.applyOrgSelection(preferId);
                    }
                    this.loadingEtablissements = false;
                    this.cdr.detectChanges();
                })
            )
            .subscribe({ next: applyRows });
    }

    /** Station / établissement modifiable en brouillon (création ou édition). */
    canEditDocumentEtablissement(): boolean {
        if (this.mode !== 'add' && this.mode !== 'edit') {
            return false;
        }
        if (this.mode === 'add' && !this.documentId) {
            return true;
        }
        const sid = Number(this.currentStatutId);
        const brouillonId = Number(this.statutIdMap['Brouillon']);
        return Number.isFinite(sid) && Number.isFinite(brouillonId) && sid === brouillonId;
    }

    /** Changement station ERP ou établissement LC. */
    onDocumentOrgSelectChange(value: unknown): void {
        if (!this.canEditDocumentEtablissement()) {
            return;
        }
        let opt: DocumentOrgSelectOption | null = null;
        if (value != null && typeof value === 'object' && 'key' in (value as object)) {
            opt = value as DocumentOrgSelectOption;
        } else {
            const key = String(value ?? '');
            opt = this.orgSelectOptions.find((o) => o.key === key) || null;
        }
        if (!opt) {
            return;
        }
        this.selectedOrgKey = opt.key;
        this.stationName = opt.label;

        if (opt.type === 'etablissement') {
            this.selectedEtablissementId = opt.id;
            this.applyFooterForSelectedOrg(opt);
            // Restreint les entrepôts aux seuls reliés à cet établissement.
            this.loadEtablissementEntrepotLinks();
            this.applyEntrepotEstablishmentFilter();
            this.cdr.detectChanges();
            return;
        }

        // Station ERP : bascule le contexte document.
        this.selectedEtablissementId = null;
        if (opt.id === Number(this.stationId)) {
            this.applyFooterForSelectedOrg(opt);
            this.applyEntrepotEstablishmentFilter();
            this.cdr.detectChanges();
            return;
        }
        setConnectedEnterpriseStationId(opt.id, {
            label: opt.label,
            nom_entreprise: opt.label,
        });
        this.stationId = opt.id;
        this.lcAuth.syncWithErpContext();
        // Recharge uniquement les données liées à la station (sans re-bootstrap LC systématique).
        this.loadStationData();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadProjects();
        this.loadTvaRates();
        this.loadCategories();
        this.loadTaxes();
        this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
        this.loadCurrentTypeDocumentPrefixFromApi();
        if (!this.documentId && this.mode === 'add') {
            this.documentReference = '';
            this.refExterne = '';
        }
        this.maybePrefetchNextDocumentReference(true);
        this.cdr.detectChanges();
    }

    private resolveStationLogoUrl(logo?: string | null): string | null {
        const raw = String(logo ?? '').trim();
        if (!raw || raw.endsWith('/')) {
            return null;
        }
        if (raw.startsWith('http://') || raw.startsWith('https://')) {
            return raw;
        }
        const logoPath = raw.startsWith('/') ? raw : `/${raw}`;
        return `${this.urlImages}${logoPath}`;
    }

    /** Logo cassé / URL invalide : on masque l’image mais on conserve l’emplacement. */
    onDocumentLogoError(): void {
        this.documentLogoBroken = true;
        this.cdr.markForCheck();
    }

    /** Initiales affichées quand l’établissement n’a pas de logo. */
    getDocumentLogoInitials(): string {
        const label = String(this.stationName || '').trim();
        if (!label) {
            return 'ET';
        }
        const parts = label.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
        }
        return label.slice(0, 2).toUpperCase();
    }

    private applyStationFooterContact(station: any): void {
        const coord = station?.coordonnees?.[0];
        const prenom = (coord?.prenom ?? '').toString().trim();
        const nom = (coord?.nom ?? '').toString().trim();
        const fullName = [prenom, nom].filter(Boolean).join(' ').trim();
        this.stationFooterCoordName = fullName || '--';
        const email = (coord?.email ?? station?.email ?? '').toString().trim();
        this.stationFooterCoordEmail = email || '--';
        const telList =
            Array.isArray(station?.telephones) && station.telephones.length
                ? station.telephones
                : Array.isArray(coord?.telephones)
                  ? coord.telephones
                  : [];
        const nums = telList
            .map((t: any) => (t?.numero ?? '').toString().trim())
            .filter(Boolean);
        this.stationFooterCoordPhones = nums.length ? nums.join(', ') : '--';
    }

    /** Snapshot footer station, pour restaurer après un choix établissement. */
    private stationEntrepriseSnapshot: {
        nom: string;
        adresse: string;
        ville: string;
        pays: string;
        matricule_fiscal: string;
    } | null = null;

    /** Met à jour le bloc Entreprise du footer selon société (station) ou établissement. */
    private applyFooterForSelectedOrg(opt?: DocumentOrgSelectOption | null): void {
        const selected =
            opt ||
            this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) ||
            null;
        if (!selected) {
            return;
        }
        if (selected.type === 'etablissement') {
            const etab =
                this.availableEtablissements.find((e) => Number(e.id) === Number(selected.id)) ||
                null;
            if (!etab) {
                if (this.entreprise) {
                    this.entreprise = { ...this.entreprise, nom: selected.label };
                }
                return;
            }
            const adresseParts = [etab.adresse, etab.code_postal].filter((x) =>
                String(x || '').trim()
            );
            this.entreprise = {
                nom: selected.label || this.etablissementOptionLabel(etab),
                adresse: adresseParts.length ? adresseParts.join(', ') : '--',
                ville: String(etab.ville || '').trim(),
                pays: String(etab.pays || '').trim(),
                matricule_fiscal:
                    String(etab.numero_identification_fiscale || '').trim() || '--',
            };
            this.stationName = this.entreprise.nom;
            return;
        }
        if (this.stationEntrepriseSnapshot) {
            this.entreprise = {
                ...this.stationEntrepriseSnapshot,
                nom: selected.label || this.stationEntrepriseSnapshot.nom,
            };
            this.stationName = this.entreprise.nom;
        } else if (this.entreprise) {
            this.entreprise = { ...this.entreprise, nom: selected.label };
            this.stationName = selected.label;
        }
    }

    /** Snapshot entreprise envoyé à l’API (footer document). */
    private buildEntreprisesPayload(): Array<{
        nom_entreprise: string;
        adresse?: string;
        matricule_fiscale?: string | null;
        telephone?: string | null;
        email?: string | null;
    }> {
        const adresseParts = [
            this.entreprise?.adresse,
            this.entreprise?.ville,
            this.entreprise?.pays,
        ]
            .map((x) => String(x || '').trim())
            .filter((x) => x && x !== '--');
        const matricule = String(this.entreprise?.matricule_fiscal || '').trim();
        const tel = String(this.stationFooterCoordPhones || '').trim();
        const email = String(this.stationFooterCoordEmail || '').trim();
        return [
            {
                nom_entreprise: String(this.entreprise?.nom || this.stationName || '--').trim() || '--',
                adresse: adresseParts.length ? adresseParts.join(', ') : undefined,
                matricule_fiscale: matricule && matricule !== '--' ? matricule : null,
                telephone: tel && tel !== '--' ? tel : null,
                email: email && email !== '--' ? email : null,
            },
        ];
    }

    /** Charge les comptes bancaires de la station pour le footer. */
    private loadBanquesForDocument(preferRib?: string | null): void {
        if (!this.stationId) {
            this.availableBanques = [];
            this.selectedBanqueId = null;
            this.applySelectedBanqueDisplay();
            return;
        }
        this.banqueService.getBanques(this.stationId).subscribe({
            next: (response) => {
                const list = Array.isArray(response?.banques) ? response.banques : [];
                this.availableBanques = list.filter(
                    (b) => b && b.statut !== false && Number((b as any).statut) !== 0
                );
                const prefer = String(preferRib || this.banque?.rib || '').trim();
                let chosen: Banque | null = null;
                if (prefer && prefer !== '--') {
                    chosen =
                        this.availableBanques.find((b) => String(b.rib || '').trim() === prefer) || null;
                }
                if (!chosen && this.selectedBanqueId != null) {
                    chosen =
                        this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) ||
                        null;
                }
                if (!chosen && this.availableBanques.length) {
                    chosen = this.availableBanques[0];
                }
                this.selectedBanqueId = chosen?.id != null ? Number(chosen.id) : null;
                this.applySelectedBanqueDisplay();
                this.cdr.markForCheck();
            },
            error: () => {
                this.availableBanques = [];
                if (!this.banque?.rib || this.banque.rib === '--') {
                    this.banque = { nom_banque: '--', rib: '--' };
                }
                this.cdr.markForCheck();
            },
        });
    }

    banqueOptionLabel(b: Banque | null | undefined): string {
        if (!b) {
            return '';
        }
        const name = String(b.nom || b.designation || 'Compte').trim();
        const rib = String(b.rib || '').trim();
        return rib ? `${name} — ${rib}` : name;
    }

    onSelectedBanqueChange(id: number | null): void {
        this.selectedBanqueId = id != null ? Number(id) : null;
        this.applySelectedBanqueDisplay();
        this.cdr.detectChanges();
    }

    private applySelectedBanqueDisplay(): void {
        const selected =
            this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) || null;
        if (selected) {
            this.banque = {
                nom_banque: String(selected.nom || selected.designation || 'Banque').trim() || 'Banque',
                rib: String(selected.rib || '').trim() || '--',
                agence: selected.agence || null,
                designation: selected.designation || null,
            };
            return;
        }
        if (!this.availableBanques.length) {
            if (!this.banque?.rib || this.banque.rib === '--') {
                this.banque = { nom_banque: '--', rib: '--' };
            }
        }
    }

    canSelectDocumentBanque(): boolean {
        return this.mode !== 'validation' && this.availableBanques.length > 1;
    }

    /** Coordonnées bancaires persistées avec le document. */
    private buildCoordonneesBancairesPayload(): Array<{
        nom: string;
        rib: string;
        banque?: string | null;
        agence?: string | null;
    }> {
        const selected =
            this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) || null;
        if (selected) {
            return [
                {
                    nom: String(selected.designation || selected.nom || 'Compte').trim() || 'Compte',
                    rib: String(selected.rib || '').trim(),
                    banque: String(selected.nom || '').trim() || null,
                    agence: selected.agence || null,
                },
            ];
        }
        const rib = String(this.banque?.rib || '').trim();
        const nom = String(this.banque?.nom_banque || '').trim();
        if (!rib || rib === '--') {
            return [];
        }
        return [
            {
                nom: nom && nom !== '--' ? nom : 'Compte',
                rib,
                banque: nom && nom !== '--' ? nom : null,
                agence: this.banque?.agence || null,
            },
        ];
    }

    private loadParametreDocumentCachet(): void {
        if (!this.stationId) {
            this.documentCachetUrl = null;
            return;
        }
        this.parametreDocumentSettingsService.getByStation(this.stationId).subscribe({
            next: (bundle) => {
                const pd = bundle?.parametre_document;
                const raw = pd?.image_cachet ?? null;
                this.documentCachetUrl = this.resolveCachetDisplayUrl(raw);
                this.paramDocAffProduitMatriciel = isTruthyTinyInt(pd?.aff_produit_matriciel ?? 1);
                this.cdr.markForCheck();
            },
            error: () => {
                this.documentCachetUrl = null;
                this.cdr.markForCheck();
            }
        });
    }

    private resolveCachetDisplayUrl(raw: string | null | undefined): string | null {
        if (raw == null || raw === '') {
            return null;
        }
        const s = String(raw).trim();
        if (s.startsWith('data:') || s.startsWith('http://') || s.startsWith('https://')) {
            return s;
        }
        const base = this.urlImages.replace(/\/$/, '');
        const path = s.startsWith('/') ? s : `/${s}`;
        return `${base}${path}`;
    }

    onCategorieSelect(categorieLibelle: string): void {
        const categorie = this.categories.find(c => c.libelle === categorieLibelle);
        if (categorie) {
            this.selectedCategorie = categorieLibelle;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        } else {
            this.selectedCategorie = '';
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }
    }

    onCategorieSaved(newCategorie: Categorie): void {
        this.toastr.success('Catégorie ajoutée avec succès !', 'Succès');
        this.loadCategories();
        setTimeout(() => {
            this.selectedCategorie = newCategorie.libelle;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }, 500);
    }

    loadTvaRates(): void {
        if (!this.stationId) {
            this.isLoadingTvaRates = false;
            this.tvaRates = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingTvaRates = true;
        this.tvaService.getTvaList(this.stationId).subscribe({
            next: (response) => {
                this.zone.run(() => {
                    const liste = response?.tvaListe || [];
                    this.tvaRates = Array.isArray(liste)
                        ? liste.filter((tva: any) => tva.statut === true)
                        : [];

                    this.isLoadingTvaRates = false;
                    this.cdr.detectChanges();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingTvaRates = false;
                    this.tvaRates = [];
                    this.toastr.error('Erreur lors du chargement des taux de TVA.', 'Erreur');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    getStockBadgeClass(product: Product): string {
        if (!product.informations_logistique || product.informations_logistique.length === 0 || product.informations_logistique.every(info => info.minimum <= 0)) {
            return 'badge-tous';
        }
        return 'badge-en-stok';
    }

    getStockStatus(product: Product | Item): string {
        const quantity = this.getStockQuantity(product);
        if (quantity > 0) {
            return 'En stock';
        }
        return 'En rupture';
    }
    private stockQuantitiesCache: Map<string, number> = new Map();
    /** Évite des centaines d’appels LC/auth/verify depuis le template (cache miss). */
    private stockQuantitiesLoadingKeys = new Set<string>();
    private averagePurchasePriceCache: Map<number, number> = new Map();

    reloadStockQuantitiesForAllProducts(): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        if (this.logicielCaisseTransfertEditId && this.isLogicielCaisseEntrepotTransfert()) {
            this.reconcileStockLcLineProductIdsFromCatalog();
        }
        this.items.forEach((item, index) => {
            if (item.type !== 'product') {
                return;
            }
            if (!item.product_id) {
                const pid = this.findProductIdForStockLineItem(item);
                if (pid) {
                    item.product_id = pid;
                }
            }
            if (item.product_id) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
            }
        });
    }
    private shouldFilterStockByEntrepot(): boolean {
        if (this.isBonTransfertOrEntrepotTransfert()) {
            return true;
        }
        const documentTypesRequiringEntrepot = [
            'BON DE LIVRAISON',
            'BON RECEPTION',
            'INVENTAIRE',
            'BON TRANSFERT',
            'BON DE SORTIE',
            'PV ECART',
        ];
        return documentTypesRequiringEntrepot.includes(this.documentType);
    }

    /** Ng-select entrepôt (hors bon de transfert et avoir : l'avoir reprend l'entrepôt source). */
    shouldShowSingleWarehouseSelect(): boolean {
        if (
            !this.isEntrepotVisible ||
            this.usesDualEntrepotSelection() ||
            this.isAvoirWarehouseLocked()
        ) {
            return false;
        }
        return [
            'BON RECEPTION',
            'FACTURE FOURNISSEUR',
            'FACTURE',
            'BON DE LIVRAISON',
            'AVOIR',
            'INVENTAIRE',
        ].includes(this.documentType);
    }

    shouldShowLockedWarehouseDisplay(): boolean {
        return this.isEntrepotVisible && this.isAvoirWarehouseLocked();
    }

    private isAvoirWarehouseLocked(): boolean {
        // Avoir fournisseur figé si besoin métier séparé ; avoir client sélectionnable pour le stock.
        return this.documentType === 'AVOIR FOURNISSEUR';
    }

    getLockedWarehouseLabel(): string {
        if (this.lockedWarehouseName && String(this.lockedWarehouseName).trim() !== '') {
            return String(this.lockedWarehouseName).trim();
        }
        const id = Number(this.selectedWarehouseId);
        if (!Number.isFinite(id) || id <= 0) {
            return '--';
        }
        const w = (this.warehouses || []).find((x: any) => Number(x?.id) === id);
        const nom = w?.nom || w?.libelle || w?.label;
        return nom && String(nom).trim() !== '' ? String(nom).trim() : `Entrepôt ${id}`;
    }

    private resolveOrgSelectKeyForEtablissementId(etabId: number): string | null {
        const id = Number(etabId);
        if (!Number.isFinite(id) || id <= 0) {
            return null;
        }
        const opt = this.orgSelectOptions.find((o) => o.type === 'etablissement' && Number(o.id) === id);
        return opt?.key ?? null;
    }

    private parseHiddenFournisseurFieldsFromDoc(doc: any): Record<string, unknown> | null {
        let hidden: unknown = doc?.hidden_fournisseur_fields;
        if (typeof hidden === 'string') {
            try {
                hidden = JSON.parse(hidden);
            } catch {
                return null;
            }
        }
        return hidden && typeof hidden === 'object' ? (hidden as Record<string, unknown>) : null;
    }

    private applyBonSortieEtablissementsFromDoc(doc: any): void {
        if (!doc || !this.isBonSortieDocument()) {
            return;
        }
        const etabSrc = Number(doc.etablissement_id);
        if (Number.isFinite(etabSrc) && etabSrc > 0) {
            this.selectedEtablissementId = etabSrc;
            const key = this.resolveOrgSelectKeyForEtablissementId(etabSrc);
            if (key) {
                this.selectedOrgKey = key;
            }
        }
        const hidden = this.parseHiddenFournisseurFieldsFromDoc(doc);
        const etabDest = Number(hidden?.[LC_ETABLISSEMENT_DEST_HIDDEN_KEY]);
        if (Number.isFinite(etabDest) && etabDest > 0) {
            this.selectedEtablissementDestId = etabDest;
            const keyDest = this.resolveOrgSelectKeyForEtablissementId(etabDest);
            if (keyDest) {
                this.selectedOrgKeyRecepteur = keyDest;
            }
        }
        this.applyEntrepotEstablishmentFilter();
    }

    /** Bon de sortie : entrepôts initial / destination depuis le document ERP. */
    private applyBonSortieEntrepotsFromDoc(doc: any): void {
        if (!doc || !this.isBonSortieDocument()) {
            return;
        }
        this.applyBonSortieEtablissementsFromDoc(doc);
        const pools = this.getEnrichedLcWarehousePools();
        const hidden = this.parseHiddenFournisseurFieldsFromDoc(doc);
        const initialId = resolveLcEntrepotIdFromErpOrHidden(
            doc.entrepot_id ?? doc.entrepot?.id,
            hidden?.[LC_ENTREPOT_HIDDEN_KEY],
            pools
        );
        const destId = resolveLcEntrepotIdFromErpOrHidden(
            doc.entrepot_dest_id ?? doc.entrepot_destination?.id ?? doc.entrepot_destination_id,
            hidden?.[LC_ENTREPOT_DEST_HIDDEN_KEY],
            pools
        );
        if (initialId != null) {
            this.selectedWarehouseInitialId = initialId;
        }
        if (destId != null) {
            this.selectedWarehouseDestinationId = destId;
        }
        this.refreshWarehouseDestinationPanel();
    }

    /** Id LC destination PV : hidden prioritaire, sinon entrepot_dest_id (souvent déjà id LC). */
    private resolvePvEcartDestinationLcIdFromDoc(
        doc: any,
        hidden: Record<string, unknown> | null
    ): number | null {
        const rawDest =
            doc?.entrepot_dest_id ??
            doc?.entrepot_destination_id ??
            doc?.entrepot_destination?.id;
        return resolvePvEcartDestinationLcId(
            rawDest,
            hidden?.[LC_ENTREPOT_DEST_HIDDEN_KEY],
            this.getEnrichedLcWarehousePools()
        );
    }

    private reapplyPvEcartEntrepotDisplayAfterFilter(): void {
        if (this.lastLoadedPvEcartDoc) {
            this.applyPvEcartEntrepotsFromPvDocument(this.lastLoadedPvEcartDoc);
            return;
        }
        if (
            this.logicielCaisseTransfertFromPvEcart &&
            this.pvEcartSourceDocumentId != null &&
            this.pvEcartSourceDocumentId > 0
        ) {
            this.loadTransfertEntrepotsFromPvEcartSource();
        }
    }

    /** Départ LC (transfert en édition) ; destination = document ERP lié au PV. */
    private applyPvEcartEntrepotsFromLcTransfertPending(): void {
        const pvDoc = this.lastLoadedPvEcartDoc;
        if (pvDoc) {
            this.applyPvEcartEntrepotsFromPvDocument(pvDoc);
            return;
        }
        const depLcId = this.pendingLcTransfertWarehouseDepId;
        const destLcId = this.pendingLcTransfertWarehouseDestId;
        this.commitPvEcartEntrepotLcIdsToUi(depLcId, destLcId);
        this.logPvEcartEntrepot('applyPvEcartEntrepotsFromLcTransfertPending — repli LC', {
            lcTransfertId: this.logicielCaisseTransfertEditId,
            depLcId,
            destLcId,
        });
        this.resolveLcUserStationIdsForDocument$().subscribe({
            next: (ctx) => this.loadPvEcartEntrepotsFromLcApi(ctx, depLcId, destLcId),
            error: (err) => {
                this.toastr.warning(
                    err?.message ||
                        'Connectez le logiciel caisse pour afficher les entrepôts du transfert.',
                    'Entrepôts'
                );
            },
        });
    }

    private commitPvEcartEntrepotLcIdsToUi(
        depLcId: number | null,
        destLcId: number | null
    ): void {
        if (depLcId != null) {
            this.selectedWarehouseInitialId = depLcId;
            this.pendingLcTransfertWarehouseDepId = depLcId;
        }
        if (destLcId != null) {
            this.selectedWarehouseDestinationId = destLcId;
            this.pendingLcTransfertWarehouseDestId = destLcId;
        }
    }

    private resolvePvEcartLinkedErpDocumentIdForEntrepotsFromContext(
        pvDoc: Record<string, unknown>
    ): number | null {
        return resolvePvEcartLinkedErpDocumentIdForEntrepots(pvDoc, this.pvEcartLinkedSourcesEntry);
    }

    /** Destination : entrepôt du bon de transfert / document lié (pas le détail LC seul). */
    private resolvePvEcartDestinationLcIdFromLinkedErpDocument$(
        pvDoc: Record<string, unknown>,
        fallbackDestLcId: number | null
    ): Observable<number | null> {
        const linkedErpId = this.resolvePvEcartLinkedErpDocumentIdForEntrepotsFromContext(pvDoc);
        if (linkedErpId == null) {
            return of(fallbackDestLcId);
        }
        return this.documentService.getDocumentById(linkedErpId).pipe(
            map((res) => {
                const linked = (res?.data?.document ?? res?.data ?? res) as Record<
                    string,
                    unknown
                >;
                if (!linked || typeof linked !== 'object') {
                    return fallbackDestLcId;
                }
                const hidden = this.parseHiddenFournisseurFieldsFromDoc(linked);
                const fromLinked = this.resolvePvEcartDestinationLcIdFromDoc(linked, hidden);
                this.logPvEcartEntrepot('resolvePvEcartDestinationFromLinkedErp', {
                    linkedErpId,
                    fromLinked,
                    fallbackDestLcId,
                });
                return fromLinked ?? fallbackDestLcId;
            }),
            catchError(() => of(fallbackDestLcId))
        );
    }

    private finalizePvEcartEntrepotLcPanelLoad(
        doc: Record<string, unknown> | null,
        depLcId: number | null,
        destLcId: number | null,
        options?: { refreshLinkedDocuments?: boolean }
    ): void {
        this.commitPvEcartEntrepotLcIdsToUi(depLcId, destLcId);
        this.logPvEcartEntrepot('finalizePvEcartEntrepotLcPanelLoad', {
            docEntrepotDestId: doc?.['entrepot_dest_id'],
            depLcId,
            destLcId,
            linkedErpId: doc
                ? this.resolvePvEcartLinkedErpDocumentIdForEntrepotsFromContext(doc)
                : null,
        });
        this.resolveLcUserStationIdsForDocument$().subscribe({
            next: (ctx) => this.loadPvEcartEntrepotsFromLcApi(ctx, depLcId, destLcId),
            error: (err) => {
                this.toastr.warning(
                    err?.message ||
                        'Connectez le logiciel caisse pour afficher les entrepôts du PV d\'écart.',
                    'Entrepôts'
                );
            },
        });
        this.updateApproveButtonState();
        if (options?.refreshLinkedDocuments && this.documentType === 'PV ECART' && this.documentId && doc) {
            this.refreshPvEcartLinkedDocuments(doc);
        }
    }

    private resolveLcUserStationIdsForDocument$(): Observable<{ userId: number; stationId: number }> {
        const uid = this.lcAuth.getBackUserId();
        const sid = this.lcAuth.getBackStationId();
        if (uid && sid) {
            return of({ userId: uid, stationId: sid });
        }
        const erp = this.lcAuth.getErpContext?.() ?? null;
        if (erp?.erpUserId && Number(erp.erpStationId) > 0) {
            return this.coordinationService.resolve(erp.erpUserId, erp.erpStationId).pipe(
                switchMap((coord) => {
                    const lcUid = coord?.user_id_logiciel;
                    const lcSid = coord?.station_id_logiciel;
                    if (lcUid && lcSid) {
                        return of({ userId: lcUid, stationId: lcSid });
                    }
                    return throwError(
                        () =>
                            new Error(
                                'Impossible de résoudre user_id / station_id logiciel caisse pour les entrepôts.'
                            )
                    );
                })
            );
        }
        return throwError(
            () =>
                new Error(
                    'Session logiciel caisse incomplète (user_id / station_id manquants).'
                )
        );
    }

    private mapLcEntrepotRecordToSelectRow(row: EntrepotApiRecord): Record<string, unknown> {
        const lcId = Number(row.id);
        const lib = String(row.libelle ?? '').trim();
        return {
            ...row,
            id: lcId,
            lc_id: lcId,
            nom: lib || `Entrepôt ${lcId}`,
            libelle: row.libelle,
            code: row.code_entrepot != null ? String(row.code_entrepot).trim() : '',
            code_entrepot: row.code_entrepot,
        };
    }

    private mergeWarehouseOptionIntoList(list: any[], opt: Record<string, unknown>): any[] {
        const lcId = Number(opt['lc_id'] ?? opt['id']);
        const next = (list || []).filter((w) => Number(w?.lc_id ?? w?.id) !== lcId);
        return [...next, opt];
    }

    private applyPvEcartEntrepotLcRow(
        which: 'initial' | 'destination',
        lcId: number,
        row: EntrepotApiRecord
    ): void {
        const opt = this.mapLcEntrepotRecordToSelectRow(row);
        if (which === 'initial') {
            this.selectedWarehouseInitialId = lcId;
            this.warehouses = this.mergeWarehouseOptionIntoList(this.warehouses, opt);
            this.allWarehouses = this.mergeWarehouseOptionIntoList(this.allWarehouses, opt);
            return;
        }
        this.selectedWarehouseDestinationId = lcId;
        this.warehouseDestinationDetail = this.mapLcEntrepotApiToDestinationPanel(row);
        this.applyWarehouseDestinationEtablissementFromDetail(this.warehouseDestinationDetail);
        this.warehousesDestination = this.mergeWarehouseOptionIntoList(
            this.warehousesDestination,
            opt
        );
    }

    /** Charge départ / destination via GET LC (user_id, station_id, entrepot_id). */
    private loadPvEcartEntrepotsFromLcApi(
        ctx: { userId: number; stationId: number },
        depLcId: number | null,
        destLcId: number | null
    ): void {
        const requests: Observable<{ which: 'initial' | 'destination'; lcId: number; row: EntrepotApiRecord }>[] =
            [];
        if (depLcId != null && depLcId > 0) {
            requests.push(
                this.lcEntrepotService
                    .getEntrepotByUserStationAndId(ctx.userId, ctx.stationId, depLcId)
                    .pipe(map((row) => ({ which: 'initial' as const, lcId: depLcId, row })))
            );
        }
        if (destLcId != null && destLcId > 0) {
            requests.push(
                this.lcEntrepotService
                    .getEntrepotByUserStationAndId(ctx.userId, ctx.stationId, destLcId)
                    .pipe(map((row) => ({ which: 'destination' as const, lcId: destLcId, row })))
            );
        }
        if (!requests.length) {
            this.isLoadingWarehouseDestinationDetail = false;
            return;
        }
        this.isLoadingWarehouseDestinationDetail = destLcId != null && destLcId > 0;
        forkJoin(requests).subscribe({
            next: (results) => {
                for (const item of results) {
                    this.applyPvEcartEntrepotLcRow(item.which, item.lcId, item.row);
                }
                this.isLoadingWarehouseDestinationDetail = false;
                this.logPvEcartEntrepot('loadPvEcartEntrepotsFromLcApi — OK', {
                    userId: ctx.userId,
                    stationId: ctx.stationId,
                    depLcId,
                    destLcId,
                });
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.isLoadingWarehouseDestinationDetail = false;
                this.logPvEcartEntrepot('loadPvEcartEntrepotsFromLcApi — erreur', {
                    message: err?.message ?? String(err),
                    depLcId,
                    destLcId,
                });
                this.toastr.warning(
                    err?.message ||
                        'Impossible de charger les entrepôts depuis le logiciel caisse.',
                    'PV d\'écart'
                );
                this.cdr.detectChanges();
            },
        });
    }

    private refreshPvEcartDestinationPanelFromLcApi(): void {
        const doc = this.lastLoadedPvEcartDoc;
        const hidden = doc ? this.parseHiddenFournisseurFieldsFromDoc(doc) : null;
        let destLcId = this.resolvePvEcartDestinationLcIdFromDoc(doc ?? {}, hidden);
        if (destLcId == null) {
            const sel = Number(this.selectedWarehouseDestinationId);
            if (Number.isFinite(sel) && sel > 0) {
                destLcId = sel;
            }
        }
        if (destLcId == null || destLcId <= 0) {
            this.warehouseDestinationDetail = null;
            this.warehouseDestinationEtablissement = null;
            this.isLoadingWarehouseDestinationDetail = false;
            this.cdr.detectChanges();
            return;
        }
        this.isLoadingWarehouseDestinationDetail = true;
        this.resolveLcUserStationIdsForDocument$().subscribe({
            next: (ctx) => {
                this.lcEntrepotService
                    .getEntrepotByUserStationAndId(ctx.userId, ctx.stationId, destLcId!)
                    .subscribe({
                        next: (row) => {
                            this.applyPvEcartEntrepotLcRow('destination', destLcId!, row);
                            this.isLoadingWarehouseDestinationDetail = false;
                            this.cdr.detectChanges();
                        },
                        error: (err) => {
                            this.isLoadingWarehouseDestinationDetail = false;
                            this.logPvEcartEntrepot('refreshPvEcartDestinationPanelFromLcApi — erreur', {
                                destLcId,
                                message: err?.message ?? String(err),
                            });
                            this.cdr.detectChanges();
                        },
                    });
            },
            error: (err) => {
                this.isLoadingWarehouseDestinationDetail = false;
                this.cdr.detectChanges();
                this.logPvEcartEntrepot('refreshPvEcartDestinationPanelFromLcApi — contexte LC', {
                    message: err?.message ?? String(err),
                });
            },
        });
    }

    /** Charge le PV source et applique la même logique entrepôts que sur add-pv-ecart. */
    private loadTransfertEntrepotsFromPvEcartSource(): void {
        const pvId = this.pvEcartSourceDocumentId;
        if (!this.logicielCaisseTransfertFromPvEcart || pvId == null || pvId <= 0) {
            return;
        }
        this.documentService
            .postPvEcartLinkedSources([pvId])
            .pipe(
                take(1),
                catchError(() => of({} as Record<string, PvEcartLinkedSourcesItem>)),
                switchMap((sources) => {
                    const entry = sources[String(pvId)];
                    this.pvEcartLinkedSourcesEntry = entry && !entry.error ? entry : null;
                    return this.documentService.getDocumentById(pvId);
                }),
                take(1)
            )
            .subscribe({
                next: (res) => {
                    const doc = res?.data?.document ?? res?.data ?? res;
                    if (doc) {
                        this.applyPvEcartEntrepotsFromPvDocument(doc, {
                            refreshLinkedDocuments: false,
                        });
                    }
                },
                error: () => {
                    this.toastr.warning(
                        'Impossible de charger le PV d\'écart pour afficher les entrepôts.',
                        'Entrepôts'
                    );
                },
            });
    }

    /**
     * Entrepôts départ / destination (PV ou transfert depuis PV) :
     * résolution ERP/hidden puis GET LC (user_id, station_id, entrepot_id).
     */
    private applyPvEcartEntrepotsFromPvDocument(
        doc: any,
        options?: { refreshLinkedDocuments?: boolean }
    ): void {
        if (!doc) {
            return;
        }
        this.lastLoadedPvEcartDoc = doc;
        const pools = this.getEnrichedLcWarehousePools();
        const hidden = this.parseHiddenFournisseurFieldsFromDoc(doc);
        let depLcId = resolveLcEntrepotIdFromErpOrHidden(
            doc.entrepot_id ?? doc.entrepot?.id,
            hidden?.[LC_ENTREPOT_HIDDEN_KEY],
            pools
        );
        if (
            depLcId == null &&
            this.pendingLcTransfertWarehouseDepId != null &&
            this.logicielCaisseTransfertFromPvEcart
        ) {
            depLcId = this.pendingLcTransfertWarehouseDepId;
        }
        const fallbackDestLcId = this.resolvePvEcartDestinationLcIdFromDoc(doc, hidden);
        this.resolvePvEcartDestinationLcIdFromLinkedErpDocument$(doc, fallbackDestLcId)
            .pipe(take(1))
            .subscribe((destLcId) => {
                const refreshLinked =
                    options?.refreshLinkedDocuments ??
                    (this.documentType === 'PV ECART' && this.documentId != null);
                this.finalizePvEcartEntrepotLcPanelLoad(doc, depLcId, destLcId, {
                    refreshLinkedDocuments: refreshLinked,
                });
            });
    }

    /** PV d'écart : entrepôts départ / destination via API LC (user_id, station_id, entrepot_id). */
    private applyPvEcartEntrepotsFromDoc(doc: any): void {
        if (!doc || this.documentType !== 'PV ECART') {
            return;
        }
        this.applyPvEcartEntrepotsFromPvDocument(doc, { refreshLinkedDocuments: true });
    }

    private getEnrichedLcWarehousePools(): any[] {
        return [
            ...(this.warehouses || []),
            ...(this.warehousesDestination || []),
            ...(this.allWarehouses || []),
            ...(this.allWarehousesEnrichedFull || []),
        ];
    }

    /** Qté envoyée / reçue depuis stock_transfert LC (logiciel caisse). */
    private refreshPvEcartLcQtyBreakdownFromLinked(
        doc: Record<string, unknown>,
        view: PvEcartLinkedDocumentsView
    ): void {
        if (this.documentType !== 'PV ECART') {
            return;
        }
        const lcId = resolvePvEcartLinkedLcTransfertId(doc, view);
        if (lcId == null) {
            return;
        }
        this.lcAuth
            .ensureAuthenticatedSession()
            .pipe(
                switchMap((ok) => {
                    if (!ok) {
                        return of(null);
                    }
                    return this.lcStockTransfert.getById(lcId).pipe(
                        switchMap((detail) => {
                            const num = String(detail.num_document ?? '').trim();
                            if (!num) {
                                return of(detail);
                            }
                            return this.lcStockTransfert
                                .getDetailForTransfertEntrepotModal(num, { id: lcId })
                                .pipe(catchError(() => of(detail)));
                        })
                    );
                }),
                take(1)
            )
            .subscribe({
                next: (detail) => {
                    if (!detail) {
                        return;
                    }
                    this.snapshotPvEcartErpLignesForSave(doc);
                    this.applyPvEcartTransfertFullLinesFromLcDetail(detail);
                    this.pvEcartLineViewFromLcDetail = true;
                    this.reconcileStockLcLineProductIdsFromCatalog();
                    this.enrichPvEcartDisplayLineReferencesFromCatalog();
                    this.calculateTotals();
                    this.cdr.markForCheck();
                },
            });
    }

    private snapshotPvEcartErpLignesForSave(doc: Record<string, unknown>): void {
        if (this.pvEcartErpLignesForSave?.length) {
            return;
        }
        const fromDoc = readPvEcartLignesFromErpDoc(doc);
        if (fromDoc.length) {
            this.pvEcartErpLignesForSave = JSON.parse(JSON.stringify(fromDoc));
            return;
        }
        const built = this.prepareLignesDocumentForSave();
        if (built.length) {
            this.pvEcartErpLignesForSave = JSON.parse(JSON.stringify(built));
        }
    }

    private mergePvEcartDocForLinkedDocumentsLoad(doc: unknown): Record<string, unknown> {
        const base =
            doc && typeof doc === 'object'
                ? ({ ...(doc as Record<string, unknown>) } as Record<string, unknown>)
                : ({} as Record<string, unknown>);
        if (this.modifiedFournisseurFields && typeof this.modifiedFournisseurFields === 'object') {
            base.hidden_fournisseur_fields = {
                ...(base.hidden_fournisseur_fields as object),
                ...(this.modifiedFournisseurFields as object),
            };
        }
        if (this.modifiedClientFields && typeof this.modifiedClientFields === 'object') {
            base.hidden_client_fields = {
                ...(base.hidden_client_fields as object),
                ...(this.modifiedClientFields as object),
            };
        }
        if (this.documentId != null && this.documentId > 0) {
            base.id = this.documentId;
        }
        return base;
    }

    private refreshPvEcartLinkedDocuments(doc: unknown): void {
        if (this.documentType !== 'PV ECART' || !this.documentId) {
            this.pvEcartLinkedDocsView = null;
            this.pvEcartLinkedDocsLoading = false;
            return;
        }
        this.pvEcartLinkedDocsLoading = true;
        this.pvEcartLinkedDocsView = null;
        this.pvEcartDocumentOriginalFromSources = null;
        const docId = this.documentId;
        const freshDoc$ = this.documentService.getDocumentById(docId).pipe(
            map(
                (res) =>
                    (res?.data?.document ?? res?.data ?? doc) as Record<string, unknown>
            ),
            catchError(() => of(this.mergePvEcartDocForLinkedDocumentsLoad(doc)))
        );

        this.lcAuth
            .ensureAuthenticatedSession()
            .pipe(
                take(1),
                switchMap(() => freshDoc$),
                switchMap((fresh) => {
                    const merged = this.mergePvEcartDocForLinkedDocumentsLoad(fresh);
                    this.lastLoadedPvEcartDoc = merged;
                    return forkJoin({
                        sources: this.documentService
                            .postPvEcartLinkedSources([docId])
                            .pipe(catchError(() => of({}))),
                        view: loadPvEcartLinkedDocuments$(
                            this.documentService,
                            merged,
                            this.lcStockTransfert
                        ).pipe(catchError(() => of(null))),
                    }).pipe(map((payload) => ({ merged, ...payload })));
                }),
                take(1)
            )
            .subscribe({
                next: ({ merged, sources, view }) => {
                    const mergedDoc = merged ?? this.mergePvEcartDocForLinkedDocumentsLoad(doc);
                    const entry = sources[String(docId)];
                    const linked = mergePvEcartLinkedDocumentsFromSourcesAndClient(
                        entry,
                        view,
                        mergedDoc
                    );
                    this.pvEcartLinkedSourcesEntry = entry && !entry.error ? entry : null;
                    this.pvEcartLinkedDocsView = linked.view;
                    this.pvEcartDocumentOriginalFromSources = linked.documentOriginal;
                    const resolvedView = linked.view ?? view;
                    this.pvEcartLinkedDocsLoading = false;
                    if (this.usesDualEntrepotSelection()) {
                        this.applyPvEcartEntrepotsFromPvDocument(mergedDoc, {
                            refreshLinkedDocuments: false,
                        });
                    }
                    if (this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert()) {
                        const linkedRef = resolvePvEcartLinkedTransfertHeaderReference(
                            mergedDoc,
                            resolvedView ?? undefined
                        );
                        if (linkedRef) {
                            this.pvEcartLinkedTransfertRefDisplay = linkedRef;
                        }
                    }
                    this.refreshPvEcartLcQtyBreakdownFromLinked(mergedDoc, resolvedView ?? undefined);
                    this.cdr.detectChanges();
                },
                error: () => {
                    this.pvEcartLinkedDocsLoading = false;
                    this.cdr.detectChanges();
                },
            });
    }

    onBonSortiePartyOrgChange(which: 'emetteur' | 'recepteur', value: unknown): void {
        if (!this.isBonSortieDocument()) {
            return;
        }
        let opt: DocumentOrgSelectOption | null = null;
        if (value != null && typeof value === 'object' && 'key' in (value as object)) {
            opt = value as DocumentOrgSelectOption;
        } else {
            const key = String(value ?? '');
            opt = this.orgSelectOptions.find((o) => o.key === key) || null;
        }
        if (!opt) {
            return;
        }
        if (which === 'emetteur') {
            this.selectedOrgKey = opt.key;
            this.selectedEtablissementId = opt.type === 'etablissement' ? opt.id : null;
            this.selectedWarehouseInitialId = null;
            if (opt.type === 'etablissement') {
                this.loadEtablissementEntrepotLinks();
            } else {
                this.applyEntrepotEstablishmentFilter();
            }
            this.reloadStockQuantitiesForAllProducts();
        } else {
            this.selectedOrgKeyRecepteur = opt.key;
            this.selectedEtablissementDestId = opt.type === 'etablissement' ? opt.id : null;
            this.selectedWarehouseDestinationId = null;
            if (opt.type === 'etablissement') {
                this.loadEtablissementEntrepotLinks();
            } else {
                this.applyEntrepotEstablishmentFilter();
            }
        }
        this.onWarehouseChange();
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    private applySourceWarehouseFromDoc(doc: any): void {
        if (!doc) {
            return;
        }
        const erpId = Number(doc.entrepot_id ?? doc.entrepot?.id);
        let hidden: any = doc?.hidden_fournisseur_fields;
        if (typeof hidden === 'string') {
            try {
                hidden = JSON.parse(hidden);
            } catch {
                hidden = null;
            }
        }
        const lcFromHidden = Number(hidden?.[LC_ENTREPOT_HIDDEN_KEY]);
        let entrepotId: number | null = null;
        if (Number.isFinite(lcFromHidden) && lcFromHidden > 0) {
            entrepotId = lcFromHidden;
        } else if (Number.isFinite(erpId) && erpId > 0) {
            entrepotId = mapErpEntrepotIdToLcSelectId(erpId, this.getEnrichedLcWarehousePools());
        }
        if (entrepotId == null) {
            return;
        }
        this.selectedWarehouseId = entrepotId;
        const nom = doc.entrepot?.nom || doc.entrepot?.libelle || doc.entrepot?.label || doc.code_entrepot;
        if (nom != null && String(nom).trim() !== '') {
            this.lockedWarehouseName = String(nom).trim();
        }
    }

    showQuantiteDisponibleColumn(): boolean {
        if (this.documentType === 'PV ECART') {
            return false;
        }
        return this.isStockLcDocumentType();
    }

    /** En-tête colonne stock (bon de sortie → quantité = stock physique LC). */
    getQuantiteStockColumnLabel(): string {
        return this.isBonSortieDocument() ? 'Quantité' : 'Quantité disponible';
    }

    /** Suffixe stock dans la popup variantes (physique vs disponible). */
    getVariantStockWebSuffix(): string {
        return this.isBonSortieDocument() ? 'phys.' : 'disp.';
    }

    private getProductLogisticsInfoArray(product: any): any[] {
        if (!product || typeof product !== 'object') {
            return [];
        }
        const raw =
            product.informations_logistique ??
            product.information_logistique ??
            product.informationsLogistique ??
            product.informations_logistiques ??
            product.product?.informations_logistique ??
            product.data?.informations_logistique ??
            product.data?.information_logistique;
        return Array.isArray(raw) ? raw : [];
    }

    private unwrapProductFromApiResponse(res: any): any {
        if (res == null || typeof res !== 'object') {
            return null;
        }
        const inner =
            res.data?.data ??
            res.data?.product ??
            res.data ??
            res.product ??
            res.produit;
        if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
            return inner;
        }
        return res;
    }

    private parseLogisticMinimum(line: any): number {
        if (line == null || typeof line !== 'object') {
            return NaN;
        }
        const raw = line.minimum ?? line.min ?? line.quantite_min ?? line.stock_min ?? line.seuil_min;
        const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'));
        return Number.isFinite(n) ? n : NaN;
    }

    private nearlyEqualQty(a: number, b: number): boolean {
        return Math.abs(a - b) < 1e-6;
    }

    private isLogisticAlertEnabledOnLine(line: any): boolean {
        if (!line || typeof line !== 'object') {
            return false;
        }
        const v = line.is_active_alert ?? line.is_active_alerte ?? line.active_alert;
        if (v === true || v === 1 || v === '1') {
            return true;
        }
        if (v === false || v === 0 || v === '0' || v === '') {
            return false;
        }
        return !!v;
    }

    private isStockRuptureAlertEnabledForItem(item: Item): boolean {
        const pid = item.product_id;
        if (pid == null) {
            return false;
        }
        const product = this.products.find((p) => Number(p.id) === Number(pid));
        if (!product) {
            return false;
        }
        const lines = this.getProductLogisticsInfoArray(product);
        if (lines.length === 0) {
            return false;
        }
        const entrepotId = this.shouldFilterStockByEntrepot() ? this.getEntrepotIdForStockQuantity() : null;
        if (entrepotId != null) {
            const line = lines.find(
                (l) => Number(l.entrepot_id ?? l.entrepotId) === Number(entrepotId)
            );
            if (line) {
                return this.isLogisticAlertEnabledOnLine(line);
            }
            return false;
        }
        return lines.some((l) => this.isLogisticAlertEnabledOnLine(l));
    }

    private queueStockRupturePopup(): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        if (this.stockRupturePopupTimer != null) {
            clearTimeout(this.stockRupturePopupTimer);
        }
        this.stockRupturePopupTimer = setTimeout(() => {
            this.stockRupturePopupTimer = null;
            this.zone.run(() => this.openStockRuptureModalIfNeeded());
        }, 400);
    }


    private getLineStockQtyForRuptureAlert(item: Item): number {
        if (item.stockResolved === true && item.availableQuantity !== undefined && item.availableQuantity !== null) {
            const n = Number(item.availableQuantity);
            return Number.isFinite(n) ? n : 0;
        }
        return this.getStockQuantityForDisplay(item);
    }

    /** Lignes produit avec quantité strictement négative (hors avoir). */
    private findProductLinesWithNegativeQuantity(): Array<{ designation: string; quantity: number }> {
        if (!this.shouldEnforceNonNegativeProductQuantity()) {
            return [];
        }
        const bad: Array<{ designation: string; quantity: number }> = [];
        for (const it of this.items) {
            if (it.type !== 'product' || !it.designation?.trim()) {
                continue;
            }
            const q = Number(it.quantity);
            if (Number.isFinite(q) && q < 0) {
                bad.push({ designation: it.designation.trim(), quantity: q });
            }
        }
        return bad;
    }

    /** Nouveau transfert entrepôt : lignes dont la quantité demandée dépasse le stock disponible (entrepôt départ). */
    private findLogicielCaisseTransfertQuantityOverAvailable(): Array<{
        designation: string;
        qty: number;
        dispo: number;
    }> {
        if (!this.isLogicielCaisseEntrepotTransfert()) {
            return [];
        }
        const over: Array<{ designation: string; qty: number; dispo: number }> = [];
        const pvEcartStockByEcart =
            this.logicielCaisseTransfertFromPvEcart &&
            this.pvEcartQtyBreakdownByItemIndex.size > 0;

        this.items.forEach((it, index) => {
            if (it.type !== 'product' || !it.designation?.trim()) {
                return;
            }
            if (pvEcartStockByEcart) {
                const row = this.pvEcartQtyBreakdownByItemIndex.get(index);
                if (!row || !Number.isFinite(row.ecartSigned)) {
                    return;
                }
                const ecart = Math.trunc(row.ecartSigned);
                if (ecart === 0) {
                    return;
                }
                if (ecart < 0) {
                    return;
                }
                const dispo = this.getLineStockQtyForRuptureAlert(it as Item);
                if (ecart > dispo) {
                    over.push({
                        designation: it.designation.trim(),
                        qty: ecart,
                        dispo: Math.trunc(dispo),
                    });
                }
                return;
            }
            const qty = Number(it.quantity);
            if (!Number.isFinite(qty) || qty <= 0) {
                return;
            }
            const dispo = this.getLineStockQtyForRuptureAlert(it as Item);
            if (qty > dispo) {
                over.push({
                    designation: it.designation.trim(),
                    qty: Math.trunc(qty),
                    dispo: Math.trunc(dispo),
                });
            }
        });
        return over;
    }

    private toastLogicielCaisseTransfertQuantityInsufficient(
        lines: Array<{ designation: string; qty: number; dispo: number }>
    ): void {
        if (!lines.length) {
            return;
        }
        const body =
            lines.length === 1
                ? `« ${lines[0].designation} » : quantité ${lines[0].qty}, disponible ${lines[0].dispo}.`
                : lines
                      .map((l) => `• ${l.designation} (${l.qty} > ${l.dispo})`)
                      .join('\n');
        this.toastr.error(body, 'Quantité insuffisante', {
            timeOut: 12000,
            closeButton: true,
        });
    }

    private openStockRuptureModalIfNeeded(): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        const lines = this.items
            .filter(
                (it) =>
                    it.type === 'product' &&
                    !!it.product_id &&
                    !!it.designation?.trim() &&
                    this.isStockRuptureAlertEnabledForItem(it as Item) &&
                    it.stockResolved === true &&
                    this.getLineStockQtyForRuptureAlert(it as Item) <= 0
            )
            .map((it) => ({
                designation: (it.designation || 'Produit').trim(),
                qty: this.getLineStockQtyForRuptureAlert(it as Item)
            }));
        if (lines.length === 0) {
            return;
        }
        this.stockRuptureModalLines = lines;
        this.cdr.detectChanges();

        const openModal = (tpl: TemplateRef<any>) => {
            if (this.stockRuptureModalRef) {
                try {
                    this.stockRuptureModalRef.dismiss();
                } catch {

                }
                this.stockRuptureModalRef = null;
            }
            const ref = this.modalService.open(tpl, {
                ariaLabelledBy: 'modal-stock-rupture-title',
                centered: true,
                size: 'md',
                windowClass: 'warning-modal-centered stock-rupture-modal-window',
                backdropClass: 'stock-rupture-backdrop',
                backdrop: 'static',
                keyboard: true
            });
            this.stockRuptureModalRef = ref;
            ref.result.then(
                () => undefined,
                () => undefined
            ).then(() => {
                if (this.stockRuptureModalRef === ref) {
                    this.stockRuptureModalRef = null;
                }
            });
        };

        const tpl = this.stockRuptureModal;
        if (tpl) {
            openModal(tpl);
            return;
        }
        setTimeout(() => {
            const t2 = this.stockRuptureModal;
            if (t2) {
                this.zone.run(() => openModal(t2));
            } else {
                const msg = lines.map((l) => `• ${l.designation} (dispo : ${l.qty})`).join('\n');
                this.toastr.warning(msg, 'Stock insuffisant', {
                    timeOut: 12000,
                    closeButton: true,
                    enableHtml: false
                });
            }
        }, 0);
    }
    /** Normalise code entrepôt pour matching ERP ↔ LC. */
    private normalizeEntrepotCode(value: unknown): string {
        return String(value ?? '').trim().toUpperCase();
    }

    /**
     * Enrichit les entrepôts LC avec erp_id (match code_entrepot puis libellé).
     * Le select garde id = ID logiciel caisse.
     */
    private enrichLcWarehousesWithErpMapping(lcRows: any[]): Observable<any[]> {
        const rows = Array.isArray(lcRows) ? lcRows : [];
        const userId = Number(this.currentUser?.id) || 0;
        const stationId = Number(this.stationId) || 0;
        const withLcMeta = (list: any[]): any[] =>
            (list || []).map((w) => {
                const lcId = Number(w?.id);
                return {
                    ...w,
                    id: lcId,
                    lc_id: lcId,
                    erp_id: w?.erp_id != null ? Number(w.erp_id) : null,
                    erp_entrepot_id:
                        w?.erp_entrepot_id != null
                            ? Number(w.erp_entrepot_id)
                            : w?.erp_id != null
                              ? Number(w.erp_id)
                              : null,
                };
            });

        if (!(userId > 0) || !(stationId > 0) || !rows.length) {
            return of(withLcMeta(rows));
        }

        return this.warehouseService.getAllWarehouses(userId, stationId).pipe(
            map((erpRows: any[]) => {
                this.cachedErpWarehouseRows = (erpRows || []) as ErpEntrepotRowLike[];
                const byCode = new Map<string, number>();
                const byName = new Map<string, number>();
                for (const e of erpRows || []) {
                    const eid = Number(e?.id);
                    if (!Number.isFinite(eid) || eid <= 0) {
                        continue;
                    }
                    const code = this.normalizeEntrepotCode(e?.code ?? e?.code_entrepot);
                    if (code) {
                        byCode.set(code, eid);
                    }
                    const nom = String(e?.nom ?? e?.libelle ?? '').trim().toLowerCase();
                    if (nom) {
                        byName.set(nom, eid);
                    }
                }
                return (rows || []).map((w) => {
                    const lcId = Number(w?.id);
                    const code = this.normalizeEntrepotCode(w?.code_entrepot ?? w?.code);
                    const nom = String(w?.nom ?? w?.libelle ?? '').trim().toLowerCase();
                    const erpId =
                        (code && byCode.get(code)) || (nom && byName.get(nom)) || null;
                    return {
                        ...w,
                        id: lcId,
                        lc_id: lcId,
                        erp_id: erpId,
                        erp_entrepot_id: erpId,
                    };
                });
            }),
            catchError(() => of(withLcMeta(rows)))
        );
    }

    private getLcEntrepotPoolForErpMapping(): LcEntrepotRowLike[] {
        const seen = new Set<number>();
        const out: LcEntrepotRowLike[] = [];
        for (const w of [
            ...(this.allWarehousesEnrichedFull || []),
            ...(this.warehouses || []),
            ...(this.allWarehouses || []),
            ...(this.warehousesDestination || []),
        ]) {
            const id = Number((w as { lc_id?: number; id?: number })?.lc_id ?? (w as { id?: number })?.id);
            if (!Number.isFinite(id) || id <= 0 || seen.has(id)) {
                continue;
            }
            seen.add(id);
            out.push(w as LcEntrepotRowLike);
        }
        return out;
    }

    private isKnownErpEntrepotId(erpId: number | null | undefined): boolean {
        const n = Number(erpId);
        if (!Number.isFinite(n) || n <= 0) {
            return false;
        }
        if (!this.cachedErpWarehouseRows.length) {
            return true;
        }
        return this.cachedErpWarehouseRows.some((e) => Number(e?.id) === n);
    }

    /** ID ERP à partir de la sélection UI (id LC ou déjà ERP). */
    private resolveErpEntrepotIdFromSelection(selectedId: number | null | undefined): number | null {
        return mapLcSelectIdToErpEntrepotId(
            selectedId,
            this.getLcEntrepotPoolForErpMapping(),
            this.cachedErpWarehouseRows
        );
    }

    /** ID logiciel caisse à partir de la sélection UI. */
    private resolveLcEntrepotIdFromSelection(selectedId: number | null | undefined): number | null {
        if (selectedId == null) {
            return null;
        }
        const n = Number(selectedId);
        if (!Number.isFinite(n) || n <= 0) {
            return null;
        }
        const pool = [
            ...(this.warehouses || []),
            ...(this.allWarehouses || []),
            ...(this.warehousesDestination || []),
            ...(this.allWarehousesEnrichedFull || []),
        ];
        let w = pool.find(
            (x: any) => Number(x?.id) === n || Number(x?.lc_id) === n
        );
        if (!w) {
            w = pool.find(
                (x: any) => Number(x?.erp_id) === n || Number(x?.erp_entrepot_id) === n
            );
        }
        const lc = Number(w?.lc_id ?? w?.id);
        if (Number.isFinite(lc) && lc > 0) {
            return lc;
        }
        return n;
    }

    /** Entrepôt LC pour POST bon-sortie-sortie (select document). */
    private resolveLcEntrepotIdForBonSortieStock(): number | null {
        const mapped = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseId);
        if (mapped != null) {
            return mapped;
        }
        const raw = Number(this.selectedWarehouseId);
        if (Number.isFinite(raw) && raw > 0) {
            console.warn('[BonSortieStock] entrepôt : repli id sélectionné', raw);
            return raw;
        }
        return null;
    }

    private getEntrepotIdForStockQuantity(): number | null {
        // Quantités / mouvements ERP → ID entrepôt ERP (jamais l'id LC brut).
        if (this.usesDualEntrepotSelection()) {
            if (this.documentType === 'PV ECART') {
                return this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
            }
            return this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseInitialId);
        }
        return this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseId);
    }

    /** Entrepôt ERP pour alimenter le stock (bon réception « Reçu », etc.). */
    private resolveWarehouseIdForStockUpdate(): number | null {
        return this.getEntrepotIdForStockQuantity();
    }
    private getStockCacheKey(productId: number, entrepotId?: number | null): string {
        if (this.shouldFilterStockByEntrepot() && entrepotId) {
            return `${productId}_${entrepotId}`;
        }
        return `${productId}`;
    }

    getStockQuantity(product: Product | Item): number {
        const useCacheOnly = this.isStockLcDocumentType();
        if (!useCacheOnly && 'availableQuantity' in product && product.availableQuantity !== undefined && product.availableQuantity !== null) {
            return product.availableQuantity;
        }
        let productId: number | undefined;
        let entrepotId: number | null | undefined;
        
        if ('product_id' in product && product.product_id) {
            productId = product.product_id;
        } else if ('id' in product && product.id !== undefined && product.id !== null) {
            productId = product.id;
        }
        if (this.shouldFilterStockByEntrepot()) {
            entrepotId = this.usesLogicielCaisseStockApi()
                ? this.getEntrepotIdForStockQuantityCache()
                : this.getEntrepotIdForStockQuantity();
        }
        if (productId !== undefined) {
            const cacheKey = this.getStockCacheKey(productId, entrepotId);
            const cachedQty = this.stockQuantitiesCache.get(cacheKey);
            if (cachedQty !== undefined) {
                return cachedQty;
            }
            if (this.stockQuantitiesLoadingKeys.has(cacheKey)) {
                return 0;
            }

            if (productId !== undefined && productId !== null) {
                // Transfert / inventaire / gestion stock : API LC (pas back-erp by-product-id)
                if (this.usesLogicielCaisseStockApi()) {
                    this.stockQuantitiesLoadingKeys.add(cacheKey);
                    this.fetchSelectOptionStockQuantity(productId).subscribe({
                        next: (quantity) => {
                            const q = Number.isFinite(quantity) ? quantity : 0;
                            const key = this.getStockCacheKey(productId!, entrepotId);
                            this.stockQuantitiesCache.set(key, q);
                            this.stockQuantitiesLoadingKeys.delete(key);
                            const prod = this.products.find((p) => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = q;
                            }
                            this.cdr.markForCheck();
                        },
                        error: () => {
                            const key = this.getStockCacheKey(productId!, entrepotId);
                            this.stockQuantitiesCache.set(key, 0);
                            this.stockQuantitiesLoadingKeys.delete(key);
                            const prod = this.products.find((p) => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            this.cdr.markForCheck();
                        },
                    });
                    return 0;
                }

                if (this.shouldFilterStockByEntrepot() && entrepotId) {
                    this.stockQuantitiesLoadingKeys.add(cacheKey);
                    this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                        next: (stockDetails: any) => {
                            let quantity = 0;
                            if (stockDetails && stockDetails.stocks_by_entrepot) {
                                const stockByEntrepot = stockDetails.stocks_by_entrepot.find((stock: any) => 
                                    stock.entrepot_id === entrepotId || stock.entrepotId === entrepotId
                                );
                                
                                if (stockByEntrepot) {
                                    quantity = Number(stockByEntrepot.quantity || stockByEntrepot.qty || 0);
                                } else {
                                    quantity = 0;
                                }
                            } else {
                                quantity = 0;
                            }
                            
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, quantity);
                            this.stockQuantitiesLoadingKeys.delete(cacheKey);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = quantity;
                            }
                            this.cdr.markForCheck();
                        },
                        error: (error) => {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            this.stockQuantitiesLoadingKeys.delete(cacheKey);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            this.cdr.markForCheck();
                        }
                    });
                } else {
                    this.stockQuantitiesLoadingKeys.add(cacheKey);
                    this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                        next: (stockDetails: any) => {
                            if (!stockDetails) {
                                const cacheKey = this.getStockCacheKey(productId, entrepotId);
                                this.stockQuantitiesCache.set(cacheKey, 0);
                                this.stockQuantitiesLoadingKeys.delete(cacheKey);
                                this.cdr.markForCheck();
                                return;
                            }
                            
                            let quantity = 0;
                            
                            if (this.shouldFilterStockByEntrepot() && entrepotId) {
                                const stockByEntrepot = stockDetails.stocks_by_entrepot?.find((stock: any) => stock.entrepot_id === entrepotId);
                                if (stockByEntrepot) {
                                    quantity = Number(stockByEntrepot.quantity || 0);
                                } else {
                                    quantity = 0;
                                }
                            } else {
                                quantity = Number(stockDetails.total_quantity || 0);
                            }
                            
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, quantity);
                            this.stockQuantitiesLoadingKeys.delete(cacheKey);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = quantity;
                            }
                            this.cdr.markForCheck();
                        },
                        error: () => {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            this.stockQuantitiesLoadingKeys.delete(cacheKey);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            this.cdr.markForCheck();
                        }
                    });
                }
            }
            return 0;
        }
        if ('informations_logistique' in product && product.informations_logistique && product.informations_logistique.length > 0) {
            return product.informations_logistique[0].minimum || 0;
        }
        
        return 0;
    }
    getStockQuantityForDisplay(item: Product | Item | null | undefined): number {
        if (item == null) return 0;
        const line = item as Item;
        if (
            line.stockResolved === true &&
            line.availableQuantity !== undefined &&
            line.availableQuantity !== null
        ) {
            const n = Number(line.availableQuantity);
            return Number.isFinite(n) ? Math.trunc(n) : 0;
        }
        const useLineOnly =
            this.documentType === 'INVENTAIRE' ||
            this.isBonTransfertOrEntrepotTransfert() ||
            this.documentType === 'BON DE LIVRAISON' ||
            this.documentType === 'BON RECEPTION' ||
            this.documentType === 'BON DE SORTIE';
        if (useLineOnly && 'availableQuantity' in item && (item as Item).availableQuantity != null) {
            const n = Number((item as Item).availableQuantity);
            return Number.isFinite(n) ? n : 0;
        }
        const useCacheOnly = (this.isStockLcDocumentType());
        const qty = useCacheOnly
            ? (this.getStockQuantity(item) ?? 0)
            : (('availableQuantity' in item && item.availableQuantity != null) ? item.availableQuantity : (this.getStockQuantity(item) ?? 0));
        const num = Number(qty);
        return Number.isFinite(num) ? Math.trunc(num) : 0;
    }

    /** Stock disponible affiché : somme du groupe / couleur si regroupement replié. */
    getProductLineStockDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id) {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return this.getStockQuantityForDisplay(item);
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (!this.isProductLineGroupHead(index)) {
                return 0;
            }
            return this.sumProductLineStockQuantities(
                this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
            );
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineStockQuantities(this.getProductLineCouleurMemberIndices(index));
        }
        return this.getStockQuantityForDisplay(item);
    }

    isProductLineStockResolved(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id) {
            return false;
        }
        let indices: number[] = [index];
        if (!this.productLineGroupCanToggle(index)) {
            return item.stockResolved === true;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (!this.isProductLineGroupHead(index)) {
                return false;
            }
            indices = this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index));
        } else if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            indices = this.getProductLineCouleurMemberIndices(index);
        }
        return (indices || []).every((mi) => this.items[mi]?.stockResolved === true);
    }

    /** Contour rouge sur la quantité si saisie > stock disponible affiché. */
    isProductLineQuantityOverAvailableStock(index: number): boolean {
        if (!this.showQuantiteDisponibleColumn()) {
            return false;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id || !String(item.designation || '').trim()) {
            return false;
        }
        if (!this.isProductLineStockResolved(index)) {
            return false;
        }
        const qty = Number(this.getProductLineQuantityDisplay(index));
        const stock = Number(this.getProductLineStockDisplay(index));
        if (!Number.isFinite(qty) || !Number.isFinite(stock)) {
            return false;
        }
        return qty > stock;
    }

    private sumProductLineStockQuantities(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product' && it.product_id) {
                sum += this.getStockQuantityForDisplay(it);
            }
        }
        return Math.trunc(sum);
    }

    /** Charge le stock de toutes les lignes agrégées (regroupement replié → total global). */
    private ensureStockLoadedForProductLineAggregate(index: number): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id) {
            return;
        }
        let indices: number[] = [index];
        if (this.productLineGroupCanToggle(index) && !this.isProductLineBarcodeGroupExpanded(index)) {
            indices = this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index));
        } else if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            indices = this.getProductLineCouleurMemberIndices(index);
        }
        for (const mi of indices) {
            const it = this.items[mi];
            if (it?.type === 'product' && it.product_id && it.stockResolved !== true) {
                this.loadStockQuantity(Number(it.product_id), it.reference || '', mi);
            }
        }
    }

    formatPlainStockQuantity(value: number | string | null | undefined): string {
        return formatPlainStockQuantity(value);
    }

    private applyStockToLine(
        index: number,
        productId: number,
        quantity: number,
        entrepotId: number | null | undefined,
        shouldUpdateCache: boolean
    ): void {
        const row = this.items[index];
        if (!row || row.type !== 'product' || Number(row.product_id) !== Number(productId)) {
            return;
        }
        const q = !Number.isFinite(quantity) || quantity < 0 ? 0 : Math.trunc(quantity);
        row.availableQuantity = q;
        row.stockResolved = true;
        if (shouldUpdateCache) {
            const cacheKey = this.getStockCacheKey(productId, entrepotId);
            this.stockQuantitiesCache.set(cacheKey, q);
        }
        if (
            (this.documentType === 'FACTURE FOURNISSEUR' || this.documentType === 'BON RECEPTION') &&
            row.product_id &&
            row.quantity != null &&
            row.quantity !== undefined
        ) {
            this.calculateValeurUnitaireFactureFournisseur(index, row);
        } else {
        this.afterStockLineUpdated();
        }
    }

    private loadStockQuantity(productId: number, refInterne: string, index: number): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        const item = this.items[index];
        if (!item) {
            return;
        }
        if (item.stockResolved === true && item.availableQuantity != null) {
            return;
        }
        item.stockResolved = false;
        // BON TRANSFERT / INVENTAIRE : ne pas écraser le cache global (utilisé par le select produits).
        // Le stock affiché doit rester le stock réel jusqu'à approbation du document.
        const isStockDoc = this.isStockLcDocumentType();
        const shouldUpdateCache = !isStockDoc;

        const entrepotIdErp = this.shouldFilterStockByEntrepot()
            ? this.getEntrepotIdForStockQuantity()
            : null;
        const product = this.findProductForLcStockMeta(productId, refInterne);
        const meta = this.buildLcStockMetaFromProduct(product, productId, refInterne);
        if (!meta) {
            this.applyStockToLine(index, productId, 0, entrepotIdErp, shouldUpdateCache);
            return;
        }
        this.lcStockGestion
            .getStockGlobaleByErpProducts([meta], {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .subscribe({
                next: (rec) => {
                    const qty = pickLcGlobaleStockQtyForDocumentType(
                        this.documentType,
                        rec[productId]
                    );
                    this.applyStockToLine(index, productId, qty, entrepotIdErp, shouldUpdateCache);
                },
                error: () => {
                    this.applyStockToLine(index, productId, 0, entrepotIdErp, shouldUpdateCache);
                },
            });
    }

    private afterStockLineUpdated(): void {
        this.cdr.markForCheck();
        this.queueStockRupturePopup();
    }

    private readUserIdFromLocalStorage(): number | null {
        try {
            const u = JSON.parse(localStorage.getItem('currentUser') || '{}');
            const id = u?.id ?? u?.user_id;
            if (id == null || id === '') {
                return null;
            }
            const n = Number(id);
            return Number.isFinite(n) && n > 0 ? n : null;
        } catch {
            return null;
        }
    }

    private readStationIdFromLocalStorageForBarcodeApi(): number {
        return getStationIdFromLocalStorage();
    }

    private isProductLikeObject(o: any): boolean {
        if (!o || typeof o !== 'object' || Array.isArray(o)) {
            return false;
        }
        const id = o.id;
        if (id == null || id === '') {
            return false;
        }
        const idNum = Number(id);
        if (!Number.isFinite(idNum)) {
            return false;
        }
        const labelKeys = ['nom', 'designation', 'name', 'libelle', 'label', 'title', 'intitule'];
        if (labelKeys.some((k) => o[k] != null && String(o[k]).trim() !== '')) {
            return true;
        }
        const skuKeys = ['ref_interne', 'reference', 'sku', 'code_article'];
        if (skuKeys.some((k) => o[k] != null && String(o[k]).trim() !== '')) {
            return true;
        }
        if (o.code_barre != null && String(o.code_barre).trim() !== '') {
            return true;
        }
        return false;
    }

    private collectProductLikeFromBarcodeResponse(node: any, out: any[], depth: number): void {
        if (node == null || depth > 12) {
            return;
        }
        if (Array.isArray(node)) {
            for (const el of node) {
                this.collectProductLikeFromBarcodeResponse(el, out, depth + 1);
            }
            return;
        }
        if (typeof node !== 'object') {
            return;
        }
        if (this.isProductLikeObject(node)) {
            out.push(node);
            return;
        }
        for (const k of Object.keys(node)) {
            const v = (node as any)[k];
            if (v != null && typeof v === 'object') {
                this.collectProductLikeFromBarcodeResponse(v, out, depth + 1);
            }
        }
    }

    private normalizeDocumentProductFromBarcodeApi(raw: any): any {
        if (!raw || typeof raw !== 'object') {
            return raw;
        }
        const nom =
            raw.nom ??
            raw.designation ??
            raw.name ??
            raw.libelle ??
            raw.label ??
            raw.title ??
            raw.intitule ??
            '';
        let liste_prix = raw.liste_prix;
        if (Array.isArray(liste_prix) && liste_prix.length > 0) {
            liste_prix = liste_prix[0];
        }
        const ref_interne = raw.ref_interne ?? raw.reference ?? raw.sku ?? raw.code_article ?? '';
        const ct = this.extractCouleurTailleFromProductLike(raw);
        return {
            ...raw,
            nom: String(nom || '').trim() || String(ref_interne || '').trim() || `Produit #${raw.id}`,
            ref_interne: ref_interne || raw.ref_interne,
            liste_prix,
            couleur: ct.couleur || raw.couleur || null,
            taille: ct.taille || raw.taille || null,
        };
    }

    private unwrapProductsFromBarcodeApiResponse(res: any): Product[] {
        if (res == null) {
            return [];
        }
        const collected: any[] = [];
        this.collectProductLikeFromBarcodeResponse(res, collected, 0);
        const byId = new Map<number, any>();
        for (const p of collected) {
            const id = Number(p.id);
            if (Number.isFinite(id)) {
                byId.set(id, p);
            }
        }
        let list = Array.from(byId.values());
        if (list.length === 0 && this.isProductLikeObject(res)) {
            list = [res];
        }
        return list.map((p) => this.normalizeDocumentProductFromBarcodeApi(p)) as Product[];
    }

    private mergeProductsFromBarcodeApiIntoStore(products: Product[]): void {
        if (!products?.length) {
            return;
        }
        let changed = false;
        for (const p of products) {
            const id = p?.id;
            if (id == null) {
                continue;
            }
            const n = Number(id);
            if (!Number.isFinite(n)) {
                continue;
            }
            const idx = this.products.findIndex((pr) => Number(pr.id) === n);
            if (idx < 0) {
                this.products.push(p as Product);
                changed = true;
            } else {
                const merged = {
                    ...this.products[idx],
                    ...p,
                    ref_fabricant:
                        this.extractRefFabricantFromProductLike(p) ||
                        (this.products[idx] as any).ref_fabricant,
                } as Product;
                this.products[idx] = merged;
                changed = true;
            }
        }
        if (changed) {
            this.invalidateBarcodePickerItemsCache();
            this.rebuildProductsForDocumentSelect();
        }
    }

    private filterProductsByBarcodeClientSide(base: Product[], qNoSpace: string): Product[] {
        return base.filter((p: any) => {
            const cb = p?.code_barre;
            if (cb == null || cb === '') {
                return false;
            }
            const s = String(cb).trim();
            if (s === '' || s === '0') {
                return false;
            }
            const normalized = s.replace(/\s/g, '');
            return normalized.includes(qNoSpace);
        });
    }

    onProductLineBarcodeQueryChange(lineIndex: number, value: string | null | undefined): void {
        const qTrim = value != null ? String(value).trim() : '';
        const prevTimer = this.barcodeLineDebounceTimers[lineIndex];
        if (prevTimer != null) {
            clearTimeout(prevTimer);
            delete this.barcodeLineDebounceTimers[lineIndex];
        }
        if (!qTrim) {
            delete this.productLineBarcodeApiHits[lineIndex];
            delete this.productLineBarcodeSearchLoading[lineIndex];
            this.cdr.markForCheck();
            return;
        }
        this.barcodeLineDebounceTimers[lineIndex] = setTimeout(() => {
            delete this.barcodeLineDebounceTimers[lineIndex];
            this.fetchProductsByBarcodeFromApi(lineIndex, qTrim);
        }, 400);
    }

    private fetchProductsByBarcodeFromApi(lineIndex: number, codeBarre: string): void {
        const requested = String(codeBarre).trim();
        const requestedNoSpace = requested.replace(/\s/g, '');
        const userId = this.readUserIdFromLocalStorage();
        const stationId = this.readStationIdFromLocalStorageForBarcodeApi();
        if (!userId || !stationId) {
            this.toastr.warning(
                'Impossible d’appeler l’API code à barre : utilisateur ou station manquant dans localStorage.',
                'Code à barre'
            );
            return;
        }
        this.productLineBarcodeSearchLoading[lineIndex] = true;
        this.cdr.markForCheck();
        this.productsService
            .getProductsByCodeBarre(codeBarre, stationId, userId)
            .pipe(
                finalize(() => {
                    this.productLineBarcodeSearchLoading[lineIndex] = false;
                    this.cdr.markForCheck();
                }),
                catchError(() => {
                    delete this.productLineBarcodeApiHits[lineIndex];
                    this.toastr.error(
                        'Impossible de récupérer le produit par code à barre.',
                        'Erreur'
                    );
                    return of(null);
                })
            )
            .subscribe((res) => {
                if (res == null) {
                    return;
                }
                const list = this.unwrapProductsFromBarcodeApiResponse(res);
                this.productLineBarcodeApiHits[lineIndex] = list;
                this.mergeProductsFromBarcodeApiIntoStore(list);
                this.cdr.markForCheck();

                const currentRaw = this.productLineBarcodeQuery[lineIndex];
                const current = currentRaw != null ? String(currentRaw).trim() : '';
                const currentNoSpace = current.replace(/\s/g, '');
                const stillSameQuery =
                    current === requested ||
                    (requestedNoSpace !== '' && currentNoSpace === requestedNoSpace);

                if (list.length === 0) {
                    this.toastr.warning('Aucun produit trouvé pour ce code à barre.', 'Code à barre');
                    return;
                }
                if (list.length === 1 && stillSameQuery) {
                    this.zone.run(() => {
                        setTimeout(() => {
                            this.applyLineFromBarcodeApiResult(lineIndex, list[0]);
                        }, 0);
                    });
                }
            });
    }

    private pickProductFromBarcodeApiList(list: Product[], preferred?: any): Product {
        if (!list?.length) {
            throw new Error('pickProductFromBarcodeApiList: liste vide');
        }
        if (list.length === 1) {
            return list[0];
        }
        const prefId = preferred?.id != null ? Number(preferred.id) : NaN;
        if (Number.isFinite(prefId)) {
            const byId = list.find((p) => Number(p.id) === prefId);
            if (byId) {
                return byId;
            }
        }
        const prefCb = String(
            (preferred as any)?.code_barre ?? (preferred as any)?.code_bar ?? ''
        ).replace(/\s/g, '');
        if (prefCb) {
            const byCb = list.find((p: any) =>
                String(p?.code_barre ?? p?.code_bar ?? '')
                    .replace(/\s/g, '') === prefCb
            );
            if (byCb) {
                return byCb;
            }
        }
        return list[0];
    }

    private applyLineFromBarcodeApiResult(lineIndex: number, productToApply: Product): void {
        this.productLineBarcodeQuery[lineIndex] = '';
        delete this.productLineBarcodeApiHits[lineIndex];
        delete this.productLineBarcodeSearchLoading[lineIndex];
        this.applyProductSelectionToLine(lineIndex, productToApply, 1);
    }

    private fetchProductByBarcodeAndApplyToLine(
        lineIndex: number,
        codeBarre: string,
        preferredProduct?: any
    ): void {
        const code = String(codeBarre ?? '').trim();
        if (!code || code === '0') {
            this.toastr.warning('Code à barre invalide.', 'Code à barre');
            delete this.barcodePickerModel[lineIndex];
            this.invalidateBarcodePickerMergedLineCache(lineIndex);
            return;
        }
        const userId = this.readUserIdFromLocalStorage();
        const stationId = this.readStationIdFromLocalStorageForBarcodeApi();
        if (!userId || !stationId) {
            this.toastr.warning(
                'Impossible d’appeler l’API code à barre : utilisateur ou station manquant dans localStorage.',
                'Code à barre'
            );
            delete this.barcodePickerModel[lineIndex];
            this.invalidateBarcodePickerMergedLineCache(lineIndex);
            return;
        }
        this.productLineBarcodeSearchLoading[lineIndex] = true;
        this.cdr.markForCheck();
        this.productsService
            .getProductsByCodeBarre(code, stationId, userId)
            .pipe(
                finalize(() => {
                    this.productLineBarcodeSearchLoading[lineIndex] = false;
                    this.cdr.markForCheck();
                }),
                catchError(() => {
                    this.toastr.error(
                        'Impossible de récupérer le produit par code à barre.',
                        'Erreur'
                    );
                    delete this.barcodePickerModel[lineIndex];
                    this.invalidateBarcodePickerMergedLineCache(lineIndex);
                    return of(null);
                })
            )
            .subscribe((res) => {
                if (res == null) {
                    return;
                }
                const list = this.unwrapProductsFromBarcodeApiResponse(res);
                this.mergeProductsFromBarcodeApiIntoStore(list);
                if (list.length === 0) {
                    this.toastr.warning('Aucun produit trouvé pour ce code à barre.', 'Code à barre');
                    delete this.barcodePickerModel[lineIndex];
                    this.invalidateBarcodePickerMergedLineCache(lineIndex);
                    return;
                }
                const toApply = this.pickProductFromBarcodeApiList(list, preferredProduct);
                this.zone.run(() => {
                    this.applyLineFromBarcodeApiResult(lineIndex, toApply);
                });
            });
    }

    getProductSelectItemsForLine(lineIndex: number): Product[] {
        const base = this.productsForDocumentSelect || [];
        const raw = this.productLineBarcodeQuery[lineIndex];
        const q = raw != null ? String(raw).trim().replace(/\s/g, '') : '';
        if (!q) {
            return base;
        }
        const apiList = this.productLineBarcodeApiHits[lineIndex];
        if (apiList != null && apiList.length > 0) {
            return apiList.filter((p) => this.productHasRefFabricantForSelect(p));
        }
        return this.filterProductsByBarcodeClientSide(base, q).filter((p) =>
            this.productHasRefFabricantForSelect(p)
        );
    }

    getBarcodePickerItemsForLine(lineIndex: number): Product[] {
        const row = this.items[lineIndex];
        const filled = row?.type === 'product' && !!row.designation?.trim();
        const m = this.barcodePickerModel[lineIndex];
        const modelKey =
            filled && m?.id != null ? `M${Number(m.id)}` : 'N';

        const base = this.getCachedBarcodePickerBaseList();
        const apiList = this.productLineBarcodeApiHits[lineIndex];
        const apiKey = apiList?.length
            ? apiList
                  .map((p) => p.id)
                  .filter((id) => id != null)
                  .sort((a, b) => Number(a) - Number(b))
                  .join(',')
            : '';
        const mergeKey = `${this.getBarcodePickerBaseFingerprint()}_${lineIndex}_${apiKey}_${modelKey}`;
        if (
            this.barcodePickerMergedKeyByLine[lineIndex] === mergeKey &&
            this.barcodePickerMergedByLine[lineIndex]
        ) {
            return this.barcodePickerMergedByLine[lineIndex];
        }
        let list: Product[];
        if (!apiList?.length) {
            list = base;
        } else {
            const byId = new Map<number, Product>();
            for (const p of base) {
                if (p?.id != null) {
                    byId.set(Number(p.id), p);
                }
            }
            for (const p of apiList) {
                if (p?.id != null) {
                    byId.set(Number(p.id), p as Product);
                }
            }
            list = this.sortBarcodePickerProducts(Array.from(byId.values()));
        }
        if (filled && m?.id != null) {
            const mid = Number(m.id);
            const has = list.some((p) => p?.id != null && Number(p.id) === mid);
            if (!has) {
                list = [m as Product, ...list];
            }
        }
        this.barcodePickerMergedByLine[lineIndex] = list;
        this.barcodePickerMergedKeyByLine[lineIndex] = mergeKey;
        return list;
    }

    private getProductsWithRealBarcodeSortedForPicker(): Product[] {
        const list = (this.products || []).filter(
            (p: any) => !this.isBarcodeEmptyOrZeroForSelect(p)
        ) as Product[];
        return this.sortBarcodePickerProducts(list);
    }

    private sortBarcodePickerProducts(list: Product[]): Product[] {
        return [...list].sort((a: any, b: any) => {
            const ca = String(a?.code_barre ?? '').trim();
            const cb = String(b?.code_barre ?? '').trim();
            return ca.localeCompare(cb, undefined, { numeric: true });
        });
    }

    private extractCouleurTailleFromProductLike(p: any): { couleur: string; taille: string } {
        if (!p || typeof p !== 'object') {
            return { couleur: '', taille: '' };
        }
        const couleurRaw =
            p.couleur ??
            p.couleur_libelle ??
            p.libelle_couleur ??
            p.nom_couleur ??
            p.color ??
            p.couleur_nom;
        const tailleRaw =
            p.taille ??
            p.taille_libelle ??
            p.libelle_taille ??
            p.nom_taille ??
            p.size ??
            p.taille_nom;
        const couleur =
            couleurRaw != null && String(couleurRaw).trim() !== '' ? String(couleurRaw).trim() : '';
        const taille =
            tailleRaw != null && String(tailleRaw).trim() !== '' ? String(tailleRaw).trim() : '';
        return { couleur, taille };
    }

    formatBarcodeDisplayForPicker(code: any): string {
        const raw = code != null ? String(code).replace(/\s/g, '').trim() : '';
        if (!raw) {
            return '';
        }
        if (/^\d{13}$/.test(raw)) {
            return `${raw[0]} ${raw.slice(1, 7)} ${raw.slice(7)}`;
        }
        if (/^\d{12}$/.test(raw)) {
            return `${raw.slice(0, 6)} ${raw.slice(6)}`;
        }
        if (/^\d{8}$/.test(raw)) {
            return `${raw.slice(0, 4)} ${raw.slice(4)}`;
        }
        return String(code).trim();
    }

    formatBarcodePickerCouleurTaille(p: any): string {
        const { couleur: c, taille: t } = this.extractCouleurTailleFromProductLike(p);
        if (c && t) {
            return `${c} / ${t}`;
        }
        if (c) {
            return c;
        }
        if (t) {
            return t;
        }
        return '—';
    }

    onBarcodePickerSearch(lineIndex: number, event: { term: string; items: any[] }): void {
        const term = event?.term ?? '';
        this.productLineBarcodeQuery[lineIndex] = term;
        this.onProductLineBarcodeQueryChange(lineIndex, term);
    }

    enableBarcodePickerEdit(lineIndex: number): void {
        const it = this.items[lineIndex];
        if (it?.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        this.barcodePickerUnlockEdit[lineIndex] = true;
        this.invalidateBarcodePickerMergedLineCache(lineIndex);
        this.cdr.markForCheck();
    }

    private restoreBarcodePickerModelForLine(lineIndex: number): void {
        const it = this.items[lineIndex];
        if (it?.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        const pid = it.product_id != null ? Number(it.product_id) : NaN;
        if (!Number.isFinite(pid)) {
            return;
        }
        const fromCatalog = this.products.find((pr) => Number(pr.id) === pid);
        if (fromCatalog) {
            this.barcodePickerModel[lineIndex] = fromCatalog;
        } else {
            this.barcodePickerModel[lineIndex] = {
                id: pid,
                nom: it.designation || '',
                code_barre: it.code_barre || '',
                ref_interne: it.reference,
                couleur: it.couleur ?? null,
                taille: it.taille ?? null,
            } as any as Product;
        }
        this.hydrateItemVariantFieldsFromBarcodePicker(lineIndex);
        this.invalidateBarcodePickerMergedLineCache(lineIndex);
    }

    onBarcodeColumnSelect(index: number, product: any): void {
        const row = this.items[index];
        if (row?.type === 'product' && row.designation?.trim() && !this.barcodePickerUnlockEdit[index]) {
            return;
        }
        const prevTimer = this.barcodeLineDebounceTimers[index];
        if (prevTimer != null) {
            clearTimeout(prevTimer);
            delete this.barcodeLineDebounceTimers[index];
        }
        if (!product) {
            this.productLineBarcodeQuery[index] = '';
            delete this.productLineBarcodeApiHits[index];
            delete this.productLineBarcodeSearchLoading[index];
            const rowAfter = this.items[index];
            if (
                rowAfter?.type === 'product' &&
                rowAfter.designation?.trim() &&
                this.barcodePickerUnlockEdit[index]
            ) {
                delete this.barcodePickerUnlockEdit[index];
                this.restoreBarcodePickerModelForLine(index);
            } else {
                delete this.barcodePickerModel[index];
                this.invalidateBarcodePickerMergedLineCache(index);
            }
            this.cdr.markForCheck();
            return;
        }
        const rawCb = (product as any).code_barre ?? (product as any).code_bar;
        const code = rawCb != null ? String(rawCb).trim() : '';
        if (!code || code === '0') {
            this.toastr.warning(
                'Ce produit n’a pas de code à barre exploitable.',
                'Code à barre'
            );
            const rowBad = this.items[index];
            if (
                rowBad?.type === 'product' &&
                rowBad.designation?.trim() &&
                this.barcodePickerUnlockEdit[index]
            ) {
                delete this.barcodePickerUnlockEdit[index];
                this.restoreBarcodePickerModelForLine(index);
            } else {
                delete this.barcodePickerModel[index];
                this.invalidateBarcodePickerMergedLineCache(index);
            }
            return;
        }
        this.fetchProductByBarcodeAndApplyToLine(index, code, product);
    }

    isProductLineBarcodeSearchLoading(lineIndex: number): boolean {
        return !!this.productLineBarcodeSearchLoading[lineIndex];
    }

    /** ng-select désignation : id produit, objet ou nom (legacy bindValue nom). */
    private resolveProductFromDesignationSelect(
        selected: unknown,
        lineIndex?: number
    ): Product | null {
        if (selected == null || selected === '') {
            return null;
        }
        if (typeof selected === 'number' && Number.isFinite(selected) && selected > 0) {
            return this.findCatalogProductById(selected, lineIndex);
        }
        if (typeof selected === 'string') {
            const s = selected.trim();
            if (/^\d+$/.test(s)) {
                return this.findCatalogProductById(Number(s), lineIndex);
            }
            if (s) {
                return this.findCatalogProductByNom(s, lineIndex);
            }
            return null;
        }
        if (typeof selected === 'object') {
            const o = selected as Product;
            if (o.id != null && Number.isFinite(Number(o.id))) {
                return (
                    this.findCatalogProductById(Number(o.id), lineIndex) ?? o
                );
            }
            const nomObj = String((o as any).nom ?? '').trim();
            if (nomObj) {
                return this.findCatalogProductByNom(nomObj, lineIndex);
            }
        }
        return null;
    }

    private findCatalogProductById(id: number, lineIndex?: number): Product | null {
        const target = Number(id);
        if (!Number.isFinite(target) || target <= 0) {
            return null;
        }
        const lineItems =
            lineIndex != null ? this.getProductSelectItemsForLine(lineIndex) : [];
        const pools = [
            lineItems,
            this.productsForDocumentSelect,
            this.products,
            this.variantModalFullGroup,
        ];
        for (const pool of pools) {
            const hit = (pool || []).find((p) => Number(p?.id) === target);
            if (hit) {
                return hit;
            }
        }
        return null;
    }

    private findCatalogProductByNom(nom: string, lineIndex?: number): Product | null {
        const target = nom.trim();
        if (!target) {
            return null;
        }
        const lineItems =
            lineIndex != null ? this.getProductSelectItemsForLine(lineIndex) : [];
        const pools = [
            lineItems,
            this.productsForDocumentSelect,
            this.products,
            this.variantModalFullGroup,
        ];
        for (const pool of pools) {
            const hit = (pool || []).find((p) => String(p?.nom ?? '').trim() === target);
            if (hit?.id != null) {
                return hit;
            }
        }
        return null;
    }

    /** Variantes : même ref. fabricant, sinon même nom (commande fournisseur / achat). */
    private getVariantGroupProductsForDesignationSelect(p: Product): Product[] {
        const refGroup = this.getRefFabricantGroupProducts(p);
        if (this.resolveVariantModalProductRows(refGroup).length >= 2) {
            return refGroup;
        }
        const nomKey = String(p?.nom ?? '')
            .trim()
            .toLowerCase();
        if (nomKey) {
            const byNom = (this.products || []).filter(
                (pr) => String(pr?.nom ?? '').trim().toLowerCase() === nomKey
            );
            if (this.resolveVariantModalProductRows(byNom).length >= 2) {
                return byNom;
            }
        }
        return refGroup;
    }

    /** Lignes du popup variantes : priorité aux codes-barres valides, sinon toute la ref. fabricant. */
    private resolveVariantModalProductRows(group: Product[]): Product[] {
        const withBarcode = this.filterVariantModalProductsByBarcode(group);
        if (withBarcode.length >= 2) {
            return withBarcode;
        }
        const byId = new Map<number, Product>();
        for (const p of this.sortVariantGroupForModal(group)) {
            const id = p?.id != null ? Number(p.id) : NaN;
            if (Number.isFinite(id) && id > 0) {
                byId.set(id, p);
            }
        }
        return Array.from(byId.values());
    }

    /**
     * Même flux que front-gestion-stock : (change) ng-select → groupe ref. fabricant → popup si ≥ 2 CB.
     */
    onProductSelect(index: number, selectedProduct: any): void {
        if (!selectedProduct) {
            delete this.productLineBarcodeQuery[index];
            delete this.productLineBarcodeApiHits[index];
            delete this.productLineBarcodeSearchLoading[index];
            delete this.barcodePickerModel[index];
            delete this.barcodePickerUnlockEdit[index];
            this.invalidateBarcodePickerMergedLineCache(index);
            const cleared = this.items[index];
            if (cleared?.type === 'product') {
                cleared.code_barre = '';
                cleared.product_id = null as any;
                cleared.designation = '';
            }
            return;
        }

        const apiHits = this.productLineBarcodeApiHits[index];
        const selectedId = selectedProduct?.id != null ? Number(selectedProduct.id) : NaN;
        const isFromBarcodeApiLookup =
            Array.isArray(apiHits) &&
            apiHits.length > 0 &&
            Number.isFinite(selectedId) &&
            apiHits.some((p: any) => Number(p?.id) === selectedId);

        this.productLineBarcodeQuery[index] = '';
        delete this.productLineBarcodeApiHits[index];
        delete this.productLineBarcodeSearchLoading[index];

        if (isFromBarcodeApiLookup) {
            this.applyProductSelectionToLine(index, selectedProduct, 1);
            return;
        }

        this.tryDesignationSelectWithVariantModal(index, selectedProduct);
    }

    private tryDesignationSelectWithVariantModal(index: number, selectedProduct: Product): void {
        const tryLocal = (): { group: Product[]; withBarcode: Product[] } => {
            const group = this.getRefFabricantGroupProducts(selectedProduct);
            const withBarcode = this.filterVariantModalProductsByBarcode(group);
            return { group, withBarcode };
        };

        let { group, withBarcode } = tryLocal();
        if (withBarcode.length >= 2) {
            this.openVariantSelectionModal(index, selectedProduct, group);
            return;
        }

        if (!this.stationId) {
            this.stationId = getStationIdFromLocalStorage();
        }
        const ref = this.extractRefFabricantFromProductLike(selectedProduct);
        if (!ref || !this.stationId) {
            const toApply = withBarcode.length === 1 ? withBarcode[0] : selectedProduct;
            this.applyProductSelectionToLine(index, toApply, 1);
            return;
        }

        this.productsService.getProductsByRefFabricant(this.stationId, ref).subscribe({
            next: (list) => {
                const mapped = (list || []).map((p) => this.mapApiProductForDocumentSelect(p));
                if (mapped.length > 0) {
                    this.mergeProductsFromBarcodeApiIntoStore(mapped);
                }
                const refreshed =
                    mapped.find((p) => Number(p?.id) === Number(selectedProduct.id)) ??
                    selectedProduct;
                group = this.getRefFabricantGroupProducts(refreshed as Product);
                if (mapped.length > 0) {
                    group = this.mergeVariantGroupProducts(group, mapped);
                }
                withBarcode = this.filterVariantModalProductsByBarcode(group);
                this.zone.run(() => {
                    if (withBarcode.length >= 2) {
                        this.openVariantSelectionModal(index, refreshed as Product, group);
                    } else {
                        const toApply =
                            withBarcode.length === 1 ? withBarcode[0] : (refreshed as Product);
                        this.applyProductSelectionToLine(index, toApply, 1);
                    }
                });
            },
            error: () => {
                this.zone.run(() => {
                    const toApply = withBarcode.length === 1 ? withBarcode[0] : selectedProduct;
                    this.applyProductSelectionToLine(index, toApply, 1);
                });
            },
        });
    }

    private applyProductSelectionToLine(index: number, selectedProduct: any, quantity: number = 1): void {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !selectedProduct?.id) {
            return;
        }

        item.product_id = selectedProduct.id;
        item.designation = selectedProduct.nom;
        item.reference = selectedProduct.ref_interne || selectedProduct.reference || '-';
        const rawCb = (selectedProduct as any).code_barre ?? (selectedProduct as any).code_bar;
        const cbTrim = rawCb != null ? String(rawCb).trim() : '';
        item.code_barre =
            cbTrim !== '' && cbTrim !== '0' ? cbTrim : '';

        const isAchat = this.isAchatDocument();
        const prixUnitaireOrigine = this.documentUsesErpPrixUnitairesCatalog()
            ? resolveErpProductPrixUnitaireAchat(selectedProduct)
            : isAchat
            ? (Number(selectedProduct.prix_unitaires) || Number(selectedProduct.prix_achat) || 0)
              : (selectedProduct.result_ht ||
                    selectedProduct.liste_prix?.[0]?.result_ht ||
                    selectedProduct.prix_unitaires ||
                    0);
        item.priceHT = prixUnitaireOrigine;
        item.prixUnitaireRef = prixUnitaireOrigine;

        if (this.documentUsesErpPrixUnitairesCatalog()) {
            item.valeur_unitaire = prixUnitaireOrigine;
        } else if (this.isStockLcDocumentType()) {
            const unit = this.resolveStockLcUnitPriceFromProductLike(selectedProduct);
            item.valeur_unitaire = unit;
            item.priceHT = unit;
        } else if (
            this.documentType === 'FACTURE FOURNISSEUR' ||
            this.documentType === 'BON RECEPTION'
        ) {
            item.valeur_unitaire = Number(selectedProduct.valeur_unitaire) || Number(selectedProduct.prix_unitaires) || 0;
        } else {
            item.valeur_unitaire = selectedProduct.valeur_unitaire || 0;
        }
        const q = Number(quantity);
        item.quantity = Number.isFinite(q) && q > 0 ? q : 1;

        if (this.documentType === 'FACTURE FOURNISSEUR' || this.documentType === 'BON RECEPTION') {
            this.calculateTotal(index);
        }
        item.availableQuantity = undefined;
        if (selectedProduct.id) {
            this.loadStockQuantity(selectedProduct.id, item.reference || '', index);
        } else {
            item.availableQuantity = undefined;
        }

        if (selectedProduct.description) {
            this.productDescriptions[index] = selectedProduct.description;
        } else {
            this.productDescriptions[index] = '';
        }
        this.showProductDescription[index] = this.isVenteAchatAffCourteDesp();

        const variantCt = this.extractCouleurTailleFromProductLike(selectedProduct);
        item.couleur = variantCt.couleur;
        item.taille = variantCt.taille;

        if (selectedProduct.unite) {
            item.unite_libelle = selectedProduct.unite.libelle || selectedProduct.unite.nom || '--';
        } else if (selectedProduct.unite_id) {
            item.unite_libelle = this.getUniteLibelle(selectedProduct.unite_id);
        } else {
            item.unite_libelle = '--';
        }
        if (selectedProduct.tva_id === null || selectedProduct.tva_id === undefined) {
            item.tva = '0';
        } else {
            const tvaFound = this.tvaRates.find(t => t.id === selectedProduct.tva_id);
            if (tvaFound) {
                item.tva = tvaFound.valeur.toString();
            } else {
                item.tva = '0';
            }
        }
        if (this.taxes && this.taxes.length > 0) {
            this.applyProductTaxes(selectedProduct, index);
        } else {
            const sub = this.taxeService.getTaxeList(this.stationId).subscribe({
                next: (res => {
                    this.loadTaxes();
                    setTimeout(() => this.applyProductTaxes(selectedProduct, index), 100);
                    sub.unsubscribe();
                }),
            });
        }

        this.calculateLine(index);
        this.calculateTotals();
        this.updateTvaSummary();
        this.barcodePickerModel[index] = selectedProduct as Product;
        delete this.barcodePickerUnlockEdit[index];
        this.invalidateBarcodePickerMergedLineCache(index);
        this.cdr.detectChanges();
        this.updateApproveButtonState();
    }

    private invalidateBarcodePickerMergedLineCache(lineIndex: number): void {
        delete this.barcodePickerMergedByLine[lineIndex];
        delete this.barcodePickerMergedKeyByLine[lineIndex];
    }

     private hydrateItemVariantFieldsFromBarcodePicker(lineIndex: number): void {
        const it = this.items[lineIndex];
        const m = this.barcodePickerModel[lineIndex] as any;
        if (it?.type !== 'product' || !m) {
            return;
        }
        const ct = this.extractCouleurTailleFromProductLike(m);
        if (!(String(it.couleur ?? '').trim()) && ct.couleur) {
            it.couleur = ct.couleur;
        }
        if (!(String(it.taille ?? '').trim()) && ct.taille) {
            it.taille = ct.taille;
        }
    }

    private syncBarcodePickerModelForProductLines(): void {
        this.items.forEach((it, idx) => {
            if (it.type !== 'product' || !it.designation?.trim()) {
                return;
            }
            this.syncBarcodePickerModelForLine(idx);
        });
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    /** Sync code-barres uniquement pour les lignes visibles (groupes repliés = tête seule). */
    private syncBarcodePickerModelForVisibleProductLines(): void {
        this.items.forEach((it, idx) => {
            if (it.type !== 'product' || !it.designation?.trim()) {
                return;
            }
            if (!this.isProductLineVisible(idx)) {
                return;
            }
            this.syncBarcodePickerModelForLine(idx);
        });
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private syncBarcodePickerModelForLine(idx: number): void {
        const it = this.items[idx];
        if (!it || it.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        const pid = it.product_id != null ? Number(it.product_id) : NaN;
        if (!Number.isFinite(pid)) {
            return;
        }
        const fromCatalog = this.products.find((pr) => Number(pr.id) === pid);
        if (fromCatalog) {
            this.barcodePickerModel[idx] = fromCatalog;
            this.hydrateItemVariantFieldsFromBarcodePicker(idx);
            return;
        }
        this.barcodePickerModel[idx] = {
            id: pid,
            nom: it.designation || '',
            code_barre: it.code_barre || '',
            ref_interne: it.reference,
            couleur: it.couleur ?? null,
            taille: it.taille ?? null,
        } as any as Product;
    }

    /** Clé de regroupement désignation / ref fabricant pour replier les codes-barres. */
    getProductLineGroupKey(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return `solo:${index}`;
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            const ref = this.normalizeRefFabricantForSelect(
                (fromCatalog as any)?.ref_fabricant ??
                    (fromCatalog as any)?.ref_fabriquant ??
                    (item as any).ref_fabricant ??
                    (item as any).ref_fabriquant
            );
            if (ref) {
                return `ref:${ref}`;
            }
        }
        const des = String(item.designation || '')
            .trim()
            .toLowerCase();
        if (des) {
            return `des:${des}`;
        }
        return `solo:${index}`;
    }

    getProductLineGroupMemberIndices(groupKey: string): number[] {
        const out: number[] = [];
        (this.items || []).forEach((it, i) => {
            if (it?.type === 'product' && this.getProductLineGroupKey(i) === groupKey) {
                out.push(i);
            }
        });
        return out;
    }

    /** Couleur normalisée pour regroupement (vide → « — »). */
    getProductLineCouleurNorm(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return '—';
        }
        const fromItem = String(item.couleur ?? '').trim();
        if (fromItem) {
            return fromItem;
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            const { couleur } = this.extractCouleurTailleFromProductLike(fromCatalog);
            if (couleur) {
                return couleur;
            }
        }
        return '—';
    }

    getProductLineCouleurGroupKey(index: number): string {
        const desKey = this.getProductLineGroupKey(index);
        const couleur = this.getProductLineCouleurNorm(index);
        return `${desKey}|c:${couleur.toLowerCase()}`;
    }

    getProductLineCouleurMemberIndices(index: number): number[] {
        const desKey = this.getProductLineGroupKey(index);
        const couleurNorm = this.getProductLineCouleurNorm(index).toLowerCase();
        return this.getProductLineGroupMemberIndices(desKey).filter(
            (mi) => this.getProductLineCouleurNorm(mi).toLowerCase() === couleurNorm
        );
    }

    isProductLineGroupHead(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        return members.length > 0 && members[0] === index;
    }

    /** Première ligne du sous-groupe couleur (dans le groupe désignation). */
    isProductLineCouleurHead(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        return colorMembers.length > 0 && colorMembers[0] === index;
    }

    /** Groupe avec plusieurs lignes code-barres sur le document. */
    productLineGroupCanToggle(index: number): boolean {
        if (!this.useProductMatrixLineDisplay()) {
            return false;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        return this.getProductLineGroupMemberIndices(key).length > 1;
    }

    /** Sous-groupe couleur avec plusieurs produits (taille / code-barres). */
    productLineCouleurGroupCanToggle(index: number): boolean {
        if (!this.useProductMatrixLineDisplay()) {
            return false;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return false;
        }
        return this.getProductLineCouleurMemberIndices(index).length > 1;
    }

    /** true = matrice couleur × taille ; false = lignes classiques (paramètre + override session). */
    useProductMatrixLineDisplay(): boolean {
        return resolveDocumentProductMatrixDisplay({
            stationAffProduitMatriciel: this.paramDocAffProduitMatriciel,
        });
    }

    isProductLineBarcodeGroupExpanded(index: number): boolean {
        return this.expandedBarcodeGroups.has(this.getProductLineGroupKey(index));
    }

    isProductLineCouleurGroupExpanded(index: number): boolean {
        return this.expandedCouleurGroups.has(this.getProductLineCouleurGroupKey(index));
    }

    isProductLineBarcodeGroupLoading(index: number): boolean {
        return !!this.barcodeGroupLoading[this.getProductLineGroupKey(index)];
    }

    getProductLineGroupBarcodeCount(index: number): number {
        return this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index)).length;
    }

    /** Nombre de couleurs distinctes dans le groupe réf. fabricant. */
    getProductLineGroupCouleurCount(index: number): number {
        const members = this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index));
        const couleurs = new Set<string>();
        for (const mi of members) {
            couleurs.add(this.getProductLineCouleurNorm(mi).toLowerCase());
        }
        return couleurs.size;
    }

    /** En-tête réf. fabricant ouvert (texte simple, sans chip). */
    shouldShowProductLineRefOpenSummary(index: number): boolean {
        return (
            this.productLineGroupCanToggle(index) &&
            this.isProductLineGroupHead(index) &&
            this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    /**
     * Nombre de colonnes du tableau produits (aligné sur document.component.html :
     * code-barres → actions).
     */
    getProductTableColumnCount(): number {
        const s = this.documentColumnSettings || {};
        let count = 1; // DÉSIGNATION
        if (s.reference) {
            count++;
        }
        if (s.taille) {
            count++;
        }
        if (s.quantite) {
            count++;
        }
        if (this.showQuantiteDisponibleColumn()) {
            count++;
        }
        if (s.unite) {
            count++;
        }
        if (this.showDocumentPrixHtColumn()) {
            count++;
        }
        if (s.remise) {
            count++;
        }
        if (s.tva) {
            count++;
        }
        if (
            s.afficherMontantsTTC &&
            this.documentType !== 'INVENTAIRE' &&
            this.documentType !== 'BON TRANSFERT'
        ) {
            count++;
        }
        if (this.showPvEcartQtyBreakdownColumns()) {
            count += 3;
        }
        count++; // TOTAL HT
        count++; // actions
        return count;
    }

    /** Colonnes après « Désignation / référence » sur la bannière réf. ouverte. */
    getProductLineRefOpenBannerTrailingColspan(): number {
        const s = this.documentColumnSettings || {};
        const leading = s.reference ? 2 : 1;
        return Math.max(1, this.getProductTableColumnCount() - leading);
    }

    /**
     * Hint code-barres (couleur · N codes) uniquement si réf. fabricant ouverte et sous-groupe couleur replié.
     * Jamais la réf. fabricant dans cette colonne (réservée à la colonne désignation).
     */
    shouldShowProductLineBarcodeColumnCouleurHint(index: number): boolean {
        return (
            this.isProductLineBarcodeGroupExpanded(index) &&
            this.isProductLineCouleurHead(index) &&
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineRefGroupCollapsedHead(index)
        );
    }

    /** Ligne produit ouverte : en-têtes de groupe sur des lignes séparées, champs alignés sur une rangée. */
    shouldShowProductLineSplitLayout(index: number): boolean {
        return this.shouldShowProductLineFullEditor(index);
    }

    /** Bandeau couleur au-dessus de la ligne code-barres / désignation (1ère ligne du sous-groupe). */
    shouldShowProductLineCouleurBannerRow(index: number): boolean {
        if (!this.shouldShowProductLineSplitLayout(index)) {
            return false;
        }
        if (this.getProductLineCouleurNorm(index) === '—') {
            return false;
        }
        return this.isProductLineCouleurHead(index);
    }

    /** Ligne variante produit (groupe ref. ouvert) — fond uniforme y compris 1ère ligne du sous-groupe couleur. */
    isProductLineVariantProductRow(index: number): boolean {
        return (
            this.shouldShowProductLineFullEditor(index) &&
            this.productLineGroupCanToggle(index) &&
            this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    getProductLineCouleurBarcodeCount(index: number): number {
        return this.getProductLineCouleurMemberIndices(index).length;
    }

    /** Libellé niveau 1 : référence fabricant (sinon désignation). */
    getProductLineRefFabricantLabel(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return '—';
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        let ref = '';
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            ref = this.normalizeRefFabricantForSelect(
                (fromCatalog as any)?.ref_fabricant ??
                    (fromCatalog as any)?.ref_fabriquant ??
                    (item as any).ref_fabricant ??
                    (item as any).ref_fabriquant
            );
        } else {
            ref = this.normalizeRefFabricantForSelect(
                (item as any).ref_fabricant ?? (item as any).ref_fabriquant
            );
        }
        if (ref) {
            return ref;
        }
        const des = String(item.designation || '').trim();
        return des || '—';
    }

    /** Niveau 1 fermé : ligne regroupée par réf. fabricant. */
    isProductLineRefGroupCollapsedHead(index: number): boolean {
        return (
            this.productLineGroupCanToggle(index) &&
            this.isProductLineGroupHead(index) &&
            !this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    /** Niveau 2 fermé : ligne regroupée par couleur (sous réf. fabricant ouverte). */
    isProductLineCouleurGroupCollapsedHead(index: number): boolean {
        return (
            this.isProductLineBarcodeGroupExpanded(index) &&
            this.isProductLineCouleurHead(index) &&
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index)
        );
    }

    /**
     * Ligne affichée alors qu’un niveau de regroupement (réf. fabricant ou couleur) est replié.
     * Aligné sur la visibilité : pas de saisie prix / détail produit tant que le groupe n’est pas ouvert.
     */
    isProductLineInCollapsedGroup(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return false;
        }
        if (!this.expandedBarcodeGroups.has(key)) {
            return true;
        }
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        if (colorMembers.length <= 1) {
            return false;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        return !this.expandedCouleurGroups.has(couleurKey);
    }

    /** Niveau 3 : éditeur produit complet (ligne feuille). */
    shouldShowProductLineFullEditor(index: number): boolean {
        if (!this.productLineGroupCanToggle(index)) {
            return true;
        }
        return !this.isProductLineInCollapsedGroup(index);
    }

    /** Groupe réf. fabricant replié (niveau 1 fermé). */
    isProductLineRefGroupCollapsed(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return false;
        }
        return !this.expandedBarcodeGroups.has(key);
    }

    /** Saisie Prix HT : pour stock LC, recopie vers valeur_unitaire (payload ligne). */
    onProductLinePriceHtInput(index: number): void {
        const item = this.items[index];
        if (item?.type === 'product' && this.isStockLcDocumentType()) {
            const pu = Number(item.priceHT);
            item.valeur_unitaire = Number.isFinite(pu) ? pu : 0;
        }
        this.calculateTotal(index);
    }

    /** Prix HT : affiché sur toute ligne produit visible (groupe ouvert ou replié). */
    shouldShowProductLinePrixHt(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        return this.isProductLineVisible(index);
    }

    showDocumentPrixHtColumn(): boolean {
        if (this.isStockLcDocumentType()) {
            return false;
        }
        return !!this.documentColumnSettings?.prixUnitaire;
    }

    showDocumentRemiseColumn(): boolean {
        if (this.isStockLcDocumentType()) {
            return false;
        }
        return !!this.documentColumnSettings?.remise;
    }

    showDocumentTvaColumn(): boolean {
        if (this.isStockLcDocumentType()) {
            return false;
        }
        return !!this.documentColumnSettings?.tva;
    }

    /**
     * Quantité en lecture seule (somme) si le regroupement affiché est fermé ;
     * éditable uniquement quand la ligne produit individuelle est visible (groupe ouvert).
     */
    isProductLineQuantityReadonly(index: number): boolean {
        if (this.isPvEcartLcLinkedLineView()) {
            return true;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return false;
        }
        // Désignation fermée → quantité globale du groupement.
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return true;
        }
        // Couleur fermée → quantité globale de la couleur.
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return true;
        }
        return false;
    }

    /** Quantité affichée : somme du groupe/couleur si fermé, sinon quantité de la ligne. */
    getProductLineQuantityDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return Number(item.quantity) || 0;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return this.sumProductLineQuantities(
                this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
            );
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineQuantities(this.getProductLineCouleurMemberIndices(index));
        }
        return Number(item.quantity) || 0;
    }

    /** PU HT d’une ligne produit (aligné affichage prix / calcul montants). */
    private resolveProductLineUnitPrice(item: any): number {
        if (!item) {
            return 0;
        }
        if (this.isStockLcDocumentType()) {
            return (
                Number(item.valeur_unitaire) ||
                Number(item.priceHT) ||
                Number(item.prixUnitaireRef) ||
                0
            );
        }
        return (
            Number(item.priceHT) ||
            Number(item.valeur_unitaire) ||
            Number(item.prixUnitaireRef) ||
            0
        );
    }

    /** Prix unitaire HT affiché (ligne ou tête de groupe replié). */
    getProductLinePrixHtDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return 0;
        }
        const linePu = (): number => this.resolveProductLineUnitPrice(item);

        if (!this.productLineGroupCanToggle(index)) {
            return linePu();
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (this.isProductLineGroupHead(index)) {
                const members = this.getProductLineGroupMemberIndices(
                    this.getProductLineGroupKey(index)
                );
                for (const mi of members) {
                    const it = this.items[mi];
                    if (it?.type === 'product') {
                        const pu =
                            Number(it.priceHT) ||
                            Number(it.valeur_unitaire) ||
                            Number(it.prixUnitaireRef) ||
                            0;
                        if (pu > 0 || String(it.designation || '').trim()) {
                            return pu;
                        }
                    }
                }
            }
            return linePu();
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            for (const mi of this.getProductLineCouleurMemberIndices(index)) {
                const it = this.items[mi];
                if (it?.type === 'product') {
                    const pu =
                        Number(it.priceHT) ||
                        Number(it.valeur_unitaire) ||
                        Number(it.prixUnitaireRef) ||
                        0;
                    if (pu > 0 || String(it.designation || '').trim()) {
                        return pu;
                    }
                }
            }
        }
        return linePu();
    }

    onProductLinePrixHtChange(index: number, value: unknown): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        const parsed = Number(value);
        const pu = Number.isFinite(parsed) ? parsed : 0;
        item.priceHT = pu;
        item.prixUnitaireRef = pu;
        if (
            this.documentType === 'FACTURE FOURNISSEUR' ||
            this.documentType === 'BON RECEPTION' ||
            this.isStockLcDocumentType()
        ) {
            item.valeur_unitaire = pu;
        }
        this.onProductLinePriceHtInput(index);
        this.calculateTotal(index);
        this.calculateTotals();
        this.updateTvaSummary();
        this.cdr.markForCheck();
    }

    private sumProductLineQuantities(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product') {
                const q = Number(it.quantity);
                if (Number.isFinite(q)) {
                    sum += q;
                }
            }
        }
        return sum;
    }

    private sumProductLineHtNet(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product' && String(it.designation || '').trim()) {
                sum += this.getLineTotalHT(it);
            }
        }
        return Number(sum.toFixed(3));
    }

    /**
     * Total HT affiché : somme des lignes du regroupement si réf. fabricant ou couleur repliée
     * (aligné sur getProductLineQuantityDisplay).
     */
    getProductLineTotalHTDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return this.getLineTotalHT(item);
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (this.isProductLineGroupHead(index)) {
                return this.sumProductLineHtNet(
                    this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
                );
            }
            return 0;
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineHtNet(this.getProductLineCouleurMemberIndices(index));
        }
        return this.getLineTotalHT(item);
    }

    /** Quantités produit ≥ 0 (sauf avoirs vente / fournisseur). */
    shouldEnforceNonNegativeProductQuantity(): boolean {
        if (this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert()) {
            return false;
        }
        if (this.isPvEcartLcLinkedLineView()) {
            return false;
        }
        return !this.isAvoirDocument();
    }

    onProductLineQuantityKeydown(event: KeyboardEvent): void {
        if (this.shouldEnforceNonNegativeProductQuantity()) {
            preventNonNegativeQuantityKeydown(event);
        }
    }

    onVariantModalQuantityKeydown(event: KeyboardEvent): void {
        preventNonNegativeQuantityKeydown(event);
    }

    onProductLineQuantityChange(index: number, value: string | number | null | undefined): void {
        if (this.isProductLineQuantityReadonly(index)) {
            return;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        if (this.shouldEnforceNonNegativeProductQuantity()) {
            item.quantity = normalizeNonNegativeIntegerQuantity(value);
        } else {
            const raw = Number(value);
            item.quantity = Number.isFinite(raw) ? raw : 0;
        }
        this.calculateTotal(index);
        this.cdr.detectChanges();
    }

    /** Affiche le sélecteur code-barres (sinon hint regroupé). */
    shouldShowProductLineBarcodePicker(index: number): boolean {
        if (!this.productLineGroupCanToggle(index)) {
            return true;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return !this.isProductLineGroupHead(index);
        }
        if (!this.productLineCouleurGroupCanToggle(index)) {
            return true;
        }
        if (!this.isProductLineCouleurGroupExpanded(index)) {
            return !this.isProductLineCouleurHead(index);
        }
        return true;
    }

    isProductLineVisible(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return true;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return true;
        }
        // Désignation repliée : uniquement la tête du groupe.
        if (!this.expandedBarcodeGroups.has(key)) {
        return members[0] === index;
        }
        // Désignation ouverte : regroupement par couleur.
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        if (colorMembers.length <= 1) {
            return true;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (!this.expandedCouleurGroups.has(couleurKey)) {
            return colorMembers[0] === index;
        }
        return true;
    }

    toggleProductLineBarcodeGroup(index: number, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.productLineGroupCanToggle(index)) {
            return;
        }
        const key = this.getProductLineGroupKey(index);
        if (this.expandedBarcodeGroups.has(key)) {
            this.expandedBarcodeGroups.delete(key);
            // Replier aussi tous les sous-groupes couleur de cette désignation.
            for (const ck of Array.from(this.expandedCouleurGroups)) {
                if (ck.startsWith(`${key}|c:`)) {
                    this.expandedCouleurGroups.delete(ck);
                }
            }
            this.ensureStockLoadedForProductLineAggregate(index);
            this.cdr.detectChanges();
            setTimeout(() => this.refreshFeatherIcons(), 0);
            return;
        }
        this.expandedBarcodeGroups.add(key);
        this.ensureProductLineBarcodeGroupLoaded(index);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    toggleProductLineCouleurGroup(index: number, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.productLineCouleurGroupCanToggle(index)) {
            return;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (this.expandedCouleurGroups.has(couleurKey)) {
            this.expandedCouleurGroups.delete(couleurKey);
            this.ensureStockLoadedForProductLineAggregate(index);
        } else {
            this.expandedCouleurGroups.add(couleurKey);
            // Charger stocks / pickers pour les lignes de cette couleur.
            for (const mi of this.getProductLineCouleurMemberIndices(index)) {
                this.syncBarcodePickerModelForLine(mi);
                const it = this.items[mi];
                if (it?.type === 'product' && it.product_id) {
                    this.loadStockQuantity(Number(it.product_id), it.reference || '', mi);
                }
            }
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
        }
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    private ensureProductLineBarcodeGroupLoaded(index: number): void {
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);

        const finishLocal = () => {
            for (const mi of members) {
                this.syncBarcodePickerModelForLine(mi);
                const it = this.items[mi];
                if (it?.type === 'product' && it.product_id) {
                    this.loadStockQuantity(Number(it.product_id), it.reference || '', mi);
                }
            }
            this.barcodePickerMergedByLine = {};
            this.barcodePickerMergedKeyByLine = {};
            this.barcodeGroupLoaded.add(key);
            this.barcodeGroupLoading[key] = false;
            this.cdr.detectChanges();
            setTimeout(() => this.refreshFeatherIcons(), 0);
        };

        if (this.barcodeGroupLoaded.has(key)) {
            finishLocal();
            return;
        }

        this.barcodeGroupLoading[key] = true;
        this.cdr.detectChanges();

        const ref = key.startsWith('ref:') ? key.slice(4) : '';
        if (!ref || !this.stationId) {
            finishLocal();
            return;
        }

        this.productsService.getProductsByRefFabricant(this.stationId, ref).subscribe({
            next: (list) => {
                const mapped = (list || []).map((p) => this.mapApiProductForDocumentSelect(p));
                this.mergeProductsFromBarcodeApiIntoStore(mapped);
                finishLocal();
            },
            error: () => finishLocal(),
        });
    }

    private getRefFabricantGroupProducts(p: Product | any): Product[] {
        const ref = this.extractRefFabricantFromProductLike(p);
        if (!ref) {
            return p?.id != null ? [p as Product] : [];
        }
        const fromList = (this.products || []).filter((pr: any) => {
            return this.refFabricantKeysMatch(
                ref,
                this.extractRefFabricantFromProductLike(pr)
            );
        });
        const byId = new Map<number, Product>();
        for (const pr of fromList) {
            if (pr?.id != null) {
                byId.set(Number(pr.id), pr);
            }
        }
        if (p?.id != null && !byId.has(Number(p.id))) {
            byId.set(Number(p.id), p as Product);
        }
        return Array.from(byId.values());
    }

    private shiftLineMetaMapsForInsert(fromIndex: number): void {
        const reindex = (src: { [index: number]: string | boolean }) => {
            const out: { [index: number]: string | boolean } = {};
            for (const k of Object.keys(src)) {
                const i = Number(k);
                if (Number.isNaN(i)) {
                    continue;
                }
                out[i >= fromIndex ? i + 1 : i] = src[i];
            }
            return out;
        };
        this.productDescriptions = reindex(this.productDescriptions) as { [index: number]: string };
        this.showProductDescription = reindex(this.showProductDescription) as { [index: number]: boolean };
    }

    /**
     * Déplace une entrée indexée (0..lineCount-1) comme une ligne du tableau `items`.
     */
    private moveSparseIndexRecord<T>(
        src: Record<number, T>,
        fromIndex: number,
        toIndex: number,
        lineCount: number
    ): Record<number, T> {
        if (fromIndex === toIndex || lineCount <= 0 || fromIndex < 0 || fromIndex >= lineCount) {
            return { ...src };
        }
        let insertAt = toIndex;
        if (fromIndex < toIndex) {
            insertAt = toIndex - 1;
        }
        const slots: (T | undefined)[] = new Array(lineCount);
        for (const key of Object.keys(src)) {
            const i = Number(key);
            if (!Number.isNaN(i) && i >= 0 && i < lineCount) {
                slots[i] = src[i];
            }
        }
        const moved = slots[fromIndex];
        slots.splice(fromIndex, 1);
        slots.splice(insertAt, 0, moved);
        const out: Record<number, T> = {};
        for (let i = 0; i < slots.length; i++) {
            if (slots[i] !== undefined) {
                out[i] = slots[i] as T;
            }
        }
        return out;
    }

    /** Réindexe code-barres, descriptions, etc. quand l'utilisateur réordonne les lignes. */
    private reorderLineMetaMapsForMove(fromIndex: number, toIndex: number, lineCount: number): void {
        const move = <T>(src: Record<number, T>) =>
            this.moveSparseIndexRecord(src, fromIndex, toIndex, lineCount);

        this.productDescriptions = move(this.productDescriptions);
        this.showProductDescription = move(this.showProductDescription);
        this.productLineBarcodeQuery = move(this.productLineBarcodeQuery);
        this.productLineBarcodeApiHits = move(this.productLineBarcodeApiHits);
        this.productLineBarcodeSearchLoading = move(this.productLineBarcodeSearchLoading);
        this.barcodePickerModel = move(this.barcodePickerModel);
        this.barcodePickerUnlockEdit = move(this.barcodePickerUnlockEdit);

        Object.values(this.barcodeLineDebounceTimers).forEach((t) => clearTimeout(t));
        this.barcodeLineDebounceTimers = move(this.barcodeLineDebounceTimers);

        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private shiftLineMetaMapsForRemove(removedIndex: number): void {
        const shiftDown = <T>(src: Record<number, T>): Record<number, T> => {
            const out: Record<number, T> = {};
            for (const key of Object.keys(src)) {
                const i = Number(key);
                if (Number.isNaN(i)) {
                    continue;
                }
                if (i < removedIndex) {
                    out[i] = src[i];
                } else if (i > removedIndex) {
                    out[i - 1] = src[i];
                }
            }
            return out;
        };

        if (this.barcodeLineDebounceTimers[removedIndex]) {
            clearTimeout(this.barcodeLineDebounceTimers[removedIndex]);
        }

        this.productDescriptions = shiftDown(this.productDescriptions);
        this.showProductDescription = shiftDown(this.showProductDescription);
        this.productLineBarcodeQuery = shiftDown(this.productLineBarcodeQuery);
        this.productLineBarcodeApiHits = shiftDown(this.productLineBarcodeApiHits);
        this.productLineBarcodeSearchLoading = shiftDown(this.productLineBarcodeSearchLoading);
        this.barcodePickerModel = shiftDown(this.barcodePickerModel);
        this.barcodePickerUnlockEdit = shiftDown(this.barcodePickerUnlockEdit);

        const timers: Record<number, ReturnType<typeof setTimeout>> = {};
        for (const key of Object.keys(this.barcodeLineDebounceTimers)) {
            const i = Number(key);
            if (Number.isNaN(i) || i === removedIndex) {
                continue;
            }
            timers[i > removedIndex ? i - 1 : i] = this.barcodeLineDebounceTimers[i];
        }
        this.barcodeLineDebounceTimers = timers;

        const merged: Record<number, Product[]> = {};
        const mergedKeys: Record<number, string> = {};
        for (const key of Object.keys(this.barcodePickerMergedByLine)) {
            const i = Number(key);
            if (Number.isNaN(i) || i === removedIndex) {
                continue;
            }
            const ni = i > removedIndex ? i - 1 : i;
            merged[ni] = this.barcodePickerMergedByLine[i];
            if (this.barcodePickerMergedKeyByLine[i] !== undefined) {
                mergedKeys[ni] = this.barcodePickerMergedKeyByLine[i];
            }
        }
        this.barcodePickerMergedByLine = merged;
        this.barcodePickerMergedKeyByLine = mergedKeys;
    }

    /** Déplace une ligne document + toutes les métadonnées indexées (code-barres, description, etc.). */
    private moveDocumentLine(fromIndex: number, toIndex: number): void {
        if (
            fromIndex === toIndex ||
            fromIndex < 0 ||
            toIndex < 0 ||
            fromIndex >= this.items.length ||
            toIndex >= this.items.length
        ) {
            return;
        }
        const lineCount = this.items.length;
        this.reorderLineMetaMapsForMove(fromIndex, toIndex, lineCount);

        let insertAt = toIndex;
        if (fromIndex < toIndex) {
            insertAt = toIndex - 1;
        }
        const [draggedItem] = this.items.splice(fromIndex, 1);
        this.items.splice(insertAt, 0, draggedItem);
    }

    private sortVariantGroupForModal(group: Product[]): Product[] {
        return [...group].sort((a, b) => {
            const ae = this.isBarcodeEmptyOrZeroForSelect(a);
            const be = this.isBarcodeEmptyOrZeroForSelect(b);
            if (ae !== be) {
                return ae ? -1 : 1;
            }
            const ca = String((a as any)?.code_barre ?? '').trim();
            const cb = String((b as any)?.code_barre ?? '').trim();
            return ca.localeCompare(cb, undefined, { numeric: true });
        });
    }

    private filterVariantModalProductsByBarcode(group: Product[]): Product[] {
        return this.sortVariantGroupForModal(group).filter((p) => !this.isBarcodeEmptyOrZeroForSelect(p));
    }

    private openVariantSelectionModal(
        lineIndex: number,
        selectedProduct: Product,
        group: Product[]
    ): void {
        const withBarcode = this.filterVariantModalProductsByBarcode(group);
        if (withBarcode.length < 2) {
            if (withBarcode.length === 1) {
                this.applyProductSelectionToLine(lineIndex, withBarcode[0], 1);
            } else {
                this.applyProductSelectionToLine(lineIndex, selectedProduct, 1);
            }
            return;
        }

        if (!this.variantSelectionModalTpl) {
            this.cdr.detectChanges();
            setTimeout(
                () => this.openVariantSelectionModal(lineIndex, selectedProduct, group),
                50
            );
            return;
        }

        this.variantModalLineSnapshot = JSON.parse(JSON.stringify(this.items[lineIndex])) as Item;
        this.variantModalLineIndex = lineIndex;
        this.variantModalPrimary = selectedProduct;
        this.variantModalFullGroup = Array.isArray(group) ? group.slice() : [];
        this.variantModalStockByProductId.clear();
        this.variantModalStockDisponibleByProductId.clear();
        this.variantModalTableLoading = true;
        this.variantModalRows = withBarcode.map((prod) => ({
            product: prod,
            selected: true,
            quantity: 0
        }));
        this.rebuildVariantModalMatrix();
        this.variantModalBulkQuantity = 0;
        this.toggleAllVariantModalRows(true);
        this.loadVariantModalStockTotalsFromApi();
        this.variantSelectionModalRef = this.modalService.open(this.variantSelectionModalTpl, {
            centered: true,
            scrollable: true,
            backdrop: 'static',
            windowClass: 'variant-selection-modal-window'
        });
        // Toutes les variantes cochées par défaut après rendu du modal.
        setTimeout(() => {
            this.toggleAllVariantModalRows(true);
            this.cdr.detectChanges();
            this.refreshFeatherIcons();
        }, 0);
        this.variantSelectionModalRef.result.then(
            () => undefined,
            () => {
                if (this.variantModalLineSnapshot != null && this.variantModalLineIndex != null) {
                    this.items[this.variantModalLineIndex] = JSON.parse(
                        JSON.stringify(this.variantModalLineSnapshot)
                    ) as Item;
                    this.variantModalLineSnapshot = null;
                    this.variantModalLineIndex = null;
                    this.variantModalPrimary = null;
                    this.variantModalRows = [];
                    this.variantModalCouleurs = [];
                    this.variantModalTailles = [];
                    this.variantModalCellKeyToRowIndex.clear();
                    this.variantModalBulkQuantity = 0;
                    this.variantModalTableLoading = false;
                    this.variantModalFullGroup = [];
                    this.variantModalStockByProductId.clear();
                    this.variantModalStockDisponibleByProductId.clear();
                    this.rebuildProductsForDocumentSelect();
                    this.calculateTotals();
                    this.updateTvaSummary();
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();
                }
            }
        );
        setTimeout(() => this.refreshFeatherIcons(), 150);
    }

    /** Clé cellule matrice couleur × taille. */
    private variantMatrixCellKey(couleur: string, taille: string): string {
        return `${String(couleur || '—').trim().toLowerCase()}||${String(taille || '—').trim().toLowerCase()}`;
    }

    /** Construit axes i=couleurs, j=tailles et index des cellules aij. */
    private rebuildVariantModalMatrix(): void {
        const couleurs: string[] = [];
        const tailles: string[] = [];
        const couleurSeen = new Set<string>();
        const tailleSeen = new Set<string>();
        this.variantModalCellKeyToRowIndex.clear();

        this.variantModalRows.forEach((row, idx) => {
            const ct = this.extractCouleurTailleFromProductLike(row.product);
            const c = ct.couleur || '—';
            const t = ct.taille || '—';
            const ck = c.toLowerCase();
            const tk = t.toLowerCase();
            if (!couleurSeen.has(ck)) {
                couleurSeen.add(ck);
                couleurs.push(c);
            }
            if (!tailleSeen.has(tk)) {
                tailleSeen.add(tk);
                tailles.push(t);
            }
            const key = this.variantMatrixCellKey(c, t);
            if (!this.variantModalCellKeyToRowIndex.has(key)) {
                this.variantModalCellKeyToRowIndex.set(key, idx);
            }
        });

        const collator = (a: string, b: string) =>
            a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
        this.variantModalCouleurs = couleurs.sort(collator);
        // Colonnes tailles : XXS → XXXL (puis numériques / autres)
        this.variantModalTailles = tailles.sort((a, b) => this.compareTailleVetementOrder(a, b));
    }

    /**
     * Ordre des tailles vêtement : XXS → XS → S → M → L → XL → XXL → XXXL…
     * Puis tailles numériques croissantes, puis le reste alpha.
     */
    private compareTailleVetementOrder(a: string, b: string): number {
        const rankA = this.getTailleVetementRank(a);
        const rankB = this.getTailleVetementRank(b);
        if (rankA !== rankB) {
            return rankA - rankB;
        }
        return String(a || '').localeCompare(String(b || ''), undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    }

    private getTailleVetementRank(raw: string): number {
        const s = String(raw || '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace(/_/g, '');
        if (!s || s === '—' || s === '-') {
            return 10000;
        }

        const letterOrder: { [k: string]: number } = {
            xxs: 10,
            '2xs': 10,
            xs: 20,
            s: 30,
            sm: 30,
            small: 30,
            m: 40,
            md: 40,
            medium: 40,
            l: 50,
            lg: 50,
            large: 50,
            xl: 60,
            '1xl': 60,
            xxl: 70,
            '2xl': 70,
            xxxl: 80,
            '3xl': 80,
            xxxxl: 90,
            '4xl': 90,
            xxxxxl: 100,
            '5xl': 100,
            xxxxxxl: 110,
            '6xl': 110
        };
        if (letterOrder[s] != null) {
            return letterOrder[s];
        }

        // Formes type "x-small", "2x-large"
        const compact = s.replace(/-/g, '');
        if (letterOrder[compact] != null) {
            return letterOrder[compact];
        }

        // Numérique (ex. 36, 38, 40…)
        const num = Number(s.replace(',', '.'));
        if (Number.isFinite(num)) {
            return 1000 + num;
        }

        // Pattern "xlarge", "xxlarge"
        if (/^x{0,6}l(arge)?$/.test(s) || /^x{1,6}-?l(arge)?$/.test(s)) {
            const xCount = (s.match(/x/g) || []).length;
            return 50 + xCount * 10;
        }

        return 5000;
    }

    hasVariantModalMatrixCell(couleur: string, taille: string): boolean {
        return this.variantModalCellKeyToRowIndex.has(this.variantMatrixCellKey(couleur, taille));
    }

    getVariantModalMatrixRow(
        couleur: string,
        taille: string
    ): { product: Product; selected: boolean; quantity: number } | null {
        const idx = this.variantModalCellKeyToRowIndex.get(this.variantMatrixCellKey(couleur, taille));
        if (idx == null) {
            return null;
        }
        return this.variantModalRows[idx] ?? null;
    }

    getVariantModalMatrixQuantity(couleur: string, taille: string): number {
        const row = this.getVariantModalMatrixRow(couleur, taille);
        return row ? this.normalizeVariantModalQuantity(row.quantity) : 0;
    }

    /**
     * Quantité demandée > stock disponible (entrepôt initial pour transfert entrepôt).
     */
    isVariantModalMatrixQuantityInsufficient(couleur: string, taille: string): boolean {
        const row = this.getVariantModalMatrixRow(couleur, taille);
        if (!row?.product) {
            return false;
        }
        const qty = this.normalizeVariantModalQuantity(row.quantity);
        if (qty <= 0) {
            return false;
        }
        const stockDisponible = this.getVariantStockWebQty(row.product);
        return qty > stockDisponible;
    }

    onVariantModalMatrixQuantityChange(
        couleur: string,
        taille: string,
        value: string | number | null | undefined
    ): void {
        const idx = this.variantModalCellKeyToRowIndex.get(this.variantMatrixCellKey(couleur, taille));
        if (idx == null) {
            return;
        }
        const q = this.normalizeVariantModalQuantity(value);
        const row = this.variantModalRows[idx];
        if (!row) {
            return;
        }
            row.quantity = q;
        row.selected = q > 0;
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    incrementVariantModalMatrixQuantity(couleur: string, taille: string): void {
        const current = this.getVariantModalMatrixQuantity(couleur, taille);
        this.onVariantModalMatrixQuantityChange(couleur, taille, current + 1);
    }

    decrementVariantModalMatrixQuantity(couleur: string, taille: string): void {
        const current = this.getVariantModalMatrixQuantity(couleur, taille);
        this.onVariantModalMatrixQuantityChange(couleur, taille, Math.max(0, current - 1));
    }

    areAllVariantModalRowsSelected(): boolean {
        return this.variantModalRows.length > 0 && this.variantModalRows.every((r) => r.selected === true);
    }

    trackVariantModalRow(index: number, row: { product: Product; selected: boolean; quantity: number }): number | string {
        const id = row?.product?.id;
        return id != null ? Number(id) : index;
    }

    clearVariantModalRowSelection(): void {
        this.variantModalRows.forEach((r) => {
            r.selected = false;
        });
    }

    setVariantModalRowSelected(rowIndex: number, checked: boolean): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        row.selected = checked === true;
        this.cdr.detectChanges();
    }

    toggleAllVariantModalRows(checked: boolean): void {
        const value = checked === true;
        this.variantModalRows.forEach((r) => (r.selected = value));
        this.cdr.detectChanges();
    }

    onVariantModalRowQuantityChange(rowIndex: number, value: string | number | null | undefined): void {
        this.setVariantModalRowQuantity(rowIndex, value);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    /** Modifie uniquement la ligne concernée (pas les lignes cochées). */
    private setVariantModalRowQuantity(rowIndex: number, newQuantity: string | number | null | undefined): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        row.quantity = this.normalizeVariantModalQuantity(newQuantity);
    }

    incrementVariantModalQuantity(rowIndex: number): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        const current = parseFloat(String(row.quantity ?? 0)) || 0;
        this.setVariantModalRowQuantity(rowIndex, current + 1);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    decrementVariantModalQuantity(rowIndex: number): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        const current = parseFloat(String(row.quantity ?? 0)) || 0;
        this.setVariantModalRowQuantity(rowIndex, Math.max(0, current - 1));
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    private normalizeVariantModalQuantity(value: string | number | null | undefined): number {
        return normalizeNonNegativeIntegerQuantity(value);
    }

    onVariantModalBulkQuantityChange(value: string | number | null | undefined): void {
        this.variantModalBulkQuantity = this.normalizeVariantModalQuantity(value);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    incrementVariantModalBulkQuantity(): void {
        this.variantModalBulkQuantity = this.normalizeVariantModalQuantity(this.variantModalBulkQuantity) + 1;
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    decrementVariantModalBulkQuantity(): void {
        this.variantModalBulkQuantity = Math.max(
            0,
            this.normalizeVariantModalQuantity(this.variantModalBulkQuantity) - 1
        );
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    applyVariantModalQuantityToAll(): void {
        const q = this.normalizeVariantModalQuantity(this.variantModalBulkQuantity);
        this.variantModalBulkQuantity = q;
        this.variantModalRows.forEach((r) => {
            r.quantity = q;
            r.selected = q > 0;
        });
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    displayCodeBarreVariant(p: Product | any): string {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return '—';
        }
        const s = String(c).trim();
        return s === '' ? '—' : s;
    }

    displayCodeBarreVariantFormatted(p: Product | any): string {
        const base = this.displayCodeBarreVariant(p);
        if (base === '—') {
            return base;
        }
        const digits = base.replace(/\s/g, '');
        if (/^\d{13}$/.test(digits)) {
            return `${digits[0]} ${digits.slice(1, 7)} ${digits.slice(7)}`;
        }
        if (/^\d{12}$/.test(digits)) {
            return `${digits.slice(0, 6)} ${digits.slice(6)}`;
        }
        if (/^\d{8}$/.test(digits)) {
            return `${digits.slice(0, 4)} ${digits.slice(4)}`;
        }
        return base;
    }

    getVariantModalStockDisplay(p: Product | any | null | undefined): number {
        if (p == null || p.id == null) {
            return 0;
        }
        const id = Number(p.id);
        if (!Number.isFinite(id)) {
            return 0;
        }
        if (this.variantModalStockByProductId.has(id)) {
            const q = this.variantModalStockByProductId.get(id);
            return q !== undefined && Number.isFinite(q) ? q : 0;
        }
        return 0;
    }

    getVariantModalGroupTotalStock(): number {
        const seen = new Set<number>();
        let sum = 0;
        for (const p of this.variantModalFullGroup) {
            if (p?.id == null || this.isBarcodeEmptyOrZeroForSelect(p)) {
                continue;
            }
            const id = Number(p.id);
            if (!Number.isFinite(id) || seen.has(id)) {
                continue;
            }
            seen.add(id);
            sum += this.getVariantModalStockDisplay(p);
        }
        return sum;
    }

    getVariantModalStockStatus(p: Product | any): string {
        return this.getVariantModalStockDisplay(p) > 0 ? 'En stock' : 'En rupture';
    }

    private loadVariantModalStockTotalsFromApi(): void {
        const metas: Array<{
            id: number;
            code_barre?: string | null;
            ref_interne?: string | null;
            ref_fabricant?: string | null;
        }> = [];
        const seen = new Set<number>();
        for (const p of this.variantModalFullGroup) {
            if (p?.id == null) {
                continue;
            }
            const id = Number(p.id);
            if (!Number.isFinite(id) || seen.has(id)) {
                continue;
            }
            seen.add(id);
            const meta = this.buildLcStockMetaFromProduct(p, id);
            if (meta) {
                metas.push(meta);
            }
        }
        if (metas.length === 0) {
            this.variantModalTableLoading = false;
            this.cdr.detectChanges();
            return;
        }
        this.variantModalTableLoading = true;
        this.lcStockGestion
            .getStockGlobaleByErpProducts(metas, {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .pipe(
                catchError(() => {
                    const empty: Record<number, { physique: number; disponible: number }> = {};
                    for (const m of metas) {
                        empty[m.id] = { physique: 0, disponible: 0 };
                    }
                    return of(empty);
                })
            )
            .subscribe({
                next: (rec) => {
                for (const m of metas) {
                    const pair = rec[m.id] ?? { physique: 0, disponible: 0 };
                    this.variantModalStockByProductId.set(m.id, pair.physique);
                    this.variantModalStockDisponibleByProductId.set(m.id, pair.disponible);
                }
                    this.variantModalTableLoading = false;
                this.toggleAllVariantModalRows(true);
                this.cdr.detectChanges();
                setTimeout(() => this.refreshFeatherIcons(), 0);
                },
                error: () => {
                    this.variantModalTableLoading = false;
                    this.cdr.detectChanges();
                },
            });
    }

    /** Stock affiché popup variantes (disponible sauf bon de sortie → physique). */
    getVariantStockWebQty(p: Product | any): number {
        if (p?.id == null) {
            return 0;
        }
        const id = Number(p.id);
        if (!Number.isFinite(id)) {
            return 0;
        }
        if (this.isBonSortieDocument()) {
            if (this.variantModalStockByProductId.has(id)) {
                return this.getVariantModalStockDisplay(p);
            }
            return 0;
        }
        if (this.variantModalStockDisponibleByProductId.has(id)) {
            const q = this.variantModalStockDisponibleByProductId.get(id);
            return q !== undefined && Number.isFinite(q) ? q : 0;
        }
        if (this.variantModalStockByProductId.has(id)) {
            return this.getVariantModalStockDisplay(p);
        }
        return 0;
    }

    getVariantStockWebStatus(p: Product | any): string {
        const q = this.getVariantStockWebQty(p);
        return q > 0 ? 'En stock' : 'En rupture';
    }

    formatVariantCouleurOnly(p: Product | any): string {
        const c = p?.couleur != null ? String(p.couleur).trim() : '';
        return c || '—';
    }

    formatVariantTailleOnly(p: Product | any): string {
        const t = p?.taille != null ? String(p.taille).trim() : '';
        return t || '—';
    }

    confirmVariantSelectionModal(modal: { close: (r?: any) => void }): void {
        const picked = this.variantModalRows.filter(
            (r) => (Number(r.quantity) || 0) > 0
        );
        if (picked.length === 0) {
            this.toastr.warning(
                'Saisissez une quantité supérieure à 0 pour au moins une variante (couleur × taille).',
                'Variantes'
            );
            return;
        }
        const baseIdx = this.variantModalLineIndex;
        if (baseIdx == null) {
            modal.close('ok');
            return;
        }
        const rows = picked.map((r) => ({
            product: r.product,
            quantity: normalizeNonNegativeIntegerQuantity(r.quantity),
        }));
        this.variantModalLineSnapshot = null;
        this.variantModalLineIndex = null;
        this.variantModalPrimary = null;
        this.variantModalRows = [];
        this.variantModalCouleurs = [];
        this.variantModalTailles = [];
        this.variantModalCellKeyToRowIndex.clear();
        this.variantModalBulkQuantity = 0;
        this.variantModalTableLoading = false;
        this.variantModalFullGroup = [];
        this.variantModalStockByProductId.clear();
        this.variantModalStockDisponibleByProductId.clear();
        this.applyMultipleVariantRowsToDocumentLine(baseIdx, rows);
        modal.close('ok');
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    private createEmptyProductLineItem(): Item {
        return {
            type: 'product',
            designation: '',
            quantity: 0,
            reference: '',
            code_barre: '',
            priceHT: 0,
            tva: '0',
            totalHT: 0
        } as Item;
    }

    private applyMultipleVariantRowsToDocumentLine(
        baseIdx: number,
        selected: { product: Product; quantity: number }[]
    ): void {
        if (selected.length === 0) {
            return;
        }
        let idx = baseIdx;
        for (let i = 0; i < selected.length; i++) {
            if (i > 0) {
                this.shiftLineMetaMapsForInsert(idx);
                this.items.splice(idx, 0, this.createEmptyProductLineItem());
            }
            this.applyProductSelectionToLine(idx, selected[i].product, selected[i].quantity);
            idx++;
        }
        this.rebuildProductsForDocumentSelect();
        this.calculateTotals();
        this.updateTvaSummary();
        this.updateApproveButtonState();
        if (selected[0]?.product) {
            const key = this.getProductLineGroupKey(baseIdx);
            this.expandedBarcodeGroups.delete(key);
            this.barcodeGroupLoaded.delete(key);
            delete this.barcodeGroupLoading[key];
        }
        this.syncBarcodePickerModelForVisibleProductLines();
    }

    openErpProductDetailFromVariantModal(productId: number | null | undefined): void {
        if (productId == null) {
            return;
        }
        this.zone.run(() => {
            this.router.navigate(['/bibliotheque-test/detail-produit', productId]);
        });
    }

    private applyProductTaxes(product: any, index: number, mergeWithExisting?: boolean): void {
        const item = this.items[index];
        let newTaxes: any[] = [];
        const activeTaxIds = new Set(
            (this.taxes || []).filter((t: any) => this.isTaxActiveForDocument(t)).map((t: any) => t.id)
        );

        if (Array.isArray(product.taxes) && product.taxes.length > 0) {
            newTaxes = product.taxes
                .filter((taxe: any) => {
                    const id = taxe.taxes_id ?? taxe.id;
                    const isActive =
                        taxe.statut === true ||
                        taxe.statut === 1 ||
                        (id != null && activeTaxIds.has(Number(id)));
                    return id != null && isActive;
                })
                .map((taxe: any) => {
                    if (taxe.taxes_id) {
                        return { ...taxe, id: taxe.taxes_id };
                    }
                    return taxe;
                });
        } else if (product.taxe_id !== null && product.taxe_id !== undefined) {
            const taxeIds = Array.isArray(product.taxe_id) ? product.taxe_id : [product.taxe_id];
            newTaxes = this.taxes.filter(
                t => taxeIds.includes(t.id) && this.isTaxActiveForDocument(t)
            );
        }

        if (mergeWithExisting && (item['taxesProduit'] || []).length > 0) {
            const existingIds = new Set((item['taxesProduit'] || []).map((t: any) => t.id ?? t.taxes_id));
            const toAdd = newTaxes.filter((t: any) => !existingIds.has(t.id));
            item['taxesProduit'] = [...(item['taxesProduit'] || []), ...toAdd];
        } else {
            item['taxesProduit'] = newTaxes;
        }

        item['fodecApplique'] = (item['taxesProduit'] || []).some((taxe: any) =>
            taxe.nom?.toLowerCase().includes('fodec') ||
            taxe.label?.toLowerCase().includes('fodec')
        );
        
        this.calculateLine(index);
        this.cdr.detectChanges();
    }

    private loadProductTaxes(productId: number, index: number): void {
        this.productsService.getDetailsProduct(productId).subscribe({
            next: (res: any) => {
                const product: Product = res.data || res;

                const item = this.items[index];
                const taxeProduit = this.taxes.find(
                    t => t.id === product.taxe_id && this.isTaxActiveForDocument(t)
                );
                item['taxesProduit'] = taxeProduit ? [taxeProduit] : [];
                item['fodecApplique'] = this.taxes.some(t =>
                    t.id === product.taxe_id &&
                    this.isTaxActiveForDocument(t) &&
                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec'))
                );

                if (taxeProduit) {
                    item.tva = taxeProduit.valeur.toString();
                } else {
                    item.tva = '0';
                }

                this.calculateLine(index);
                this.cdr.detectChanges();
            },

        });
    }

    calculateLine(index: number): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        const prixUnitaire = this.resolveProductLineUnitPrice(item);
        // Accepter qnt négatives (avoirs / retours) — ne pas forcer à 1 si quantity = 0 explicite.
        const qteRaw = Number(item.quantity);
        const qte = Number.isFinite(qteRaw) ? qteRaw : 1;
        const htBrut = Number(prixUnitaire) * qte;
        const remisePourcent = Number(item.remise || 0);
        const montantRemise = htBrut * (remisePourcent / 100);
        const htApresRemise = htBrut - montantRemise;
        item.totalHTBrut = +htBrut.toFixed(3);
        item.montantRemise = +montantRemise.toFixed(3);
        item.htNet = +htApresRemise.toFixed(3);
        let totalTaxesAvantTVA = 0;
        let taxesAvantTVAInclusesTVA = 0;
        const taxesAvant: any[] = [];

        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const valeurNum = parseFloat(taxe.valeur || '0');
            if (isNaN(valeurNum)) return;
            const isFixe = taxe.valeur_fixe === true || taxe.valeur_fixe === 1;
            if (!isFixe && valeurNum === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (appliqueAvantTVA) {
                const Base_Taxe_Ligne = htApresRemise;
                const montantTaxe = isFixe ? valeurNum : Base_Taxe_Ligne * (valeurNum / 100);
                totalTaxesAvantTVA += montantTaxe;
                taxesAvant.push({
                    nom: taxe.nom || taxe.label,
                    taux: valeurNum,
                    montant: +montantTaxe.toFixed(3)
                });
                const estFODEC = taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec');
                const appliqueALaTVA = taxe.applique_tva === true ||
                                       taxe.applique_a_la_tva === true ||
                                       taxe.appliquee_a_la_tva === true ||
                                       taxe.applique_a_tva === true ||
                                       taxe.appliquee_a_tva === true ||
                                       estFODEC;

                if (appliqueALaTVA) {
                    taxesAvantTVAInclusesTVA += montantTaxe;
                }
            }
        });

        item.taxesAvantTVA = +totalTaxesAvantTVA.toFixed(3);
        item.listeTaxesAvantTVA = taxesAvant;
        const baseTVA = htApresRemise + taxesAvantTVAInclusesTVA;
        item.baseTVA = +baseTVA.toFixed(3);
        const tauxTVA = Number(item.tva || 0);
        const montantTVA = baseTVA * (tauxTVA / 100);
        item.montantTVA = +montantTVA.toFixed(3);
        let totalTaxesApresTVA = 0;
        const taxesApres: any[] = [];

        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const valeurNum = parseFloat(taxe.valeur || '0');
            if (isNaN(valeurNum)) return;
            const isFixe = taxe.valeur_fixe === true || taxe.valeur_fixe === 1;
            if (!isFixe && valeurNum === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (!appliqueAvantTVA) {
                const Base_ApresTVA_Ligne = baseTVA + montantTVA;
                const montant = isFixe ? valeurNum : Base_ApresTVA_Ligne * (valeurNum / 100);
                totalTaxesApresTVA += montant;
                taxesApres.push({
                    nom: taxe.nom || taxe.label,
                    taux: valeurNum,
                    montant: +montant.toFixed(3)
                });
            }
        });

        item.taxesApresTVA = +totalTaxesApresTVA.toFixed(3);
        item.listeTaxesApresTVA = taxesApres;
        item.totalHT = +(htApresRemise + totalTaxesAvantTVA).toFixed(3);
        item.ttcLigne = +(htApresRemise + totalTaxesAvantTVA + montantTVA + totalTaxesApresTVA).toFixed(3);
    }

    onProjectSelect(libelle: string): void {
        this.selectedProject = libelle;
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    onFournisseurSaved(apiResponse: any): void {

        let newFournisseur;
        if (apiResponse?.fournisseur) {
            newFournisseur = apiResponse.fournisseur;
        } else if (apiResponse?.fornisseur) {
            newFournisseur = apiResponse.fornisseur;
        } else if (apiResponse?.data) {
            newFournisseur = apiResponse.data;
        } else if (apiResponse?.id) {
            newFournisseur = apiResponse;
        }

        if (!newFournisseur || !newFournisseur.id) {
            this.toastr.error('Erreur: Fournisseur invalide dans la réponse');
            return;
        }

        this.toastr.success(apiResponse.message || 'Fournisseur ajouté avec succès !', 'Succès');

        this.loadFournisseurs(newFournisseur.id);
    }

    onClientSaved(apiResponse: any): void {
        if (!apiResponse || !apiResponse.client) {
            this.toastr.error('Réponse invalide de l\'API');
            return;
        }

        const newClient = apiResponse.client;

        this.toastr.success(apiResponse.message || 'Client ajouté avec succès !', 'Succès');

        const clientIdToSelect = newClient.id;

        this.loadClients(clientIdToSelect);
    }

    /** Clients logiciel caisse (pagination) — indisponibilité LC n’empêche pas l’ERP. */
    private fetchCaisseClientsForDocument(): Observable<CaisseClient[]> {
        const loadPages = (): Observable<CaisseClient[]> => {
            try {
                if (!this.lcAuth.getBackStationId() || !this.lcAuth.getLogicielCaisseToken()) {
        return of([] as CaisseClient[]);
                }
            } catch {
                return of([] as CaisseClient[]);
            }
            const pageSize = 100;
            return this.lcClientService.getClients({ page: 1, limit: pageSize }).pipe(
                expand((response) => {
                    const currentPage = Number(response.pagination?.page) || 1;
                    const totalPages = Number(response.pagination?.totalPages) || 1;
                    if (currentPage >= totalPages) {
                        return EMPTY;
                    }
                    return this.lcClientService.getClients({
                        page: currentPage + 1,
                        limit: pageSize,
                    });
                }),
                map((response) => response.items ?? []),
                reduce((all, pageItems) => all.concat(pageItems), [] as CaisseClient[]),
                catchError(() => of([] as CaisseClient[]))
            );
        };
        if (this.lcAuth.isReadyForNavigation?.()) {
            return loadPages();
        }
        return this.lcAuth.bootstrap().pipe(
            switchMap(() => loadPages()),
            catchError(() => of([] as CaisseClient[]))
        );
    }

    /** ENUM ERP / LC : clients caisse → champ `type` uniquement (pas `type_client`). */
    private normalizeErpClientType(type?: string | null): string {
        const t = String(type ?? '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        if (!t || t === 'particulier' || t === 'individuel' || t === 'materiel') {
            return 'Individuel';
        }
        if (t === 'professionnel' || t === 'patente' || t === 'entreprise') {
            return 'Professionnel';
        }
        if (t === 'negoce') {
            return 'Négoce';
        }
        return String(type ?? '').trim() || 'Individuel';
    }

    /** Tous les clients actifs ERP (pagination API) — évite d’omettre les particuliers (limite 100). */
    private fetchAllActiveErpClientsForDocument(): Observable<Client[]> {
        const stationId = Number(this.stationId);
        if (!Number.isFinite(stationId) || stationId <= 0) {
            return of([]);
        }
        const pageSize = 100;
        return this.clientService.getActiveClient(stationId, 1, pageSize).pipe(
            expand((response) => {
                const currentPage = response.meta?.page ?? 1;
                const totalPages = response.meta?.nb_total_pages ?? response.meta?.pages ?? 1;
                if (currentPage >= totalPages) {
                    return EMPTY;
                }
                return this.clientService.getActiveClient(stationId, currentPage + 1, pageSize);
            }),
            map((response) => response.data ?? []),
            reduce((all, pageData) => all.concat(pageData), [] as Client[]),
            catchError(() => of([] as Client[]))
        );
    }

    private normalizeClientTypeKey(client: Client | null | undefined): string {
        if (!client) {
            return '';
        }
        const raw = this.isCaisseClient(client)
            ? (client.type ?? '')
            : (client.type ?? (client as { type_client?: string }).type_client ?? '');
        return String(raw)
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    /** ng-select bindLabel="nom_prenom" : libellé de repli si nom vide. */
    private enrichClientForNgSelect(client: Client): Client {
        const label = this.getClientSelectLabel(client);
        const nom = String(client.nom_prenom || '').trim();
        if (!nom && label) {
            return { ...client, nom_prenom: label };
        }
        return client;
    }

    private mapCaisseClientToDocumentClient(c: CaisseClient): Client {
        const nomPrenom =
            [c.prenom, c.nom].filter(Boolean).join(' ').trim() || `Client caisse #${c.id}`;
        return {
            // ID négatif pour éviter collision avec un client ERP de même id numérique
            id: -Math.abs(Number(c.id)),
            type: this.normalizeErpClientType(c.type),
            civilite: String(c.civilite ?? ''),
            nom_prenom: nomPrenom,
            nom_entreprise: c.nom_entreprise ?? null,
            numero_identification_fiscale: c.numero_identification_fiscale ?? null,
            code_client: c.code_client ?? null,
            raison_social: c.raison_social ?? null,
            forme_juridique: c.forme_juridique ?? null,
            station_id: Number(c.station_id) || this.stationId || 0,
            user_id: Number(c.user_id) || 0,
            identifiant_unique: c.identifiant_unique?.trim() || `LC-${c.id}`,
            emails: c.email ? [{ email: String(c.email) }] : [],
            telephones: c.telephone
                ? [{ type: 'Principal', num_tel: String(c.telephone), code_pays: '' }]
                : [],
            adresses: [],
            is_archive: false,
            source: 'caisse',
            created_at: c.created_at ?? undefined,
            updated_at: c.updated_at ?? undefined
        };
    }

    private clientDedupeKeyForDocument(client: Pick<Client, 'nom_prenom' | 'emails' | 'telephones' | 'id' | 'identifiant_unique'>): string {
        const email = String(client.emails?.[0]?.email || '')
            .trim()
            .toLowerCase();
        const tel = String(client.telephones?.[0]?.num_tel || '')
            .replace(/\s+/g, '')
            .trim();
        // Identité forte : email ou téléphone — évite d’exclure toute la caisse sur un nom vague.
        if (email || tel) {
            return `${email}|${tel}`;
        }
        const name = String(client.nom_prenom || '')
            .trim()
            .toLowerCase();
        if (name) {
            return `name:${name}`;
        }
        const uid = String(client.identifiant_unique || client.id || '').trim();
        return uid ? `id:${uid}` : '';
    }

    private mergeErpClientsWithCaisse(erpClients: Client[], caisse: CaisseClient[]): Client[] {
        const merged: Client[] = [...(erpClients || [])].map((c) => ({
            ...c,
            source: c.source ?? 'erp'
        }));
        const existing = new Set(
            merged.map((c) => this.clientDedupeKeyForDocument(c)).filter((k) => !!k)
        );
        for (const raw of caisse || []) {
            const mapped = this.mapCaisseClientToDocumentClient(raw);
            const key = this.clientDedupeKeyForDocument(mapped);
            if (key && existing.has(key)) {
                continue;
            }
            if (key) {
                existing.add(key);
            }
            merged.push(mapped);
        }
        return merged;
    }

    isCaisseClient(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        return client.source === 'caisse' || String(client.identifiant_unique || '').startsWith('LC-');
    }

    /** Libellé ng-select : nom_entreprise pour Professionnel / Négoce. */
    getClientSelectLabel(client: Client | null | undefined): string {
        if (!client) {
            return '';
        }
        const type = this.normalizeClientTypeKey(client);
        const isEntrepriseType = type === 'professionnel' || type === 'negoce' || type === 'patente';
        const entreprise = String(client.nom_entreprise || client.raison_social || '').trim();
        const personne = String(client.nom_prenom || '').trim();

        if (isEntrepriseType) {
            if (entreprise && personne && entreprise.toLowerCase() !== personne.toLowerCase()) {
                return `${entreprise} - ${personne}`;
            }
            return entreprise || personne || `Client #${client.id ?? ''}`;
        }
        return personne || entreprise || `Client #${client.id ?? ''}`;
    }

    /** Client professionnel = type Professionnel uniquement (ENUM ERP) — hors Négoce. */
    isClientPatente(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = this.normalizeClientTypeKey(client);
        return t === 'professionnel' || t === 'patente' || t === 'entreprise';
    }

    /** Client type Négoce (vente négoce uniquement). */
    isClientNegoce(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = this.normalizeClientTypeKey(client);
        return t === 'negoce';
    }

    isClientParticulier(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = this.normalizeClientTypeKey(client);
        if (t === 'individuel' || t === 'particulier' || t === 'materiel') {
            return true;
        }
        // Type inconnu / vide → traité comme particulier (pas pro / négoce)
        return !this.isClientPatente(client) && !this.isClientNegoce(client);
    }

    /** Recalcule la liste ng-select selon Professionnel / Particulier / Négoce. */
    private refreshClientsForSelect(): void {
        const all = this.clients || [];
        if (this.isVenteNegoceContext || this.clientSearchMode === 'negoce') {
            this.clientsForSelect = all
                .filter((c) => this.isClientNegoce(c))
                .map((c) => this.enrichClientForNgSelect(c));
            return;
        }
        this.clientsForSelect = (
            this.clientSearchMode === 'patente'
                ? all.filter((c) => this.isClientPatente(c))
                : all.filter((c) => this.isClientParticulier(c))
        ).map((c) => this.enrichClientForNgSelect(c));
    }

    get clientSearchPlaceholder(): string {
        if (this.isVenteNegoceContext || this.clientSearchMode === 'negoce') {
            return 'Rechercher un client négoce…';
        }
        return this.clientSearchMode === 'patente'
            ? 'Rechercher par entreprise…'
            : 'Rechercher par nom…';
    }

    setClientSearchMode(mode: 'patente' | 'particulier' | 'negoce'): void {
        if (this.isVenteNegoceContext) {
            mode = 'negoce';
        }
        if (this.clientSearchMode === mode) {
            return;
        }
        this.clientSearchMode = mode;
        this.selectedClient = null;
        this.selectedClientId = null;
        this.clientId = null;
        this.refreshClientsForSelect();
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    /**
     * Recherche : professionnel → nom d'entreprise (pas email) ;
     * particulier → nom / prénom (pas email).
     */
    searchClients = (term: string, item: Client): boolean => {
        const t = String(term || '')
            .trim()
            .toLowerCase();
        if (!t) {
            return true;
        }
        let hayParts: Array<string | null | undefined>;
        if (this.clientSearchMode === 'patente' || this.clientSearchMode === 'negoce') {
            hayParts = [
                item?.nom_entreprise,
                item?.raison_social,
                item?.code_client,
                item?.identifiant_unique,
                item?.numero_identification_fiscale
            ];
        } else {
            hayParts = [
                item?.nom_prenom,
                item?.code_client,
                item?.identifiant_unique
            ];
        }
        const hay = hayParts
            .filter(Boolean)
            .join(' ')
            .toLowerCase()
            .replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, ' ');
        return hay.includes(t);
    };

    /** FK ERP : null pour un client uniquement présent en caisse. */
    resolveDocumentClientId(client: Client | null | undefined): number | null {
        if (!client?.id || this.isCaisseClient(client)) {
            return null;
        }
        return client.id;
    }

    /** Libellé client persisté / affiché : entreprise si pro, sinon nom+prénom. */
    resolveDocumentClientDisplayName(client: Client | null | undefined): string {
        if (!client) {
            return 'Client inconnu';
        }
        const type = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const isPro =
            type === 'professionnel' || type === 'negoce' || type === 'patente' || type === 'entreprise';
        const entreprise = String(
            (client as any).nom_entreprise || (client as any).raison_social || ''
        ).trim();
        const nomPrenom = String(client.nom_prenom || '').trim();
        if (isPro) {
            return entreprise || nomPrenom || 'Client inconnu';
        }
        return nomPrenom || entreprise || 'Client inconnu';
    }

    loadClients(clientIdToSelect?: number): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingClients = false;
            this.clients = [];
            this.clientsForSelect = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingClients = true;
        forkJoin({
            erp: this.fetchAllActiveErpClientsForDocument(),
            caisse: this.fetchCaisseClientsForDocument()
        }).subscribe({
            next: ({ erp, caisse }) => {
                this.zone.run(() => {
                    const erpList = (erp || []) as Client[];
                    this.clients = this.mergeErpClientsWithCaisse(erpList, caisse);
                    this.refreshClientsForSelect();
                    this.isLoadingClients = false;

                    const idToSelect = clientIdToSelect ?? this.pendingClientId;

                    if (idToSelect !== undefined) {
                        const clientToSelect = this.clients.find(c => c.id === idToSelect);
                        if (clientToSelect) {
                            if (this.isVenteNegoceContext) {
                                this.clientSearchMode = 'negoce';
                            } else {
                                this.clientSearchMode = this.isClientPatente(clientToSelect)
                                    ? 'patente'
                                    : this.isClientNegoce(clientToSelect)
                                      ? 'patente'
                                      : 'particulier';
                                // En vente classique, un client négoce n’est pas sélectionnable
                                if (this.isClientNegoce(clientToSelect)) {
                                    this.selectedClient = null;
                                    this.selectedClientId = null;
                                    this.clientId = null;
                                    this.refreshClientsForSelect();
                                    this.pendingClientId = undefined;
                                    this.isLoadingClients = false;
                                    this.cdr.detectChanges();
                                    this.toastr.warning(
                                        'Ce client est de type Négoce : utilisez le menu Vente négoce.',
                                        'Client non disponible'
                                    );
                                    return;
                                }
                            }
                            this.refreshClientsForSelect();
                            this.selectedClient = clientToSelect;
                            this.selectedClientId = idToSelect;
                            this.clientId = idToSelect;

                            this.editMode = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };

                            if (this.mode === 'add' || !this.documentId) {
                                this.modifiedClientFields = {
                                    nomClient: false,
                                    identifiant: false,
                                    numeroIdentification: false,
                                    adresse: false,
                                    email: false
                                };
                                this.modifiedFournisseurFields = {
                                    nomEntreprise: false,
                                    numeroIdentification: false,
                                    responsable: false,
                                    telephone: false,
                                    adresse: false
                                };
                            } else {
                                this.loadModifiedFields();
                            }

                            this.cdr.detectChanges();

                            setTimeout(() => {
                                this.initializeFeatherIcons();
                            }, 200);

                            this.updateApproveButtonState();
                            this.cdr.detectChanges();

                            setTimeout(() => {
                                this.initializeFeatherIcons();
                            }, 200);

                            this.toastr.info(`Client "${clientToSelect.nom_prenom}" chargé.`);
                        } else {
                            this.selectedClient = null;
                        }
                        this.pendingClientId = undefined;
                    }

                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.zone.run(() => {
                    this.isLoadingClients = false;
                    this.clients = [];
                    this.clientsForSelect = [];
                    this.toastr.error('Erreur lors du chargement des clients.', 'Erreur');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    private applySelectedClientFromList(client: Client, clientId: number): void {
        this.selectedClient = client;
        this.selectedClientId = clientId;
        this.clientId = clientId;
        this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };

        if (this.mode === 'add' || !this.documentId) {
            this.modifiedClientFields = {
                nomClient: false,
                identifiant: false,
                numeroIdentification: false,
                adresse: false,
                email: false
            };
            this.modifiedFournisseurFields = {
                nomEntreprise: false,
                numeroIdentification: false,
                responsable: false,
                telephone: false,
                adresse: false
            };
        } else {
            this.loadModifiedFields();
        }
        this.loadWarehouses();
        this.updateApproveButtonState();
        this.cdr.detectChanges();
        setTimeout(() => {
            this.initializeFeatherIcons();
        }, 150);
    }

    onClientSelect(value: any): void {
        let clientId: number | null = null;

        if (value === null || value === undefined) {
            // ng-select peut émettre null pendant le refresh de la liste — ignorer si sélection en cours
            if (this.clientSelectLoading || this.selectedClient) {
                return;
            }
            this.selectedClient = null;
            this.selectedClientId = null;
            this.clientId = null;
            this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
            this.cdr.detectChanges();
            return;
        }

        if (typeof value === 'object' && value.id !== undefined) {
            clientId = typeof value.id === 'number' ? value.id : parseInt(value.id, 10);
        } else if (typeof value === 'number') {
            clientId = value;
        } else if (typeof value === 'string') {
            clientId = parseInt(value, 10);
        }

        if (clientId == null || isNaN(clientId)) {
            this.toastr.error('ID de client invalide');
            return;
        }

        this.clientSelectLoading = true;
        const fromList = this.clients.find((c) => Number(c.id) === Number(clientId));
        // Appliquer immédiatement pour fermer le select et éviter le reset ng-select
        if (fromList) {
            this.applySelectedClientFromList(fromList, clientId);
        }

        if (fromList && this.isCaisseClient(fromList)) {
            this.clientSelectLoading = false;
            return;
        }

        this.clientService.getClientById(clientId).subscribe({
            next: (clientComplet) => {
                if (!clientComplet || !clientComplet.id) {
                    this.clientSelectLoading = false;
                    if (!fromList) {
                        this.toastr.error('Les données du client sont invalides.');
                    }
                    return;
                }
                if (!Array.isArray(clientComplet.adresses)) {
                    clientComplet.adresses = clientComplet.adresses ? [clientComplet.adresses] : [];
                }
                if (!Array.isArray(clientComplet.telephones)) {
                    clientComplet.telephones = clientComplet.telephones ? [clientComplet.telephones] : [];
                }
                if (!Array.isArray(clientComplet.emails)) {
                    clientComplet.emails = clientComplet.emails ? [clientComplet.emails] : [];
                }
                const existingIndex = this.clients.findIndex(
                    (c) => Number(c.id) === Number(clientComplet.id)
                );
                if (existingIndex >= 0) {
                    this.clients[existingIndex] = clientComplet;
                } else {
                    this.clients = [clientComplet, ...this.clients];
                }
                this.refreshClientsForSelect();

                this.selectedClient = clientComplet;
                this.selectedClientId = clientComplet.id;
                this.clientId = clientComplet.id;
                this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };

                if (this.mode === 'add' || !this.documentId) {
                    this.modifiedClientFields = {
                        nomClient: false,
                        identifiant: false,
                        adresse: false,
                        email: false
                    };
                    this.modifiedFournisseurFields = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };
                } else {
                    this.loadModifiedFields();
                }
                this.loadWarehouses();
                this.updateApproveButtonState();
                this.clientSelectLoading = false;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.initializeFeatherIcons();
                }, 150);
            },
            error: (err) => {
                this.clientSelectLoading = false;
                const client = this.clients.find((c) => Number(c.id) === Number(clientId));
                if (client) {
                    this.applySelectedClientFromList(client, clientId);
                } else {
                    this.selectedClientId = null;
                    this.selectedClient = null;
                    this.clientId = null;
                    this.pendingClientId = clientId;
                    const errorMessage =
                        err?.error?.message || err?.error?.error || err?.message || 'Erreur inconnue';
                    this.toastr.error(
                        `Impossible de charger les données du client: ${errorMessage}`,
                        'Erreur'
                    );
                }
            }
        });
    }

    onFournisseurSelect(fournisseurId: number | any): void {
        let id: number | null = null;
        
        if (fournisseurId === null || fournisseurId === undefined) {
            this.selectedFournisseur = null;
            this.selectedFournisseurId = null;
            this.clientId = null;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
            return;
        }

        if (typeof fournisseurId === 'object' && fournisseurId.id !== undefined) {
            id = typeof fournisseurId.id === 'number' ? fournisseurId.id : parseInt(fournisseurId.id, 10);
        } 
        else if (typeof fournisseurId === 'number') {
            id = fournisseurId;
        }
        else if (typeof fournisseurId === 'string') {
            id = parseInt(fournisseurId, 10);
        }
        
        if (!id || isNaN(id)) {
            this.toastr.error('ID de fournisseur invalide');
            return;
        }

        
        this.fournisseurService.getFournisseurById(id).subscribe({
            next: (fournisseurComplet) => {
                
                if (!fournisseurComplet || !fournisseurComplet.id) {
                    this.toastr.error('Les données du fournisseur sont invalides.');
                    return;
                }

                if (!Array.isArray(fournisseurComplet.adresses)) {
                    fournisseurComplet.adresses = fournisseurComplet.adresses ? [fournisseurComplet.adresses] : [];
                }
                if (!Array.isArray(fournisseurComplet.telephones)) {
                    fournisseurComplet.telephones = fournisseurComplet.telephones ? [fournisseurComplet.telephones] : [];
                }
                if (!Array.isArray(fournisseurComplet.emails)) {
                    fournisseurComplet.emails = fournisseurComplet.emails ? [fournisseurComplet.emails] : [];
                }

                const responsable = (fournisseurComplet as any).responsable || 
                                  (fournisseurComplet as any).contact || 
                                  (fournisseurComplet as any).nom_contact ||
                                  '';
                
                const fournisseurWithExtras = {
                    ...fournisseurComplet,
                    responsable: responsable,
                    phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                } as any;

                const existingIndex = this.fournisseurs.findIndex(f => f.id === fournisseurComplet.id);
                if (existingIndex >= 0) {
                    this.fournisseurs[existingIndex] = fournisseurWithExtras as Fournisseur;
                } else {
                    this.fournisseurs = [fournisseurWithExtras as Fournisseur, ...this.fournisseurs];
                }
                
                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                this.selectedFournisseurId = fournisseurComplet.id;
                this.clientId = fournisseurComplet.id;

                this.editModeFournisseur = {
                    nomEntreprise: false,
                    numeroIdentification: false,
                    responsable: false,
                    telephone: false,
                    adresse: false
                };

                if (this.mode === 'add' || !this.documentId) {
                    this.modifiedClientFields = {
                        nomClient: false,
                        identifiant: false,
                        adresse: false,
                        email: false
                    };
                    this.modifiedFournisseurFields = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };
                } else {
                    this.loadModifiedFields();
                }
                this.loadWarehouses();
                
                this.loadProjects();
                this.updateApproveButtonState();
                this.cdr.detectChanges();

                setTimeout(() => {
                    this.initializeFeatherIcons();
                }, 150);
            },
            error: (err) => {
                const fournisseur = this.fournisseurs.find(f => f.id === id);
                if (fournisseur) {

                    if (!Array.isArray(fournisseur.adresses)) {
                        fournisseur.adresses = fournisseur.adresses ? [fournisseur.adresses] : [];
                    }
                    if (!Array.isArray(fournisseur.telephones)) {
                        fournisseur.telephones = fournisseur.telephones ? [fournisseur.telephones] : [];
                    }
                    if (!Array.isArray(fournisseur.emails)) {
                        fournisseur.emails = fournisseur.emails ? [fournisseur.emails] : [];
                    }
                    
                    this.selectedFournisseur = fournisseur;
                    this.selectedFournisseurId = id;
                    this.clientId = id;

                    this.editModeFournisseur = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };

                    if (this.mode === 'add' || !this.documentId) {
                        this.modifiedClientFields = {
                            nomClient: false,
                            identifiant: false,
                            adresse: false,
                            email: false
                        };
                        this.modifiedFournisseurFields = {
                            nomEntreprise: false,
                            numeroIdentification: false,
                            responsable: false,
                            telephone: false,
                            adresse: false
                        };
                    } else {
                        this.loadModifiedFields();
                    }
                    this.loadWarehouses();
                    
                    this.loadProjects();
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();

                    setTimeout(() => {
                        this.initializeFeatherIcons();
                    }, 150);
                } else {
                    this.selectedFournisseurId = null;
                    this.selectedFournisseur = null;
                    this.clientId = null;
                    const errorMessage = err?.error?.message || err?.error?.error || err?.message || 'Erreur inconnue';
                    this.toastr.error(`Impossible de charger les données du fournisseur: ${errorMessage}`, 'Erreur');
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onProjectSaved(): void {
        this.toastr.success('Projet ajouté avec succès !', 'Succès');
        this.loadProjects();
    }

    openAjoutFournisseurModal() {
        this.ajoutFournisseurComponent.openModal();
    }

    openAjoutClientModal() {
        this.ajoutClientComponent.openModal();
    }

    private normalizeTypeDocumentTitre(s: string | null | undefined): string {
        return (s || '')
            .trim()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    private extractTypePrefixFromTypeRow(type: any): string {
        if (!type || typeof type !== 'object') {
            return '';
        }
        const flat = this.extractTypePrefixFromFlatObject(type);
        if (flat) {
            return flat;
        }
        const nested = type.type_document ?? type.typeDocument ?? type.document_type;
        if (nested && typeof nested === 'object') {
            return this.extractTypePrefixFromFlatObject(nested);
        }
        return '';
    }

    private extractTypePrefixFromFlatObject(o: any): string {
        if (!o || typeof o !== 'object') {
            return '';
        }
        const candidates = [
            o.prefix,
            o.preffix,
            o.preffixe,
            o.ref_prefix,
            o.reference_prefix,
            o.prefix_reference,
            o.prefixe,
            o.code_prefix,
            o.code,
            o.libelle_prefix,
            o.prefix_ref
        ];
        for (const c of candidates) {
            if (c != null && String(c).trim() !== '') {
                const s = String(c).trim();
                if (/^[\d.]+$/.test(s)) {
                    continue;
                }
                return s;
            }
        }
        return '';
    }

    private extractRefCounterFromTypeRow(type: any): number | null {
        if (!type || typeof type !== 'object') {
            return null;
        }
        const v = type.ref_counter ?? type.refCounter ?? type.compteur_ref ?? type.counter;
        if (v == null || v === '') {
            return null;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }

    /** Réponse GET /api/documents/ref-counter/:type_document_id */
    private extractRefCounterFromApiResponse(res: any): number | null {
        const raw = res?.data ?? res;
        const v =
            raw?.ref_counter ??
            raw?.refCounter ??
            raw?.compteur_ref ??
            res?.ref_counter ??
            res?.data?.ref_counter;
        if (v == null || v === '') {
            return null;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }

    /** Alimente typeDocumentsMeta.refCounter pour buildInitialRefFromTypeMeta (prochaine ref = counter + 1). */
    private ensureTypeMetaRefCounter(counter: number | null): void {
        const dt = this.documentType;
        if (!dt) {
            return;
        }
        const tid = this.typeDocumentIdMap[dt];
        const prev = this.typeDocumentsMeta[dt];
        this.typeDocumentsMeta[dt] = {
            id: prev?.id ?? (tid != null ? Number(tid) : 0),
            prefix: prev?.prefix ?? this.documentTypeToRefPrefix[dt] ?? 'DOC',
            refCounter: counter != null && Number.isFinite(counter) ? Number(counter) : prev?.refCounter ?? null
        };
    }

    private isProvisionalDraftRef(ref: string | null | undefined): boolean {
        return String(ref || '').trim().toUpperCase().includes('BROUILLON');
    }

    private documentRefPayloadSpread(): { ref_externe?: string; ref_interne?: string } {
        // Uniquement le 1er document (popup) : seed. Les suivants : le backend alloue N+1 sans trou.
        // Document déjà persisté : ne jamais renvoyer la ref (immuable, même en brouillon).
        if (!this.referenceSeedFromPopup || this.documentId) {
            return {};
        }
        const r = (this.documentReference || this.refExterne || '').trim();
        if (!r || /^0+$/.test(r) || this.isProvisionalDraftRef(r)) {
            return {};
        }
        return { ref_externe: r, ref_interne: r };
    }

    /** Après POST /api/documents réussi : synchronise le compteur serveur. */
    private incrementRefCounterAfterDocumentCreate(typeDocumentId: number | null | undefined): void {
        // No-op : l'incrément est atomique dans createDocument (évite les numéros sautés).
    }

    private incrementRefCountersAfterDocumentCreates(pairedBonLivraisonId?: number | null): void {
        // No-op : voir incrementRefCounterAfterDocumentCreate.
    }

    private finishDocumentReferenceHeaderPrefetch(): void {
        this.documentReferenceHeaderPending = false;
        this.cdr.markForCheck();
    }

    /** Référence = num_document LC (pas compteur / modèle ERP bon transfert). */
    private usesLcTransfertNumDocumentReference(): boolean {
        return this.isLogicielCaisseEntrepotTransfert();
    }

    /**
     * Transfert LC existant (ex. ouverture depuis PV validé) : ne pas appeler previewNextNumDocument (+1).
     */
    private shouldSkipLcTransfertNextReferencePrefetch(): boolean {
        const lcEdit = Number(this.logicielCaisseTransfertEditId);
        if (Number.isFinite(lcEdit) && lcEdit > 0) {
            return true;
        }
        return (
            this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert()
        );
    }

    /** type_document_id ERP pour le type courant (map statique puis métadonnées API). */
    private resolveTypeDocumentIdForCurrentDocument(): number | null {
        if (this.usesLcTransfertNumDocumentReference()) {
            return null;
        }
        const fromMap = this.typeDocumentIdMap[this.documentType];
        if (fromMap != null && !Number.isNaN(Number(fromMap))) {
            return Number(fromMap);
        }
        const metaId = this.typeDocumentsMeta[this.documentType]?.id;
        if (metaId != null && Number(metaId) > 0 && !Number.isNaN(Number(metaId))) {
            return Number(metaId);
        }
        return null;
    }

    /**
     * Transfert entrepôt (logiciel caisse) : popup référence uniquement s'il n'existe encore aucun transfert LC.
     */
    private decideFirstLcStockTransfertForReference(proceed: (forceFirst?: boolean) => void): void {
        forkJoin({
            counts: this.lcStockTransfert.getCounts().pipe(catchError(() => of(null))),
            nextNum: this.lcStockTransfert.previewNextNumDocument().pipe(catchError(() => of(null))),
        }).subscribe(({ counts, nextNum }) => {
            const totalFromCounts = Number(counts?.tous);
            const totalFallback =
                (Number(counts?.en_cours) || 0) +
                (Number(counts?.livraison) || 0) +
                (Number(counts?.livraison_reception) || 0) +
                (Number(counts?.clos) || 0);
            const existingTotal = Number.isFinite(totalFromCounts) && totalFromCounts > 0
                ? totalFromCounts
                : totalFallback;

            const trimmed = String(nextNum ?? '').trim();
            const nextSeq = /^\d+$/.test(trimmed) ? parseInt(trimmed, 10) : NaN;

            if (existingTotal > 0) {
                if (Number.isFinite(nextSeq) && nextSeq > 1) {
                    this.ensureTypeMetaRefCounter(nextSeq - 1);
                } else {
                    this.ensureTypeMetaRefCounter(Math.max(existingTotal, 1));
                }
                proceed(false);
                return;
            }

            if (Number.isFinite(nextSeq) && nextSeq > 1) {
                this.ensureTypeMetaRefCounter(nextSeq - 1);
                proceed(false);
                return;
            }

            this.lcStockTransfert.list({ tab: 'tous', page: 1, limit: 1 }).pipe(
                catchError(() => of(null))
            ).subscribe((listRes) => {
                const total = Number(listRes?.pagination?.total ?? NaN);
                if (Number.isFinite(total) && total > 0) {
                    proceed(false);
                } else {
                    proceed(true);
                }
            });
        });
    }

    private applyNextLcTransfertNumDocument(onDone?: () => void): void {
        const prefetchGen = ++this.documentReferencePrefetchGen;
        this.documentReferenceHeaderPending = true;
        this.cdr.markForCheck();
        this.lcStockTransfert.previewNextNumDocument().subscribe({
            next: (num) => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                const ref = (num || '').trim();
                this.documentReference = ref;
                this.refExterne = ref;
                this.numericReference = this.getNumericReferenceFromRefString(ref);
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            },
            error: () => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                this.documentReference = '00000001';
                this.refExterne = this.documentReference;
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            },
        });
    }

    private applyNextReferenceFromRefCounterApi(onDone?: () => void): void {
        // Document déjà créé : la référence est immuable (ne pas régénérer l’affichage).
        if (this.documentId || this.mode === 'edit' || this.mode === 'validation') {
            this.documentReferenceHeaderPending = false;
            onDone?.();
            return;
        }
        if (this.isLogicielCaisseEntrepotTransfert()) {
            if (this.shouldSkipLcTransfertNextReferencePrefetch()) {
                this.documentReferenceHeaderPending = false;
                onDone?.();
                this.cdr.markForCheck();
                return;
            }
            this.applyNextLcTransfertNumDocument(onDone);
            return;
        }
        const typeId = this.typeDocumentIdMap[this.documentType];
        const prefix = this.getReferencePrefix();
        const uid = Number(this.currentUser?.id);
        const prefetchGen = ++this.documentReferencePrefetchGen;
        this.documentReferenceHeaderPending = true;
        this.cdr.markForCheck();
        if (!this.stationId || typeId == null || !Number.isFinite(uid) || uid <= 0) {
            this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
            this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
            this.finishDocumentReferenceHeaderPrefetch();
            onDone?.();
            return;
        }
        this.documentService.getRefCounter(typeId, this.stationId, uid).subscribe({
            next: (res: any) => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                const c = this.extractRefCounterFromApiResponse(res);
                this.ensureTypeMetaRefCounter(c);
                this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.refExterne = this.documentReference;
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            },
            error: () => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.refExterne = this.documentReference;
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            }
        });
    }

    private applyTypeDocumentsFromApi(response: any): void {
        let typesData: any[] = [];
        if (Array.isArray(response)) {
            typesData = response;
        } else if (response?.data?.types && Array.isArray(response.data.types)) {
            typesData = response.data.types;
        } else if (Array.isArray(response?.data)) {
            typesData = response.data;
        } else if (response?.types && Array.isArray(response.types)) {
            typesData = response.types;
        }

        if (!Array.isArray(typesData)) {
            return;
        }

        typesData.forEach((type: any) => {
            const titreNorm = this.normalizeTypeDocumentTitre(type.titre || type.nom || '');
            const id = Number(type.id);
            if (!id || Number.isNaN(id)) {
                return;
            }
            const docTypeKey = this.resolveDocTypeKeyFromApiTitre(titreNorm);
            if (!docTypeKey) {
                return;
            }

            const prefix = this.extractTypePrefixFromTypeRow(type);
            const refCounter = this.extractRefCounterFromTypeRow(type);

            this.typeDocumentIdMap[docTypeKey] = id;
            if (prefix && !this.isFacPrefixMisappliedForDocType(docTypeKey, prefix)) {
                this.documentTypeToRefPrefix[docTypeKey] = prefix;
            }
            this.typeDocumentsMeta[docTypeKey] = {
                id,
                prefix: (prefix && !this.isFacPrefixMisappliedForDocType(docTypeKey, prefix)
                    ? prefix
                    : this.documentTypeToRefPrefix[docTypeKey]) || 'DOC',
                refCounter
            };
            this.typeIdToDocumentTypeFromApi[id] = docTypeKey;
        });
    }

    /** Mappe le titre API type_documents vers la clé métier front (DEVIS, CF, …). */
    private resolveDocTypeKeyFromApiTitre(titreNorm: string): string | null {
        if (!titreNorm) {
            return null;
        }
        if (titreNorm.includes('AVOIR') && titreNorm.includes('FOURNISSEUR')) {
            return 'AVOIR FOURNISSEUR';
        }
        if (titreNorm.includes('FACTURE') && titreNorm.includes('FOURNISSEUR')) {
            return 'FACTURE FOURNISSEUR';
        }
        if (titreNorm.includes('RETOUR') && titreNorm.includes('FOURNISSEUR')) {
            return 'RETOUR FOURNISSEUR';
        }
        if (titreNorm.includes('COMMANDE') && titreNorm.includes('FOURNISSEUR')) {
            return 'COMMANDE FOURNISSEUR';
        }
        if (titreNorm.includes('BON') && (titreNorm.includes('RECEPTION') || titreNorm.includes('RÉCEPTION'))) {
            return 'BON RECEPTION';
        }
        if (titreNorm.includes('BON') && titreNorm.includes('LIVRAISON')) {
            return 'BON DE LIVRAISON';
        }
        if (titreNorm.includes('BON') && titreNorm.includes('SORTIE')) {
            return 'BON DE SORTIE';
        }
        if (titreNorm.includes('BON') && titreNorm.includes('TRANSFERT')) {
            return 'BON TRANSFERT';
        }
        if (titreNorm.includes('COMMANDE') && titreNorm.includes('CLIENT')) {
            return 'COMMANDE CLIENT';
        }
        if (titreNorm === 'AVOIR' || (titreNorm.includes('AVOIR') && !titreNorm.includes('FOURNISSEUR'))) {
            return 'AVOIR';
        }
        if (titreNorm.includes('DEVIS')) {
            return 'DEVIS';
        }
        if (titreNorm.includes('FACTURE') && !titreNorm.includes('FOURNISSEUR')) {
            return 'FACTURE';
        }
        if (titreNorm.includes('INVENTAIRE')) {
            return 'INVENTAIRE';
        }
        if (titreNorm.includes('PV') && titreNorm.includes('ECART')) {
            return 'PV ECART';
        }
        const known = Object.keys(this.documentTypeToRefPrefix);
        if (known.includes(titreNorm)) {
            return titreNorm;
        }
        return null;
    }

    private loadTypeDocumentsMetadata(): void {
        this.documentService.getTypeDocuments().subscribe({
            next: (res) => {
                this.applyTypeDocumentsFromApi(res);
                this.loadCurrentTypeDocumentPrefixFromApi();
                this.maybePrefetchNextDocumentReference(true);
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            },
            error: () => {
            }
        });
    }

    private loadReferenceModelFromParametreDocument(): void {
        if (!this.stationId) {
            return;
        }
        if (this.usesLcTransfertNumDocumentReference()) {
            this.referenceModelDetail = null;
            this.referenceModelType = null;
            this.maybePrefetchNextDocumentReference(true);
            return;
        }
        const typeDocumentId =
            this.typeDocumentIdMap[this.documentType] ??
            (this.documentType ? undefined : this.typeDocumentIdMap['FACTURE']);
        this.parametreDocumentSettingsService.getByStation(this.stationId).pipe(
            tap((bundle) => {
                const pd = bundle?.parametre_document as Record<string, unknown> | undefined;
                if (pd != null) {
                    this.paramDocMajPrixAchatProduit = isTruthyTinyInt(pd['maj_prix_achat_produit']);
                    this.paramDocBaseCalculPrixAchat = normalizeBaseCalculPrixAchat(pd['base_calcul_prix_achat']);
                }
            }),
            switchMap((bundle) => {
                const pd = bundle?.parametre_document;
                const raw = resolveModeleReferenceForType(
                    pd?.modeles_reference,
                    typeDocumentId,
                    pd?.modele_reference ?? null
                );
                if (raw == null) {
                    return of(null);
                }
                const idOrType = Number(raw);
                if (Number.isNaN(idOrType)) {
                    return of(null);
                }
                return this.documentService.getReferenceModelById(idOrType).pipe(
                    catchError(() =>
                        this.documentService.getReferenceModelsAll().pipe(
                            map((res: any) => {
                                const list: any[] = Array.isArray(res?.data) ? res.data : [];
                                let m = list.find((x) => Number(x.id) === idOrType);
                                if (!m) {
                                    m = list.find((x) => Number(x.model_type) === idOrType);
                                }
                                // Prefer model matching current document type when ambiguous
                                if (!m && typeDocumentId != null) {
                                    m = list.find(
                                        (x) =>
                                            Number(x.type_document_id) === Number(typeDocumentId) &&
                                            Number(x.model_type) === idOrType
                                    );
                                }
                                return m ?? null;
                            })
                        )
                    )
                );
            }),
            catchError(() => of(null))
        ).subscribe((model) => {
            this.applyReferenceModelFromParametre(model, typeDocumentId);
        });
    }

    private applyReferenceModelFromParametre(
        model: ReferenceModel | any | null,
        typeDocumentId?: number
    ): void {
        if (!model || typeof model !== 'object') {
            this.referenceModelDetail = null;
            if (!this.documentId) {
                this.referenceModelType = this.documentService.getDefaultReferenceModelType(
                    this.stationId,
                    typeDocumentId
                );
            }
            this.maybePrefetchNextDocumentReference(true);
            this.cdr.markForCheck();
            return;
        }
        const id = Number(model.id);
        const mt = Number(model.model_type ?? model.modelType);
        this.referenceModelDetail = {
            id: Number.isNaN(id) ? 0 : id,
            model_type: Number.isNaN(mt) ? 0 : mt,
            current_counter: Number(model.current_counter ?? 0),
            prefix: model.prefix != null ? String(model.prefix).trim() : null,
            description: model.description != null ? String(model.description) : ''
        };
        if (!Number.isNaN(mt) && mt > 0) {
            this.documentService.setDefaultReferenceModelType(this.stationId, mt, typeDocumentId);
            if (!this.documentId) {
                this.referenceModelType = mt;
            }
        }
        this.maybePrefetchNextDocumentReference(true);
        this.cdr.markForCheck();
    }

    private buildInitialRefFromTypeMeta(docType: string, fallbackPrefix: string): string {
        const meta = this.typeDocumentsMeta[docType];
        const rawP = (meta?.prefix || fallbackPrefix || 'DOC').trim() || 'DOC';
        const p = this.substituteReferenceYearInPrefix(rawP) || rawP;
        const fmt = this.getModelReferenceFormatMeta();
        const year = new Date().getFullYear();

        if (fmt?.kind === 'year_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'year_concat_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${year}${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${year}${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. 00000X-2026 (séquence puis année avec tiret)
        if (fmt?.kind === 'seq_year') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${nextNum.toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${nextNum.toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
        }

        if (fmt?.kind === 'prefix_year_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. DEV-00000X (sans année dans la chaîne)
        if (fmt?.kind === 'prefix_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${p}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${p}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. 0000001 (numéro seul)
        if (fmt?.kind === 'seq_only') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return nextNum.toString().padStart(fmt.sequencePad, '0');
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return nextNum.toString().padStart(fmt.sequencePad, '0');
            }
            return (1).toString().padStart(fmt.sequencePad, '0');
        }

        if (meta?.refCounter != null && meta.refCounter >= 0) {
            const nextNum = meta.refCounter + 1;
            return `${p}-${nextNum.toString().padStart(4, '0')}`;
        }
        return `${p}-0001`;
    }


    private needsTypeDocumentsApiForRef(): boolean {
        return true;
    }

    private checkRoute(): void {
        const currentUrl = this.router.url;

        if (currentUrl.includes('/vente-negoce/devis/add-devis') || currentUrl.includes('/vente/devis/add-devis')) {
            this.documentType = 'DEVIS';
        } else if (currentUrl.includes('/vente-negoce/commande-client/add-commande-client') || currentUrl.includes('/vente/commande-client/add-commande-client')) {
            this.documentType = 'COMMANDE CLIENT';
        } else if (
            currentUrl.includes('/vente-negoce/bon-sortie/add-bon-sortie') ||
            currentUrl.includes('/vente/bon-sortie/add-bon-sortie') ||
            currentUrl.includes('/vente-negoce/bon-sortie/edit-bon-sortie') ||
            currentUrl.includes('/vente/bon-sortie/edit-bon-sortie')
        ) {
            this.documentType = 'BON DE SORTIE';
        } else if (currentUrl.includes('/vente-negoce/bon-livraison/add-bon-livraison') || currentUrl.includes('/vente/bon-livraison/add-bon-livraison')) {
            this.documentType = 'BON DE LIVRAISON';
        } else if (currentUrl.includes('/vente-negoce/avoir/add-facture') || currentUrl.includes('/vente-negoce/avoir/edit-facture')
            || currentUrl.includes('/vente/avoir/add-facture') || currentUrl.includes('/vente/avoir/edit-facture')) {
            this.documentType = 'AVOIR';
        } else if (currentUrl.includes('/achat/avoir-fournisseur/add-avoir-fournisseur') || currentUrl.includes('/achat/avoir-fournisseur/edit-avoir-fournisseur')) {
            this.documentType = 'AVOIR FOURNISSEUR';
        } else if (currentUrl.includes('/vente/facture/add-facture') || currentUrl.includes('/vente/facture/edit-facture')
            || currentUrl.includes('/vente-negoce/facture/add-facture') || currentUrl.includes('/vente-negoce/facture/edit-facture')) {
            this.documentType = 'FACTURE';
        } else if (
            currentUrl.includes('/achat/commande-fournisseur/add-commande-fournisseur') ||
            currentUrl.includes('/achat/commande-fournisseur/edit-commande-fournisseur')
        ) {
            this.documentType = 'COMMANDE FOURNISSEUR';
        } else if (
            currentUrl.includes('/achat/facture-fournisseur/add-facture-fournisseur') ||
            currentUrl.includes('/achat/facture-fournisseur/edit-facture-fournisseur')
        ) {
            this.documentType = 'FACTURE FOURNISSEUR';
        } else if (
            currentUrl.includes('/achat/retour-fournisseur/add-retour-fournisseur') ||
            currentUrl.includes('/achat/retour-fournisseur/edit-retour-fournisseur')
        ) {
            this.documentType = 'RETOUR FOURNISSEUR';
        } else if (
            currentUrl.includes('/achat/bon-reception/add-bon-reception') ||
            currentUrl.includes('/achat/bon-reception/edit-bon-reception')
        ) {
            this.documentType = 'BON RECEPTION';
        } else if (currentUrl.includes('/stock/inventaire/add-inventaire') 
                   || currentUrl.includes('/inventaire/add-inventaire')
                   || currentUrl.includes('/inventaire/ajout-inventaire')) {
            this.documentType = 'INVENTAIRE';
        } else if (currentUrl.includes('/transfert-entrepot/nouveau')) {
            this.documentType = 'TRANSFERT';
        } else if (currentUrl.includes('/stock/bon-transfert/add-bon-transfert') 
                   || currentUrl.includes('/bon-transfert/add-bon-transfert')
                   || currentUrl.includes('/bon-transfert/ajout-bonTransfert')) {
            this.documentType = 'BON TRANSFERT';
        } else if (currentUrl.includes('/stock/pv-ecart/add-pv-ecart')) {
            this.documentType = 'PV ECART';
        } else {
            this.documentType = 'DEVIS';
        }

        if (!this.isLogicielCaisseEntrepotTransfert()) {
        this.loadCurrentTypeDocumentPrefixFromApi();
        } else if (!this.shouldSkipLcTransfertNextReferencePrefetch()) {
            this.maybePrefetchNextDocumentReference(true);
        }
        if (this.isBonSortieDocument()) {
            this.loadEtablissementEntrepotLinks();
        }
        this.cdr.detectChanges();
    }

    private substituteReferenceYearInPrefix(raw: string | null | undefined): string {
        let s = (raw ?? '').trim();
        if (!s) {
            return '';
        }
        const y = new Date().getFullYear();
        s = s.replace(/\{YYYY\}/gi, String(y)).replace(/\{YEAR\}/gi, String(y));
        s = s.replace(/(?<![0-9])(20\d{2})(?![0-9])/g, String(y));
        return s.replace(/-+$/, '').trim();
    }

    private resolveTypeDocumentIdForPrefixLoad(typeDocumentIdOverride?: number | null): number | null {
        if (this.usesLcTransfertNumDocumentReference()) {
            return null;
        }
        if (
            typeDocumentIdOverride != null &&
            !Number.isNaN(Number(typeDocumentIdOverride)) &&
            Number(typeDocumentIdOverride) > 0
        ) {
            return Number(typeDocumentIdOverride);
        }
        const fromMap = this.typeDocumentIdMap[this.documentType];
        if (fromMap != null && !Number.isNaN(Number(fromMap))) {
            return Number(fromMap);
        }
        if (this.currentTypeDocumentId != null && !Number.isNaN(Number(this.currentTypeDocumentId))) {
            return Number(this.currentTypeDocumentId);
        }
        return null;
    }

    private refreshReferencePrefixFromTypeDocument$(typeDocumentIdOverride?: number | null): Observable<void> {
        const resolved = this.resolveTypeDocumentIdForPrefixLoad(typeDocumentIdOverride);
        if (resolved == null || Number.isNaN(resolved)) {
            this.typeDocumentPrefixRawFromApi = null;
            return of(undefined);
        }
        return this.documentService.getTypeDocumentById(resolved).pipe(
            tap((row: any) => {
                const rawPrefix = this.extractTypePrefixFromTypeRow(row);
                const trimmedPrefix = rawPrefix && String(rawPrefix).trim() !== '' ? String(rawPrefix).trim() : null;
                this.typeDocumentPrefixRawFromApi =
                    trimmedPrefix && !this.isGenericFacPrefixMisappliedForCurrentType(trimmedPrefix)
                        ? trimmedPrefix
                        : null;
                const rc = this.extractRefCounterFromTypeRow(row);
                if (this.documentType) {
                    const basePrefix =
                        this.typeDocumentPrefixRawFromApi ||
                        this.documentTypeToRefPrefix[this.documentType] ||
                        'DOC';
                    this.typeDocumentsMeta[this.documentType] = {
                        id: resolved,
                        prefix: basePrefix,
                        refCounter: rc
                    };
                }
            }),
            map(() => undefined),
            catchError(() => {
                this.typeDocumentPrefixRawFromApi = null;
                return of(undefined);
            }),
            tap(() => {
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            })
        );
    }

    private loadCurrentTypeDocumentPrefixFromApi(typeDocumentIdOverride?: number | null): void {
        if (this.usesLcTransfertNumDocumentReference()) {
            return;
        }
        this.refreshReferencePrefixFromTypeDocument$(typeDocumentIdOverride).subscribe();
    }

    private getAddDocumentHeaderButtons(): any[] {
        if (this.documentType === 'RETOUR FOURNISSEUR') {
            return [
                { label: 'Retour', action: () => this.onHeaderRetour(), type: 'primary' },
                { label: 'Annuler', action: () => this.onHeaderAnnuler(), type: 'secondary' },
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                {
                    label: 'Approuver',
                    action: () => this.openReferenceModal(),
                    type: 'primary',
                    disabled: this.isApproveButtonDisabled || this.isSubmitting,
                },
            ];
        }
        return [
            { label: 'Retour', action: () => this.onHeaderRetour(), type: 'primary' },
            { label: 'Annuler', action: () => this.onHeaderAnnuler(), type: 'secondary' },
            { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
            {
                label: 'Approuver',
                action: () => this.openReferenceModal(),
                type: 'primary',
                disabled: this.isApproveButtonDisabled || this.isSubmitting
            }
        ];
    }

    private updateHeaderConfig(): void {
        const currentUrl = this.router.url;
        if (currentUrl.includes('/action/apercu') || currentUrl.includes('/action/validation')) {
            return;
        }

        let buttons: any[] = [];
        const conversionAddForm =
            this.mode === 'add' && (this.isPendingConversion || !!this.conversionFromRef);

        if (this.mode === 'validation') {
            buttons = this.getButtonsForValidationMode(this.documentType);

        } else if (conversionAddForm) {
            buttons = this.getAddDocumentHeaderButtons();

        } else if (this.mode === 'edit' || this.isEditing) {
            const statut = this.currentStatutId;
            buttons = this.getButtonsForDocumentType(this.documentType, statut);

        } else {
            buttons = this.getAddDocumentHeaderButtons();
        }

        this.headerService.setConfig({
            title: this.getHeaderDocumentTypeLabel(),
            buttons: this.applyHeaderButtonsSubmitGuard(buttons),
        });
    }

    /** Au moins un champ utile rempli (sinon Retour/Annuler ne font rien).
     *  La référence auto-générée / entrepôt par défaut ne comptent pas. */
    private hasMeaningfulDocumentContent(): boolean {
        const hasProduct = this.items.some(
            (i) => i.type === 'product' && !!(i.designation && String(i.designation).trim())
        );
        const hasParty = !!(this.selectedClient || this.selectedFournisseur);
        const hasNote = !!(this.note && String(this.note).trim());
        const hasProject = !!(this.selectedProject && String(this.selectedProject).trim());
        // Ref saisie via popup uniquement (pas la preview auto)
        const hasUserRef = !!this.referenceSeedFromPopup;
        if (this.usesDualEntrepotSelection()) {
            const dep = Number(this.selectedWarehouseInitialId);
            const rec = Number(this.selectedWarehouseDestinationId);
            const hasWh =
                (Number.isFinite(dep) && dep > 0) || (Number.isFinite(rec) && rec > 0);
            if (hasWh) {
                return true;
            }
        }
        return hasProduct || hasParty || hasNote || hasProject || hasUserRef;
    }

    private navigateAfterDocumentExit(): void {
        this.documentPreviewService.clear();
        const ret = this.route.snapshot.queryParams['return'];
        if (typeof ret === 'string' && ret.trim().startsWith('/')) {
            void this.router.navigateByUrl(ret.trim());
            return;
        }
        const base = this.getBasePath();
        if (this.isLogicielCaisseEntrepotTransfert()) {
            void this.router.navigate([base, 'tous']);
            return;
        }
        void this.router.navigate([base]);
    }

    /** Retour : si vide → liste ; sinon crée/sauve brouillon puis liste. */
    private onHeaderRetour(): void {
        if (!this.hasMeaningfulDocumentContent()) {
            if (this.isLogicielCaisseEntrepotTransfert()) {
                this.navigateAfterDocumentExit();
            }
            return;
        }
        this.saveAsDraft();
    }

    /** Annuler : si vide → aucune action ; sinon retour liste sans créer de document. */
    private onHeaderAnnuler(): void {
        if (this.isPendingConversion || this.conversionFromRef) {
            this.isPendingConversion = false;
            this.conversionFromRef = null;
            this.conversionStateService.clear();
            this.documentPreviewService.clear();
            this.router.navigate([this.getBasePath()]);
            return;
        }
        if (!this.hasMeaningfulDocumentContent()) {
            return;
        }
        this.documentPreviewService.clear();
        this.router.navigate([this.getBasePath()]);
    }

    /** Brouillon déjà enregistré : Annuler = quitter vers la liste (sans passer en Annulé ici). */
    private onHeaderAnnulerExistingBrouillon(): void {
        this.documentPreviewService.clear();
        this.router.navigate([this.getBasePath()]);
    }

    private getButtonsForValidationMode(documentType: string): any[] {
        const baseButtons = [
            { label: 'Retour', action: () => this.retour(), type: 'primary' },
            { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
        ];
        return [...baseButtons, ...this.buildPostCreateActionButtons(documentType, (statutId) =>
            this.changeStatutAndSave(statutId)
        )];
    }

    /**
     * Actions post-création (statut Crée) — aligné approve-vente / projet vente.
     * Ex. DEVIS : Accepter + Négocier.
     */
    private buildPostCreateActionButtons(
        documentType: string,
        onStatut: (statutId: number) => void
    ): any[] {
        const buttons: any[] = [];
        switch (documentType) {
            case 'DEVIS':
                buttons.push({
                    label: 'Accepter',
                    action: () => onStatut(this.statutIdMap['Accepté']),
                    type: 'primary'
                });
                buttons.push({
                    label: 'Négocier',
                    action: () => onStatut(this.statutIdMap['Négociation']),
                    type: 'primary'
                });
                break;
            case 'COMMANDE CLIENT':
            case 'COMMANDE FOURNISSEUR':
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'BON DE LIVRAISON':
                buttons.push({
                    label: 'Livrer',
                    action: () => onStatut(this.statutIdMap['Livré']),
                    type: 'primary'
                });
                break;
            case 'BON RECEPTION':
                buttons.push({
                    label: 'En contrôle',
                    action: () => onStatut(this.statutIdMap['En contrôle']),
                    type: 'primary'
                });
                break;
            case 'PV ECART':
                buttons.push({
                    label: 'Soumettre',
                    action: () => onStatut(this.statutIdMap['Soumis']),
                    type: 'primary'
                });
                break;
            case 'BON DE SORTIE':
                buttons.push({
                    label: 'Fermer',
                    action: () => onStatut(this.statutIdMap['Fermé']),
                    type: 'primary'
                });
                break;
            case 'INVENTAIRE':
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Inventorié'] ?? this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'BON TRANSFERT':
                buttons.push({
                    label: 'Transférer',
                    action: () => onStatut(this.statutIdMap['Transféré'] ?? this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'FACTURE':
            case 'FACTURE FOURNISSEUR':
            case 'AVOIR':
            case 'AVOIR FOURNISSEUR':
            case 'RETOUR FOURNISSEUR':
                // Pas d’action métier supplémentaire (facture déjà Non payé / avoir déjà créé)
                break;
            default:
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
        }
        return buttons;
    }

    private getButtonsForDocumentType(documentType: string, statut: number | null): any[] {
        const baseButtons = [
            { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
            { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
        ];
        if (documentType === 'PV ECART' && statut != null) {
            const pvBaseButtons = [
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
            ];
            return this.getPvEcartButtonsForStatut(statut, pvBaseButtons);
        }
        if (statut === this.statutIdMap['Non utilisé'] || statut === this.statutIdMap['Partiellement utilisé'] || statut === this.statutIdMap['Utilisé']) {
            return baseButtons;
        }
        // Bon de réception reçu : Retour + Annuler
        if (documentType === 'BON RECEPTION' && statut === this.statutIdMap['Reçu']) {
            return [
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
                { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
            ];
        }
        // Statuts finalisés (projet vente) : Retour + Annuler
        if (
            statut === this.statutIdMap['Payé'] ||
            statut === this.statutIdMap['Partiellement payé'] ||
            statut === this.statutIdMap['Reçu'] ||
            statut === this.statutIdMap['Fermé'] ||
            statut === this.statutIdMap['Transféré'] ||
            statut === this.statutIdMap['Livré'] ||
            statut === this.statutIdMap['Valide'] ||
            statut === this.statutIdMap['Accepté'] ||
            statut === this.statutIdMap['Non payé']
        ) {
            return baseButtons;
        }
        // Statut Crée : mêmes actions que la page validation (ex. DEVIS → Accepter / Négocier)
        if (statut === this.statutIdMap['Crée'] || statut === this.statutIdMap['Créé']) {
            if (documentType === 'RETOUR FOURNISSEUR') {
                return [
                    {
                        label: 'Retour',
                        action: () => this.saveAndExecute(() => this.retour()),
                        type: 'primary',
                    },
                    {
                        label: 'Annuler',
                        action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']),
                        type: 'secondary',
                    },
                    {
                        label: 'Retourner',
                        action: () => this.changeStatutAndSave(this.statutIdMap['Retourné']),
                        type: 'primary',
                    },
                ];
            }
            if (documentType === 'BON TRANSFERT' && this.isBonTransfertFromPvEcart()) {
                return [
                    { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
                    {
                        label: 'Annuler',
                        action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']),
                        type: 'secondary',
                    },
                    { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                    {
                        label: 'Approuver',
                        action: () => this.openReferenceModal(),
                        type: 'primary',
                        disabled: this.isApproveButtonDisabled || this.isSubmitting,
                    },
                ];
            }
            return [
                ...baseButtons,
                ...this.buildPostCreateActionButtons(documentType, (statutId) =>
                    this.changeStatutAndSave(statutId)
                )
            ];
        }
        else if (statut === this.statutIdMap['Négociation']) {
            if (documentType === 'DEVIS') {
                return [
                    ...baseButtons,
                    { label: 'Accepter', action: () => this.changeStatutAndSave(this.statutIdMap['Accepté']), type: 'primary' }
                ];
            } else {
                return this.getButtonsForDocumentType(documentType, this.statutIdMap['Crée']);
            }
        }
        else if (statut === this.statutIdMap['Annulé']) {
            if (documentType === 'BON RECEPTION') {
                return [
                    { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' }
                ];
            }
            return [
                {
                    label: 'Remettre en brouillon',
                    action: () => this.remettreEnBrouillonFromAnnule(),
                    type: 'primary'
                },
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' }
            ];
        }
        else if (statut === this.statutIdMap['Brouillon']) {
            if (documentType === 'BON TRANSFERT' && this.isBonTransfertFromPvEcart()) {
                return [
                    { label: 'Retour', action: () => this.onHeaderRetour(), type: 'secondary' },
                    { label: 'Annuler', action: () => this.onHeaderAnnulerExistingBrouillon(), type: 'primary' },
                    { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                    {
                        label: 'Approuver',
                        action: () => this.openReferenceModal(),
                        type: 'primary',
                        disabled: this.isApproveButtonDisabled || this.isSubmitting,
                    },
                ];
            }
            return [
                { label: 'Retour', action: () => this.onHeaderRetour(), type: 'secondary' },
                { label: 'Annuler', action: () => this.onHeaderAnnulerExistingBrouillon(), type: 'primary' },
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                { label: 'Approuver', action: () => this.openReferenceModal(), type: 'primary', disabled: this.isApproveButtonDisabled || this.isSubmitting }
            ];
        }
        else {
            return [
                ...baseButtons,
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                { label: 'Approuver', action: () => this.openReferenceModal(), type: 'primary', disabled: this.isApproveButtonDisabled || this.isSubmitting }
            ];
        }
    }

    /** Boutons workflow PV d'écart (alignés sur approve-vente). */
    private getPvEcartButtonsForStatut(statut: number, baseButtons: any[]): any[] {
        const annuler = {
            label: 'Annuler',
            action: () => this.changePvEcartStatutAndSave('Annulé'),
            type: 'secondary' as const,
        };
        if (statut === this.statutIdMap['Brouillon']) {
            return [
                ...baseButtons,
                annuler,
                {
                    label: 'Soumettre',
                    action: () => this.changePvEcartStatutAndSave('Soumis'),
                    type: 'primary' as const,
                },
            ];
        }
        if (
            statut === this.statutIdMap['Soumis'] ||
            statut === this.statutIdMap['Crée'] ||
            statut === this.statutIdMap['Créé'] ||
            statut === this.statutIdMap['En traitement'] ||
            statut === this.statutIdMap['Rejeté']
        ) {
            return [
                ...baseButtons,
                annuler,
                {
                    label: 'Valider',
                    action: () => this.validatePvEcartFromEnTraitement(),
                    type: 'primary' as const,
                },
            ];
        }
        if (this.isStatutPvEcartValide(statut)) {
            return [...baseButtons];
        }
        if (statut === this.statutIdMap['Annulé']) {
            return [
                {
                    label: 'Remettre en brouillon',
                    action: () => this.remettreEnBrouillonFromAnnule(),
                    type: 'primary' as const,
                },
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' as const },
            ];
        }
        if (statut === this.statutIdMap['Clôturé']) {
            return [...baseButtons];
        }
        return [...baseButtons, annuler];
    }

    /**
     * Changement de statut PV d'écart avec résolution API si l'id local est absent.
     */
    private changePvEcartStatutAndSave(statutLabel: string): void {
        const mapped = this.statutIdMap[statutLabel];
        const mappedId = Number(mapped);
        if (Number.isFinite(mappedId) && mappedId > 0) {
            this.changeStatutAndSave(mappedId);
            return;
        }
        if (this.isSubmitting) {
            return;
        }
        this.resolvePvEcartWorkflowStatutId$(statutLabel)
            .pipe(take(1))
            .subscribe({
                next: (id) => {
                    this.statutIdMap[statutLabel] = id;
                    this.changeStatutAndSave(id);
                },
                error: (err) => {
                    this.toastr.error(
                        err instanceof Error ? err.message : `Statut « ${statutLabel} » introuvable.`,
                        'PV d\'écart'
                    );
                    this.cdr.markForCheck();
                },
            });
    }

    /** PV d'écart déjà au statut Validé (map locale ou constantes workflow). */
    private isStatutPvEcartValide(statutId: number | null | undefined): boolean {
        if (statutId == null || !Number.isFinite(Number(statutId))) {
            return false;
        }
        const id = Number(statutId);
        const ids = new Set<number>();
        for (const key of ['Validé', 'Valide'] as const) {
            const fromMap = this.statutIdMap[key];
            if (fromMap != null && Number(fromMap) > 0) {
                ids.add(Number(fromMap));
            }
            const wf = getWorkflowStatutId(key);
            if (wf != null && wf > 0) {
                ids.add(Number(wf));
            }
        }
        return ids.has(id);
    }

    /** Résout statut_id « Validé » (API puis map locale puis constantes workflow). */
    private resolvePvEcartWorkflowStatutId$(label: string): Observable<number> {
        const fromMap =
            this.statutIdMap[label] ??
            (label === 'Validé'
                ? this.statutIdMap['Valide']
                : label === 'Valide'
                  ? this.statutIdMap['Validé']
                  : undefined);
        return this.documentService.getStatutIdByTitre(label).pipe(
            map((apiId) => {
                if (apiId != null && Number(apiId) > 0) {
                    return Number(apiId);
                }
                if (fromMap != null && Number(fromMap) > 0) {
                    return Number(fromMap);
                }
                const wf = getWorkflowStatutId(label);
                return wf != null && wf > 0 ? wf : null;
            }),
            switchMap((id) =>
                id != null
                    ? of(id)
                    : throwError(
                          () =>
                              new Error(
                                  `Statut « ${label} » introuvable (vérifiez statut_documents).`
                              )
                      )
            )
        );
    }

    /**
     * PV « Soumis » (ou legacy En traitement) → Valider : statut ERP « Validé », sauvegarde, ouverture transfert LC lié.
     */
    private validatePvEcartFromEnTraitement(): void {
        if (this.isSubmitting) {
            return;
        }
        if (this.documentType !== 'PV ECART') {
            this.changeStatutAndSave(this.statutIdMap['Validé']);
            return;
        }
        if (!this.documentId || !this.stationId) {
            this.toastr.error('ID du document ou station manquant.');
            return;
        }

        if (this.isStatutPvEcartValide(this.currentStatutId)) {
            this.openLinkedTransfertEntrepotAfterPvValide(this.documentId);
            return;
        }

        this.setDocumentSubmitting(true);
        this.recalculateAll();

        const mappedValide =
            Number(this.statutIdMap['Validé'] ?? this.statutIdMap['Valide']) || 0;
        const valideId$ =
            mappedValide > 0
                ? of(mappedValide)
                : this.resolvePvEcartWorkflowStatutId$('Validé');

        valideId$
            .pipe(
                switchMap((valideId) =>
                    this.documentService
                        .updateStatut(this.documentId!, {
                            statut_id: valideId,
                            station_id: this.stationId!,
                        })
                        .pipe(
                            switchMap(() => this.updateDocument(valideId)),
                            map(() => valideId)
                        )
                )
            )
            .subscribe({
                next: (valideId) => {
                    this.currentStatutId = valideId;
                    this.statutIdMap['Validé'] = valideId;
                    this.statutIdMap['Valide'] = valideId;
                    const docId = this.documentId!;
                    this.setDocumentSubmitting(false);
                    this.toastr.success('Document mis à jour !');
                    this.openLinkedTransfertEntrepotAfterPvValide(docId);
                },
                error: (err) => {
                    this.setDocumentSubmitting(false);
                    this.toastr.error(
                        this.extractDocumentApiErrorMessage(err) ||
                            (err instanceof Error ? err.message : 'Erreur lors du passage en Validé.'),
                        'PV d\'écart'
                    );
                    this.updateHeaderConfig();
                    this.cdr.markForCheck();
                },
            });
    }

    /** Après Validé : ouvrir le transfert entrepôt LC lié (sans POST stock-transferts). */
    private openLinkedTransfertEntrepotAfterPvValide(pvDocumentId: number): void {
        this.setDocumentSubmitting(true);
        this.updateHeaderConfig();

        this.lcAuth
            .ensureAuthenticatedSession()
            .pipe(
                switchMap((sessionOk) => {
                    if (!sessionOk) {
                        return throwError(
                            () =>
                                new Error(
                                    'Connectez le module logiciel caisse pour ouvrir le transfert entrepôt.'
                                )
                        );
                    }
                    return this.documentService.getDocumentById(pvDocumentId);
                }),
                map((response) => {
                    const fresh = (response?.data?.document ??
                        response?.data ??
                        response) as Record<string, unknown> | null;
                    return fresh;
                }),
                switchMap((freshDoc) => {
                    if (freshDoc) {
                        this.lastLoadedPvEcartDoc = freshDoc;
                    }
                    const doc = (freshDoc ??
                        this.lastLoadedPvEcartDoc ?? {
                            id: pvDocumentId,
                            document_original_id: this.documentOriginalId,
                            hidden_client_fields: this.modifiedClientFields,
                            hidden_fournisseur_fields: this.modifiedFournisseurFields,
                        }) as Record<string, unknown>;
                    if (
                        this.modifiedClientFields &&
                        typeof this.modifiedClientFields === 'object'
                    ) {
                        doc.hidden_client_fields = {
                            ...(doc.hidden_client_fields as object),
                            ...(this.modifiedClientFields as object),
                        };
                    }
                    if (
                        this.modifiedFournisseurFields &&
                        typeof this.modifiedFournisseurFields === 'object'
                    ) {
                        doc.hidden_fournisseur_fields = {
                            ...(doc.hidden_fournisseur_fields as object),
                            ...(this.modifiedFournisseurFields as object),
                        };
                    }

                    return loadPvEcartLinkedDocuments$(
                        this.documentService,
                        doc,
                        this.lcStockTransfert
                    ).pipe(
                        switchMap((view) => {
                            this.pvEcartLinkedDocsView = view;
                            return resolvePvEcartLinkedLcTransfertId$(
                                this.documentService,
                                this.lcStockTransfert,
                                doc,
                                view
                            ).pipe(map((lcId) => ({ lcId, view })));
                        })
                    );
                }),
                take(1)
            )
            .subscribe({
                next: ({ lcId, view }) => {
                    this.setDocumentSubmitting(false);
                    if (lcId != null) {
                        this.navigateToTransfertEntrepotAfterPvValide(lcId, pvDocumentId);
                        return;
                    }
                    const link = view?.transfert?.link;
                    if (link?.path?.includes('transfert-entrepot')) {
                        const rawLc =
                            link.queryParams?.['lcTransfertId'] ?? link.queryParams?.['id'];
                        const lcFromLink = Number(rawLc);
                        if (Number.isFinite(lcFromLink) && lcFromLink > 0) {
                            this.navigateToTransfertEntrepotAfterPvValide(
                                lcFromLink,
                                pvDocumentId
                            );
                            return;
                        }
                    }
                    this.updateHeaderConfig();
                    this.cdr.markForCheck();
                    this.toastr.error(
                        'Transfert entrepôt lié introuvable — vérifiez la section Documents liés.',
                        'PV d\'écart'
                    );
                },
                error: (err) => {
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    this.cdr.markForCheck();
                    this.toastr.error(
                        err instanceof Error
                            ? err.message
                            : 'Impossible de résoudre le transfert entrepôt lié.',
                        'PV d\'écart'
                    );
                },
            });
    }

    /** Transfert LC en écran document (`/transfert-entrepot/nouveau`), pas approve / détail LC. */
    private navigateToTransfertEntrepotAfterPvValide(
        lcTransfertId: number,
        pvDocumentId: number
    ): void {
        const lcId = Number(lcTransfertId);
        if (!Number.isFinite(lcId) || lcId <= 0) {
            this.cdr.markForCheck();
            this.toastr.error(
                'Transfert entrepôt introuvable — impossible d’ouvrir l’écran transfert.',
                'PV d\'écart'
            );
            return;
        }
        this.logicielCaisseTransfertFromPvEcart = true;
        const q = buildPvEcartTransfertEntrepotNouveauQueryParams(lcId, pvDocumentId);
        const ret = this.route.snapshot.queryParams['return'];
        if (typeof ret === 'string' && ret.trim()) {
            q.return = ret.trim();
        } else {
            q.return = `/stock/pv-ecart/add-pv-ecart?id=${pvDocumentId}`;
        }
        void this.router
            .navigate(['/transfert-entrepot/nouveau'], {
                queryParams: q,
            })
            .then((ok) => {
                if (!ok) {
                    this.toastr.error(
                        'Navigation vers le transfert entrepôt impossible.',
                        'PV d\'écart'
                    );
                    this.updateHeaderConfig();
                    this.cdr.markForCheck();
                }
            });
    }

    /** PV « Validé » → duplication en bon de transfert (brouillon) — action manuelle « Approuver ». */
    private convertPvEcartValideToBonTransfertAndNavigate(pvDocumentId: number): void {
        const pvDoc: Record<string, unknown> = {
            document_original_id: this.documentOriginalId,
            type_document_id: this.currentTypeDocumentId ?? this.typeDocumentIdMap['PV ECART'],
            id: pvDocumentId,
        };
        convertPvEcartToBonTransfert$(this.documentService, pvDocumentId, pvDoc).subscribe({
            next: ({ newBtId, refExterne }) => {
                const refHint = refExterne ? ` (${refExterne})` : '';
                this.toastr.success(`Bon de transfert créé${refHint}.`, 'Conversion');
                this.setDocumentSubmitting(false);
                void this.router.navigate(['/stock/bon-transfert/add-bon-transfert'], {
                    queryParams: {
                        id: newBtId,
                        return: '/stock/pv-ecart/valide',
                    },
                });
            },
            error: (err) => {
                this.setDocumentSubmitting(false);
                this.toastr.error(
                    err?.error?.message || err?.message || 'Conversion en bon de transfert impossible.',
                    'Erreur'
                );
            },
        });
    }

    saveAsDraft(): void {
        if (this.isSavingDraft) {
            return;
        }

        if (!this.hasMeaningfulDocumentContent()) {
            // Document vide : aucune création, aucune navigation
            return;
        }

        if (this.isLogicielCaisseEntrepotTransfert()) {
            this.saveLogicielCaisseTransfertAsDraft();
            return;
        }

        if (this.mode === 'edit' && this.documentId) {
            this.setSavingDraft(true);
            this.toastr.info('Mise à jour du brouillon en cours...', 'Brouillon');

            this.recalculateAll();
            this.updateDocument(this.statutIdMap['Brouillon']).subscribe({
                next: (res) => {
                    this.applyAllocatedReferenceFromCreateResponse(res);
                    this.currentStatutId = this.statutIdMap['Brouillon'];
                    this.updateHeaderConfig();
                    this.toastr.success('Brouillon mis à jour !');
                    this.navigateAfterDocumentExit();
                },
                error: (err) => {
                    this.toastr.error('Échec mise à jour brouillon', 'Erreur');
                    this.navigateAfterDocumentExit();
                },
                complete: () => this.setSavingDraft(false)
            });
            return;
        }
        this.setSavingDraft(true);
        this.toastr.info('Sauvegarde en brouillon en cours...', 'Brouillon');

        this.calculateTotals();
        const payload = this.buildPerfectDraftPayload();

        this.documentService.create(payload).subscribe({
            next: (res) => {
                const newId = res?.data?.id || res?.data?.document?.id;
                if (newId) {
                    this.documentId = newId;
                    this.mode = 'edit';
                    this.isEditing = true;
                    this.currentStatutId = 1; // Brouillon
                    this.applyAllocatedReferenceFromCreateResponse(res);
                    this.saveModifiedFields();
                    this.updateHeaderConfig();
                }

                this.toastr.success('Document sauvegardé en brouillon !');
                this.navigateAfterDocumentExit();
            },
            error: (err) => {
                this.toastr.error('Échec sauvegarde brouillon, retour quand même', 'Erreur');
                this.navigateAfterDocumentExit();
            },
            complete: () => this.setSavingDraft(false)
        });
    }

    /** Transfert entrepôt LC : brouillon via API stock-transferts (onglet Brouillon). */
    private saveLogicielCaisseTransfertAsDraft(): void {
        const dep = Number(this.selectedWarehouseInitialId);
        const rec = Number(this.selectedWarehouseDestinationId);
        if (
            !Number.isFinite(dep) ||
            dep <= 0 ||
            !Number.isFinite(rec) ||
            rec <= 0 ||
            dep === rec
        ) {
            this.toastr.warning(
                'Pour enregistrer le brouillon, choisissez deux entrepôts distincts (départ et destination).',
                'Transfert'
            );
            return;
        }

        if (this.findProductLinesWithNegativeQuantity().length > 0) {
            this.toastr.error('Les quantités ne peuvent pas être négatives.', 'Transfert');
            return;
        }

        const body = this.buildLogicielCaisseTransfertSaveBody(true);
        if (!body) {
            return;
        }

        const existingLcId = this.logicielCaisseTransfertEditId;
        this.setSavingDraft(true);
        this.toastr.info('Sauvegarde du brouillon en cours…', 'Transfert');

        const save$ = existingLcId
            ? this.lcStockTransfert.replace(existingLcId, body).pipe(
                  map(() => ({ id: existingLcId, num_document: this.documentReference }))
              )
            : this.lcStockTransfert.create(body);

        save$.subscribe({
            next: (lcRes) => {
                if (lcRes?.id) {
                    this.logicielCaisseTransfertEditId = lcRes.id;
                    if (lcRes.num_document) {
                        this.documentReference = lcRes.num_document;
                    }
                }
                this.lcStockTransfert.notifyListRefresh();
                this.toastr.success('Bon de transfert enregistré en brouillon.', 'Transfert');
                this.navigateAfterDocumentExit();
            },
            error: (err: Error) => {
                this.toastr.error(err?.message || 'Échec de la sauvegarde du brouillon.', 'Transfert');
            },
            complete: () => {
                this.setSavingDraft(false);
            },
        });
    }

    /** Items LC : vue complète UI (transfert LC) prioritaire sur les seules lignes d’écart ERP. */
    private resolvePvEcartItemsForLcTransfertBody() {
        if (this.pvEcartLineViewFromLcDetail || this.pvEcartQtyBreakdownByItemIndex.size > 0) {
            const productIndexes: number[] = [];
            (this.items || []).forEach((it, idx) => {
                if (it.type === 'product' && String(it.designation ?? '').trim()) {
                    productIndexes.push(idx);
                }
            });
            return mapUiItemsToPvRegularisationItems(this.items, (lineIdx) => {
                const itemIdx = productIndexes[lineIdx];
                return itemIdx != null ? this.productDescriptions[itemIdx] : undefined;
            });
        }
        const fromDoc = resolvePvEcartItemsForLcTransfertFromErpDoc(this.lastLoadedPvEcartDoc);
        if (fromDoc.length > 0) {
            return fromDoc;
        }
        const productIndexes: number[] = [];
        (this.items || []).forEach((it, idx) => {
            if (it.type === 'product' && String(it.designation ?? '').trim()) {
                productIndexes.push(idx);
            }
        });
        return mapUiItemsToPvRegularisationItems(this.items, (lineIdx) => {
            const itemIdx = productIndexes[lineIdx];
            return itemIdx != null ? this.productDescriptions[itemIdx] : undefined;
        });
    }

    /**
     * Transfert entrepôt ouvert depuis PV : toutes les lignes LC (envoyée / reçue / écart),
     * pas seulement les lignes d’écart du PV ERP.
     */
    private applyPvEcartTransfertFullLinesFromLcDetail(detail: StockTransfertDetail): void {
        this.items = [];
        this.pvEcartQtyBreakdownByItemIndex.clear();
        const headerIsReception = Number(detail.is_reception) || 0;
        for (const lg of detail.lignes || []) {
            const ref = String(lg.reference ?? '').trim() || '-';
            const lib = String(lg.libelle_article ?? '').trim();
            for (const bc of lg.barcodes || []) {
                const { qteEnvoyee, qteRecue } = readLcTransfertBarcodeQuantites(
                    bc,
                    headerIsReception
                );
                const qSigned = Math.trunc(Number(bc.quantite) || 0);
                if (qteEnvoyee === 0 && qteRecue === 0 && qSigned === 0) {
                    continue;
                }
                const ecartSigned = qteRecue - qteEnvoyee;
                const lineQty = qSigned !== 0 ? qSigned : ecartSigned;
                const itemIndex = this.items.length;
                this.items.push({
                    type: 'product',
                    designation: lib,
                    quantity: lineQty,
                    reference: ref,
                    code_barre: String(bc.code_barre ?? '').trim(),
                    priceHT: 0,
                    tva: '0',
                    totalHT: 0,
                    product_id: bc.product_id ?? null,
                    couleur: bc.couleur ?? null,
                    taille: bc.taille ?? null,
                } as Item);
                this.pvEcartQtyBreakdownByItemIndex.set(itemIndex, {
                    qteEnvoyee,
                    qteRecue,
                    ecartSigned,
                });
            }
        }
        if (this.items.length === 0) {
            this.items.push(this.createEmptyProductLineItem());
        }
        this.enrichPvEcartDisplayLineReferencesFromCatalog();
    }

    /** Réf. interne produit (catalogue ERP) à la place de « - » / ref. ligne LC. */
    private enrichPvEcartDisplayLineReferencesFromCatalog(): void {
        if (!this.showPvEcartQtyBreakdownColumns()) {
            return;
        }
        for (const item of this.items) {
            if (item.type !== 'product' || !String(item.designation ?? '').trim()) {
                continue;
            }
            const pid = item.product_id != null ? Number(item.product_id) : NaN;
            if (Number.isFinite(pid) && pid > 0) {
                const fromCatalog = (this.products || []).find((p) => Number(p.id) === pid);
                const cat = fromCatalog as { ref_interne?: string; reference?: string } | undefined;
                const ref = String(
                    cat?.ref_interne ?? cat?.reference ?? (item as { ref_interne?: string }).ref_interne ?? ''
                ).trim();
                if (ref) {
                    item.reference = ref;
                }
            }
        }
    }

    /** Remplit le tableau produit du transfert depuis le PV source (lignes d’écart uniquement — legacy). */
    private applyPvEcartSourceLinesToTransfertItems(doc: Record<string, unknown>): void {
        const lines = mapPvEcartErpLignesToTransfertUiLines(doc);
        this.items = [];
        this.productDescriptions = {};
        this.showProductDescription = {};
        for (const ln of lines) {
            const itemIndex = this.items.length;
            this.items.push({
                type: 'product',
                designation: ln.designation,
                quantity: ln.quantity,
                reference: ln.reference,
                code_barre: ln.code_barre,
                product_id: ln.product_id,
                priceHT: 0,
                tva: '0',
                totalHT: 0,
            } as Item);
            this.productDescriptions[itemIndex] = ln.description;
            this.showProductDescription[itemIndex] = !!ln.description?.trim();
        }
        if (this.items.length === 0) {
            this.items.push(this.createEmptyProductLineItem());
        }
    }

    /**
     * Corps POST/PUT logiciel-caisse stock-transferts (approbation ou brouillon).
     * @param allowEmptyLignes true pour Retour avec entrepôts/date/note sans lignes produit.
     */
    private buildLogicielCaisseTransfertSaveBody(
        allowEmptyLignes: boolean,
        warehouseOverride?: { depart: number; dest: number }
    ): StockTransfertCreateBody | null {
        const dep = warehouseOverride?.depart ?? Number(this.selectedWarehouseInitialId);
        const rec = warehouseOverride?.dest ?? Number(this.selectedWarehouseDestinationId);
        if (
            !Number.isFinite(dep) ||
            dep <= 0 ||
            !Number.isFinite(rec) ||
            rec <= 0 ||
            dep === rec
        ) {
            return null;
        }

        const dateRaw = (this.documentDate || this.getTodayLocal()).trim();
        let d: Date;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateRaw)) {
            d = new Date(`${dateRaw}T12:00:00`);
        } else {
            d = new Date(dateRaw);
        }
        const date_transfert = !isNaN(d.getTime()) ? d.toISOString() : new Date().toISOString();

        const fromPvEcart =
            this.logicielCaisseTransfertFromPvEcart || this.isBonTransfertFromPvEcart();
        if (fromPvEcart) {
            const pvItems = this.resolvePvEcartItemsForLcTransfertBody();
            const pvBody = buildLcPvEcartTransfertBody(dep, rec, pvItems, this.note);
            if (pvBody) {
                return {
                    ...pvBody,
                    date_transfert,
                    ...(allowEmptyLignes ? { allow_empty_lignes: true } : {}),
                };
            }
        }

        const lignes: StockTransfertCreateBody['lignes'] = [];
        for (let itemIndex = 0; itemIndex < this.items.length; itemIndex++) {
            const it = this.items[itemIndex];
            if (it.type !== 'product' || !it.designation?.trim()) {
                continue;
            }
            const q = normalizeNonNegativeIntegerQuantity(it.quantity);
            if (q <= 0) {
                continue;
            }
            const refLine =
                it.reference != null && String(it.reference).trim() !== ''
                    ? String(it.reference).trim()
                    : '-';
            const cb = String(it.code_barre ?? '').trim();
            const lineNote = this.getProductLineNoteForStockTransfert(itemIndex);
            lignes.push({
                libelle_article: it.designation.trim(),
                reference: refLine,
                ...(lineNote ? { note: lineNote } : {}),
                allocations: [
                    {
                        product_id: null,
                        code_barre: cb || null,
                        quantite: q,
                        selected: true,
                        ...(lineNote ? { note: lineNote } : {}),
                    },
                ],
            });
        }

        return {
            date_transfert,
            entrepot_id_depart: dep,
            entrepot_id_reception: rec,
            origine: 'manuelle',
            note: (this.note ?? '').trim() || null,
            lignes,
            ...(allowEmptyLignes ? { allow_empty_lignes: true } : {}),
        };
    }

    private buildPerfectDraftPayload(): any {
        const isAchat = this.isAchatDocument();

        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (p) {
                projetPivot = {
                    id_projet: String(p.id),
                    titre: p.libelle || 'Projet sans titre'
                };
            }
        }

        const f = (n: number): string => Number(n || 0).toFixed(3);

        const payload: any = {
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,
            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),
            user_id: this.currentUser.id,
            station_id: this.stationId,
            etablissement_id: this.resolvePayloadEtablissementId(),
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 1, // Brouillon
            entrepot_id: this.usesDualEntrepotSelection() 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.usesDualEntrepotSelection() && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            client_data: !isAchat && this.selectedClient ? {
                client_id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || null,
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                fournisseur_id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : null,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            lignes_document: this.prepareLignesDocumentForSave(),
            parametrage_doc: this.buildParametrageDoc(),
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            }
        };

        const cleaned = this.cleanPayload(payload as DocumentPayload);
        return cleaned;
    }

    private buildDraftPayload(): DocumentPayload {
        const isAchat = this.isAchatDocument();

        const projetPivot = this.selectedProject && this.projects.length > 0
            ? this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject))
            : null;

        const payload: DocumentPayload = {
            ...this.documentRefPayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || '',

            total_ht: this.totals.totalHT.toFixed(3),
            total_tva: this.totals.totalTVA.toFixed(3),
            total_ttc: this.totals.totalTTC.toFixed(3),
            timbre_fiscal: this.getTimbreFiscalEffective().toFixed(3),
            net_payer: this.totals.netAPayer.toFixed(3),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            etablissement_id: this.resolvePayloadEtablissementId(),
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 1, // Brouillon
            ...this.referenceModelTypePayloadSpread(),
            entrepot_id: this.usesDualEntrepotSelection() 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.usesDualEntrepotSelection() && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            client_id: !isAchat ? this.resolveDocumentClientId(this.selectedClient) : null,
            fournisseur_id: isAchat ? this.selectedFournisseur?.id ?? null : null,

            client_data: !isAchat && this.selectedClient ? {
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : undefined,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '',
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : undefined,

            projets: projetPivot ? [{
                id_projet: String(projetPivot.id),
                titre: projetPivot.libelle
            }] : [],
            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),

            date_echeance: '', // À calculer si nécessaire
            nbr_date: 0, // À définir si nécessaire
            color: '#134AD3', // Couleur par défaut

            lignes_document: this.prepareLignesDocumentForSave(),
            parametrage_doc: this.buildParametrageDoc()
        };

        return this.cleanPayload(payload);
    }

    private updateDocumentStatut(statutId: number, withRetour: boolean = false): void {
        if (!this.documentId || !this.stationId) {
            this.toastr.error('ID du document ou station manquant.');
            return;
        }

        const payload = {
            statut_id: statutId,
            station_id: this.stationId
        };
        this.documentService.updateStatut(this.documentId, payload).subscribe({
            next: (response) => {
                this.toastr.success(`Statut mis à jour avec succès (ID: ${statutId}).`);
                if (withRetour) {
                    this.retour();
                }
            },
            error: (err) => {
                this.toastr.error(`Échec de la mise à jour du statut: ${err?.error?.message || 'Erreur serveur'}`);
            }
        });

    }

    private getApproveStatutId(): number {
        if (this.isAvoirDocument()) {
            return this.statutIdMap['Non utilisé'];
        }
        if (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR') {
            return this.statutIdMap['Non payé'];
        }
        // Bon de livraison : Approuver → Livré (déclenche sortie de stock)
        if (this.documentType === 'BON DE LIVRAISON') {
            return this.statutIdMap['Livré'];
        }
        if (this.documentType === 'BON RECEPTION') {
            return this.statutIdMap['À réceptionner'];
        }
        if (this.documentType === 'PV ECART') {
            return (
                this.statutIdMap['Validé'] ??
                this.statutIdMap['Valide'] ??
                getWorkflowStatutId('Validé')
            );
        }
        if (this.documentType === 'BON TRANSFERT' && this.isBonTransfertFromPvEcart()) {
            return this.statutIdMap['Crée'] ?? this.statutIdMap['Créé'];
        }
        return (
            this.statutIdMap['Crée'] ??
            this.statutIdMap['Créé'] ??
            this.statutIdMap['Cree'] ??
            0
        );
    }

    /**
     * POST /api/documents exige des FK `erp_main.entrepots` — pas les ids logiciel caisse.
     * @returns message utilisateur ou null si le payload contient les bons ids ERP.
     */
    private validateErpEntrepotMappingForDocumentSave(
        payload: Record<string, unknown>
    ): string | null {
        const needsDest =
            this.usesDualEntrepotSelection() &&
            (this.isErpBonTransfertDocument() ||
                this.isLogicielCaisseEntrepotTransfert() ||
                Number(payload.type_document_id) ===
                    Number(this.typeDocumentIdMap['BON TRANSFERT']));

        if (this.usesDualEntrepotSelection()) {
            const depSel = this.selectedWarehouseInitialId;
            const dstSel = this.selectedWarehouseDestinationId;
            const erpSrc = this.resolveErpEntrepotIdFromSelection(depSel);
            const erpDst = this.resolveErpEntrepotIdFromSelection(dstSel);

            if (depSel != null && (erpSrc == null || erpSrc <= 0)) {
                return (
                    "L'entrepôt de départ n'est pas relié à un entrepôt ERP. " +
                    'Alignez le code et le libellé entrepôt entre logiciel caisse et ERP (paramètres entrepôts).'
                );
            }
            if (dstSel != null && (erpDst == null || erpDst <= 0)) {
                return (
                    "L'entrepôt de destination n'est pas relié à un entrepôt ERP. " +
                    'Alignez le code et le libellé entrepôt entre logiciel caisse et ERP (paramètres entrepôts).'
                );
            }
            if (needsDest && (erpDst == null || erpDst <= 0)) {
                return (
                    "Le champ entrepot_dest_id est obligatoire pour le bon de transfert ERP. " +
                    'Choisissez une destination mappée vers un entrepôt stock ERP.'
                );
            }
            if (erpSrc != null && !this.isKnownErpEntrepotId(erpSrc)) {
                return (
                    `L'entrepôt de départ (id ${erpSrc}) n'existe pas dans les entrepôts ERP. ` +
                    'Synchronisez l\'entrepôt depuis Paramètres (ERP + caisse) ou alignez code / libellé.'
                );
            }
            if (erpDst != null && !this.isKnownErpEntrepotId(erpDst)) {
                return (
                    `L'entrepôt de destination (id ${erpDst}) n'existe pas dans les entrepôts ERP. ` +
                    'Synchronisez l\'entrepôt depuis Paramètres (ERP + caisse) ou alignez code / libellé.'
                );
            }
            return null;
        }

        if (this.selectedWarehouseId != null) {
            const erp = this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseId);
            if (erp == null || erp <= 0) {
                return (
                    "L'entrepôt sélectionné n'est pas relié à un entrepôt ERP. " +
                    'Vérifiez le paramétrage entrepôts (code / libellé).'
                );
            }
        }
        return null;
    }

    private isBonTransfertFromPvEcart(): boolean {
        return isBonTransfertDocumentFromPvEcart(
            {
                type_document_id: this.currentTypeDocumentId,
                type_initial: this.documentTypeInitialId,
                note: this.loadedDocumentNote || this.note,
            },
            this.documentType
        );
    }

    customFields: { label: string; value: string }[] = [];

    addField(): void {
        this.customFields.push({label: '', value: ''});
        this.cdr.detectChanges();
    }

    removeField(index: number): void {
        this.customFields.splice(index, 1);
        this.cdr.detectChanges();
    }

    addClient(): void {
        const basePath = this.isAchatDocument()
            ? '/tiers/fournisseurs/add-fournisseur'
            : '/tiers/clients/add-client';
        this.router.navigate([basePath]);
    }

    refreshFeatherIcons(): void {
        this.zone.run(() => {
        setTimeout(() => {
                this.cleanAndReplaceFeatherIcons();
        }, 0);
        });
    }

    private cleanAndReplaceFeatherIcons(): void {
        this.refreshEyeIconsOnly();
    }

    private isRefreshingIcons = false;
    private isInitializingIcons = false;
    private iconInitializationTimeout: any = null;

    ngOnDestroy(): void {
        for (const k of Object.keys(this.barcodeLineDebounceTimers)) {
            const t = this.barcodeLineDebounceTimers[Number(k)];
            if (t != null) {
                clearTimeout(t);
            }
        }
        this.barcodeLineDebounceTimers = {};
        if (this.stockRupturePopupTimer != null) {
            clearTimeout(this.stockRupturePopupTimer);
            this.stockRupturePopupTimer = null;
        }
        const currentUrl = this.router.url;
        if (!currentUrl.includes('/action/apercu') && !currentUrl.includes('/edit-')) {
            this.documentPreviewService.clear();
        }
    }

    retour(): void {
        this.documentPreviewService.clear();
        const basePath = this.getBasePath();
        this.router.navigate([basePath]);
    }


    openReferenceModal(): void {
        if (!this.validateClientAndProject()) {
            return;
        }
        if (
            this.documentType === 'INVENTAIRE' ||
            this.documentType === 'BON DE LIVRAISON' ||
            this.documentType === 'BON RECEPTION' ||
            this.documentType === 'AVOIR'
        ) {
            const hasProduct = this.items.some(i => i.type === 'product' && i.designation?.trim());
            const hasEntrepot = this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined;
            if (!hasProduct || !hasEntrepot) {
                this.modalRef = this.modalService.open(this.depotWarningModal, {
                    ariaLabelledBy: 'modal-depot-warning-title',
                    centered: true,
                    size: 'sm',
                    windowClass: 'warning-modal-centered'
                });
                return;
            }
        }
        const isNewDocument = this.mode === 'add' || !this.documentId;
        // Mode édition : jamais de popup référence (Approuver continue directement)
        if (!isNewDocument) {
            this.confirmReference();
            return;
        }
        const refTrimmed = (this.documentReference || '').trim();
        const refEmptyOrPlaceholder = refTrimmed === '' || /^0+$/.test(refTrimmed);

        const assignProvisionalRefIfNeeded = () => {
            if (isNewDocument && refEmptyOrPlaceholder) {
                this.documentReference = this.getReferenceConcreteValueForModal();
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.cdr.detectChanges();
            }
        };

        /**
         * 1er document du type (création) → popup pour saisir la référence de départ.
         * Mode edit → pas de popup.
         * Documents suivants → auto-incrément, pas de popup.
         */
        const finishOpenReference = () => {
            const proceed = (forceFirst?: boolean) => {
                assignProvisionalRefIfNeeded();
                const isFirst =
                    forceFirst === true ||
                    (forceFirst !== false && this.isFirstDocumentReferenceForType());
                if (isFirst) {
                    this.openReferenceModalInternal();
                    return;
                }
                this.confirmReference();
            };

            const decideFirstOfType = () => {
                if (this.isLogicielCaisseEntrepotTransfert()) {
                    this.decideFirstLcStockTransfertForReference(proceed);
                    return;
                }

                const typeId = this.resolveTypeDocumentIdForCurrentDocument();
                const uid = Number(this.currentUser?.id);
                const stationId =
                    Number(this.stationId) > 0
                        ? Number(this.stationId)
                        : Number(getStationIdFromLocalStorage()) || 0;
                if (!stationId || typeId == null) {
                    proceed(true);
                    return;
                }

                const afterCounter = (counter: number | null) => {
                    this.ensureTypeMetaRefCounter(counter);
                    if (counter == null || !Number.isFinite(Number(counter))) {
                        proceed(true);
                        return;
                    }
                    if (Number(counter) <= 0) {
                        this.documentService.countByStatut(stationId, Number(typeId)).pipe(
                            catchError(() => of(null))
                        ).subscribe((res: any) => {
                            const total = Number(
                                res?.data?.total_documents ??
                                res?.total_documents ??
                                res?.data?.total ??
                                NaN
                            );
                            if (Number.isFinite(total) && total > 0) {
                                proceed(false);
                            } else {
                                proceed(true);
                            }
                        });
                        return;
                    }
                    proceed(false);
                };

                if (!Number.isFinite(uid) || uid <= 0) {
                    this.documentService.countByStatut(stationId, Number(typeId)).pipe(
                        catchError(() => of(null))
                    ).subscribe((res: any) => {
                        const total = Number(
                            res?.data?.total_documents ??
                            res?.total_documents ??
                            res?.data?.total ??
                            NaN
                        );
                        if (Number.isFinite(total) && total <= 0) {
                            afterCounter(0);
                            return;
                        }
                        afterCounter(total > 0 ? 1 : null);
                    });
                    return;
                }

                this.documentService.getRefCounter(Number(typeId), stationId, uid).pipe(
                    catchError(() => of(null))
                ).subscribe((res: any) => {
                    const c = this.extractRefCounterFromApiResponse(res);
                    if (c != null) {
                        afterCounter(c);
                        return;
                    }
                    // Fallback : nombre de documents du type
                    this.documentService.countByStatut(stationId, Number(typeId)).pipe(
                        catchError(() => of(null))
                    ).subscribe((countRes: any) => {
                        const total = Number(
                            countRes?.data?.total_documents ??
                            countRes?.total_documents ??
                            countRes?.data?.total ??
                            NaN
                        );
                        if (Number.isFinite(total) && total <= 0) {
                            afterCounter(0);
                        } else if (Number.isFinite(total) && total > 0) {
                            afterCounter(1);
                        } else {
                            afterCounter(null);
                        }
                    });
                });
            };

            decideFirstOfType();
        };

        if (this.usesLcTransfertNumDocumentReference()) {
            finishOpenReference();
            return;
        }

        const afterPrefixFromApi$ = this.needsTypeDocumentsApiForRef()
            ? this.documentService.getTypeDocuments().pipe(
                  tap((res) => this.applyTypeDocumentsFromApi(res)),
                  catchError(() => of(null)),
                  switchMap(() => this.refreshReferencePrefixFromTypeDocument$())
              )
            : this.refreshReferencePrefixFromTypeDocument$();

        afterPrefixFromApi$.subscribe({
            next: () => finishOpenReference(),
            error: () => finishOpenReference()
        });
    }

    /**
     * True s’il n’existe encore aucune séquence réelle pour ce type (compteur ≤ 0).
     * Ne pas utiliser referenceModelDetail.current_counter : il est partagé entre types.
     */
    private isFirstDocumentReferenceForType(): boolean {
        const metaRc = this.typeDocumentsMeta[this.documentType]?.refCounter;
        if (metaRc != null && Number.isFinite(Number(metaRc)) && Number(metaRc) > 0) {
            return false;
        }
        return true;
    }

    private getReferencePrefix(): string {
        const staticP = this.documentTypeToRefPrefix[this.documentType] || 'DOC';
        const staticResolved = this.substituteReferenceYearInPrefix(staticP) || staticP;

        const fromType = this.substituteReferenceYearInPrefix(this.typeDocumentPrefixRawFromApi);
        if (fromType && !this.isGenericFacPrefixMisappliedForCurrentType(fromType)) {
            return fromType;
        }
        const fromModel = this.referenceModelDetail?.prefix;
        if (fromModel != null && String(fromModel).trim() !== '') {
            const m = this.substituteReferenceYearInPrefix(String(fromModel).replace(/-+$/, '').trim());
            if (m && !this.isGenericFacPrefixMisappliedForCurrentType(m)) {
                return m;
            }
        }
        return staticResolved;
    }

    private isFacPrefixMisappliedForDocType(docTypeKey: string, prefix: string): boolean {
        const p = String(prefix || '').trim().toUpperCase();
        const isFacLike = p === 'FAC' || p.startsWith('FAC-');
        if (!isFacLike) {
            return false;
        }
        return docTypeKey !== 'FACTURE' && docTypeKey !== 'FACTURE FOURNISSEUR';
    }

    private isGenericFacPrefixMisappliedForCurrentType(modelPrefixNormalized: string): boolean {
        const p = modelPrefixNormalized.toUpperCase();
        const isFacLike = p === 'FAC' || p.startsWith('FAC-');
        if (!isFacLike) {
            return false;
        }
        return (
            this.documentType !== 'FACTURE' &&
            this.documentType !== 'FACTURE FOURNISSEUR'
        );
    }

    private getReferenceModelTypeForPayload(): number | null {
        const d = this.referenceModelDetail;
        if (d != null && d.model_type != null) {
            const mt = Number(d.model_type);
            if (!Number.isNaN(mt) && mt > 0) {
                return mt;
            }
        }
        return this.referenceModelType;
    }

    private referenceModelTypePayloadSpread(): { reference_model_type: number } | Record<string, never> {
        const t = this.getReferenceModelTypeForPayload();
        return t != null ? { reference_model_type: t } : {};
    }

    private escapeRegExp(s: string): string {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    private getNumericReferenceFromRefString(ref: string | null | undefined): number {
        const r = (ref || '').trim();
        const mYc = r.match(/^(\d{4})(\d+)$/);
        if (mYc) {
            const y0 = parseInt(mYc[1], 10);
            if (y0 >= 2000 && y0 <= 2099) {
                const n = parseInt(mYc[2], 10);
                return isNaN(n) ? 1 : n;
            }
        }
        const mSeqYear = r.match(/^(\d+)-(\d{4})$/);
        if (mSeqYear) {
            const n = parseInt(mSeqYear[1], 10);
            return isNaN(n) ? 1 : n;
        }
        const mDash = r.match(/-(\d+)$/);
        if (mDash) {
            const n = parseInt(mDash[1], 10);
            return isNaN(n) ? 1 : n;
        }
        if (/^\d+$/.test(r)) {
            const n = parseInt(r, 10);
            return isNaN(n) ? 1 : n;
        }
        return 1;
    }

    private extractSequenceFromLastReference(lastRef: string | null | undefined, prefix: string): number | null {
        const ref = (lastRef || '').trim();
        if (!ref) {
            return null;
        }
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind === 'seq_only' && /^\d+$/.test(ref)) {
            const n = parseInt(ref, 10);
            return isNaN(n) ? null : n;
        }
        if (fmt?.kind === 'year_concat_seq') {
            const mCat = ref.match(/^(\d{4})(\d+)$/);
            if (mCat) {
                const y0 = parseInt(mCat[1], 10);
                if (y0 >= 2000 && y0 <= 2099) {
                    return parseInt(mCat[2], 10);
                }
            }
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                return parseInt(mYs[2], 10);
            }
            if (/^\d+$/.test(ref)) {
                const n = parseInt(ref, 10);
                return isNaN(n) ? null : n;
            }
        }
        if (fmt?.kind === 'seq_year') {
            const mSy = ref.match(/^(\d+)-(\d{4})$/i);
            if (mSy) {
                return parseInt(mSy[1], 10);
            }
            // Ancienne ref modèle 3 (AAAA-séquence) : réutiliser le compteur
            const mYsLegacy = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYsLegacy) {
                return parseInt(mYsLegacy[2], 10);
            }
        }
        if (fmt?.kind === 'year_seq') {
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                return parseInt(mYs[2], 10);
            }
        }
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        if (!new RegExp(`^${this.escapeRegExp(p)}`, 'i').test(ref)) {
            return null;
        }
        const stripped = ref.replace(new RegExp(`^${this.escapeRegExp(p)}`, 'i'), '').replace(/^-+/, '');
        if (!stripped) {
            return null;
        }
        const parts = stripped.split('-').filter((s) => s.length > 0);
        for (let i = parts.length - 1; i >= 0; i--) {
            const seg = parts[i];
            if (/^\d{4}$/.test(seg)) {
                const y = parseInt(seg, 10);
                if (y >= 2000 && y <= 2099) {
                    continue;
                }
            }
            const digits = seg.replace(/\D/g, '');
            if (!digits.length) {
                continue;
            }
            const n = parseInt(digits, 10);
            if (!isNaN(n)) {
                return n;
            }
        }
        return null;
    }

    private getModelReferenceFormatMeta():
        | { kind: 'year_seq'; sequencePad: number }
        | { kind: 'year_concat_seq'; sequencePad: number }
        | { kind: 'seq_year'; sequencePad: number }
        | { kind: 'prefix_year_seq'; sequencePad: number }
        | { kind: 'prefix_seq'; sequencePad: number }
        | { kind: 'seq_only'; sequencePad: number }
        | null {
        const desc = this.referenceModelDetail?.description?.trim();
        if (!desc) {
            return null;
        }
        const idx = desc.indexOf(':');
        const part = idx >= 0 ? desc.slice(idx + 1).trim() : desc;
        if (!part) {
            return null;
        }
        const sub = this.substituteReferenceYearInPrefix(part) || part;
        const withPrefix = this.applyEffectivePrefixToFormatExampleString(sub).trim();
        if (!withPrefix) {
            return null;
        }
        const hyphenCount = (withPrefix.match(/-/g) || []).length;

        // Aucun tiret : soit 202600000X (modèle 4), soit 000000X (seq_only)
        if (hyphenCount === 0) {
            const raw = withPrefix.trim();
            if (raw && /^[\dX]+$/i.test(raw)) {
                const mCat = raw.match(/^((?:20\d{2}|\d{4}))([\dX]+)$/i);
                if (mCat) {
                    const y0 = parseInt(mCat[1], 10);
                    const tail = mCat[2];
                    if (
                        y0 >= 2000 &&
                        y0 <= 2099 &&
                        tail.length >= 1 &&
                        (/X/i.test(raw) || tail.length >= 2)
                    ) {
                        let sequencePad: number;
                        if (/X/i.test(tail)) {
                            const beforeX = tail.split(/X/i)[0] || '';
                            const digitsBefore = beforeX.replace(/\D/g, '');
                            sequencePad = Math.max(digitsBefore.length || 5, 4);
                        } else {
                            const digits = tail.replace(/\D/g, '');
                            sequencePad = Math.max(digits.length || 4, 4);
                        }
                        return { kind: 'year_concat_seq', sequencePad };
                    }
                }
            }
            if (raw && /\d/.test(raw) && /^[\dX]+$/i.test(raw)) {
                let sequencePad: number;
                if (/X/i.test(raw)) {
                    const beforeX = raw.split(/X/i)[0] || '';
                    const digitsBefore = beforeX.replace(/\D/g, '');
                    sequencePad = Math.max(digitsBefore.length || 5, 4);
                } else {
                    const digits = raw.replace(/\D/g, '');
                    sequencePad = Math.max(digits.length || 4, 4);
                }
                return { kind: 'seq_only', sequencePad };
            }
        }

        // AAAA-séquence ou PRÉFIXE-séquence : exactement un tiret
        if (hyphenCount === 1) {
            const mY = withPrefix.match(/^((?:20\d{2}|\d{4}))-(.+)$/);
            if (mY) {
                const y = parseInt(mY[1], 10);
                if (y >= 2000 && y <= 2099) {
                    const tailRaw = mY[2].trim();
                    let sequencePad: number;
                    if (/X/i.test(tailRaw)) {
                        const beforeX = tailRaw.split(/X/i)[0] || '';
                        const digitsBefore = beforeX.replace(/\D/g, '');
                        sequencePad = Math.max(digitsBefore.length || 5, 4);
                    } else {
                        const digits = tailRaw.replace(/\D/g, '');
                        sequencePad = Math.max(digits.length || 4, 4);
                    }
                    return { kind: 'year_seq', sequencePad };
                }
            }
            const mP = withPrefix.match(/^([^-]+)-(.+)$/);
            if (mP) {
                const leftRaw = mP[1].trim();
                const rightRaw = mP[2].trim();
                const ry = parseInt(rightRaw, 10);
                // Modèle 4 : 00000X-2026 (chiffres / X à gauche, année 2000–2099 à droite)
                if (
                    /^\d{4}$/.test(rightRaw) &&
                    !isNaN(ry) &&
                    ry >= 2000 &&
                    ry <= 2099 &&
                    /^[\dX]+$/i.test(leftRaw)
                ) {
                    let sequencePad: number;
                    if (/X/i.test(leftRaw)) {
                        const beforeX = leftRaw.split(/X/i)[0] || '';
                        const digitsBefore = beforeX.replace(/\D/g, '');
                        sequencePad = Math.max(digitsBefore.length || 5, 4);
                    } else {
                        const digits = leftRaw.replace(/\D/g, '');
                        sequencePad = Math.max(digits.length || 4, 4);
                    }
                    return { kind: 'seq_year', sequencePad };
                }
                const tailRaw = rightRaw;
                let sequencePad: number;
                if (/X/i.test(tailRaw)) {
                    const beforeX = tailRaw.split(/X/i)[0] || '';
                    const digitsBefore = beforeX.replace(/\D/g, '');
                    sequencePad = Math.max(digitsBefore.length || 5, 4);
                } else {
                    const digits = tailRaw.replace(/\D/g, '');
                    sequencePad = Math.max(digits.length || 4, 4);
                }
                return { kind: 'prefix_seq', sequencePad };
            }
        }

        const tailMatch = withPrefix.match(/^(.+)-(\d{4})-(.+)$/);
        if (tailMatch) {
            const firstSeg = tailMatch[1].trim();
            const looksLikeYearOnly =
                /^(?:20\d{2}|\d{4})$/.test(firstSeg) &&
                (() => {
                    const n = parseInt(firstSeg, 10);
                    return n >= 2000 && n <= 2099;
                })() &&
                !/[A-Za-z]/.test(firstSeg);
            if (looksLikeYearOnly) {
                return null;
            }
            const tailRaw = tailMatch[3].trim();
            let sequencePad: number;
            if (/X/i.test(tailRaw)) {
                const beforeX = tailRaw.split(/X/i)[0] || '';
                const digitsBefore = beforeX.replace(/\D/g, '');
                sequencePad = Math.max(digitsBefore.length || 5, 4);
            } else {
                const digits = tailRaw.replace(/\D/g, '');
                sequencePad = Math.max(digits.length || 4, 4);
            }
            return { kind: 'prefix_year_seq', sequencePad };
        }
        return null;
    }


    private getModelReferenceTemplateInfo(): { threeSegments: true; sequencePad: number } | null {
        const m = this.getModelReferenceFormatMeta();
        return m?.kind === 'prefix_year_seq' ? { threeSegments: true, sequencePad: m.sequencePad } : null;
    }

    getReferenceConcreteValueForModal(): string {
        if (this.usesLcTransfertNumDocumentReference()) {
            const r = (this.documentReference || this.refExterne || '').trim();
            if (r && !/^0+$/.test(r)) {
                return r;
            }
            return '00000001';
        }
        return this.buildInitialRefFromTypeMeta(this.documentType, this.getReferencePrefix());
    }

    getReferencePlaceholder(): string {
        return this.getReferenceConcreteValueForModal();
    }

    getReferenceInputPlaceholder(): string {
        return this.getReferenceConcreteValueForModal();
    }

    getReferenceModalHelpLine(): string {
        if (this.usesLcTransfertNumDocumentReference()) {
            return 'Numéro de transfert entrepôt (logiciel caisse), distinct du bon transfert ERP.';
        }
        const desc = this.referenceModelDetail?.description?.trim();
        if (desc) {
            const idx = desc.indexOf(':');
            const line = idx >= 0 ? desc.slice(0, idx).trim() : desc;
            if (line) {
                return line;
            }
        }
        return this.getDefaultReferenceModalHelpLine();
    }

    private getDefaultReferenceModalHelpLine(): string {
        const t = this.documentType;
        if (t === 'DEVIS') {
            return 'Indiquez la référence du devis.';
        }
        if (t === 'FACTURE' || t === 'FACTURE FOURNISSEUR') {
            return 'Indiquez la référence de la facture.';
        }
        if (t === 'COMMANDE CLIENT' || t === 'COMMANDE FOURNISSEUR') {
            return 'Indiquez la référence de la commande.';
        }
        if (t === 'TRANSFERT') {
            return 'Indiquez le numéro du transfert entrepôt.';
        }
        if (t === 'BON DE LIVRAISON' || t === 'BON RECEPTION' || t === 'BON DE SORTIE' || t === 'BON TRANSFERT') {
            return 'Indiquez la référence du bon.';
        }
        if (t === 'INVENTAIRE') {
            return 'Indiquez la référence de l’inventaire.';
        }
        if (t === 'AVOIR' || t === 'AVOIR FOURNISSEUR') {
            return 'Indiquez la référence de l’avoir.';
        }
        return 'Indiquez la référence du document.';
    }

    private applyEffectivePrefixToFormatExampleString(fmt: string): string {
        const prefix = this.getReferencePrefix();
        if (!fmt?.trim() || !prefix) {
            return fmt;
        }
        let out = fmt.trim();
        out = out.replace(
            /(^|[\s;,:()\/])([A-Za-z0-9]{1,20})-((?:20\d{2}|\d{4}))-([^\s]+)/g,
            (_m, lead: string, _oldPref: string, year: string, tail: string) =>
                `${lead}${prefix}-${year}-${tail}`
        );
        out = out.replace(
            /^([A-Za-z0-9]{1,20})-((?:20\d{2}|\d{4}))-(.+)$/,
            (_m, _oldPref: string, year: string, tail: string) => `${prefix}-${year}-${tail}`
        );
        return out;
    }

    getReferenceFormatExample(): string {
        if (this.usesLcTransfertNumDocumentReference()) {
            const r = (this.documentReference || '').trim();
            if (r && !/^0+$/.test(r)) {
                return r;
            }
            return '00000001';
        }
        const prefix = this.getReferencePrefix();
        const desc = this.referenceModelDetail?.description?.trim();
        if (desc) {
            const idx = desc.indexOf(':');
            const part = idx >= 0 ? desc.slice(idx + 1).trim() : desc;
            if (part) {
                const sub = this.substituteReferenceYearInPrefix(part) || part;
                return this.applyEffectivePrefixToFormatExampleString(sub);
            }
        }
        const fmt = this.getModelReferenceFormatMeta();
        const y = new Date().getFullYear();
        if (fmt?.kind === 'year_seq') {
            return `${y}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'year_concat_seq') {
            return `${y}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'seq_year') {
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${y}`;
        }
        if (fmt?.kind === 'prefix_year_seq') {
            return `${prefix}-${y}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'prefix_seq') {
            return `${prefix}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'seq_only') {
            return (1).toString().padStart(fmt.sequencePad, '0');
        }
        return `${prefix}-0001`;
    }

    getReferenceValidationMessage(): string {
        const ex = this.getReferenceFormatExample();
        const placeholder = this.getReferencePlaceholder();
        if (this.referenceModelDetail?.description?.trim()) {
            return `Référence invalide. Format attendu : ${ex} (ex. ${placeholder}).`;
        }
        return `Référence invalide. Utilisez le préfixe « ${this.getReferencePrefix()} » suivi d’un numéro (ex. ${placeholder}) ou uniquement des chiffres.`;
    }

    private parseReferenceThreeSegmentParts(ref: string): { prefix: string; year: number; seq: number; pad: number } | null {
        const tmpl = this.getModelReferenceTemplateInfo();
        if (!tmpl?.threeSegments) {
            return null;
        }
        const p = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
        const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d{4})-(\\d+)$`, 'i');
        const m = ref.trim().match(re);
        if (!m) {
            return null;
        }
        return {
            prefix: p,
            year: parseInt(m[1], 10),
            seq: parseInt(m[2], 10),
            pad: tmpl.sequencePad
        };
    }

    private parseReferenceYearSequenceParts(ref: string): { year: number; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'year_seq') {
            return null;
        }
        const m = ref.trim().match(/^(\d{4})-(\d+)$/i);
        if (!m) {
            return null;
        }
        return {
            year: parseInt(m[1], 10),
            seq: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceYearConcatParts(ref: string): { year: number; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'year_concat_seq') {
            return null;
        }
        const m = ref.trim().match(/^(\d{4})(\d+)$/);
        if (!m) {
            return null;
        }
        const y0 = parseInt(m[1], 10);
        if (y0 < 2000 || y0 > 2099) {
            return null;
        }
        return {
            year: y0,
            seq: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceSeqYearParts(ref: string): { seq: number; year: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'seq_year') {
            return null;
        }
        const m = ref.trim().match(/^(\d+)-(\d{4})$/i);
        if (!m) {
            return null;
        }
        return {
            seq: parseInt(m[1], 10),
            year: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferencePrefixSequenceParts(ref: string): { prefix: string; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'prefix_seq') {
            return null;
        }
        const p = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
        const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d+)$`, 'i');
        const m = ref.trim().match(re);
        if (!m) {
            return null;
        }
        return {
            prefix: p,
            seq: parseInt(m[1], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceSeqOnlyParts(ref: string): { seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'seq_only') {
            return null;
        }
        const r = ref.trim();
        if (!/^\d+$/.test(r)) {
            return null;
        }
        const seq = parseInt(r, 10);
        return { seq: isNaN(seq) ? 1 : seq, pad: fmt.sequencePad };
    }

    private parseReferenceCounterAndPadding(): { num: number; pad: number } {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            return { num: three.seq, pad: three.pad };
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            return { num: ys.seq, pad: ys.pad };
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            return { num: yc.seq, pad: yc.pad };
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            return { num: sy.seq, pad: sy.pad };
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            return { num: ps.seq, pad: ps.pad };
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            return { num: so.seq, pad: so.pad };
        }
        const prefix = this.getReferencePrefix();
        const re = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`);
        const m = ref.match(re);
        if (m) {
            const n = parseInt(m[1], 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(m[1].length, 4) };
        }
        if (/^\d+$/.test(ref)) {
            const n = parseInt(ref, 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(ref.length, 4) };
        }
        const loose = ref.match(/^(.+)-(\d+)$/);
        if (loose) {
            const n = parseInt(loose[2], 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(loose[2].length, 4) };
        }
        return { num: 1, pad: 4 };
    }

    private incrementRefExterneTwoSegment(lastRef: string | null | undefined, prefix: string): string {
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        const ref = (lastRef || '').trim();
        if (!ref) {
            return `${p}-0001`;
        }
        const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const same = new RegExp(`^${escape(p)}-(\\d+)$`, 'i');
        const m = ref.match(same);
        if (m) {
            const num = parseInt(m[1], 10);
            const nextNum = isNaN(num) ? 1 : num + 1;
            const pad = Math.max(m[1].length, 4);
            return `${p}-${nextNum.toString().padStart(pad, '0')}`;
        }
        const carried = this.extractSequenceFromLastReference(ref, p);
        if (carried != null) {
            const nextNum = carried + 1;
            const pad = Math.max(String(nextNum).length, 4);
            return `${p}-${nextNum.toString().padStart(pad, '0')}`;
        }
        return `${p}-0001`;
    }

    private incrementRefExterneForCurrentModel(lastRef: string | null | undefined, prefix: string): string {
        const fmt = this.getModelReferenceFormatMeta();
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        const year = new Date().getFullYear();

        if (fmt?.kind === 'year_seq') {
            const ref = (lastRef || '').trim();
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                const refYear = parseInt(mYs[1], 10);
                const num = parseInt(mYs[2], 10);
                if (refYear === year) {
                    return `${year}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    return `${year}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                return `${refYear}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${year}-${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'year_concat_seq') {
            const ref = (lastRef || '').trim();
            const mCat = ref.match(/^(\d{4})(\d+)$/);
            if (mCat) {
                const refYear = parseInt(mCat[1], 10);
                const num = parseInt(mCat[2], 10);
                if (refYear === year) {
                    return `${year}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    return `${year}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                return `${refYear}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${year}${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'seq_year') {
            const ref = (lastRef || '').trim();
            const mSy = ref.match(/^(\d+)-(\d{4})$/i);
            if (mSy) {
                const num = parseInt(mSy[1], 10);
                const refYear = parseInt(mSy[2], 10);
                if (refYear === year) {
                    return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
                }
                if (refYear < year) {
                    return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
                }
                return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${refYear}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${(carried + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
        }

        if (fmt?.kind === 'prefix_year_seq') {
            const ref = (lastRef || '').trim();
            const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d{4})-(\\d+)$`, 'i');
            const m = ref.match(re);
            if (m) {
                const refYear = parseInt(m[1], 10);
                const num = parseInt(m[2], 10);
                if (refYear === year) {
                    const nextNum = (isNaN(num) ? 0 : num) + 1;
                    return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    const nextNum = (isNaN(num) ? 0 : num) + 1;
                    return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
                }
                const nextNum = (isNaN(num) ? 0 : num) + 1;
                return `${p}-${refYear}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                const nextNum = carried + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'prefix_seq') {
            const ref = (lastRef || '').trim();
            const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d+)$`, 'i');
            const m = ref.match(re);
            if (m) {
                const num = parseInt(m[1], 10);
                return `${p}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${p}-${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'seq_only') {
            const ref = (lastRef || '').trim();
            if (/^\d+$/.test(ref)) {
                const num = parseInt(ref, 10);
                return (num + 1).toString().padStart(fmt.sequencePad, '0');
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return (carried + 1).toString().padStart(fmt.sequencePad, '0');
            }
            return (1).toString().padStart(fmt.sequencePad, '0');
        }

        return this.incrementRefExterneTwoSegment(lastRef, prefix);
    }
    private loadNextReferenceInBackground(): void {
        this.applyNextReferenceFromRefCounterApi();
    }

    /** Précharge la prochaine référence auto-incrémentée (nouveau document uniquement). */
    private maybePrefetchNextDocumentReference(force = false): void {
        if (this.documentId || this.mode === 'edit' || this.mode === 'validation') {
            return;
        }
        if (this.shouldSkipLcTransfertNextReferencePrefetch()) {
            return;
        }
        if (!force) {
            const r = (this.documentReference || this.refExterne || '').trim();
            if (r && !/^0+$/.test(r)) {
                return;
            }
        }
        this.beginDocumentReferenceHeaderLoad();
        this.loadNextReferenceInBackground();
    }

    isHeaderDocumentReferenceLoading(): boolean {
        if (
            this.logicielCaisseTransfertFromPvEcart &&
            this.isLogicielCaisseEntrepotTransfert() &&
            this.pvEcartLinkedTransfertRefPending
        ) {
            return true;
        }
        if (this.documentReferenceHeaderPending) {
            if (this.mode === 'validation') {
                return false;
            }
            if (this.mode === 'edit' || !this.documentId) {
                return true;
            }
        }
        if (this.isLoadingEdit && this.mode === 'edit') {
            return true;
        }
        return false;
    }

    isDocumentProductsTableLoading(): boolean {
        return this.isLoadingEdit;
    }

    /** Démarre l’état « chargement référence » (en-tête + popup) pour un nouveau document. */
    private beginDocumentReferenceHeaderLoad(): void {
        if (this.documentId || this.mode === 'edit' || this.mode === 'validation') {
            return;
        }
        if (this.shouldSkipLcTransfertNextReferencePrefetch()) {
            return;
        }
        this.documentReferenceHeaderPending = true;
        this.documentReference = '';
        this.refExterne = '';
        this.cdr.markForCheck();
    }

    /** Référence affichée à côté du type de document (sans placeholder 0001 / 001). */
    getHeaderDocumentReference(): string {
        if (this.isHeaderDocumentReferenceLoading()) {
            return '';
        }
        if (this.logicielCaisseTransfertFromPvEcart && this.isLogicielCaisseEntrepotTransfert()) {
            const lcLoaded = (this.documentReference || '').trim();
            if (lcLoaded && !/^0+$/.test(lcLoaded) && !this.isProvisionalDraftRef(lcLoaded)) {
                return lcLoaded;
            }
            const linked = this.pvEcartLinkedTransfertRefDisplay.trim();
            if (linked && !/^0+$/.test(linked)) {
                return linked;
            }
        }
        const r = (this.documentReference || this.refExterne || '').trim();
        if (r && !/^0+$/.test(r)) {
            return r;
        }
        return '';
    }

    /** Charge la référence « document de transfert » (Documents liés PV) pour l’en-tête. */
    private refreshPvEcartLinkedTransfertHeaderReference(
        pvDoc: Record<string, unknown> | null | undefined
    ): void {
        if (!this.logicielCaisseTransfertFromPvEcart || !this.isLogicielCaisseEntrepotTransfert()) {
            return;
        }
        this.pvEcartLinkedTransfertRefPending = true;
        this.pvEcartLinkedTransfertRefDisplay = '';
        this.cdr.markForCheck();
        const doc = (pvDoc ?? this.lastLoadedPvEcartDoc) as Record<string, unknown> | null;
        if (!doc) {
            this.pvEcartLinkedTransfertRefPending = false;
            this.cdr.markForCheck();
            return;
        }
        loadPvEcartLinkedDocuments$(this.documentService, doc, this.lcStockTransfert)
            .pipe(take(1))
            .subscribe({
                next: (view) => {
                    this.pvEcartLinkedDocsView = view;
                    this.pvEcartLinkedTransfertRefDisplay =
                        resolvePvEcartLinkedTransfertHeaderReference(doc, view);
                    this.pvEcartLinkedTransfertRefPending = false;
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.pvEcartLinkedTransfertRefDisplay =
                        resolvePvEcartLinkedTransfertHeaderReference(doc, null);
                    this.pvEcartLinkedTransfertRefPending = false;
                    this.cdr.markForCheck();
                },
            });
    }

    private assignProvisionalRefExterneForType(): void {
        this.applyNextReferenceFromRefCounterApi();
    }

    private openReferenceModalInternal(): void {
        if (!this.referenceModal) {
            this.cdr.detectChanges();
            setTimeout(() => this.openReferenceModalInternal(), 50);
            return;
        }
        this.referenceSeedFromPopup = true;
        this.modalRef = this.modalService.open(this.referenceModal, {
            ariaLabelledBy: 'modal-reference-title',
            centered: true,
            size: 'sm',
            windowClass: 'warning-modal-centered'
        });
    }

    openmargeModal(index: number): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            this.margeModalDesignation = '—';
            this.margeModalPercentDisplay = null;
            this.margeModalMontantDisplay = null;
            this.margeModalHint =
                'La marge est calculée sur les lignes produit. Pour un sous-total ou une autre ligne, ajoutez ou sélectionnez une ligne produit.';
        } else {
            const r = this.computeProductLineMargin(index);
            this.margeModalDesignation = r.designation;
            this.margeModalPercentDisplay = r.pct;
            this.margeModalMontantDisplay = r.montant;
            this.margeModalHint = r.hint;
        }
        this.cdr.detectChanges();
        this.modalRef = this.modalService.open(this.margeModal, {
            ariaLabelledBy: 'modal-marge-title',
            centered: true,
            size: 'sm',
            windowClass: 'warning-modal-centered'
        });
    }

    private getProductCostUnitaire(product: Product | undefined): number {
        if (!product) {
            return 0;
        }
        const pa = Number(product.prix_unitaires);
        if (Number.isFinite(pa) && pa > 0) {
            return pa;
        }
        const vu = Number(product.valeur_unitaire);
        if (Number.isFinite(vu) && vu > 0) {
            return vu;
        }
        return 0;
    }

    private computeProductLineMargin(index: number): {
        designation: string;
        pct: number | null;
        montant: number | null;
        hint: string;
    } {
        const item = this.items[index];
        const designation = (item.designation || 'Produit').trim();
        const product = item.product_id ? this.products.find(p => p.id === item.product_id) : undefined;
        const qRaw = Number(item.quantity);
        const q = Number.isFinite(qRaw) ? qRaw : 0;
        const remise = Number(item.remise || 0) / 100;

        const hintVente =
            'Prix de vente HT unitaire (après remise) comparé au coût d’achat (fiche produit : prix d’achat ou valeur unitaire).';
        const hintAchat =
            'Écart entre la valorisation stock (CMUP / valeur unitaire article) et le prix d’achat unitaire sur la ligne.';
        const hintStockDoc =
            'Valeur unitaire saisie sur la ligne comparée au coût d’achat (fiche produit).';
        const hintPasCout =
            'Coût ou valorisation produit introuvable : vérifiez la fiche article ou sélectionnez à nouveau le produit.';
        const hintPrixQty =
            'Indiquez un prix unitaire HT et une quantité pour calculer la marge.';

        if (this.isStockLcDocumentType()) {
            const valUnit = Number(item.valeur_unitaire || 0) * (1 - remise);
            const pa = this.getProductCostUnitaire(product);
            if (!product || pa <= 0) {
                return { designation, pct: null, montant: null, hint: hintPasCout };
            }
            const margeUnit = valUnit - pa;
            const montant = margeUnit * q;
            const pct = Math.abs(valUnit) > 1e-9 ? (margeUnit / valUnit) * 100 : null;
            return { designation, pct, montant, hint: hintStockDoc };
        }

        if (this.isAchatDocument()) {
            const prixAchatUnit = Number(item.priceHT || 0) * (1 - remise);
            let cmup = 0;
            const vuLigneFf = Number((item as any).valeur_unitaire);
            if (
                this.documentType === 'FACTURE FOURNISSEUR' &&
                Number.isFinite(vuLigneFf) &&
                vuLigneFf > 0
            ) {
                cmup = vuLigneFf;
            } else if (product) {
                const vu = Number(product.valeur_unitaire);
                const pap = Number(product.prix_unitaires);
                if (Number.isFinite(vu) && vu > 0) {
                    cmup = vu;
                } else if (Number.isFinite(pap) && pap > 0) {
                    cmup = pap;
                }
            }
            if (cmup <= 0) {
                return { designation, pct: null, montant: null, hint: hintPasCout };
            }
            const ecartUnit = cmup - prixAchatUnit;
            const montant = ecartUnit * q;
            const pct = Math.abs(cmup) > 1e-9 ? (ecartUnit / cmup) * 100 : null;
            return { designation, pct, montant, hint: hintAchat };
        }

        const pvUnit = Number(item.priceHT || 0) * (1 - remise);
        const pa = this.getProductCostUnitaire(product);
        if (!product || pa <= 0) {
            return { designation, pct: null, montant: null, hint: hintPasCout };
        }
        if (Math.abs(pvUnit) < 1e-9 && Math.abs(q) < 1e-9) {
            return { designation, pct: null, montant: null, hint: hintPrixQty };
        }
        const margeUnit = pvUnit - pa;
        const montant = margeUnit * q;
        const pct = Math.abs(pvUnit) > 1e-9 ? (margeUnit / pvUnit) * 100 : null;
        return { designation, pct, montant, hint: hintVente };
    }
    removeAjoutLigne(itemIndex: number, ajoutLigneIndex: number): void {
        const item = this.items[itemIndex];
        if (item && item.ajout_ligne && item.ajout_ligne.length > ajoutLigneIndex) {
            item.ajout_ligne.splice(ajoutLigneIndex, 1);
            item.ajout_ligne.forEach((ligne, idx) => {
                ligne.order = idx + 1;
            });
            if (item.ajout_ligne.length === 0) {
                item.ajout_ligne = undefined;
            }
            this.cdr.detectChanges();
        }
    }

    getColspanForAjoutLigne(): number {
        return this.getProductTableColumnCount();
    }

    confirmReference(): void {
        this.modalRef?.close();
        if (this.isSubmitting) return;

        // Appliquer la référence modifiée dans le popup avant création
        const refFromModal = (this.documentReference || '').trim();
        const isNewDocument = this.mode === 'add' || !this.documentId;
        if (refFromModal && !/^0+$/.test(refFromModal) && !this.isProvisionalDraftRef(refFromModal)) {
            this.documentReference = refFromModal;
            this.refExterne = refFromModal;
            this.numericReference = this.getNumericReferenceFromRefString(refFromModal) ?? this.numericReference;
            // Seed compteur UNIQUEMENT à la 1re création (pas à l’approbation d’un brouillon existant)
            if (isNewDocument) {
                this.referenceSeedFromPopup = true;
                const seq = this.getNumericReferenceFromRefString(refFromModal);
                if (seq != null && Number.isFinite(seq) && seq > 0) {
                    this.ensureTypeMetaRefCounter(0);
                }
            } else {
                this.referenceSeedFromPopup = false;
            }
        } else if (!isNewDocument) {
            this.referenceSeedFromPopup = false;
        }

        if (this.usesDualEntrepotSelection()) {
            const hasInitialEntrepot = this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined;
            const hasDestinationEntrepot = this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined;
            
            if (!hasInitialEntrepot || !hasDestinationEntrepot) {
                this.modalRef = this.modalService.open(this.depotWarningModal, {
                    ariaLabelledBy: 'modal-depot-warning-title',
                    centered: true,
                    size: 'sm',
                    windowClass: 'warning-modal-centered'
                });
                return;
            }
        }
        if (
            this.usesDualEntrepotSelection() ||
            this.isLogicielCaisseEntrepotTransfert() ||
            this.isErpBonTransfertDocument()
        ) {
            const entrepotMapErrEarly = this.validateErpEntrepotMappingForDocumentSave({});
            if (entrepotMapErrEarly) {
                this.setDocumentSubmitting(false);
                this.updateHeaderConfig();
                this.cdr.detectChanges();
                this.toastr.error(entrepotMapErrEarly, 'Entrepôt', { timeOut: 12000 });
                return;
            }
        }
        if (this.isLogicielCaisseEntrepotTransfert()) {
            const pvEcartApproveByEcartBreakdown =
                this.logicielCaisseTransfertFromPvEcart &&
                this.pvEcartQtyBreakdownByItemIndex.size > 0;
            if (!pvEcartApproveByEcartBreakdown) {
                if (this.findProductLinesWithNegativeQuantity().length > 0) {
                    this.toastr.error('Les quantités ne peuvent pas être négatives.', 'Transfert');
                    return;
                }
                const overQty = this.findLogicielCaisseTransfertQuantityOverAvailable();
                if (overQty.length > 0) {
                    this.toastLogicielCaisseTransfertQuantityInsufficient(overQty);
                    return;
                }
            }
        }
        this.recalculateAll();
        if (this.mode === 'add' || !this.documentId) {
            this.setDocumentSubmitting(true);
            this.toastr.info('Création du document en cours...', '', { timeOut: 5000 });

            const createAndThenNavigateForAdd = (
                res: any,
                pairedBonLivraisonId?: number | null,
                opts?: { skipRefCounterIncrement?: boolean }
            ) => {
                const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                if (!newId) {
                    this.toastr.error('Erreur : ID non reçu après création');
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    return;
                }
                this.applyAllocatedReferenceFromCreateResponse(res);
                // opts.skipRefCounterIncrement conservé pour compat ; incrément géré côté API create.
                this.documentId = newId;
                this.currentStatutId = this.getApproveStatutId();
                this.saveModifiedFields();

                const navigateAfterCreate = () => {
                    this.toastr.success(
                        pairedBonLivraisonId
                            ? 'Facture et bon de livraison créés et approuvés.'
                            : 'Document créé et approuvé !'
                    );
                    if (this.documentType === 'INVENTAIRE') {
                        this.router.navigate(['/inventaire/action/validation'], { queryParams: { id: newId } });
                    } else if (this.isErpBonTransfertDocument()) {
                        this.router.navigate(['/bon-transfert/action/validation'], { queryParams: { id: newId } });
                    } else if (this.isLogicielCaisseEntrepotTransfert()) {
                        const lcId = Number((res as any)?.lcTransfertId ?? newId);
                        this.router.navigate(['/transfert-entrepot/action/validation'], {
                            queryParams: { id: lcId, return: '/transfert-entrepot/tous' },
                        });
                    } else {
                        // Facture / FF (Non payé) et autres → page validation (Retour / Annuler)
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], { queryParams: { id: newId } });
                    }
                };

                this.runPostCreateStockUpdates(newId, () => this.schedulePostDocumentStockAlerts(), pairedBonLivraisonId);
                if (this.documentType === 'FACTURE FOURNISSEUR') {
                    this.updateProductsValeurUnitaireForFactureFournisseur();
                }

                const approveStatutId = this.getApproveStatutId();
                const stationIdForStatut =
                    Number(res?.data?.document?.station_id ?? res?.data?.station_id ?? this.stationId) || this.stationId;

                const finishCreate = () => {
                    this.currentStatutId = approveStatutId;
                    this.linkTicketsToErpFactureIfNeeded$(newId, res).subscribe({
                        next: () => {
                            this.setDocumentSubmitting(false);
                            this.updateHeaderConfig();
                            this.cdr.detectChanges();
                            navigateAfterCreate();
                        },
                        error: () => {
                            this.setDocumentSubmitting(false);
                            this.updateHeaderConfig();
                            this.cdr.detectChanges();
                            navigateAfterCreate();
                        }
                    });
                };

                // Garantir le statut d'approbation (Non payé pour facture) après création
                if (approveStatutId != null && stationIdForStatut) {
                    this.documentService.updateStatut(newId, {
                        statut_id: approveStatutId,
                        station_id: stationIdForStatut
                    }).subscribe({
                        next: () => finishCreate(),
                        error: (err) => {
                            this.toastr.warning(
                                err?.error?.message ||
                                    'Facture créée, mais le statut Non payé n\'a pas pu être appliqué. Vérifiez dans la liste.',
                                'Statut'
                            );
                            finishCreate();
                        }
                    });
                } else {
                    finishCreate();
                }
            };
            if (this.conversionFromRef) {
                const cf = this.conversionFromRef;
                const documentOriginalIdForConvert = cf.isAvoir
                    ? cf.sourceId
                    : cf.documentOriginalId != null
                      ? cf.documentOriginalId
                      : cf.sourceId;
                const convertCall = cf.isAvoir && cf.totalsAvoir
                    ? this.documentService.convertDocumentType(
                          cf.sourceId,
                          cf.typeDocumentId,
                          cf.statutId,
                          documentOriginalIdForConvert,
                          cf.totalsAvoir,
                          cf.workflowStep
                      )
                    : this.documentService.convertDocumentType(
                          cf.sourceId,
                          cf.typeDocumentId,
                          cf.statutId,
                          documentOriginalIdForConvert,
                          undefined,
                          cf.workflowStep
                      );

                convertCall.pipe(
                    switchMap((res: any) => {
                        const stationIdFromRes = res?.data?.document?.station_id ?? res?.data?.station_id ?? this.stationId;
                        const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                        if (!newId) {
                            return throwError(() => new Error('ID du document converti non reçu'));
                        }
                        this.documentId = newId;
                        this.documentOriginalId = cf.sourceId;
                        this.recalculateAll();
                        this.currentTypeDocumentId = cf.typeDocumentId;
                        return this.documentService.getDocumentById(newId).pipe(
                            switchMap((docRes: any) => {
                                const doc = docRes?.data?.document ?? docRes?.data ?? docRes;
                                let docStationId = stationIdFromRes;
                                if (doc) {
                                    if (doc.statut_id != null) {
                                        this.currentStatutId = doc.statut_id;
                                    }
                                    if (doc.type_document_id != null) {
                                        this.currentTypeDocumentId = doc.type_document_id;
                                    }
                                    if (doc.user_id != null) {
                                        this.currentDocumentUserId = Number(doc.user_id);
                                    }
                                    if (doc.station_id != null) {
                                        docStationId = Number(doc.station_id);
                                    }
                                }
                                this.mode = 'edit';
                                this.isEditing = true;
                                return this.performUpdateDocument(this.currentStatutId ?? undefined).pipe(
                                    catchError((updateErr) => {
                                        const msg =
                                            updateErr?.error?.message ||
                                            updateErr?.message ||
                                            'Mise à jour des lignes impossible';
                                        this.toastr.warning(
                                            `Document créé (n° ${newId}) mais enrichissement des lignes refusé : ${msg}`,
                                            'Conversion'
                                        );
                                        return of(null);
                                    }),
                                    map(() => ({ res, stationIdFromRes: docStationId }))
                                );
                            }),
                            catchError(() => of({ res, stationIdFromRes: stationIdFromRes ?? this.stationId }))
                        );
                    }),
                    switchMap(({ res, stationIdFromRes }: { res: any; stationIdFromRes: number }) => {
                        const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                        const stationId = Number(stationIdFromRes) || Number(this.stationId);
                        const updateStatutCall = stationId
                            ? this.documentService.updateStatut(newId, { statut_id: cf.statutId, station_id: stationId })
                            : this.documentService.updateStatus(newId, cf.statutId);
                        return updateStatutCall.pipe(
                            map(() => res),
                            catchError(() => of(res))
                        );
                    })
                ).subscribe({
                    next: (res) => {
                        this.conversionFromRef = null;
                        this.isPendingConversion = false;
                        createAndThenNavigateForAdd(res, undefined, { skipRefCounterIncrement: true });
                    },
                    error: (err) => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || err?.message || 'Erreur lors de la conversion');
                    }
                });
                return;
            }

            const payload = this.buildCreatePayload();

            if (this.usesDualEntrepotSelection()) {
                if (this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined) {
                    payload.entrepot_id = this.selectedWarehouseInitialId;
                }
                if (this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined) {
                    payload.entrepot_dest_id = this.selectedWarehouseDestinationId;
                }
            } else if (this.selectedWarehouseId !== null && this.selectedWarehouseId !== undefined) {
                payload.entrepot_id = this.selectedWarehouseId;
            }

            this.applyLogicielCaisseEntrepotToPayload(payload);

            if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
                payload.parametrage_doc = this.buildParametrageDoc();
            }

            const entrepotMapErr = this.validateErpEntrepotMappingForDocumentSave(
                payload as Record<string, unknown>
            );
            if (entrepotMapErr) {
                this.setDocumentSubmitting(false);
                this.updateHeaderConfig();
                this.cdr.detectChanges();
                this.toastr.error(entrepotMapErr, 'Entrepôt', { timeOut: 12000 });
                return;
            }

            if (this.isLogicielCaisseEntrepotTransfert()) {
                this.createBonTransfertViaLogicielCaisseOnly();
                return;
            }

            if (this.documentType === 'FACTURE') {
                this.createFactureWithOptionalBonLivraison$().subscribe({
                    next: ({ res, pairedBlId }) => createAndThenNavigateForAdd(res, pairedBlId),
                    error: (err) => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || 'Erreur lors de la création');
                    }
                });
            } else {
                this.documentService.create(payload).subscribe({
                    next: (res) => createAndThenNavigateForAdd(res),
                    error: (err) => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || 'Erreur lors de la création');
                    }
                });
            }

        } else {
            this.setDocumentSubmitting(true);
            this.toastr.info('Approbation en cours...', '', { timeOut: 5000 });

            const approveUpdate$ =
                this.documentType === 'PV ECART'
                    ? this.resolvePvEcartWorkflowStatutId$('Validé').pipe(
                          switchMap((sid) =>
                              this.updateDocument(sid).pipe(map(() => sid))
                          )
                      )
                    : (() => {
                          const statutApprouve = this.getApproveStatutId();
                          return this.updateDocument(statutApprouve).pipe(map(() => statutApprouve));
                      })();

            approveUpdate$
                .pipe(
                    finalize(() => {
                        this.setDocumentSubmitting(false);
                    })
                )
                .subscribe({
                    next: (statutApprouve: number) => {
                        this.toastr.success('Document approuvé avec succès !');
                        this.currentStatutId = statutApprouve;
                        this.updateHeaderConfig();

                        if (this.documentType === 'FACTURE FOURNISSEUR') {
                            this.updateProductsValeurUnitaireForFactureFournisseur();
                        }

                        const afterApproveNavigate = () => {
                            if (this.documentType === 'INVENTAIRE') {
                                this.router.navigate(['/inventaire/action/validation'], {
                                    queryParams: { id: this.documentId }
                                });
                            } else if (this.isErpBonTransfertDocument()) {
                                const q: Record<string, string> = { id: String(this.documentId) };
                                const ret = this.route.snapshot.queryParams['return'];
                                if (typeof ret === 'string' && ret.trim()) {
                                    q['return'] = ret.trim();
                                }
                                if (this.isBonTransfertFromPvEcart()) {
                                    const lcId = this.pvEcartApprovedLcTransfertId;
                                    if (lcId != null && lcId > 0) {
                                        q['source'] = 'lc';
                                        q['lcTransfertId'] = String(lcId);
                                    }
                                }
                                this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                                    queryParams: q,
                                });
                            } else if (this.isLogicielCaisseEntrepotTransfert()) {
                                this.router.navigate(['/transfert-entrepot/action/validation'], {
                                    queryParams: {
                                        id: this.documentId,
                                        return: '/transfert-entrepot/tous',
                                    },
                                });
                            } else {
                                // Facture / FF (Non payé) → validation (Retour / Annuler)
                                this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                                    queryParams: { id: this.documentId }
                                });
                            }
                        };

                        const afterStockOrSkip = () => {
                            this.linkTicketsToErpFactureIfNeeded$(this.documentId, {
                                data: {
                                    document: {
                                        id: this.documentId,
                                        ref_externe: this.documentReference || this.refExterne
                                    }
                                }
                            }).subscribe({
                                next: () => afterApproveNavigate(),
                                error: () => afterApproveNavigate()
                            });
                        };

                        // Avoir / BR / BL / bon de sortie / BT (PV écart) à l'approbation
                        if (
                            (this.shouldApplyLcBonSortieStock() ||
                                this.requiresStockUpdate() ||
                                (this.isErpBonTransfertDocument() &&
                                    this.isBonTransfertFromPvEcart())) &&
                            this.documentId != null
                        ) {
                            this.runPostCreateStockUpdates(this.documentId, () => {
                                this.schedulePostDocumentStockAlerts();
                                afterStockOrSkip();
                            });
                        } else {
                            afterStockOrSkip();
                        }
                    },
                    error: (err) => {
                        const msg =
                            err?.message ||
                            err?.error?.message ||
                            'Erreur lors de l\'approbation';
                        this.toastr.error(msg);
                    }
                });
        }
    }

    private extractNewDocumentIdFromCreateResponse(res: any): number | null {
        const raw = res?.data?.id ?? res?.data?.document?.id ?? res?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    }

    /** Applique la référence réellement allouée par le backend (source de vérité). */
    private applyAllocatedReferenceFromCreateResponse(res: any): void {
        const allocated = String(
            res?.data?.document?.ref_externe ??
                res?.data?.ref_externe ??
                res?.data?.document?.ref_interne ??
                res?.ref_externe ??
                ''
        ).trim();
        if (allocated) {
            this.documentReference = allocated;
            this.refExterne = allocated;
            this.numericReference = this.getNumericReferenceFromRefString(allocated);
        }
        const seq = this.numericReference;
        if (seq != null && Number.isFinite(Number(seq)) && Number(seq) > 0) {
            this.ensureTypeMetaRefCounter(Number(seq));
        } else {
            const prev = this.typeDocumentsMeta[this.documentType]?.refCounter;
            const next = prev != null && Number.isFinite(Number(prev)) ? Number(prev) + 1 : 1;
            this.ensureTypeMetaRefCounter(next);
        }
        this.cdr.markForCheck();
    }

    private buildCreatePayloadForDocumentType(
        docType: string,
        options?: { document_original_id?: number | null }
    ): any {
        const prevType = this.documentType;
        this.documentType = docType;
        try {
            const payload = this.buildCreatePayload();
            // Ne jamais réutiliser la ref du document principal (ex. facture → BL) :
            // le backend alloue la prochaine séquence du type cible.
            delete payload.ref_externe;
            delete payload.ref_interne;
            if (options?.document_original_id != null && options.document_original_id !== undefined) {
                payload.document_original_id = options.document_original_id;
            }
            return payload;
        } finally {
            this.documentType = prevType;
        }
    }

    private createFactureWithOptionalBonLivraison$(): Observable<{ res: any; pairedBlId: number | null }> {
        return this.parametreDocumentSettingsService.getByStation(this.stationId).pipe(
            catchError(() => of(null)),
            switchMap((bundle) => {
                const activeBonLiv =
                    bundle != null && isTruthyTinyInt(bundle.parametre_document?.active_bon_liv);
                let payload = this.buildCreatePayload();
                if (this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined) {
                    payload.entrepot_id = this.selectedWarehouseId;
                }
                this.applyLogicielCaisseEntrepotToPayload(payload);
                if (!payload.parametrage_doc) {
                    payload.parametrage_doc = this.buildParametrageDoc();
                }
                return this.documentService.create(payload).pipe(
                    switchMap((res) => {
                        const factureId = this.extractNewDocumentIdFromCreateResponse(res);
                        if (!activeBonLiv || factureId == null) {
                            return of({ res, pairedBlId: null as number | null });
                        }
                        const blPayload = this.buildCreatePayloadForDocumentType('BON DE LIVRAISON', {
                            document_original_id: factureId
                        });
                        if (this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined) {
                            blPayload.entrepot_id = this.selectedWarehouseId;
                        }
                        this.applyLogicielCaisseEntrepotToPayload(blPayload);
                        if (!blPayload.parametrage_doc) {
                            blPayload.parametrage_doc = this.buildParametrageDoc();
                        }
                        return this.documentService.create(blPayload).pipe(
                            map((blRes) => ({
                                res,
                                pairedBlId: this.extractNewDocumentIdFromCreateResponse(blRes)
                            })),
                            catchError((err) => {
                                this.toastr.warning(
                                    'La facture a été créée, mais la génération automatique du bon de livraison a échoué. Vous pouvez le créer manuellement.',
                                    'Bon de livraison',
                                    { timeOut: 10000 }
                                );
                                return of({ res, pairedBlId: null });
                            })
                        );
                    })
                );
            })
        );
    }

    private buildCreatePayload(): any {
        const isAchat = this.isAchatDocument();

        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (p) {
                projetPivot = {
                    id_projet: String(p.id),
                    titre: p.libelle || 'Projet sans titre'
                };
            }
        }

        const f = (n: number) => Number(n || 0).toFixed(3);

        const payload = {
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,
            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            etablissement_id: this.resolvePayloadEtablissementId(),
            type_document_id: this.typeDocumentIdMap[this.documentType],
            entrepot_id: this.usesDualEntrepotSelection() 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.usesDualEntrepotSelection() && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            statut_id: this.getApproveStatutId(),

            client_data: !isAchat && this.selectedClient ? {
                client_id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || null,
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                fournisseur_id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : null,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],

            parametrage_doc: this.buildParametrageDoc(),
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },
            lignes_document: this.prepareLignesDocumentForSave()
        };
        return payload;
    }

    cancelReference(): void {
        this.referenceSeedFromPopup = false;
        this.modalRef?.dismiss('Cancel');
    }

    increment(): void {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            const next = three.seq + 1;
            this.documentReference = `${three.prefix}-${three.year}-${next.toString().padStart(three.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            const next = ys.seq + 1;
            this.documentReference = `${ys.year}-${next.toString().padStart(ys.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            const next = yc.seq + 1;
            const calY = new Date().getFullYear();
            const refY = yc.year < calY ? calY : yc.year;
            this.documentReference = `${refY}${next.toString().padStart(yc.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            const next = sy.seq + 1;
            const calY = new Date().getFullYear();
            const refY = sy.year < calY ? calY : sy.year;
            this.documentReference = `${next.toString().padStart(sy.pad, '0')}-${refY}`;
            this.numericReference = next;
            return;
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            const next = ps.seq + 1;
            this.documentReference = `${ps.prefix}-${next.toString().padStart(ps.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            const next = so.seq + 1;
            this.documentReference = next.toString().padStart(so.pad, '0');
            this.numericReference = next;
            return;
        }
        const fmtYs = this.getModelReferenceFormatMeta();
        if (fmtYs?.kind === 'year_seq') {
            const prefix = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
            const reLegacy = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`, 'i');
            const mLeg = ref.match(reLegacy);
            if (mLeg) {
                const num = parseInt(mLeg[1], 10);
                const year = new Date().getFullYear();
                const next = num + 1;
                this.documentReference = `${year}-${next.toString().padStart(fmtYs.sequencePad, '0')}`;
                this.numericReference = next;
                return;
            }
        }
        const prefix = this.getReferencePrefix();
        const { num, pad } = this.parseReferenceCounterAndPadding();
        const next = num + 1;
        this.documentReference = `${prefix}-${next.toString().padStart(pad, '0')}`;
        this.numericReference = next;
    }

    decrement(): void {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            if (three.seq <= 1) {
                return;
            }
            const next = three.seq - 1;
            this.documentReference = `${three.prefix}-${three.year}-${next.toString().padStart(three.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            if (ys.seq <= 1) {
                return;
            }
            const next = ys.seq - 1;
            this.documentReference = `${ys.year}-${next.toString().padStart(ys.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            if (yc.seq <= 1) {
                return;
            }
            const next = yc.seq - 1;
            this.documentReference = `${yc.year}${next.toString().padStart(yc.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            if (sy.seq <= 1) {
                return;
            }
            const next = sy.seq - 1;
            this.documentReference = `${next.toString().padStart(sy.pad, '0')}-${sy.year}`;
            this.numericReference = next;
            return;
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            if (ps.seq <= 1) {
                return;
            }
            const next = ps.seq - 1;
            this.documentReference = `${ps.prefix}-${next.toString().padStart(ps.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            if (so.seq <= 1) {
                return;
            }
            const next = so.seq - 1;
            this.documentReference = next.toString().padStart(so.pad, '0');
            this.numericReference = next;
            return;
        }
        const fmtYs = this.getModelReferenceFormatMeta();
        if (fmtYs?.kind === 'year_seq') {
            const prefix = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
            const reLegacy = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`, 'i');
            const mLeg = ref.match(reLegacy);
            if (mLeg) {
                const num = parseInt(mLeg[1], 10);
                if (num <= 1) {
                    return;
                }
                const year = new Date().getFullYear();
                const next = num - 1;
                this.documentReference = `${year}-${next.toString().padStart(fmtYs.sequencePad, '0')}`;
                this.numericReference = next;
                return;
            }
        }
        const prefix = this.getReferencePrefix();
        const { num, pad } = this.parseReferenceCounterAndPadding();
        if (num <= 1) {
            return;
        }
        const next = num - 1;
        this.documentReference = `${prefix}-${next.toString().padStart(pad, '0')}`;
        this.numericReference = next;
    }
    incrementQuantity(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            if (this.isProductLineQuantityReadonly(index)) {
                return;
            }
            const currentQty = parseFloat(item.quantity?.toString() || '0');
            item.quantity = this.shouldEnforceNonNegativeProductQuantity()
                ? normalizeNonNegativeIntegerQuantity(currentQty) + 1
                : currentQty + 1;
            this.calculateTotal(index);
            if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
            }
        }
    }
    decrementQuantity(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            if (this.isProductLineQuantityReadonly(index)) {
                return;
            }
            const currentQty = parseFloat(item.quantity?.toString() || '0');
            if (this.shouldEnforceNonNegativeProductQuantity()) {
                item.quantity = Math.max(0, normalizeNonNegativeIntegerQuantity(currentQty) - 1);
            } else {
            item.quantity = currentQty - 1;
            }
            this.calculateTotal(index);
            if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
            }
        }
    }
    incrementPrice(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
                const currentPrice = parseFloat(item.priceHT?.toString() || '0');
                item.priceHT = currentPrice + 1;
            this.onProductLinePriceHtInput(index);
        }
    }
    decrementPrice(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
                const currentPrice = parseFloat(item.priceHT?.toString() || '0');
                if (currentPrice > 0) {
                    item.priceHT = Math.max(0, currentPrice - 1);
                }
            this.onProductLinePriceHtInput(index);
        }
    }

    isValidNumber(value: string): boolean {
        const v = (value || '').trim();
        if (v === '') {
            return false;
        }
        if (/^\d+$/.test(v)) {
            return true;
        }
        const prefix = this.getReferencePrefix();
        const pNorm = prefix.replace(/-+$/, '').trim() || 'DOC';

        const fmtMeta = this.getModelReferenceFormatMeta();
        if (fmtMeta?.kind === 'year_seq') {
            if (/^\d{4}-\d+$/.test(v)) {
                return true;
            }
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d+$`, 'i').test(v);
        }
        if (fmtMeta?.kind === 'year_concat_seq') {
            if (!/^\d{4}\d+$/.test(v)) {
                return false;
            }
            const y0 = parseInt(v.slice(0, 4), 10);
            return y0 >= 2000 && y0 <= 2099;
        }
        if (fmtMeta?.kind === 'seq_year') {
            return /^\d+-\d{4}$/.test(v);
        }
        if (fmtMeta?.kind === 'seq_only') {
            return /^\d+$/.test(v);
        }
        if (fmtMeta?.kind === 'prefix_seq') {
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d+$`, 'i').test(v);
        }

        if (this.getModelReferenceTemplateInfo()?.threeSegments) {
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d{4}-\\d+$`, 'i').test(v);
        }

        const strict = new RegExp(`^${this.escapeRegExp(prefix)}-\\d+$`);
        if (strict.test(v)) {
            return true;
        }
        const match = v.match(/^(.+)-(\d+)$/);
        return match != null && !isNaN(parseInt(match[2], 10));
    }

    validateInput(input: any): void {
        this.cdr.markForCheck();
    }

    goToApercu(): void {
        this.saveModifiedFields();

        const buildAndNavigate = (previewPayload: any) => {
            const previewData = {
                isDraft: true,
                previewData: previewPayload,
                mode: this.mode,
                documentType: this.documentType
            };
            this.documentPreviewService.setPreviewData(previewData);

            const urlWithoutQuery = this.router.url.split('?')[0];
            const segments = urlWithoutQuery.split('/').filter(Boolean);
            const baseSegments = segments.slice(0, -1);
            const apercuPath: string[] = baseSegments.length > 0
                ? [...baseSegments, 'action', 'apercu']
                : (this.getBasePath().replace(/^\//, '') + '/action/apercu').split('/').filter(Boolean);

            this.router.navigate(apercuPath, {
                queryParams: { id: this.documentId || undefined },
                queryParamsHandling: 'merge'
            }).then(success => {
                if (!success) {
                    this.documentPreviewService.clear();
                }
            });
        };

        const runRefThenNavigate = () => {
            const data = this.buildPreviewDataForApercu();
            const refTrimmed = (this.documentReference || this.refExterne || '').trim();
            const refEmptyOrPlaceholder = refTrimmed === '' || /^0+$/.test(refTrimmed);
            const prefix = this.getReferencePrefix();
            const typeId = this.typeDocumentIdMap[this.documentType];

            if (refEmptyOrPlaceholder && this.stationId && typeId != null) {
                const uid = Number(this.currentUser?.id);
                if (Number.isFinite(uid) && uid > 0) {
                    this.documentService.getRefCounter(typeId, this.stationId, uid).subscribe({
                        next: (res: any) => {
                            const c = this.extractRefCounterFromApiResponse(res);
                            this.ensureTypeMetaRefCounter(c);
                            const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                            data.reference = ref;
                            data.ref_externe = ref;
                            data.ref_interne = ref;
                            buildAndNavigate(data);
                        },
                        error: () => {
                            const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                            data.reference = ref;
                            data.ref_externe = ref;
                            data.ref_interne = ref;
                            buildAndNavigate(data);
                        }
                    });
                } else {
                    const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                    data.reference = ref;
                    data.ref_externe = ref;
                    data.ref_interne = ref;
                    buildAndNavigate(data);
                }
            } else if (refEmptyOrPlaceholder) {
                const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                data.reference = ref;
                data.ref_externe = ref;
                data.ref_interne = ref;
                buildAndNavigate(data);
            } else {
                buildAndNavigate(data);
            }
        };

        if (this.needsTypeDocumentsApiForRef()) {
            this.documentService.getTypeDocuments().subscribe({
                next: (res) => {
                    this.applyTypeDocumentsFromApi(res);
                    runRefThenNavigate();
                },
                error: () => runRefThenNavigate()
            });
        } else {
            runRefThenNavigate();
        }
    }

    private collectAjoutLignesBetweenProductsForApercu(productIndex: number, nextProductIndex: number): any[] {
        const result: any[] = [];
        let order = 1;
        for (let i = productIndex + 1; i < nextProductIndex; i++) {
            const item = this.items[i];
            if (!item) {
                continue;
            }
            if (item.type === 'text' || item.type === 'heading' ||
                item.type === 'separator' || item.type === 'subtotal') {
                const newLigne: any = {
                    contenu_text: '',
                    rubrique: '',
                    separateur: false,
                    sous_total: 0,
                    order
                };
                if (item.type === 'text') {
                    const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                    newLigne.contenu_text = content;
                } else if (item.type === 'heading') {
                    const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                    newLigne.rubrique = content;
                } else if (item.type === 'separator') {
                    newLigne.separateur = true;
                } else if (item.type === 'subtotal') {
                    const subTotal = (item.subTotal !== undefined && item.subTotal !== null) ? Number(item.subTotal) : 0;
                    newLigne.sous_total = subTotal;
                }
                result.push(newLigne);
                order++;
            }
        }
        return result;
    }

    private getWarehouseSnapshotForPreview(id: number | null | undefined): { id: number; nom: string } | null {
        if (id == null || id === undefined) {
            return null;
        }
        const lcId = this.resolveLcEntrepotIdFromSelection(id) ?? Number(id);
        const pools = this.getEnrichedLcWarehousePools();
        const w = pools.find(
            (wh: any) => Number(wh?.id) === lcId || Number(wh?.lc_id) === lcId
        );
        return w ? { id: Number(w.lc_id ?? w.id), nom: w.nom || w.libelle || '--' } : null;
    }

    private buildPreviewWarehouseFields(): Record<string, any> {
        const isDualEntrepot = this.usesDualEntrepotSelection();
        const entrepotId = isDualEntrepot ? this.selectedWarehouseInitialId : this.selectedWarehouseId;
        const entrepotSnap = this.getWarehouseSnapshotForPreview(entrepotId);
        if (!isDualEntrepot) {
            return {
                entrepot_id: entrepotId ?? null,
                entrepot: entrepotSnap
            };
        }
        const destId = this.selectedWarehouseDestinationId;
        return {
            entrepot_id: entrepotId ?? null,
            entrepot_dest_id: destId ?? null,
            entrepot: entrepotSnap,
            entrepot_destination: this.getWarehouseSnapshotForPreview(destId)
        };
    }

    private buildPreviewCategoriesForApercu(): Array<{ nom: string; titre: string; libelle?: string }> {
        if (this.documentType !== 'FACTURE FOURNISSEUR') {
            return [];
        }
        const lib = (this.selectedCategorie || '').trim();
        if (!lib) {
            return [];
        }
        return [{ nom: lib, titre: lib, libelle: lib }];
    }

    private buildPreviewDataForApercu(): any {
        const isAchat = this.isAchatDocument();
        const productsWithIndex: { item: Item; index: number }[] = [];
        this.items.forEach((item, index) => {
            if (item.type === 'product' && item.designation?.trim()) {
                productsWithIndex.push({ item, index });
            }
        });

        const previewRef = this.refExterne || this.documentReference;
        const previewData = {
            id: this.documentId || null,
            client_id: !isAchat ? this.resolveDocumentClientId(this.selectedClient) : null,
            fournisseur_id: isAchat && this.selectedFournisseur ? this.selectedFournisseur.id : null,
            typeDocument: {titre: this.documentType},
            ...this.buildPreviewWarehouseFields(),
            reference: this.documentReference,
            ref_externe: previewRef,
            ref_interne: previewRef,
            date: this.documentDate,
            date_document: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || '',
            client_data: !isAchat && this.selectedClient ? {
                id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                nom_prenom: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '--',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || '--',
                email: this.getEmailString(this.selectedClient.emails),
                adresse: this.getAdresseString(this.selectedClient.adresses),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fournisseur_data: isAchat && this.selectedFournisseur ? {
                id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '--',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '--',
                email: this.getEmailString(this.selectedFournisseur.emails),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                telephone: this.getTelephoneString(this.selectedFournisseur.telephones)
            } : null,

            projets: this.selectedProject ? [{
                id_projet: this.getProjetCode(),
                titre: this.selectedProject
            }] : [],

            lignesDocument: productsWithIndex.map(({ item: i, index: productIndex }, productIdx) => {
                const nextProductIndex = productIdx < productsWithIndex.length - 1
                    ? productsWithIndex[productIdx + 1].index
                    : this.items.length;
                const ajoutFromItems = this.collectAjoutLignesBetweenProductsForApercu(productIndex, nextProductIndex);
                const ajoutFallback = (i.ajout_ligne && i.ajout_ligne.length > 0)
                    ? i.ajout_ligne.map((ligne: any) => ({
                        contenu_text: ligne.contenu_text || '',
                        rubrique: ligne.rubrique || '',
                        separateur: ligne.separateur === true || ligne.separateur === 1 || ligne.separateur === 'true',
                        sous_total: Number(ligne.sous_total) || 0,
                        order: Number(ligne.order) || 0
                    }))
                    : [];
                const rawAjout = ajoutFromItems.length > 0 ? ajoutFromItems : ajoutFallback;
                const filteredAjout = rawAjout.filter((al: any) =>
                    al.separateur ||
                    (Number(al.sous_total) > 0) ||
                    (al.contenu_text && String(al.contenu_text).trim().length > 0) ||
                    (al.rubrique && String(al.rubrique).trim().length > 0)
                );
                const prixUnitaire = (this.isStockLcDocumentType())
                    ? (Number(i.valeur_unitaire) || 0)
                    : (Number(i.priceHT) || 0);
                const qnt = i.quantity !== null && i.quantity !== undefined ? i.quantity : 0;
                return {
                    libelle: i.designation,
                    qnt: qnt,
                    prix_ht: prixUnitaire,
                    valeur_unitaire: (this.isStockLcDocumentType()) ? prixUnitaire : undefined,
                    tva: Number(i.tva) || 0,
                    total_ht: qnt * prixUnitaire,
                    product_id: i.product_id || null,
                    ajout_ligne: filteredAjout.length > 0
                        ? filteredAjout.map((al: any, idx: number) => ({
                            contenu_text: al.contenu_text || '',
                            rubrique: al.rubrique || '',
                            separateur: !!al.separateur,
                            sous_total: Number(al.sous_total) || 0,
                            order: idx + 1
                        }))
                        : undefined
                };
            }),

            total_ht: this.totals.totalHT,
            total_tva: this.totals.totalTVA,
            total_ttc: this.totals.totalTTC,
            timbre_fiscal: this.getTimbreFiscalEffective(),
            net_payer: this.totals.netAPayer,

            categories: this.buildPreviewCategoriesForApercu(),

            categorie_libelle:
                this.documentType === 'FACTURE FOURNISSEUR' && (this.selectedCategorie || '').trim()
                    ? (this.selectedCategorie as string).trim()
                    : null,

            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            }
        };
        return previewData;
    }

    private isAchatDocument(): boolean {
        return this.documentTypesAchat.has(this.getNormalizedDocumentTypeForTax());
    }

    public shouldShowClient(): boolean {
        if (this.isBonTransfertOrEntrepotTransfert()) {
            return false;
        }
        if (this.isBonSortieDocument()) {
            return false;
        }
        const docType = this.documentType;
        if (
            docType === 'INVENTAIRE' ||
            docType === 'BON TRANSFERT' ||
            docType === 'TRANSFERT' ||
            docType === 'PV ECART'
        ) {
            return false;
        }
        if (this.isLogicielCaisseEntrepotTransfert()) {
            return false;
        }
        if (
            docType === 'COMMANDE FOURNISSEUR' ||
            docType === 'FACTURE FOURNISSEUR' ||
            docType === 'AVOIR FOURNISSEUR' ||
            docType === 'BON RECEPTION' ||
            docType === 'RETOUR FOURNISSEUR'
        ) {
            return false;
        }
        return true;
    }

    public shouldShowFournisseur(): boolean {
        const docType = this.documentType;
        if (
            docType === 'INVENTAIRE' ||
            docType === 'BON TRANSFERT' ||
            docType === 'TRANSFERT' ||
            docType === 'PV ECART'
        ) {
            return false;
        }
        return docType === 'COMMANDE FOURNISSEUR'
            || docType === 'FACTURE FOURNISSEUR'
            || docType === 'AVOIR FOURNISSEUR'
            || docType === 'BON RECEPTION'
            || docType === 'RETOUR FOURNISSEUR';
    }
    public shouldShowEntrepotDestinationPanel(): boolean {
        return this.usesDualEntrepotSelection();
    }

    public shouldAlignDetailsRight(): boolean {
        return (
            !this.shouldShowClient() &&
            !this.shouldShowFournisseur() &&
            !this.shouldShowEntrepotDestinationPanel()
        );
    }

    onDualEntrepotDestinationChange(): void {
        this.logEntrepotDestinationPanelState('ng-select change (avant refresh)', {
            ngSelectValue: this.selectedWarehouseDestinationId,
        });
        this.refreshWarehouseDestinationPanel();
        this.onWarehouseChange();
    }

    /** Réaffiche le ng-select destination (comme « edit » client / fournisseur). */
    editWarehouseDestination(): void {
        if (this.isEntrepotReadonly || this.isEntrepotDestinationReadonly) {
            return;
        }
        this.selectedWarehouseDestinationId = null;
        this.warehouseDestinationDetail = null;
        this.warehouseDestinationEtablissement = null;
        this.isLoadingWarehouseDestinationDetail = false;
        this.onWarehouseChange();
        this.cdr.detectChanges();
    }

    getDestinationWarehouseSelectLabel(item: { nom?: string; code?: string; libelle?: string } | null): string {
        if (!item) {
            return '';
        }
        return this.formatWarehouseNomCode(item);
    }

    getDestinationWarehouseNomCodeDisplay(): string {
        if (this.isLoadingWarehouseDestinationDetail && !this.warehouseDestinationDetail) {
            return 'Chargement…';
        }
        const src = this.warehouseDestinationDetail ?? this.findWarehouseInDestinationList();
        return this.formatWarehouseNomCode(src);
    }

    getDestinationWarehouseAdresseDisplay(): string {
        if (this.isLoadingWarehouseDestinationDetail && !this.warehouseDestinationDetail) {
            return 'Chargement…';
        }
        const src = this.warehouseDestinationDetail ?? this.findWarehouseInDestinationList();
        return this.formatWarehouseAdresseForPanel(src);
    }

    getDestinationEtablissementNomDisplay(): string {
        const etab = this.warehouseDestinationEtablissement;
        if (!etab) {
            return '—';
        }
        const label =
            String(etab.libelle || etab.raison_sociale || '').trim() ||
            this.etablissementOptionLabel(etab);
        return label || '—';
    }

    getDestinationEtablissementMatriculeDisplay(): string {
        const nif = String(this.warehouseDestinationEtablissement?.numero_identification_fiscale ?? '').trim();
        return nif || 'Non renseigné';
    }

    getDestinationEtablissementAdresseDisplay(): string {
        const etab = this.warehouseDestinationEtablissement;
        if (!etab) {
            return '—';
        }
        const formatted = this.formatAdresse({
            adresse: etab.adresse ?? '',
            code_postal: etab.code_postal ?? '',
            region: etab.ville ?? '',
            pays: etab.pays ?? '',
        });
        if (formatted === 'Adresse non renseignée') {
            return 'Non renseigné';
        }
        return formatted.replace(/^,\s*/, '').trim() || 'Non renseigné';
    }

    private findWarehouseInDestinationList(): Record<string, unknown> | null {
        const lcId = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
        if (lcId == null || lcId <= 0) {
            return null;
        }
        const poolNames = [
            'warehousesDestination',
            'allWarehousesEnrichedFull',
            'allWarehouses',
            'warehouses',
        ] as const;
        const pools = [
            this.warehousesDestination,
            this.allWarehousesEnrichedFull,
            this.allWarehouses,
            this.warehouses,
        ];
        for (let i = 0; i < pools.length; i++) {
            const pool = pools[i];
            const w = (pool || []).find(
                (x: any) => Number(x?.id) === lcId || Number(x?.lc_id) === lcId
            );
            if (w && typeof w === 'object') {
                if (DEBUG_ENTREPOT_DESTINATION_PANEL) {
                    console.info('[Document][Entrepôt destination] trouvé dans liste', {
                        pool: poolNames[i],
                        searchedLcId: lcId,
                        rowId: w.id,
                        rowLcId: w.lc_id,
                        rowErpId: w.erp_id,
                        rowNom: w.nom ?? w.libelle,
                        rowCode: w.code_entrepot ?? w.code,
                    });
                }
                return this.normalizeLcWarehouseRowForDestinationPanel(w);
            }
        }
        if (DEBUG_ENTREPOT_DESTINATION_PANEL) {
            console.warn('[Document][Entrepôt destination] aucune ligne liste pour lcId', lcId);
        }
        return null;
    }

    /** Trace id ng-select vs id réellement affiché (détection décalage LC/ERP). */
    private logEntrepotDestinationPanelState(
        phase: string,
        extra?: Record<string, unknown>
    ): void {
        const pvTrace =
            DEBUG_PV_ECART_ENTREPOT && this.documentType === 'PV ECART';
        if (!DEBUG_ENTREPOT_DESTINATION_PANEL && !pvTrace) {
            return;
        }
        const selectedNgModelId = this.selectedWarehouseDestinationId;
        const resolvedLcId = this.resolveLcEntrepotIdFromSelection(selectedNgModelId);
        const detail = this.warehouseDestinationDetail;
        const displayedLcId =
            detail != null
                ? Number(detail['lc_id'] ?? detail['id'])
                : null;
        const idsMatch =
            resolvedLcId != null &&
            displayedLcId != null &&
            Number.isFinite(displayedLcId)
                ? resolvedLcId === displayedLcId
                : null;
        const payload: Record<string, unknown> = {
            phase,
            /** Valeur liée au ng-select (bindValue=id LC). */
            idEntrepotSelectionneNgSelect: selectedNgModelId,
            /** Id LC résolu dans les listes chargées. */
            idEntrepotLcResolu: resolvedLcId,
            /** Id LC porté par warehouseDestinationDetail (affiché). */
            idEntrepotAfficheDetail: Number.isFinite(displayedLcId) ? displayedLcId : null,
            libelleAffiche: detail ? this.formatWarehouseNomCode(detail) : null,
            erpIdSurDetail: detail?.['erp_id'] ?? detail?.['erp_entrepot_id'] ?? null,
            selectionEgaleAffichage: idsMatch,
            ...extra,
        };
        const prefix =
            pvTrace ? '[Document][PV ECART][Entrepôt destination]' : '[Document][Entrepôt destination]';
        if (idsMatch === false) {
            console.warn(`${prefix} ID sélectionné ≠ ID affiché — voir détail`, payload);
        } else {
            console.info(prefix, payload);
        }
    }

    /** Normalise une ligne entrepôt LC pour l’affichage panneau destination. */
    private normalizeLcWarehouseRowForDestinationPanel(row: any): Record<string, unknown> {
        const nom = String(row?.nom ?? row?.libelle ?? '').trim() || `Entrepôt ${row?.id ?? ''}`;
        const codeRaw = row?.code_entrepot ?? row?.code ?? '';
        const code = codeRaw != null ? String(codeRaw).trim() : '';
        const ville = String(row?.ville ?? '').trim();
        const pays = String(row?.pays ?? '').trim();
        const adresseList =
            row?.adresse != null && String(row.adresse).trim()
                ? String(row.adresse).trim()
                : [ville, pays].filter(Boolean).join(' • ');
        return {
            ...row,
            id: Number(row?.lc_id ?? row?.id),
            lc_id: Number(row?.lc_id ?? row?.id),
            nom,
            libelle: nom,
            code,
            code_entrepot: code || null,
            ville,
            pays,
            adresse: adresseList,
        };
    }

    private mapLcEntrepotApiToDestinationPanel(row: EntrepotApiRecord): Record<string, unknown> {
        return this.normalizeLcWarehouseRowForDestinationPanel(row);
    }

    private readWarehouseNomCode(entrepot: unknown): { nom: string; code: string } {
        if (entrepot == null || entrepot === '') {
            return { nom: '--', code: '' };
        }
        if (typeof entrepot === 'string') {
            const s = entrepot.trim();
            if (!s) {
                return { nom: '--', code: '' };
            }
            const sep = s.lastIndexOf(' - ');
            if (sep > 0) {
                const nom = s.slice(0, sep).trim();
                const code = s.slice(sep + 3).trim();
                return { nom: nom || s, code };
            }
            return { nom: s, code: '' };
        }
        const e = entrepot as Record<string, unknown>;
        const nom = String(e['nom'] ?? e['libelle'] ?? '').trim();
        const code = String(e['code'] ?? e['code_entrepot'] ?? e['codeEntrepot'] ?? '').trim();
        if (nom && code && nom.toLowerCase() === code.toLowerCase()) {
            return { nom, code: '' };
        }
        return { nom: nom || code || '--', code: nom ? code : '' };
    }

    private formatWarehouseNomCode(entrepot: unknown): string {
        const { nom, code } = this.readWarehouseNomCode(entrepot);
        if (nom === '--') {
            return '—';
        }
        if (code) {
            return `${nom} - ${code}`;
        }
        return nom;
    }

    private formatWarehouseAdresseForPanel(entrepot: unknown): string {
        if (entrepot == null || entrepot === '') {
            return 'Non renseigné';
        }
        if (typeof entrepot === 'string') {
            const s = entrepot.trim();
            return s || 'Non renseigné';
        }
        const e = entrepot as Record<string, unknown>;
        let street = String(e['adresse'] ?? '').trim();
        if (street.includes('•')) {
            street = '';
        }
        const formatted = this.formatAdresse({
            adresse: street,
            code_postal: e['code_postal'] ?? '',
            region: e['region'] ?? e['ville'] ?? '',
            pays: e['pays'] ?? '',
        });
        if (formatted === 'Adresse non renseignée') {
            return 'Non renseigné';
        }
        return formatted.replace(/^,\s*/, '').trim() || 'Non renseigné';
    }

    private resolveEtablissementForDestinationEntrepot(entrepotId: number): EtablissementRow | null {
        const lcEntrepotId =
            this.resolveLcEntrepotIdFromSelection(entrepotId) ?? Number(entrepotId);
        const link = (this.etablissementEntrepotLinks || []).find(
            (l) => Number(l.entrepot_id) === Number(lcEntrepotId)
        );
        let etabId = link ? Number(link.etablissement_id) : NaN;
        if (!Number.isFinite(etabId) || etabId <= 0) {
            etabId = Number(this.selectedEtablissementDestId) || 0;
        }
        if (etabId > 0) {
            return this.availableEtablissements.find((e) => Number(e.id) === etabId) ?? null;
        }
        return null;
    }

    private applyWarehouseDestinationEtablissementFromDetail(data: Record<string, unknown> | null): void {
        if (!data) {
            this.warehouseDestinationEtablissement = null;
            return;
        }
        const nested = data['etablissement'];
        if (nested && typeof nested === 'object') {
            this.warehouseDestinationEtablissement = nested as EtablissementRow;
            return;
        }
        const id = Number(this.selectedWarehouseDestinationId);
        this.warehouseDestinationEtablissement = Number.isFinite(id)
            ? this.resolveEtablissementForDestinationEntrepot(id)
            : null;
    }

    refreshWarehouseDestinationPanel(): void {
        if (!this.usesDualEntrepotSelection()) {
            this.warehouseDestinationDetail = null;
            this.warehouseDestinationEtablissement = null;
            return;
        }
        if (this.documentType === 'PV ECART') {
            this.refreshPvEcartDestinationPanelFromLcApi();
            return;
        }
        const lcId = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
        this.logEntrepotDestinationPanelState('refresh — début', {
            lcIdDemandeApi: lcId,
        });
        if (lcId == null || lcId <= 0) {
            this.warehouseDestinationDetail = null;
            this.warehouseDestinationEtablissement = null;
            this.isLoadingWarehouseDestinationDetail = false;
            this.cdr.detectChanges();
            return;
        }
        const fromList = this.findWarehouseInDestinationList();
        if (fromList) {
            this.warehouseDestinationDetail = fromList;
            this.applyWarehouseDestinationEtablissementFromDetail(fromList);
            this.logEntrepotDestinationPanelState('refresh — après liste locale', {
                idListeNormalise: fromList['id'],
                lcIdListeNormalise: fromList['lc_id'],
            });
        }
        const finish = (data: Record<string, unknown> | null, source: 'liste' | 'api-lc' | 'repli') => {
            if (data) {
                this.warehouseDestinationDetail = data;
            }
            this.applyWarehouseDestinationEtablissementFromDetail(this.warehouseDestinationDetail);
            if (!this.warehouseDestinationEtablissement && !this.etablissementLinksLoaded) {
                this.loadEtablissementEntrepotLinks(true);
            }
            this.applyWarehouseDestinationEtablissementFromDetail(this.warehouseDestinationDetail);
            this.isLoadingWarehouseDestinationDetail = false;
            this.logEntrepotDestinationPanelState(`refresh — fin (${source})`, {
                idApiLcRecu: data?.['id'],
                lcIdApiRecu: data?.['lc_id'],
            });
            this.cdr.detectChanges();
        };
        if (!this.lcAuth.isReadyForNavigation?.()) {
            finish(fromList, 'liste');
            return;
        }
        this.isLoadingWarehouseDestinationDetail = !fromList;
        this.lcEntrepotService.getEntrepotById(lcId).subscribe({
            next: (row) => {
                const stillSelected = this.resolveLcEntrepotIdFromSelection(
                    this.selectedWarehouseDestinationId
                );
                if (stillSelected !== lcId) {
                    const ignore =
                        this.documentType !== 'PV ECART' ||
                        Number(this.selectedWarehouseDestinationId) !== lcId;
                    if (ignore) {
                        this.logPvEcartEntrepot(
                            'refreshWarehouseDestinationPanel — réponse LC ignorée (sélection changée)',
                            {
                                lcIdDemande: lcId,
                                lcIdSelectionCourante: stillSelected,
                                selectedWarehouseDestinationId: this.selectedWarehouseDestinationId,
                            }
                        );
                        return;
                    }
                }
                const mapped = this.mapLcEntrepotApiToDestinationPanel(row);
                if (DEBUG_ENTREPOT_DESTINATION_PANEL) {
                    console.info('[Document][Entrepôt destination] GET LC /entrepot/id', {
                        lcIdDemande: lcId,
                        idReponseApi: row?.id,
                        libelleReponse: row?.libelle,
                        codeReponse: row?.code_entrepot,
                    });
                }
                finish(mapped, 'api-lc');
            },
            error: (err) => {
                console.warn('[Document][Entrepôt destination] GET LC échec — repli liste', {
                    lcIdDemande: lcId,
                    error: err?.message ?? err,
                });
                finish(fromList ?? this.warehouseDestinationDetail, 'repli');
            },
        });
    }

    private requiresStockUpdate(): boolean {
        const t = this.documentType;
        if (t === 'BON RECEPTION') {
            return this.currentStatutId === this.statutIdMap['Reçu'];
        }
        if (t === 'BON DE LIVRAISON') {
            return this.currentStatutId === this.statutIdMap['Livré'];
        }
        if (t === 'INVENTAIRE') {
            return false;
        }
        if (t === 'BON TRANSFERT' || t === 'TRANSFERT') {
            return false;
        }
        if (t === 'AVOIR FOURNISSEUR') {
            return false;
        }
        return t === 'AVOIR';
    }

    private getMouvementStockDateAndRef(documentId: number | null): { formattedDate: string; referenceDoc: string | null } {
        let formattedDate = this.documentDate || new Date().toISOString().split('T')[0];
        if (!formattedDate.includes('T')) {
            formattedDate = `${formattedDate}T12:00:00Z`;
        }
        const referenceDoc = this.documentReference?.trim() || this.refExterne?.trim() || null;
        return { formattedDate, referenceDoc };
    }

    private extractValeurUnitaireProduitDepuisApi(product: any): number {
        const vu = parseFloat(String(product?.valeur_unitaire ?? '').replace(',', '.'));
        if (Number.isFinite(vu) && vu >= 0) {
            return vu;
        }
        const pa = parseFloat(String(product?.prix_unitaires ?? '').replace(',', '.'));
        if (Number.isFinite(pa) && pa >= 0) {
            return pa;
        }
        return 0;
    }

    private resolveQuantiteStockPourCmup(item: any, product?: any): number {
        const pid = item?.product_id;
        if (!pid) {
            return 0;
        }
        const entrepotId = this.shouldFilterStockByEntrepot() ? this.getEntrepotIdForStockQuantity() : null;
        const cacheKey = this.getStockCacheKey(pid, entrepotId);
        const cached = this.stockQuantitiesCache.get(cacheKey);
        if (cached !== undefined && Number.isFinite(Number(cached))) {
            return Math.max(0, Number(cached));
        }
        if (item?.availableQuantity != null) {
            const q = Number(item.availableQuantity);
            if (Number.isFinite(q)) {
                return Math.max(0, q);
            }
        }
        const p = product ?? {};
        const candidates = [
            p.quantity,
            p.quantite,
            p.stock_quantity,
            p.total_quantity,
            p?.data?.quantity
        ];
        for (const c of candidates) {
            if (c != null && c !== '') {
                const n = Number(c);
                if (Number.isFinite(n)) {
                    return Math.max(0, n);
                }
            }
        }
        return 0;
    }

    private getPrixUnitaireEntreeFactureFournisseurPourCmup(item: any, product?: any): number {
        return resolvePrixEntreeUnitaireForCmup(item, product, this.paramDocBaseCalculPrixAchat);
    }

    private logCmupValeurUnitaireDetail(
        source: 'sauvegarde-approbation' | 'saisie-ligne',
        item: any,
        parts: {
            valeur_unitaire_produit: number;
            quantite_stock: number;
            prix_ht_brut: number;
            remise_pct: number;
            prix_entree_unitaire_net: number;
            quantite_entree: number;
            resultat: number | null;
        }
    ): void {
        const pid = item?.product_id;
        const libelle = (item?.designation && String(item.designation).trim()) || `produit #${pid}`;
        const n =
            parts.valeur_unitaire_produit * parts.quantite_stock +
            parts.prix_entree_unitaire_net * parts.quantite_entree;
        const d = parts.quantite_stock + parts.quantite_entree;

    }

    private computeCmupValeurUnitaireFactureFournisseur(product: any, item: any): number | null {
        const prixEntreeUnitaire = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
        const quantiteEntree =
            item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        const prixHtBrut = Number(item.priceHT) || 0;
        const remisePct = Number(item.remise || 0);
        const valeur_unitaire_precedent = this.extractValeurUnitaireProduitDepuisApi(product);
        const quantite_stock = this.resolveQuantiteStockPourCmup(item, product);
        const rounded = computeCmupWeightedAverage({
            valeurPrecedent: valeur_unitaire_precedent,
            quantiteStock: quantite_stock,
            prixEntreeUnitaire,
            quantiteEntree,
        });
        this.logCmupValeurUnitaireDetail('sauvegarde-approbation', item, {
            valeur_unitaire_produit: valeur_unitaire_precedent,
            quantite_stock,
            prix_ht_brut: prixHtBrut,
            remise_pct: remisePct,
            prix_entree_unitaire_net: prixEntreeUnitaire,
            quantite_entree: quantiteEntree,
            resultat: rounded,
        });
        return rounded;
    }

    private getProductPutMandatoryIds(): { station_id: number; client_id: number } {
        const station_id = Number(this.stationId) || 0;
        const client_id = this.isAchatDocument()
            ? Number(this.selectedFournisseurId) || 0
            : Number(this.selectedClientId ?? this.selectedClient?.id) || 0;
        return { station_id, client_id };
    }

    private updateProductsValeurUnitaireForFactureFournisseur(): void {
        if (this.documentType !== 'FACTURE FOURNISSEUR') {
            return;
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.product_id && i.designation?.trim());
        if (productItems.length === 0) {
            return;
        }
        const putIds = this.getProductPutMandatoryIds();
        const updates: Observable<any>[] = productItems.map((item) =>
            this.productsService.getDetailsProduct(item.product_id!).pipe(
                catchError(() => of({ data: {} } as any)),
                switchMap((res: any) => {
                    const product = res?.data ?? res;
                    const valueToSend = this.computeCmupValeurUnitaireFactureFournisseur(product, item);
                    if (valueToSend === null) {
                        return of(null);
                    }
                    if (!this.paramDocMajPrixAchatProduit) {
                        return this.productsService.updateProductValeurUnitaire(item.product_id!, valueToSend, putIds).pipe(
                            catchError(() => {
                                return this.productsService.getDetailsProduct(item.product_id!).pipe(
                                    switchMap((productRes: any) => {
                                        const productData = productRes?.data ?? productRes;
                                        return this.productsService.updateProduct(
                                            item.product_id!,
                                            {
                                                ...productData,
                                                valeur_unitaire: valueToSend
                                            },
                                            putIds
                                        );
                                    }),
                                    catchError(() => {
                                        this.toastr.warning(
                                            `Mise à jour valeur_unitaire impossible pour un produit (vérifier le backend).`,
                                            '',
                                            { timeOut: 5000 }
                                        );
                                        return of(null);
                                    })
                                );
                            })
                        );
                    }
                    const lignePu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
                    return this.productsService
                        .updateProduct(
                            item.product_id!,
                            {
                                ...product,
                                valeur_unitaire: valueToSend,
                                prix_unitaires: lignePu
                            },
                            putIds
                        )
                        .pipe(
                            catchError(() => {
                                return this.productsService.getDetailsProduct(item.product_id!).pipe(
                                    switchMap((productRes: any) => {
                                        const productData = productRes?.data ?? productRes;
                                        const lu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productData);
                                        return this.productsService.updateProduct(
                                            item.product_id!,
                                            {
                                                ...productData,
                                                valeur_unitaire: valueToSend,
                                                prix_unitaires: lu
                                            },
                                            putIds
                                        );
                                    }),
                                    catchError(() => {
                                        this.toastr.warning(
                                            `Mise à jour valeur_unitaire impossible pour un produit (vérifier le backend).`,
                                            '',
                                            { timeOut: 5000 }
                                        );
                                        return of(null);
                                    })
                                );
                            })
                        );
                })
            )
        );
        forkJoin(updates).subscribe({

            error: () => {
                this.toastr.warning('Erreur lors de la mise à jour de la valeur_unitaire des produits.', '', { timeOut: 5000 });
            }
        });
    }

    /** Bon de sortie : sortie stock LC au clic « Fermer » (approve-vente), pas à la création / Approuver. */
    private shouldApplyLcBonSortieStock(): boolean {
        return false;
    }

    private runPostCreateStockUpdates(
        documentId: number | null,
        onComplete?: () => void,
        pairedBonLivraisonId?: number | null
    ): void {
        const done = () => onComplete?.();
        if (pairedBonLivraisonId) {
            this.updateStockForDocument(pairedBonLivraisonId, done, 'BON DE LIVRAISON');
            return;
        }
        if (this.shouldApplyLcBonSortieStock() && documentId) {
            this.applyLcBonSortieStockAfterDocument(documentId, done);
            return;
        }
        if (this.isBonTransfertFromPvEcart() && documentId) {
            this.applyLcBonTransfertFromPvEcartOnApprove(documentId, done);
            return;
        }
        if (this.documentType === 'RETOUR FOURNISSEUR' && documentId) {
            this.applyLcRetourFournisseurDisponibleStock(documentId, done);
            return;
        }
        if (this.requiresStockUpdate() && documentId) {
            this.updateStockForDocument(documentId, done);
            return;
        }
        done();
    }

    private resolveLcBonTransfertDepartDestForStock(): {
        depart: number | null;
        dest: number | null;
    } {
        let hidden: Record<string, unknown> = {};
        const rawHidden = this.modifiedFournisseurFields as Record<string, unknown>;
        if (rawHidden && typeof rawHidden === 'object') {
            hidden = rawHidden;
        }
        const hiddenDep = Number(hidden[LC_ENTREPOT_HIDDEN_KEY]);
        const hiddenDest = Number(hidden[LC_ENTREPOT_DEST_HIDDEN_KEY]);
        const depSel = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseInitialId);
        const destSel = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
        return {
            depart:
                (Number.isFinite(hiddenDep) && hiddenDep > 0 ? hiddenDep : null) ??
                depSel ??
                null,
            dest:
                (Number.isFinite(hiddenDest) && hiddenDest > 0 ? hiddenDest : null) ??
                destSel ??
                null,
        };
    }

    private buildLcBonTransfertStockLigneFromItem(
        item: Item,
        allowSignedQuantities: boolean
    ): Observable<LcBonReceptionEntreeLigne | null> {
        const qnt = Number(item.quantity ?? item.qnt) || 0;
        if (allowSignedQuantities ? qnt === 0 : qnt <= 0) {
            return of(null);
        }
        return this.buildLcBonSortieStockLigneFromItem(item).pipe(
            map((row) => (row ? { ...row, qnt } : null))
        );
    }

    /** PV validé avec stock déjà régularisé (évite double mouvement sur BT issu PV). */
    private resolvePvEcartWorkflowRegularisation$(): Observable<{
        skipStock: boolean;
        lcIdFromPv: number | null;
    }> {
        const docRecord: Record<string, unknown> = {
            id: this.documentId,
            document_original_id: this.documentOriginalId,
            type_document_id: this.typeDocumentIdMap['BON TRANSFERT'],
        };
        const rootId = resolveTransferWorkflowRootId(docRecord);
        if (rootId == null || rootId <= 0) {
            return of({ skipStock: false, lcIdFromPv: null });
        }
        return this.documentService.getDocumentsByOriginalId(rootId).pipe(
            map((res) => {
                const children = parseConvertedChildrenFromApiResponse(res) as Array<
                    Record<string, unknown>
                >;
                const pv = findPvEcartWithRegularisationApplied(children);
                if (!pv) {
                    return { skipStock: false, lcIdFromPv: null };
                }
                return {
                    skipStock: true,
                    lcIdFromPv: readPvEcartLcTransfertIdFromDoc(pv),
                };
            }),
            catchError(() => of({ skipStock: false, lcIdFromPv: null }))
        );
    }

    private resolveExistingLcTransfertIdForPvEcartBt(documentId: number): number | null {
        return extractLogicielCaisseTransfertId(
            {
                id: documentId,
                hidden_client_fields: this.modifiedClientFields,
                hidden_fournisseur_fields: this.modifiedFournisseurFields,
            },
            documentId
        );
    }

    private patchErpBonTransfertLcLink$(
        lcTransfertId: number,
        numDocument: string | null | undefined
    ): Observable<void> {
        if (this.documentId == null) {
            return throwError(() => new Error('ID document ERP manquant'));
        }
        const payload = this.buildCreatePayload() as Record<string, unknown>;
        this.applyLogicielCaisseEntrepotToPayload(payload);
        let hidden = payload.hidden_client_fields as Record<string, unknown>;
        if (!hidden || typeof hidden !== 'object') {
            hidden = { ...(this.modifiedClientFields as unknown as Record<string, unknown>) };
        } else {
            hidden = { ...hidden };
        }
        hidden.logiciel_caisse_transfert_id = lcTransfertId;
        hidden.stock_transfert_id = lcTransfertId;
        const num = String(numDocument ?? '').trim();
        if (num) {
            hidden.stock_transfert_num_document = num;
        }
        payload.hidden_client_fields = hidden;
        if (this.currentStatutId != null) {
            payload.statut_id = this.currentStatutId;
        }
        return this.documentService
            .update(this.documentId, this.cleanPayload(payload as unknown as DocumentPayload))
            .pipe(map(() => undefined));
    }

    private lcBonTransfertSortieByBarcodeFromPvEcart$(
        documentId: number,
        depart: number,
        dest: number
    ): Observable<unknown> {
        const productItems = this.items.filter(
            (i) => i.type === 'product' && i.designation?.trim() && i.product_id
        );
        if (!productItems.length) {
            return of(null);
        }
        const { referenceDoc } = this.getMouvementStockDateAndRef(documentId);
        const refFallback =
            (referenceDoc && String(referenceDoc).trim()) || `BON TRANSFERT #${documentId}`;
        const docRecord: Record<string, unknown> = {
            id: documentId,
            type_document_id: this.typeDocumentIdMap['BON TRANSFERT'],
            type_initial: this.documentTypeInitialId ?? STOCK_TRANSFER_WORKFLOW_TYPE_IDS.PV_ECART,
            ref_externe: this.refExterne || this.documentReference,
            document_original_id: this.documentOriginalId,
        };

        return resolvePvEcartStockReference$(this.documentService, docRecord, refFallback).pipe(
            switchMap((refDoc) =>
                forkJoin(
                    productItems.map((item) =>
                        this.buildLcBonTransfertStockLigneFromItem(item as Item, true)
                    )
                ).pipe(map((rows) => ({ rows, refDoc })))
            ),
            switchMap(({ rows, refDoc }: { rows: Array<LcBonReceptionEntreeLigne | null>; refDoc: string }) => {
                const lignes = (rows || [])
                    .filter(
                        (r): r is LcBonReceptionEntreeLigne =>
                            !!r &&
                            Number(r.qnt) !== 0 &&
                            !!(r.code_barre || r.ref_interne || r.ref_fabricant || r.product_id)
                    )
                    .map(({ code_barre, ref_interne, ref_fabricant, qnt, libelle, product_id }) => ({
                        code_barre,
                        ref_interne,
                        ref_fabricant,
                        qnt,
                        libelle,
                        product_id,
                    }));
                if (!lignes.length) {
                    return throwError(
                        () =>
                            new Error(
                                'Lignes sans code-barres ni référence LC — stock non mis à jour.'
                            )
                    );
                }
                return this.lcStockReception.bonTransfertSortieByBarcode({
                    entrepot_id: depart,
                    entrepot_dest_id: dest,
                    reference_document: refDoc,
                    from_pv_ecart: true,
                    stock_mode: 'both',
                    lignes,
                });
            })
        );
    }

    /**
     * BT issu PV d'écart — Approuver : POST stock-transferts LC, lien ERP, puis stock barcode.
     */
    private applyLcBonTransfertFromPvEcartOnApprove(documentId: number, onComplete?: () => void): void {
        const { depart, dest } = this.resolveLcBonTransfertDepartDestForStock();
        if (!depart || !dest) {
            this.toastr.warning(
                'Entrepôts LC introuvables — transfert et stock non mis à jour.',
                'Stock',
                { timeOut: 8000 }
            );
            onComplete?.();
            return;
        }
        const productItems = this.items.filter(
            (i) => i.type === 'product' && i.designation?.trim() && i.product_id
        );
        if (!productItems.length) {
            onComplete?.();
            return;
        }

        const existingLcIdBt = this.resolveExistingLcTransfertIdForPvEcartBt(documentId);

        this.lcAuth
            .ensureAuthenticatedSession()
            .pipe(
                switchMap((ok) => {
                    if (!ok) {
                        return throwError(
                            () =>
                                new Error(
                                    'Connectez le module logiciel caisse pour enregistrer le transfert.'
                                )
                        );
                    }
                    return this.resolvePvEcartWorkflowRegularisation$().pipe(
                        map((wf) => ({
                            skipStock: wf.skipStock,
                            lcId:
                                wf.lcIdFromPv ??
                                existingLcIdBt ??
                                null,
                        }))
                    );
                }),
                switchMap(({ skipStock, lcId }) => {
                    const existingLcId = lcId;
                    const body = this.buildLogicielCaisseTransfertSaveBody(false, { depart, dest });
                    if (!body) {
                        return throwError(
                            () => new Error('Entrepôts LC invalides pour le transfert entrepôt.')
                        );
                    }
                    if (body.lignes.length === 0 && existingLcId == null) {
                        return throwError(
                            () =>
                                new Error('Ajoutez au moins une ligne produit avec quantité.')
                        );
                    }
                    const lcSave$ =
                        existingLcId != null
                            ? body.lignes.length > 0
                                ? this.lcStockTransfert.replace(existingLcId, body).pipe(
                                      map((res) => {
                                          const t = res.transfert as { num_document?: string } | undefined;
                                          return {
                                              id: existingLcId,
                                              num_document: t?.num_document ?? this.documentReference,
                                          };
                                      })
                                  )
                                : of({
                                      id: existingLcId,
                                      num_document: this.documentReference,
                                  })
                            : this.lcStockTransfert.create(body);
                    return lcSave$.pipe(map((lcRes) => ({ lcRes, skipStock })));
                }),
                switchMap(({ lcRes, skipStock }) => {
                    this.pvEcartApprovedLcTransfertId = lcRes.id;
                    this.lcStockTransfert.notifyListRefresh();
                    this.toastr.success(
                        lcRes.num_document
                            ? `Transfert entrepôt ${lcRes.num_document} enregistré.`
                            : 'Transfert entrepôt enregistré.',
                        'Bon de transfert (PV écart)'
                    );
                    return this.patchErpBonTransfertLcLink$(lcRes.id, lcRes.num_document).pipe(
                        map(() => ({ lcRes, skipStock })),
                        catchError((err: unknown) => {
                            const msg =
                                err && typeof err === 'object' && (err as Error).message
                                    ? String((err as Error).message)
                                    : 'Échec enregistrement du lien ERP';
                            this.toastr.warning(
                                `Le transfert LC (#${lcRes.id}) a été créé, mais le lien ERP n'a pas pu être enregistré : ${msg}`,
                                'Transfert',
                                { timeOut: 12000 }
                            );
                            return of({ lcRes, skipStock });
                        })
                    );
                }),
                switchMap(({ skipStock }) => {
                    if (skipStock) {
                        this.toastr.info(
                            'Stock déjà régularisé lors de la validation du PV — aucun mouvement supplémentaire.',
                            'Stock'
                        );
                        return of(null);
                    }
                    return this.lcBonTransfertSortieByBarcodeFromPvEcart$(documentId, depart, dest);
                }),
                finalize(() => onComplete?.())
            )
            .subscribe({
                next: (res) => {
                    if (res == null) {
                        return;
                    }
                    if ((res as { already_applied?: boolean })?.already_applied) {
                        this.toastr.info(
                            'Stock déjà mis à jour pour ce bon (idempotence).',
                            'Stock'
                        );
                    } else if ((Number((res as { updated?: number })?.updated) || 0) > 0) {
                        this.toastr.success(
                            `Stock disponible et physique mis à jour pour ${(res as { updated: number }).updated} ligne(s).`,
                            'Bon de transfert (PV écart)'
                        );
                    } else {
                        this.toastr.warning('Aucune ligne de stock modifiée.', 'Stock');
                    }
                    this.stockQuantitiesCache.clear();
                    setTimeout(() => this.reloadStockQuantitiesForAllProducts(), 400);
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    const msg =
                        this.extractDocumentApiErrorMessage(err) ||
                        (err && typeof err === 'object' && (err as Error).message
                            ? String((err as Error).message)
                            : 'Échec approbation bon de transfert (PV écart)');
                    this.toastr.error(msg, 'Stock', { timeOut: 12000 });
                },
            });
    }

    private buildLcBonSortieStockLigneFromItem(item: Item): Observable<LcBonReceptionEntreeLigne | null> {
        const qnt = Number(item.quantity ?? item.qnt) || 0;
        if (qnt <= 0) {
            return of(null);
        }
        const productId = Number(item.product_id);
        const lineRef = String(item.reference ?? '').trim();
        const libelle = String(item.designation ?? '').trim() || null;
        const lineCbRaw = String((item as any).code_barre ?? (item as any).code_bar ?? '')
            .replace(/\s/g, '')
            .trim();

        const pack = (p: any): LcBonReceptionEntreeLigne => {
            const prod = p?.data || p || {};
            const fromMeta = this.buildLcStockMetaFromProduct(
                this.findProductForLcStockMeta(productId, lineRef),
                productId,
                lineRef
            );
            const cb =
                (lineCbRaw && lineCbRaw !== '0' && lineCbRaw !== '-'
                    ? lineCbRaw
                    : null) ||
                (fromMeta?.code_barre
                    ? String(fromMeta.code_barre).replace(/\s/g, '').trim()
                    : null) ||
                String(prod.code_barre ?? prod.code_bar ?? '')
                    .replace(/\s/g, '')
                    .trim() ||
                null;
            const ref =
                (fromMeta?.ref_interne ? String(fromMeta.ref_interne).trim() : null) ||
                String(prod.ref_interne || prod.reference || lineRef || '').trim() ||
                null;
            return {
                code_barre: cb && cb !== '0' && cb !== '-' ? cb : null,
                ref_interne: ref && ref !== '-' && ref !== '—' ? ref : null,
                qnt,
                libelle: libelle || String(prod.nom || '').trim() || null,
                product_id: Number.isFinite(productId) && productId > 0 ? productId : undefined,
            };
        };

        if (lineCbRaw && lineCbRaw !== '0' && lineCbRaw !== '-') {
            return of(pack(null));
        }
        const meta = this.buildLcStockMetaFromProduct(
            this.findProductForLcStockMeta(productId, lineRef),
            productId,
            lineRef
        );
        if (meta?.code_barre || meta?.ref_interne) {
            return of(pack(null));
        }
        if (!Number.isFinite(productId) || productId <= 0) {
            return of(pack(null));
        }
        return this.productsService.getDetailsProduct(productId).pipe(
            map((product) => pack(product)),
            catchError(() => of(pack(null)))
        );
    }

    private applyLcRetourFournisseurDisponibleStock(
        documentId: number,
        onComplete?: () => void
    ): void {
        this.runLcRetourFournisseurStock(documentId, 'disponible', onComplete);
    }

    private applyLcRetourFournisseurPhysiqueStock(
        documentId: number,
        onComplete?: () => void
    ): void {
        this.runLcRetourFournisseurStock(documentId, 'physique', onComplete);
    }

    private applyLcRetourFournisseurAnnulerDisponibleStock(
        documentId: number,
        onComplete?: () => void
    ): void {
        this.runLcRetourFournisseurStock(documentId, 'annuler_disponible', onComplete);
    }

    private runLcRetourFournisseurStock(
        documentId: number,
        phase: 'disponible' | 'physique' | 'annuler_disponible',
        onComplete?: () => void
    ): void {
        const lcEntrepotId = this.resolveLcEntrepotIdForBonSortieStock();
        if (!lcEntrepotId) {
            this.toastr.warning(
                "Entrepôt manquant : le stock n'a pas été mis à jour. Sélectionnez l'entrepôt du retour.",
                'Stock',
                { timeOut: 7000 }
            );
            onComplete?.();
            return;
        }
        const productItems = this.items.filter(
            (i) => i.type === 'product' && i.designation?.trim() && i.product_id
        );
        if (!productItems.length) {
            onComplete?.();
            return;
        }
        const { referenceDoc } = this.getMouvementStockDateAndRef(documentId);
        const refDoc =
            (referenceDoc && String(referenceDoc).trim()) || `RETOUR FOURNISSEUR #${documentId}`;

        forkJoin(productItems.map((item) => this.buildLcBonSortieStockLigneFromItem(item as Item)))
            .pipe(
                switchMap((rows: Array<LcBonReceptionEntreeLigne | null>) => {
                    const lignes = (rows || []).filter(
                        (r): r is LcBonReceptionEntreeLigne =>
                            !!r &&
                            Number(r.qnt) > 0 &&
                            !!(r.code_barre || r.ref_interne || r.product_id)
                    );
                    if (!lignes.length) {
                        return throwError(
                            () =>
                                new Error(
                                    'Aucune ligne exploitable (code-barres / référence produit).'
                                )
                        );
                    }
                    const params = {
                        entrepot_id: lcEntrepotId,
                        reference_document: refDoc,
                        lignes,
                    };
                    if (phase === 'disponible') {
                        return this.lcStockReception.retourFournisseurDisponibleSortie(params);
                    }
                    if (phase === 'physique') {
                        return this.lcStockReception.retourFournisseurPhysiqueSortie(params);
                    }
                    return this.lcStockReception.retourFournisseurAnnulerDisponible(params);
                }),
                finalize(() => onComplete?.())
            )
            .subscribe({
                next: (res) => {
                    if (res?.already_applied) {
                        this.toastr.info('Stock déjà mis à jour pour ce retour (idempotence).', 'Stock');
                    } else if ((res?.updated ?? 0) > 0) {
                        const msg =
                            phase === 'disponible'
                                ? `Stock disponible diminué (${res.updated} ligne(s)).`
                                : phase === 'physique'
                                  ? `Stock physique diminué (${res.updated} ligne(s)).`
                                  : `Stock disponible réintégré (${res.updated} ligne(s)).`;
                        this.toastr.success(msg, 'Retour fournisseur');
                    }
                    this.stockQuantitiesCache.clear();
                    setTimeout(() => this.reloadStockQuantitiesForAllProducts(), 400);
                },
                error: (err) => {
                    this.toastr.error(
                        err?.message || 'Échec mise à jour stock retour fournisseur.',
                        'Stock',
                        { timeOut: 12000 }
                    );
                },
            });
    }

    private applyLcBonSortieStockAfterDocument(documentId: number, onComplete?: () => void): void {
        const lcEntrepotId = this.resolveLcEntrepotIdForBonSortieStock();
        console.log('[BonSortieStock] début applyLcBonSortieStockAfterDocument', {
            documentId,
            lcEntrepotId,
            selectedWarehouseId: this.selectedWarehouseId,
            refExterne: this.refExterne || this.documentReference,
        });

        if (!lcEntrepotId) {
            console.warn('[BonSortieStock] annulé — entrepôt LC introuvable');
            this.toastr.warning(
                "Entrepôt manquant : le stock physique n'a pas été diminué. Sélectionnez l'entrepôt du bon de sortie.",
                'Stock',
                { timeOut: 7000 }
            );
            onComplete?.();
            return;
        }

        const productItems = this.items.filter(
            (i) => i.type === 'product' && i.designation?.trim() && i.product_id
        );
        if (!productItems.length) {
            console.warn('[BonSortieStock] annulé — aucune ligne produit');
            onComplete?.();
            return;
        }

        const { referenceDoc } = this.getMouvementStockDateAndRef(documentId);
        const refDoc =
            (referenceDoc && String(referenceDoc).trim()) || `BON DE SORTIE #${documentId}`;

        forkJoin(productItems.map((item) => this.buildLcBonSortieStockLigneFromItem(item as Item)))
            .pipe(
                switchMap((rows: Array<LcBonReceptionEntreeLigne | null>) => {
                    const lignes = (rows || []).filter(
                        (r): r is LcBonReceptionEntreeLigne =>
                            !!r &&
                            Number(r.qnt) > 0 &&
                            !!(r.code_barre || r.ref_interne || r.product_id)
                    );
                    console.log('[BonSortieStock] lignes préparées', lignes);
                    if (!lignes.length) {
                        return throwError(
                            () =>
                                new Error(
                                    'Lignes sans code-barres, référence ni id produit — stock non mis à jour.'
                                )
                        );
                    }
                    return this.lcStockReception.sortieByBarcode({
                        entrepot_id: lcEntrepotId,
                        reference_document: refDoc,
                        lignes,
                    });
                }),
                finalize(() => onComplete?.())
            )
            .subscribe({
                next: (res) => {
                    console.log('[BonSortieStock] succès', res);
                    if (res?.already_applied) {
                        this.toastr.info(
                            'Stock déjà mis à jour pour ce bon de sortie (idempotence).',
                            'Stock'
                        );
                    } else if ((res?.updated ?? 0) > 0) {
                        const skipped = Array.isArray(res?.skipped) ? res.skipped.length : 0;
                        if (skipped > 0) {
                            this.toastr.warning(
                                `Stock diminué pour ${res.updated} produit(s) ; ${skipped} ligne(s) ignorée(s). Voir la console [BonSortieStock].`,
                                'Stock',
                                { timeOut: 10000 }
                            );
                        } else {
                            this.toastr.success(
                                `Stock physique diminué pour ${res.updated} produit(s).`,
                                'Bon de sortie'
                            );
                        }
                    } else {
                        this.toastr.warning(
                            'Aucune ligne de stock modifiée (updated=0). Voir la console [BonSortieStock].',
                            'Stock',
                            { timeOut: 10000 }
                        );
                    }
                    this.stockQuantitiesCache.clear();
                    setTimeout(() => this.reloadStockQuantitiesForAllProducts(), 400);
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.error('[BonSortieStock] échec', err);
                    const msg =
                        err && typeof err === 'object' && (err as any).message
                            ? String((err as any).message)
                            : 'Échec de la sortie stock';
                    this.toastr.error(msg, 'Stock', { timeOut: 12000 });
                },
        });
    }

    private updateStockForDocument(
        documentId: number,
        onComplete?: () => void,
        stockDocumentTypeOverride?: string
    ): void {
        const docTypeForStock = stockDocumentTypeOverride ?? this.documentType;
        const stockTypeRequiresUpdate = (): boolean => {
            const t = docTypeForStock;
            return (
                t === 'BON DE LIVRAISON' ||
                t === 'BON RECEPTION' ||
                t === 'INVENTAIRE' ||
                t === 'AVOIR'
            );
        };
        if (!stockTypeRequiresUpdate()) {
            return;
        }
        if (docTypeForStock === 'BON TRANSFERT' || docTypeForStock === 'TRANSFERT') {
            return;
        }
        if (
            docTypeForStock === 'BON RECEPTION' &&
            this.currentStatutId !== this.statutIdMap['Reçu']
        ) {
            onComplete?.();
            return;
        }
        // BL : stock seulement si Livré (création Approuver), ou override (BL jumelé facture).
        if (docTypeForStock === 'BON DE LIVRAISON') {
            const isLivre = this.currentStatutId === this.statutIdMap['Livré'];
            const isPairedOverride = stockDocumentTypeOverride === 'BON DE LIVRAISON';
            if (!isLivre && !isPairedOverride) {
                onComplete?.();
                return;
            }
        }
        if (docTypeForStock === 'INVENTAIRE') {
            onComplete?.();
            return;
        }

        const erpWarehouseId = this.resolveWarehouseIdForStockUpdate();
        if (!erpWarehouseId) {
            if (
                docTypeForStock === 'AVOIR' ||
                docTypeForStock === 'AVOIR FOURNISSEUR' ||
                docTypeForStock === 'BON RECEPTION' ||
                docTypeForStock === 'BON DE LIVRAISON'
            ) {
                this.toastr.warning(
                    'Entrepôt manquant : sélectionnez un entrepôt pour mettre à jour le stock.',
                    'Stock',
                    { timeOut: 7000 }
                );
            }
            onComplete?.();
            return;
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);

        if (productItems.length === 0) {
            onComplete?.();
            return;
        }


        const mouvementType = docTypeForStock;
        const stockUpdates: Observable<any>[] = [];

        productItems.forEach((item, index) => {
            const qteRaw = item.quantity ?? item.qnt;
            if (!item.product_id || (qteRaw === null || qteRaw === undefined)) {
                return;
            }

            const quantite = Number(qteRaw) || 0;
            if (docTypeForStock !== 'INVENTAIRE' && quantite === 0) {
                return;
            }

            const productId = item.product_id;
            // Avoir : lignes souvent en négatif (conversion) — prix module stock en valeur absolue
            const prixVenteFromItem = Math.abs(Number(item.priceHT || 0));
            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    let prixVente = prixVenteFromItem;
                    
                    if (prixVente <= 0) {
                        if (productData.result_ht) {
                            prixVente = parseFloat(productData.result_ht);
                        } else if (productData.liste_prix) {
                            const listePrix = Array.isArray(productData.liste_prix) 
                                ? productData.liste_prix[0] 
                                : productData.liste_prix;
                            
                            if (listePrix?.result_ht) {
                                prixVente = parseFloat(listePrix.result_ht);
                            } else if (listePrix?.montant) {
                                prixVente = parseFloat(listePrix.montant);
                            }
                        }
                        if (prixVente <= 0 && productData.prix_unitaires) {
                            prixVente = parseFloat(productData.prix_unitaires);
                        }
                    }

                    if (
                        (docTypeForStock === 'BON RECEPTION' ||
                            docTypeForStock === 'AVOIR FOURNISSEUR' ||
                            docTypeForStock === 'AVOIR') &&
                        prixVente <= 0 &&
                        prixAchat > 0
                    ) {
                        prixVente = prixAchat;
                    }

                    if (
                        prixVente <= 0 &&
                        docTypeForStock !== 'BON RECEPTION' &&
                        docTypeForStock !== 'INVENTAIRE' &&
                        docTypeForStock !== 'AVOIR FOURNISSEUR' &&
                        docTypeForStock !== 'AVOIR'
                    ) {
                        return of(null);
                    }
                    
                    const refInterne =
                        String(
                            productData.ref_interne ||
                                productData.reference ||
                                item.reference ||
                                ''
                        ).trim() || `ERP-${productId}`;
                    const legacyFindProductObservable = this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((existingProduct: any) => {
                            if (existingProduct && existingProduct.id) {
                                const stockProductId = existingProduct.id;
                                return this.stockService.updateProductPrices(stockProductId, prixAchat, prixVente, productId).pipe(
                                    switchMap((updateResponse: any) => {
                                        const updatedStockProductId = updateResponse?.stockProductId || updateResponse?.data?.id || updateResponse?.id || updateResponse?.product?.id || stockProductId;
                                        return of(updatedStockProductId);
                                    }),
                                    catchError((updateError) => {
                                        return of(stockProductId);
                                    })
                                );
                            } else {
                                return this.stockService.createProduct({
                                    id: productId,
                                    ref_interne: refInterne,
                                    nom: productData.nom || item.designation || '',
                                    prix_achat: prixAchat,
                                    prix_vente: prixVente > 0 ? prixVente : Math.max(prixAchat, 0.001)
                                }).pipe(
                                    switchMap((createResponse: any) => {
                                        let stockProductId = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                        
                                        if (!stockProductId) {
                                            return throwError(() => new Error('ID du produit module stock non trouvé dans la réponse de création'));
                                        }
                                        
                                        return of(stockProductId);
                                    }),
                                    catchError((createError) => {
                                        if (createError.status === 400 && createError.error?.existing_product_id) {
                                            const existingStockProductId = createError.error.existing_product_id;
                                            return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                                switchMap((updateResponse: any) => {
                                                    const updatedStockProductId = updateResponse?.stockProductId || updateResponse?.data?.id || updateResponse?.id || updateResponse?.product?.id || existingStockProductId;
                                                    return of(updatedStockProductId);
                                                }),
                                                catchError((updateError) => {
                                                    return of(existingStockProductId);
                                                })
                                            );
                                        }

                                        return throwError(() => createError);
                                    })
                                );
                            }
                        }),
                        catchError((error) => {
                            return throwError(() => error);
                        })
                    );

                    const findProductObservable =
                        docTypeForStock === 'BON RECEPTION'
                            ? this.stockService
                                  .resolveStockTableProductIdFromErpId(productId, {
                                      entrepotIdForZeroStock: erpWarehouseId
                                  })
                                  .pipe(
                                      switchMap((resolvedId) => {
                                          if (resolvedId != null && Number(resolvedId) > 0) {
                                              return of(Number(resolvedId));
                                          }
                                          return legacyFindProductObservable;
                                      }),
                                      catchError(() => legacyFindProductObservable)
                                  )
                            : legacyFindProductObservable;
                    
                    const updatePriceObservable = findProductObservable;

                    return updatePriceObservable.pipe(
                        switchMap((stockProductId: number | null) => {

                            if (!stockProductId) {
                                return of({ success: false, productId: productId, error: 'ID du produit module stock manquant', step: 'stock_product_id_missing' });
                            }
                            
                            const finalStockProductId = stockProductId;
                            if (docTypeForStock === 'INVENTAIRE') {

                                return this.stockService.getStockByProductAndEntrepot(finalStockProductId, erpWarehouseId).pipe(
                                    catchError(() => of({ quantity: 0 })),
                                    switchMap((currentStock: any) => {
                                        const quantityStock = Number(currentStock?.quantity ?? currentStock?.qty ?? 0);
                                        const quantiteSaisie = quantite;
                                        const delta = quantiteSaisie - quantityStock;
                                        if (delta === 0) {
                                            return of({
                                                success: true,
                                                productId: productId,
                                                productLocalId: finalStockProductId,
                                                response: null,
                                                skippedNoDelta: true
                                            });
                                        }
                                        const stockApres = quantityStock + delta;
                                        const { formattedDate, referenceDoc } = this.getMouvementStockDateAndRef(documentId);
                                        return this.stockService.createMouvementStock({
                                            product_id: finalStockProductId,
                                            entrepot_id: erpWarehouseId,
                                            type: 'INVENTAIRE',
                                            quantite: delta,
                                            date: formattedDate,
                                            reference_document: referenceDoc,
                                            document_id: documentId || null,
                                            stock_avant: quantityStock,
                                            stock_apres: stockApres
                                        }).pipe(
                                            map((response: any) => ({
                                                success: true,
                                                productId: productId,
                                                productLocalId: finalStockProductId,
                                                response
                                            })),
                                            catchError((error) => {
                                                return of({
                                                    success: false,
                                                    productId: productId,
                                                    productLocalId: finalStockProductId,
                                                    error
                                                });
                                            })
                                        );
                                    })
                                );
                            }
                            const isBonLivraison = docTypeForStock === 'BON DE LIVRAISON';
                            const isAvoirType =
                                docTypeForStock === 'AVOIR' || docTypeForStock === 'AVOIR FOURNISSEUR';
                            const isAvoirFournisseur = docTypeForStock === 'AVOIR FOURNISSEUR';

                            const quantiteSortieStock = quantite < 0 ? quantite : -quantite;
                            const quantiteMouvement = isAvoirType
                                ? (isAvoirFournisseur ? quantite : -quantite)
                                : isBonLivraison
                                    ? quantiteSortieStock
                                    : quantite;

                            const { formattedDate, referenceDoc } = this.getMouvementStockDateAndRef(documentId);

                            return this.stockService.getStockByProductAndEntrepot(finalStockProductId, erpWarehouseId).pipe(
                                catchError(() => of({ quantity: 0 })),
                                switchMap((currentStock: any) => {
                                    const stockAvant = Number(currentStock?.quantity || 0);
                                    const stockApres = stockAvant + quantiteMouvement;
                                    return this.stockService.createMouvementStock({
                                        product_id: finalStockProductId,
                                        entrepot_id: erpWarehouseId,
                                        type: mouvementType,
                                        quantite: quantiteMouvement,
                                        date: formattedDate,
                                        reference_document: referenceDoc,
                                        document_id: documentId || null,
                                        stock_avant: stockAvant,
                                        stock_apres: stockApres
                                    }).pipe(
                                        catchError((error) => {
                                            throw error;
                                        })
                                    );
                                })
                            );
                        }),
                        catchError((error) => {
                            return of({ success: false, productId: productId, error: error?.error || error?.message || 'Erreur inconnue', step: 'stock_update' });
                        })
                    );
                }),
                catchError((error) => {
                    return of({ success: false, productId: productId, error: error?.error || error?.message || 'Erreur lors de la récupération du produit', step: 'product_fetch' });
                })
            );

            stockUpdates.push(productObservable);
        });
        if (stockUpdates.length > 0) {
            forkJoin(stockUpdates).pipe(
                finalize(() => {
                    if (docTypeForStock === 'BON RECEPTION') {
                        this.invalidateDocumentStockDisplayCache();
                    }
                    onComplete?.();
                })
            ).subscribe({
                next: (results) => {
                    const successResults = results.filter(r => {
                        if (r && typeof r === 'object' && 'success' in r) {
                            return r.success === true;
                        }
                        return r !== null && r !== undefined;
                    });
                    const errorResults = results.filter(r => {
                        if (r && typeof r === 'object' && 'success' in r) {
                            return r.success === false;
                        }
                        return r === null || r === undefined;
                    });

                    const successCount = successResults.length;
                    const errorCount = errorResults.length;

                    if (successCount === productItems.length) {
                        this.toastr.success(`Stock mis à jour pour ${successCount} produit(s)`, 'Succès');
                    } else if (successCount > 0) {
                        this.toastr.warning(`Stock partiellement mis à jour (${successCount}/${productItems.length})`, 'Attention');
                    } else {
                        this.toastr.error(`Aucune mise à jour de stock effectuée (${errorCount} erreur(s))`, 'Erreur');
                    }
                },
                error: (error) => {
                    const errorMessage = error?.error?.message || error?.message || 'Erreur inconnue';
                    this.toastr.error(`Erreur lors de la mise à jour du stock: ${errorMessage}`, 'Erreur');
                }
            });
        } else {
            onComplete?.();
        }
    }

    /** Vide le cache UI stock (document) et recharge après un BR « Reçu ». */
    private invalidateDocumentStockDisplayCache(): void {
        this.stockQuantitiesCache.clear();
        this.selectOptionStockByCacheKey.clear();
        this.selectOptionStockLoadingKeys.clear();
        this.items.forEach((item) => {
            if (item && 'availableQuantity' in item) {
                (item as Item).availableQuantity = undefined;
            }
        });
        this.products.forEach((p) => {
            (p as any).availableQuantity = undefined;
        });
        this.reloadStockQuantitiesForAllProducts();
        if (this.products.length > 0) {
            this.preloadStockQuantitiesForAllProducts();
        }
        this.preloadSelectStockTotalsForDocumentOptions();
        this.cdr.detectChanges();
    }

    private schedulePostDocumentStockAlerts(): void {
        const ids = [
            ...new Set(
                this.items
                    .filter((i) => i.type === 'product' && i.product_id)
                    .map((i) => Number(i.product_id))
            )
        ].filter((id) => !isNaN(id) && id > 0);
        if (ids.length === 0) {
            return;
        }
        const tasks = ids.map((pid) =>
            this.checkLogisticStockAlertForProduct$(pid).pipe(catchError(() => of(undefined)))
        );
        forkJoin(tasks).subscribe();
    }

    private checkLogisticStockAlertForProduct$(erpProductId: number): Observable<void> {
        return forkJoin({
            productRes: this.productsService.getDetailsProduct(erpProductId).pipe(
                catchError(() => of(null))
            ),
            snapshot: this.stockService.getStockAlertSnapshotByErpProductId(erpProductId).pipe(
                catchError(() => of(null))
            )
        }).pipe(
            switchMap(({ productRes, snapshot }) => {
                const product = this.unwrapProductFromApiResponse(productRes);
                if (!product || typeof product !== 'object') {
                    return of(undefined);
                }
                if (!snapshot) {
                    return of(undefined);
                }
                const lines = this.getProductLogisticsInfoArray(product);
                const nom = (product.nom || product.designation || `Produit #${erpProductId}`).toString().trim();
                const stocks = snapshot.stocksByEntrepot ?? [];
                const totalQty = Number(snapshot.totalQuantity ?? 0);
                const hasPerEntrepot = stocks.length > 0;

                for (const line of lines) {
                    const lineEidRaw = line.entrepot_id ?? line.entrepotId ?? line.warehouse_id;
                    const lineEid = Number(lineEidRaw);
                    if (isNaN(lineEid)) {
                        continue;
                    }
                    if (!this.isLogisticAlertEnabledOnLine(line)) {
                        continue;
                    }
                    const minVal = this.parseLogisticMinimum(line);
                    if (!Number.isFinite(minVal)) {
                        continue;
                    }
                    let qty: number;
                    if (hasPerEntrepot) {
                        const stockRow = stocks.find((s) => Number(s.entrepotId) === lineEid);
                        qty = stockRow != null ? Number(stockRow.quantity) : 0;
                    } else {
                        qty = totalQty;
                    }
                    if (!Number.isFinite(qty)) {
                        continue;
                    }
                    const seuilExactAtteint = this.nearlyEqualQty(qty, minVal);
                    const ruptureOuSousSeuil =
                        this.nearlyEqualQty(qty, 0) || (minVal > 0 && qty < minVal);
                    if (!seuilExactAtteint && !ruptureOuSousSeuil) {
                        continue;
                    }
                    const scope = hasPerEntrepot ? `entrepôt ${lineEid}` : 'total (tous entrepôts)';
                    const body = `« ${nom || 'Produit'} » — ${scope} : quantité ${qty}, minimum produit ${minVal}.`;
                    const userId = Number(this.currentUser?.id);
                    const stationId = Number(this.stationId);
                    const clientId = Number(
                        (this.currentUser as any)?.client_id ??
                            (this.currentUser as any)?.clientId ??
                            userId
                    );
                    if (userId && stationId) {
                        this.zone.run(() => {
                            this.appNotifications
                                .create({
                                    client_id: clientId || userId,
                                    station_id: stationId,
                                    user_id: userId,
                                    titre: 'Alerte stock',
                                    message: body,
                                    type: 'stock_minimum',
                                    erp_product_id: erpProductId,
                                    stock_product_id: snapshot.stockProductId ?? null,
                                    stock_id: snapshot.stockTableProductId ?? null,
                                    entrepot_id: lineEid
                                })
                                .subscribe();
                        });
                    }
                }
                return of(undefined);
            }),
            catchError(() => of(undefined))
        );
    }

    private createMouvementsStockForBonTransfert$(documentId: number): Observable<void> {
        if (this.documentType !== 'BON TRANSFERT' || !documentId) {
            return of(undefined);
        }
        if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
            return of(undefined);
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);
        if (productItems.length === 0) {
            return of(undefined);
        }
        const { referenceDoc } = this.getMouvementStockDateAndRef(documentId);
        const perProduct: Observable<any>[] = [];

        productItems.forEach((item) => {
            if (!item.product_id || item.quantity === null || item.quantity === undefined || item.quantity === 0) {
                return;
            }
            const productId = item.product_id;
            const quantite = Number(item.quantity);
            const prixVente = Number(item.priceHT || 0);

            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const refInterne = productData.ref_interne || productData.reference || item.reference || '';
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    const prixVenteStock = prixVente > 0 ? prixVente : (prixAchat > 0 ? prixAchat : 0.01);
                    if (!refInterne) {
                        return of(null);
                    }
                    return this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((stockProduct: any) => {
                            if (stockProduct?.id) {
                                return this.stockService.updateProductPrices(stockProduct.id, prixAchat, prixVenteStock, productId).pipe(
                                    switchMap(() => of(stockProduct.id)),
                                    catchError(() => of(stockProduct.id))
                                );
                            }
                            return this.stockService.createProduct({
                                id: productId,
                                ref_interne: refInterne,
                                nom: productData.nom || item.designation || '',
                                prix_achat: prixAchat,
                                prix_vente: prixVenteStock
                            }).pipe(
                                switchMap((createResponse: any) => {
                                    const id = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                    return id != null ? of(id) : of(null);
                                }),
                                catchError((createError: any) => {
                                    if (createError?.status === 400 && createError?.error?.existing_product_id) {
                                        const existingId = createError.error.existing_product_id;
                                        return this.stockService.updateProductPrices(existingId, prixAchat, prixVenteStock, productId).pipe(
                                            switchMap(() => of(existingId)),
                                            catchError(() => of(existingId))
                                        );
                                    }
                                    return of(null);
                                })
                            );
                        }),
                        switchMap((stockProductId: number | null) => {
                            if (!stockProductId) {
                                return of(null);
                            }
                            const entrepotInitialId = this.selectedWarehouseInitialId!;
                            const entrepotDestinationId = this.selectedWarehouseDestinationId!;
                            return this.stockService.transferStock({
                                entrepot_initial_id: entrepotInitialId,
                                entrepot_dest_id: entrepotDestinationId,
                                product_id: stockProductId,
                                quantity: quantite,
                                document_id: documentId,
                                reference_document: referenceDoc
                            }).pipe(
                                catchError((err) => {
                                    const msg = err?.error?.message || err?.message || 'Erreur transfert de stock';
                                    this.toastr.error(msg, 'Stock — transfert', { timeOut: 8000 });
                                    return of(null);
                                })
                            );
                        }),
                        catchError(() => of(null))
                    );
                }),
                catchError(() => of(null))
            );
            perProduct.push(productObservable);
        });

        if (perProduct.length === 0) {
            return of(undefined);
        }
        return from(perProduct).pipe(
            concatMap((obs) => obs),
            toArray(),
            map((results) => {
                const okCount = results.filter(r => r !== null && r !== undefined).length;
                if (okCount === perProduct.length) {
                    this.toastr.success('Transfert de stock enregistré pour le bon.', 'Stock', { timeOut: 3000 });
                } else if (okCount > 0) {
                    this.toastr.warning(
                        'Bon de transfert : certains mouvements de stock n’ont pas pu être enregistrés (réf. produit, prix, module stock).',
                        'Attention',
                        { timeOut: 6000 }
                    );
                } else {
                    this.toastr.warning(
                        'Bon de transfert : aucun mouvement de stock enregistré (vérifiez les lignes produit et les prix).',
                        'Attention',
                        { timeOut: 6000 }
                    );
                }
                return undefined;
            }),
            catchError((err) => {
                console.error('[Bon transfert] Flux mouvements-stock:', err);
                this.toastr.warning(
                    'Erreur lors de l’enregistrement des mouvements de stock.',
                    'Attention',
                    { timeOut: 5000 }
                );
                return of(undefined);
            })
        );
    }

    private transferStockForDocument(documentId: number): void {
        if (this.documentType !== 'BON TRANSFERT') {
            return;
        }

        if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
            return;
        }

        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);
        productItems.forEach((item, idx) => {
            console.log(`🔄 [transferStockForDocument] Produit ${idx + 1}: product_id=${item.product_id}, quantity=${item.quantity}, designation=${item.designation}`);
        });
        
        if (productItems.length === 0) {
            return;
        }

        const stockTransfers: Observable<any>[] = [];

        productItems.forEach((item, index) => {
            if (!item.product_id || item.quantity === null || item.quantity === undefined || item.quantity === 0) {
                return;
            }

            const productId = item.product_id;
            const quantite = Number(item.quantity);
            const prixVente = Number(item.priceHT || 0);

            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const refInterne = productData.ref_interne || productData.reference || item.reference || '';
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    
                    if (!refInterne) {

                        return of(null);
                    }
                    
                    if (prixVente <= 0) {
                        return of(null);
                    }

                    return this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((stockProduct: any) => {
                            let stockProductId: number | null = null;
                            
                            if (stockProduct && stockProduct.id) {
                                const existingStockProductId = stockProduct.id;

                                return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                    switchMap(() => of(existingStockProductId)),
                                    catchError(() => of(existingStockProductId))
                                );
                            } else {

                                return this.stockService.createProduct({
                                    id: productId,
                                    ref_interne: refInterne,
                                    nom: productData.nom || item.designation || '',
                                    prix_achat: prixAchat,
                                    prix_vente: prixVente
                                }).pipe(
                                    switchMap((createResponse: any) => {
                                        const createdStockProductId = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                        
                                        if (!createdStockProductId) {
                                            return of(null);
                                        }
                                        
                                        return of(createdStockProductId);
                                    }),
                                    catchError((createError) => {
                                        if (createError.status === 400 && createError.error?.existing_product_id) {
                                            const existingStockProductId = createError.error.existing_product_id;
                                            return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                                switchMap(() => of(existingStockProductId)),
                                                catchError(() => of(existingStockProductId))
                                            );
                                        }

                                        return of(null);
                                    })
                                );
                            }
                        }),
                        switchMap((stockProductId: number | null) => {
                            if (!stockProductId) {
                                return of(null);
                            }

                            if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
                                return of(null);
                            }

                            return this.stockService.transferStock({
                                entrepot_initial_id: this.selectedWarehouseInitialId,
                                entrepot_dest_id: this.selectedWarehouseDestinationId,
                                product_id: stockProductId,
                                quantity: quantite
                            }).pipe(
                                catchError((transferError) => {
                                    return of(null);
                                })
                            );
                        }),
                        catchError((error) => {
                            return of(null);
                        })
                    );
                }),
                catchError((error) => {
                    return of(null);
                })
            );

            stockTransfers.push(productObservable);
        });

        if (stockTransfers.length > 0) {
            forkJoin(stockTransfers).subscribe({
                next: (results) => {
                    const successCount = results.filter(r => r !== null && r !== undefined).length;
                    if (successCount === productItems.length) {
                        this.toastr.success(`Stock transféré pour ${successCount} produit(s)`, 'Succès');
                    } else if (successCount > 0) {
                        this.toastr.warning(`Transfert partiel (${successCount}/${productItems.length})`, 'Attention');
                    } else {
                        this.toastr.error('Aucun transfert de stock effectué', 'Erreur');
                    }
                },
                error: (error) => {
                    const errorMessage = error?.error?.message || error?.message || 'Erreur inconnue';
                    this.toastr.error(`Erreur lors du transfert de stock: ${errorMessage}`, 'Erreur');
                }
            });
        } else {
            console.warn('⚠️ [transferStockForDocument] Aucun transfert de stock à effectuer');
        }
    }

    private getProjetCode(): string {
        const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
        return p?.id?.toString() || '';
    }

    addItem(type: 'code_bar' | 'product' | 'text' | 'heading' | 'separator' | 'subtotal'): void {

        const hasClient = (this.selectedClientId !== null && this.selectedClientId !== undefined) || 
                         (this.selectedClient !== null && this.selectedClient !== undefined);
        const hasFournisseur = (this.selectedFournisseurId !== null && this.selectedFournisseurId !== undefined) || 
                               (this.selectedFournisseur !== null && this.selectedFournisseur !== undefined);

        const isStockDocument = this.isStockLcDocumentType();

        if (type === 'product' && !hasClient && !hasFournisseur && !isStockDocument) {
            this.modalRef = this.modalService.open(this.warningModal, {
                ariaLabelledBy: 'modal-warning-title',
                centered: true,
                size: 'sm',
                windowClass: 'warning-modal-centered'
            });
            return;
        }

        switch (type) {
            case 'product':
                this.items.push({
                    type: 'product',
                    designation: '',
                    quantity: 0,
                    reference: '',
                    code_barre: '',
                    priceHT: 0,
                    tva: '0',
                    totalHT: 0
                });
                break;
            case 'text':
                this.items.push({ type: 'text', content: '' });
                break;
            case 'heading':
                this.items.push({ type: 'heading', content: '' });
                break;
            case 'separator':
                this.items.push({ type: 'separator' });
                break;
            case 'subtotal':
                const subTotal = this.calculateSubTotal();
                this.items.push({ type: 'subtotal', subTotal });
                break;
        }

        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
    }

    removeItem(index: number): void {
        if (index < 0 || index >= this.items.length) {
            return;
        }
        const indices = this.resolveProductLineIndicesToRemove(index)
            .filter((i) => i >= 0 && i < this.items.length)
            .sort((a, b) => b - a);
        if (indices.length === 0) {
            return;
        }

        const desKeysToClear = new Set<string>();
        const couleurKeysToClear = new Set<string>();
        for (const i of indices) {
            const it = this.items[i];
            if (it?.type !== 'product') {
                continue;
            }
            desKeysToClear.add(this.getProductLineGroupKey(i));
            couleurKeysToClear.add(this.getProductLineCouleurGroupKey(i));
        }

        for (const i of indices) {
            this.shiftLineMetaMapsForRemove(i);
            this.items.splice(i, 1);
        }

        for (const key of desKeysToClear) {
            this.expandedBarcodeGroups.delete(key);
            this.barcodeGroupLoaded.delete(key);
            delete this.barcodeGroupLoading[key];
            for (const ck of Array.from(this.expandedCouleurGroups)) {
                if (ck.startsWith(`${key}|c:`)) {
                    this.expandedCouleurGroups.delete(ck);
                }
            }
        }
        for (const ck of couleurKeysToClear) {
            this.expandedCouleurGroups.delete(ck);
        }

        this.rebuildProductsForDocumentSelect();
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    /**
     * Delete selon l’affichage :
     * - groupe désignation replié → toutes les lignes du groupe
     * - désignation ouverte, couleur repliée → toutes les lignes de cette couleur
     * - regroupement ouvert (ligne produit visible) → uniquement cette ligne
     */
    private resolveProductLineIndicesToRemove(index: number): number[] {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return [index];
        }

        const desKey = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(desKey);
        if (members.length <= 1) {
            return [index];
        }

        if (!this.expandedBarcodeGroups.has(desKey)) {
            return members.slice();
        }

        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (
            colorMembers.length > 1 &&
            !this.expandedCouleurGroups.has(couleurKey) &&
            this.isProductLineCouleurHead(index)
        ) {
            return colorMembers.slice();
        }

        return [index];
    }

    getRemoveItemTitle(index: number): string {
        const indices = this.resolveProductLineIndicesToRemove(index);
        if (indices.length > 1) {
            const item = this.items[index];
            if (item?.type === 'product' && !this.isProductLineBarcodeGroupExpanded(index)) {
                return `Supprimer le groupement (${indices.length} produits)`;
            }
            if (
                item?.type === 'product' &&
                this.isProductLineBarcodeGroupExpanded(index) &&
                !this.isProductLineCouleurGroupExpanded(index)
            ) {
                return `Supprimer la couleur ${this.getProductLineCouleurNorm(index)} (${indices.length} produits)`;
            }
            return `Supprimer ${indices.length} lignes`;
        }
        return 'Supprimer';
    }

    private buildLigneDocumentAttributsProduit(row: any, barcodePickerProduct?: any | null): {
        code_bar: string | null;
        ref_interne: string | null;
        ref_fabricant: string | null;
        couleur: string | null;
        taille: string | null;
    } {
        const rawCb = row?.code_barre ?? row?.code_bar;
        const cbTrim = rawCb != null ? String(rawCb).trim() : '';
        const code_bar = cbTrim === '' || cbTrim === '0' ? null : cbTrim;

        const rawRefInterne = row?.ref_interne ?? row?.reference;
        const refTrim = rawRefInterne != null ? String(rawRefInterne).trim() : '';
        const ref_interne = refTrim === '' || refTrim === '-' ? null : refTrim;

        const pickRefFab = barcodePickerProduct
            ? this.normalizeRefFabricantForSelect(
                  (barcodePickerProduct as any)?.ref_fabricant ??
                      (barcodePickerProduct as any)?.ref_fabriquant
              )
            : '';
        const rowRefFab = this.normalizeRefFabricantForSelect(
            (row as any)?.ref_fabricant ?? (row as any)?.ref_fabriquant
        );
        const ref_fabricant = rowRefFab || pickRefFab || null;

        const rowCt = this.extractCouleurTailleFromProductLike(row);
        const pickCt = barcodePickerProduct
            ? this.extractCouleurTailleFromProductLike(barcodePickerProduct)
            : { couleur: '', taille: '' };
        const couleurStr = rowCt.couleur || pickCt.couleur;
        const tailleStr = rowCt.taille || pickCt.taille;
        const couleur = couleurStr !== '' ? couleurStr : null;
        const taille = tailleStr !== '' ? tailleStr : null;

        return { code_bar, ref_interne, ref_fabricant, couleur, taille };
    }

    private prepareLignesDocumentForSave(): any[] {
        if (
            this.documentType === 'PV ECART' &&
            this.pvEcartLineViewFromLcDetail &&
            this.pvEcartErpLignesForSave?.length
        ) {
            return JSON.parse(JSON.stringify(this.pvEcartErpLignesForSave));
        }
        try {
            this.items.forEach((_, idx) => this.hydrateItemVariantFieldsFromBarcodePicker(idx));
            const itemsCopy = JSON.parse(JSON.stringify(this.items));
            const productsWithIndex: Array<{product: any, index: number}> = [];
            itemsCopy.forEach((item: any, index: number) => {
                if (item.type === 'product' && item.designation?.trim()) {
                    productsWithIndex.push({ product: item, index });
                    item.ajout_ligne = [];
                }
            });

            
            if (productsWithIndex.length === 0) {
                return [];
            }
            productsWithIndex.forEach(({product, index: productIndex}, productIdx: number) => {
                const nextProductIndex = productIdx < productsWithIndex.length - 1 
                    ? productsWithIndex[productIdx + 1].index 
                    : itemsCopy.length;


                let order = 1;
                for (let i = productIndex + 1; i < nextProductIndex; i++) {
                    const item = itemsCopy[i];
                    
                    if (!item) {
                        continue;
                    }
                    if (item.type === 'text' || item.type === 'heading' || 
                        item.type === 'separator' || item.type === 'subtotal') {
                        const newLigne: any = {
                            contenu_text: '',
                            rubrique: '',
                            separateur: false,
                            sous_total: 0,
                            order: order
                        };

                        if (item.type === 'text') {
                            const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                            newLigne.contenu_text = content;
                        } else if (item.type === 'heading') {
                            const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                            newLigne.rubrique = content;
                        } else if (item.type === 'separator') {
                            newLigne.separateur = true;
                        } else if (item.type === 'subtotal') {
                            const subTotal = (item.subTotal !== undefined && item.subTotal !== null) ? Number(item.subTotal) : 0;
                            newLigne.sous_total = subTotal;
                        }

                        product.ajout_ligne.push(newLigne);
                        order++;
                    }
                }
            });
            const result = productsWithIndex.map(({product: i, index: productIndex}) => {
                const sourceItem = this.items[productIndex];
                const prixUnitaire = (this.isStockLcDocumentType())
                    ? Number(i.valeur_unitaire || 0)
                    : Number(i.priceHT || 0);
                const remiseValue = i.remise !== undefined && i.remise !== null ? Number(i.remise) : 0;
                const qnt = i.quantity !== null && i.quantity !== undefined ? Number(i.quantity) : 0;
                const htBrut = qnt * prixUnitaire;
                const montantRemise = remiseValue > 0 ? htBrut * (remiseValue / 100) : 0;
                const htNet = sourceItem?.htNet != null ? Number(sourceItem.htNet) : (htBrut - montantRemise);

                const montantTVA = sourceItem?.montantTVA != null ? Number(sourceItem.montantTVA) : 0;
                const ttcLigne = sourceItem?.ttcLigne != null ? Number(sourceItem.ttcLigne) : 0;
                const prixHT = (this.isStockLcDocumentType())
                    ? prixUnitaire
                    : (Number((i as any).prixUnitaireRef) || prixUnitaire);
                const description = this.productDescriptions[productIndex] || '';
                const taxesProduit = (sourceItem && (sourceItem as any)['taxesProduit']) ? (sourceItem as any)['taxesProduit'] : (i['taxesProduit'] || []);
                const taxeIds = taxesProduit
                    .map((taxe: any) => this.getTaxIdForPayload(taxe))
                    .filter((id: number | null): id is number => id !== null && id !== undefined);
                const taxeArray = taxesProduit
                    .map((taxe: any) => this.getTaxObjectForPayload(taxe))
                    .filter((t: any): t is { id: number; taxes_id: number; nom: string; label: string } => t != null);
                let ajoutLignes: any[] | undefined = undefined;
                if (i.ajout_ligne && Array.isArray(i.ajout_ligne) && i.ajout_ligne.length > 0) {


                    ajoutLignes = i.ajout_ligne
                        .map((ligne: any, idx: number) => {
                            const ajoutLigne: any = {
                                contenu_text: (ligne.contenu_text !== undefined && ligne.contenu_text !== null) ? String(ligne.contenu_text) : '',
                                rubrique: (ligne.rubrique !== undefined && ligne.rubrique !== null) ? String(ligne.rubrique) : '',
                                separateur: ligne.separateur === true || ligne.separateur === 1 || ligne.separateur === 'true',
                                sous_total: (ligne.sous_total !== undefined && ligne.sous_total !== null) ? Number(ligne.sous_total) : 0,
                                order: (ligne.order !== undefined && ligne.order !== null) ? Number(ligne.order) : (idx + 1)
                            };
                            return ajoutLigne;
                        })
                        .filter((al: any) => {
                            const hasContent = al.separateur || 
                                al.sous_total > 0 || 
                                (al.contenu_text && al.contenu_text.trim().length > 0) || 
                                (al.rubrique && al.rubrique.trim().length > 0);

                            return hasContent;
                        });
                    if (ajoutLignes.length > 0) {
                        ajoutLignes.forEach((al: any, idx: number) => {
                            al.order = idx + 1;
                        });
                    } else {
                        ajoutLignes = undefined;

                    }
                } else {
                    console.log(`ℹ️ [prepareLignesDocumentForSave] Aucune ajout_ligne pour "${i.designation}"`);
                }

                const rowForMeta = sourceItem || i;
                const attrsLigne = this.buildLigneDocumentAttributsProduit(
                    rowForMeta,
                    this.barcodePickerModel[productIndex]
                );
                const ligneDoc: any = {
                    libelle: i.designation.trim(),
                    qnt: qnt,
                    prix_ht: prixHT.toFixed(3),
                    tva: Number(i.tva) || 0,
                    product_id: i.product_id || null,
                    taxe_id: taxeIds.length > 0 ? (taxeIds.length === 1 ? taxeIds[0] : taxeIds) : null,
                    taxe_ids: taxeIds,
                    taxe: taxeArray,
                    remise: remiseValue,
                    reference: attrsLigne.ref_interne ?? i.reference ?? null,
                    code_bar: attrsLigne.code_bar,
                    ref_interne: attrsLigne.ref_interne,
                    ref_fabricant: attrsLigne.ref_fabricant,
                    couleur: attrsLigne.couleur,
                    taille: attrsLigne.taille,
                    total_ht: Number(htNet).toFixed(3),
                    montant_tva: Number(montantTVA).toFixed(3),
                    ttc_ligne: Number(ttcLigne).toFixed(3)
                };
                if (this.isStockLcDocumentType()) {
                    ligneDoc.valeur_unitaire = prixUnitaire.toFixed(3);
                } else if (this.documentType === 'FACTURE FOURNISSEUR') {
                    ligneDoc.prix_achat = prixUnitaire.toFixed(3);
                } else {
                    if (this.isAchatDocument()) {
                        ligneDoc.prix_achat = prixUnitaire.toFixed(3);
                    } else {
                        ligneDoc.prix_vente = prixUnitaire.toFixed(3);
                    }
                }
                if (ajoutLignes !== undefined && ajoutLignes !== null && ajoutLignes.length > 0) {
                    ligneDoc.ajout_ligne = ajoutLignes;
                } else {
                    ligneDoc.ajout_ligne = [];

                }
                if (description && description.trim()) {
                    ligneDoc.description = description.trim();
                }

                return ligneDoc;
            });

            return result;
        } catch (error) {
            this.items.forEach((_, idx) => this.hydrateItemVariantFieldsFromBarcodePicker(idx));
            return this.items
                .map((i, idx) => ({ i, idx }))
                .filter(({ i }) => i.type === 'product' && i.designation?.trim())
                .map(({ i, idx }) => {
                    const taxesProduit = i['taxesProduit'] || [];
                    const taxeIds = taxesProduit
                        .map((taxe: any) => this.getTaxIdForPayload(taxe))
                        .filter((id: number | null): id is number => id !== null && id !== undefined);
                    const taxeArray = taxesProduit
                        .map((taxe: any) => this.getTaxObjectForPayload(taxe))
                        .filter((t: any): t is { id: number; taxes_id: number; nom: string; label: string } => t != null);
                    const qnt = i.quantity !== null && i.quantity !== undefined ? Number(i.quantity) : 0;
                    const prixUnitaireFallback = Number(i.priceHT || 0);
                    const prixUnitaireRefFallback = Number((i as any).prixUnitaireRef);
                    const remiseFallback = Number(i.remise || 0);
                    const htBrutFallback = qnt * prixUnitaireFallback;
                    const montantRemiseFallback = remiseFallback > 0 ? htBrutFallback * (remiseFallback / 100) : 0;
                    const htNet = i.htNet != null ? Number(i.htNet) : (htBrutFallback - montantRemiseFallback);
                    const montantTVA = i.montantTVA != null ? Number(i.montantTVA) : 0;
                    const ttcLigne = i.ttcLigne != null ? Number(i.ttcLigne) : 0;
                    const prixHtFallback = (this.isStockLcDocumentType())
                        ? prixUnitaireFallback
                        : (prixUnitaireRefFallback || prixUnitaireFallback);
                    const attrsFb = this.buildLigneDocumentAttributsProduit(i, this.barcodePickerModel[idx]);
                    const out: any = {
                        libelle: i.designation!.trim(),
                        qnt: qnt,
                        prix_ht: prixHtFallback.toFixed(3),
                        tva: Number(i.tva) || 0,
                        product_id: i.product_id || null,
                        taxe_id: taxeIds.length > 0 ? (taxeIds.length === 1 ? taxeIds[0] : taxeIds) : null,
                        taxe_ids: taxeIds,
                        taxe: taxeArray,
                        remise: i.remise || 0,
                        reference: attrsFb.ref_interne ?? i.reference ?? null,
                        code_bar: attrsFb.code_bar,
                        ref_interne: attrsFb.ref_interne,
                        ref_fabricant: attrsFb.ref_fabricant,
                        couleur: attrsFb.couleur,
                        taille: attrsFb.taille,
                        total_ht: Number(htNet).toFixed(3),
                        montant_tva: Number(montantTVA).toFixed(3),
                        ttc_ligne: Number(ttcLigne).toFixed(3),
                        ajout_ligne: i.ajout_ligne && i.ajout_ligne.length > 0 ? i.ajout_ligne.map((ligne: any) => ({
                            contenu_text: ligne.contenu_text || '',
                            rubrique: ligne.rubrique || '',
                            separateur: ligne.separateur || false,
                            sous_total: Number(ligne.sous_total) || 0,
                            order: Number(ligne.order) || 0
                        })) : undefined
                    };
                    if (!this.isStockLcDocumentType()) {
                        if (this.isAchatDocument()) {
                            out.prix_achat = prixUnitaireFallback.toFixed(3);
                        } else {
                            out.prix_vente = prixUnitaireFallback.toFixed(3);
                        }
                    }
                    return out;
                });
        }
    }

    moveItemToFirst(index: number): void {
        if (index <= 0 || index >= this.items.length) {
            return;
        }
        this.moveDocumentLine(index, 0);
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.markForCheck();
    }
    draggedIndex: number | null = null;

    onDragStart(event: DragEvent, index: number): void {
        this.draggedIndex = index;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/html', index.toString());
        }
        if (event.target) {
            (event.target as HTMLElement).style.opacity = '0.5';
        }
    }

    onDragEnd(event: DragEvent): void {
        if (event.target) {
            (event.target as HTMLElement).style.opacity = '1';
        }
        this.draggedIndex = null;
    }

    onDragOver(event: DragEvent, index: number): void {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
        }
    }

    onDrop(event: DragEvent, dropIndex: number): void {
        event.preventDefault();
        if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
            return;
        }

        this.moveDocumentLine(this.draggedIndex, dropIndex);

        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.markForCheck();
        this.draggedIndex = null;
    }

    onDragEnter(event: DragEvent): void {
        event.preventDefault();
    }

    calculateSubTotal(): number {
        const subTotal = this.items
            .filter(item => item.type === 'product' && item.designation)
            .reduce((sum, item) => sum + (item.totalHT || 0), 0);
        return subTotal;
    }

    calculateTotal(index: number): void {
        const item = this.items[index];
        if (item.type === 'product' && item.designation) {
            if ((this.isStockLcDocumentType()) && item.product_id && item.quantity) {
                if (this.erpBonTransfertUsesLocalUnitPriceOnly()) {
                    const product = this.products.find((p) => p.id === item.product_id);
                    if (product) {
                        this.applyStockLcUnitPriceToItemFromProduct(index, product);
                    } else {
                        this.calculateLine(index);
                    }
                    this.calculateTotals();
                } else {
                this.calculateAveragePurchasePrice(index, item);
                }
                this.updateApproveButtonState();
                this.refreshFeatherIcons();

                if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                    const q = parseFloat(String(item.quantity ?? 0)) || 0;
                    const cacheKey = this.getStockCacheKey(item.product_id, this.selectedWarehouseId);
                    this.stockQuantitiesCache.set(cacheKey, q);
                }
                return;
            }
            if (
                (this.documentType === 'FACTURE FOURNISSEUR' || this.documentType === 'BON RECEPTION') &&
                item.product_id &&
                item.quantity != null &&
                item.quantity !== undefined
            ) {
                this.calculateValeurUnitaireFactureFournisseur(index, item);
                return;
            }
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
        }
    }

    private calculateValeurUnitaireFactureFournisseur(index: number, item: any): void {
        if (!item.product_id || !this.stationId) {
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
            return;
        }
        const productHintListe = this.products.find((p) => p.id === item.product_id);
        const prixEntreeInitial = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productHintListe);
        const quantiteEntree = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        if (quantiteEntree <= 0) {
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
            return;
        }
        const valeurUnitaireBase = (item as any).valeurUnitaireBase;
        const hasBase = valeurUnitaireBase != null;
        const persistCmupOnProductCatalog = this.documentType === 'FACTURE FOURNISSEUR';
        const doApplyAndPatch = (
            valeur_unitaire_nouveau: number,
            _valeur_unitaire_precedent: number,
            _quantite_stock: number,
            productSnapshot?: any
        ) => {
            if (!persistCmupOnProductCatalog) {
                this.applyValeurUnitaireAndRefresh(index, item, valeur_unitaire_nouveau);
                return;
            }
            const valueToSend = Number(Number(valeur_unitaire_nouveau).toFixed(3));
            const putIds = this.getProductPutMandatoryIds();
            const applyLocal = () => this.applyValeurUnitaireAndRefresh(index, item, valeur_unitaire_nouveau);

            const doFullProductPut = (pd: any) => {
                const productData = pd?.data ?? pd;
                const lignePu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productData);
                return this.productsService.updateProduct(
                    item.product_id!,
                    {
                        ...productData,
                        valeur_unitaire: valueToSend,
                        prix_unitaires: lignePu
                    },
                    putIds
                );
            };

            if (!this.paramDocMajPrixAchatProduit) {
                this.productsService
                    .updateProductValeurUnitaire(item.product_id!, valueToSend, putIds)
                    .pipe(
                        catchError(() =>
                            this.productsService.getDetailsProduct(item.product_id!).pipe(
                                switchMap((productRes: any) => {
                                    const productData = productRes?.data ?? productRes;
                                    return this.productsService.updateProduct(
                                        item.product_id!,
                                        {
                                            ...productData,
                                            valeur_unitaire: valueToSend
                                        },
                                        putIds
                                    );
                                }),
                                catchError(() => {
                                    this.toastr.warning(
                                        'Erreur lors de la mise à jour de la valeur_unitaire du produit.',
                                        '',
                                        { timeOut: 5000 }
                                    );
                                    return of(null);
                                })
                            )
                        )
                    )
                    .subscribe({ next: () => applyLocal() });
                return;
            }

            const src$ =
                productSnapshot != null
                    ? doFullProductPut(productSnapshot)
                    : this.productsService.getDetailsProduct(item.product_id!).pipe(switchMap((res) => doFullProductPut(res)));
            src$
                .pipe(
                    catchError(() =>
                        this.productsService.getDetailsProduct(item.product_id!).pipe(
                            switchMap((productRes: any) => doFullProductPut(productRes)),
                            catchError(() => {
                                this.toastr.warning(
                                    'Erreur lors de la mise à jour de la valeur_unitaire du produit.',
                                    '',
                                    { timeOut: 5000 }
                                );
                                return of(null);
                            })
                        )
                    )
                )
                .subscribe({ next: () => applyLocal() });
        };
        if (hasBase) {
            const valeur_unitaire_precedent = Number(valeurUnitaireBase) || 0;
            const quantite_stock = this.resolveQuantiteStockPourCmup(item);
            const prixEntree = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productHintListe);
            const denom = quantite_stock + quantiteEntree;
            const valeur_unitaire_nouveau =
                denom > 0
                    ? (valeur_unitaire_precedent * quantite_stock + prixEntree * quantiteEntree) / denom
                    : prixEntree;
            const roundedVu = Number(valeur_unitaire_nouveau.toFixed(3));
            this.logCmupValeurUnitaireDetail('saisie-ligne', item, {
                valeur_unitaire_produit: valeur_unitaire_precedent,
                quantite_stock,
                prix_ht_brut: Number(item.priceHT) || 0,
                remise_pct: Number(item.remise || 0),
                prix_entree_unitaire_net: prixEntree,
                quantite_entree: quantiteEntree,
                resultat: roundedVu
            });
            doApplyAndPatch(roundedVu, valeur_unitaire_precedent, quantite_stock, productHintListe);
            return;
        }
        this.productsService
            .getDetailsProduct(item.product_id)
            .pipe(
                catchError(() => of({ valeur_unitaire: 0, quantity: 0 } as any)),
                map((res: any) => {
                    const product = res?.data ?? res;
                    const prixEntree = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
                    const valeur_unitaire_precedent = this.extractValeurUnitaireProduitDepuisApi(product);
                    const quantite_stock = this.resolveQuantiteStockPourCmup(item, product);
                    (item as any).valeurUnitaireBase = valeur_unitaire_precedent;
                    (item as any).quantiteStockBase = quantite_stock;
                    const denom = quantite_stock + quantiteEntree;
                    const valeur_unitaire_nouveau =
                        denom > 0
                            ? (valeur_unitaire_precedent * quantite_stock + prixEntree * quantiteEntree) / denom
                            : prixEntree;
                    const roundedVu = Number(valeur_unitaire_nouveau.toFixed(3));
                    return {
                        valeur_unitaire_nouveau: roundedVu,
                        valeur_unitaire_precedent,
                        quantite_stock,
                        productSnapshot: product,
                        prixEntree
                    };
                })
            )
            .subscribe({
                next: ({ valeur_unitaire_nouveau, valeur_unitaire_precedent, quantite_stock, productSnapshot, prixEntree }) => {
                    this.logCmupValeurUnitaireDetail('saisie-ligne', item, {
                        valeur_unitaire_produit: valeur_unitaire_precedent,
                        quantite_stock,
                        prix_ht_brut: Number(item.priceHT) || 0,
                        remise_pct: Number(item.remise || 0),
                        prix_entree_unitaire_net: prixEntree,
                        quantite_entree: quantiteEntree,
                        resultat: valeur_unitaire_nouveau
                    });
                    doApplyAndPatch(valeur_unitaire_nouveau, valeur_unitaire_precedent, quantite_stock, productSnapshot);
                },
                error: () => {
                    const valeur_unitaire_nouveau = prixEntreeInitial;

                    if (index >= 0 && index < this.items.length && this.items[index]) {
                        this.items[index].valeur_unitaire = valeur_unitaire_nouveau;
                        (this.items[index] as any).valeurUnitaireIsMoyennePonderee = false;
                    }
                    item.valeur_unitaire = valeur_unitaire_nouveau;
                    (item as any).valeurUnitaireIsMoyennePonderee = false;
                    this.calculateLine(index);
                    this.calculateTotals();
                    this.updateApproveButtonState();
                    this.refreshFeatherIcons();
                    this.cdr.detectChanges();
                }
            });
    }

    private applyValeurUnitaireAndRefresh(index: number, item: any, valeur_unitaire_nouveau: number): void {
        if (index >= 0 && index < this.items.length && this.items[index]) {
            this.items[index].valeur_unitaire = valeur_unitaire_nouveau;
            (this.items[index] as any).valeurUnitaireIsMoyennePonderee = true;
        }
        item.valeur_unitaire = valeur_unitaire_nouveau;
        (item as any).valeurUnitaireIsMoyennePonderee = true;
        this.calculateLine(index);
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    private calculateAveragePurchasePrice(index: number, item: any): void {
        if (!item.product_id || !this.stationId) {
            return;
        }
        const product = this.products.find(p => p.id === item.product_id);
        if (!product) {
            return;
        }

        const valeurModifieeUtilisateur = item.valeur_unitaire;
        const valeurUnitaireProduit = product.valeur_unitaire;
        const prixUnitairesProduit = product.prix_unitaires;
        const valeurProduitBackend = valeurUnitaireProduit || prixUnitairesProduit || 0;

        const valeurInitiale = (valeurModifieeUtilisateur && valeurModifieeUtilisateur > 0) 
            ? valeurModifieeUtilisateur 
            : valeurProduitBackend;
        const quantiteEntree = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        if (quantiteEntree === 0) {
            this.updateValeurUnitaire(index, item, valeurInitiale);
            return;
        }

        this.documentService.calculateValeurUnitaire(
            item.product_id,
            quantiteEntree,
            this.selectedWarehouseId || undefined,
            this.stationId,
            valeurInitiale
        ).pipe(
            catchError((error) => {
                this.stockService.getProductByProductId(item.product_id).pipe(
                    switchMap((stockProduct: any) => {
                        
                        if (!stockProduct || !stockProduct.id) {
                            return of({ quantiteEnStock: 0, valeurPrecedente: valeurInitiale });
                        }
                        
                        const stockProductId = stockProduct.id;
                        const entrepotId = this.selectedWarehouseId;

                        if (entrepotId) {
                            return this.stockService.getStockByProductAndEntrepot(stockProductId, entrepotId).pipe(
                                map((stock: any) => {
                                    const quantiteEnStock = Number(stock?.quantity || 0);
                                    const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                    const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                    const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                    return { quantiteEnStock, valeurPrecedente };
                                }),
                                catchError((error) => {
                                    return this.stockService.getTotalStockByProduct(stockProductId).pipe(
                                        map((totalQuantity: number) => {
                                            const quantiteEnStock = totalQuantity || 0;
                                            const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                            const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                            const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                            return { quantiteEnStock, valeurPrecedente };
                                        })
                                    );
                                })
                            );
                        } else {
                            return this.stockService.getTotalStockByProduct(stockProductId).pipe(
                                map((totalQuantity: number) => {
                                    const quantiteEnStock = totalQuantity || 0;
                                    const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                    const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                    const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                    return { quantiteEnStock, valeurPrecedente };
                                })
                            );
                        }
                    }),
                    catchError(() => {
                        return of({ quantiteEnStock: 0, valeurPrecedente: valeurInitiale });
                    })
                ).subscribe({
                    next: (result: { quantiteEnStock: number, valeurPrecedente: number }) => {
                        const { quantiteEnStock, valeurPrecedente } = result;
                        const quantiteGlobale = quantiteEnStock + quantiteEntree;

                        let valeurCalculee: number;
                        if (quantiteGlobale <= 0) {
                            valeurCalculee = valeurInitiale;
                        } else {
                            const produit1 = valeurPrecedente * quantiteEnStock;
                            const produit2 = valeurInitiale * quantiteEntree;
                            const somme = produit1 + produit2;
                            const valeurMoyenne = somme / quantiteGlobale;
                            valeurCalculee = Number(valeurMoyenne.toFixed(3));

                        }
                        this.updateValeurUnitaire(index, item, valeurCalculee);
                    }
                });
                
                return of(null);
            })
        ).subscribe({
            next: (response: any) => {
                if (!response) {
                    return;
                }

                const valeurCalculeeBackend = response?.data?.valeur_unitaire || response?.valeur_unitaire || response?.data || response;
                const valeurCalculee = typeof valeurCalculeeBackend === 'number' ? valeurCalculeeBackend : parseFloat(valeurCalculeeBackend) || valeurInitiale;

                this.updateValeurUnitaire(index, item, valeurCalculee);
            },
            error: (error) => {
                this.updateValeurUnitaire(index, item, valeurInitiale);
            }
        });
    }

    private updateValeurUnitaire(index: number, item: any, nouvelleValeur: number): void {

        
        this.zone.run(() => {
            if (index >= 0 && index < this.items.length && this.items[index]) {
                const ancienneValeur = this.items[index].valeur_unitaire;
                this.items[index].valeur_unitaire = nouvelleValeur;
                if (!Number(this.items[index].priceHT)) {
                    this.items[index].priceHT = nouvelleValeur;
                }
                Object.assign(item, this.items[index]);

            } else {
                item.valeur_unitaire = nouvelleValeur;
                if (!Number(item.priceHT)) {
                    item.priceHT = nouvelleValeur;
                }

            }

            if (index >= 0 && index < this.items.length) {
                this.calculateLine(index);
            }
            this.calculateTotals();
            this.updateApproveButtonState();

            this.cdr.markForCheck();
            this.cdr.detectChanges();
        });
        setTimeout(() => {
            this.zone.run(() => {
                if (index >= 0 && index < this.items.length && this.items[index]) {
                    const valeurActuelle = this.items[index].valeur_unitaire;
                    if (valeurActuelle !== nouvelleValeur) {
                        this.items[index].valeur_unitaire = nouvelleValeur;
                        Object.assign(item, this.items[index]);
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }
                }
            });
        }, 100);
    }
    
    calculateTotals(): void {
        this.items.forEach((row, index) => {
            if (row.type === 'product') {
                this.calculateLine(index);
            }
        });

        const lignes = this.items.filter(i => i.type === 'product' && i.designation?.trim());

        this.totals.totalRemise = lignes.reduce((s, i) => s + (i.montantRemise || 0), 0);
        this.totals.totalHT = lignes.reduce(
            (s, i) => s + (Number(i.htNet) || this.getLineTotalHT(i) || 0),
            0
        );
        this.totals.totalTaxesAvantTVA = lignes.reduce((s, i) => s + (i.taxesAvantTVA || 0), 0);
        this.totals.totalBaseTVA = lignes.reduce((s, i) => s + (i.baseTVA || 0), 0);
        this.totals.totalTVA = lignes.reduce((s, i) => s + (i.montantTVA || 0), 0);
        this.totals.totalTaxesApresTVA = lignes.reduce((s, i) => s + (i.taxesApresTVA || 0), 0);
        this.totals.totalTTC = lignes.reduce((s, i) => s + (i.ttcLigne || 0), 0);
        const Total_TTC = this.totals.totalTTC;
        const Total_HT = this.totals.totalHT;
        this.totals.Base_RS = Total_TTC;
        const tauxRSDecimal = parseFloat(this.totals.Taux_RS || '0') / 100;
        this.totals.RS = this.totals.Base_RS * tauxRSDecimal;
        this.totals.retenueSource = this.totals.RS;
        this.totals.Net_à_payer = Total_TTC - this.totals.RS;

        const Total_TVA = this.totals.totalTVA;

        this.totals.documentLevelTaxLines = [];
        this.totals.taxesAfterHT = [];
        this.totals.taxesAfterTTC = [];
        this.totals.taxesAfterTimbre = [];
        this.totals.documentLevelTaxesTotal = 0;

        const allTaxes = (this.taxes || []).filter((t: any) => this.isTaxActiveForDocument(t));

        const taxIdsUsedOnLines = new Set<number>();
        (this.items || []).forEach((it: any) => {
            if (it.type !== 'product' || !it['taxesProduit']) return;
            (it['taxesProduit'] || []).forEach((t: any) => {
                const id = t.taxes_id ?? t.id;
                if (id != null) taxIdsUsedOnLines.add(Number(id));
            });
        });

        for (const tax of allTaxes) {
            const appliqueAvantTva = tax.applique_avant_tva === true || tax.applique_avant_tva === 1;
            const appliqueApresTva = tax.applique_apres_tva === true || tax.applique_apres_tva === 1;
            const appliqueTva = tax.applique_tva === true || tax.applique_tva === 1 || tax.applique_a_la_tva === true || tax.applique_a_la_tva === 1;
            const taxeSurProduits = tax.taxe_applique_sur_produits === true || tax.taxe_applique_sur_produits === 1;
            const valeurNum = Number(tax.valeur) || 0;
            const valeurPourcentage = tax.valeur_pourcentage === true || tax.valeur_pourcentage === 1;
            const isFixe = tax.valeur_fixe === true || tax.valeur_fixe === 1;
            const label = tax.label || tax.nom || 'Taxe';
            const taxId = tax.id != null ? Number(tax.id) : null;

            if (appliqueTva) {
                if (!this.isAvoirDocument()) {
                    const amount = isFixe ? valeurNum : (valeurPourcentage ? Total_TVA * (valeurNum / 100) : valeurNum);
                    this.totals.taxesAfterTimbre.push({ label, amount: Number(amount.toFixed(3)) });
                    this.totals.documentLevelTaxesTotal += amount;
                }
            } else if (appliqueAvantTva || taxeSurProduits) {
                if (taxeSurProduits && taxId != null && !taxIdsUsedOnLines.has(taxId)) {
                    continue;
                }
                let amount = 0;
                if (taxeSurProduits && taxId != null) {
                    (this.items || []).forEach((it: any) => {
                        if (it.type !== 'product' || !it['taxesProduit']) return;
                        const hasThisTax = (it['taxesProduit'] || []).some((t: any) => Number(t.taxes_id ?? t.id) === taxId);
                        if (!hasThisTax) return;
                        const listAvant = it.listeTaxesAvantTVA || [];
                        const listApres = it.listeTaxesApresTVA || [];
                        const labelNorm = (label || '').trim();
                        const matchAvant = listAvant.find((x: any) => Math.abs(Number(x.taux) - valeurNum) < 0.01 && ((x.nom || '').trim() === labelNorm || (x.nom || '') === (tax.nom || '')));
                        const matchApres = listApres.find((x: any) => Math.abs(Number(x.taux) - valeurNum) < 0.01 && ((x.nom || '').trim() === labelNorm || (x.nom || '') === (tax.nom || '')));
                        amount += (matchAvant?.montant || 0) + (matchApres?.montant || 0);
                    });
                } else if (isFixe) {
                    amount = valeurNum;
                } else if (valeurPourcentage) {
                    amount = Total_HT * (valeurNum / 100);
                } else {
                    amount = valeurNum;
                }
                this.totals.taxesAfterHT.push({ label, amount: Number(amount.toFixed(3)) });
                if (!taxeSurProduits) {
                    this.totals.documentLevelTaxesTotal += amount;
                }
            } else if (appliqueApresTva && !taxeSurProduits) {
                const amount = isFixe ? valeurNum : (valeurPourcentage ? Total_TTC * (valeurNum / 100) : valeurNum);
                this.totals.taxesAfterTTC.push({ label, amount: Number(amount.toFixed(3)) });
                this.totals.documentLevelTaxesTotal += amount;
            }
        }

        const sumTaxesAfterHT = this.totals.taxesAfterHT.reduce((s, t) => s + (t.amount || 0), 0);
        this.totals.totalTTC = Number((Total_HT + sumTaxesAfterHT + Total_TVA).toFixed(3));
        this.totals.Base_RS = this.totals.totalTTC;
        this.totals.RS = this.totals.Base_RS * tauxRSDecimal;
        this.totals.retenueSource = this.totals.RS;
        this.totals.Net_à_payer = Number((this.totals.totalTTC - this.totals.RS).toFixed(3));

        this.totals.documentLevelTaxLines = [
            ...this.totals.taxesAfterHT,
            ...this.totals.taxesAfterTTC,
            ...this.totals.taxesAfterTimbre
        ];
        this.totals.documentLevelTaxesTotal = Number(this.totals.documentLevelTaxesTotal.toFixed(3));
        const sumTimbreDynamique = this.totals.taxesAfterTimbre.reduce((s, t) => s + (t.amount || 0), 0);
        this.totals.timbreFiscal = this.isAvoirDocument() ? 0 : Number(sumTimbreDynamique.toFixed(3));
        this.totals.netAPayer = this.totals.Net_à_payer + this.totals.documentLevelTaxesTotal;

        this.updateTvaSummary();
        this.cdr.detectChanges();
    }

    updateApproveButtonState(): void {
        const hasClient = this.selectedClient !== null;
        const hasFournisseur = this.selectedFournisseur !== null;
        const hasProduct = this.items.some(i => i.type === 'product' && i.designation?.trim());
        let partyOk = true;
        if (this.shouldShowFournisseur()) {
            partyOk = hasFournisseur;
        } else if (this.shouldShowClient()) {
            partyOk = hasClient;
        } else if (this.isBonSortieDocument() || this.documentType === 'PV ECART') {
            partyOk =
                this.selectedWarehouseInitialId != null &&
                this.selectedWarehouseDestinationId != null;
        }
        this.isApproveButtonDisabled = !partyOk || !hasProduct;
        this.headerService.updateButtonState('Approuver', this.isApproveButtonDisabled);
    }

    public getBasePath(): string {
        const url = this.router.url || '';
        const ventePrefix = url.includes('/vente-negoce/') ? '/vente-negoce' : '/vente';
        if (url.includes(`${ventePrefix}/avoir/`)) {
            return `${ventePrefix}/avoir`;
        }
        if (url.includes('/achat/avoir-fournisseur/')) {
            return '/achat/avoir-fournisseur';
        }
        switch (this.documentType) {
            case 'DEVIS':
                return `${ventePrefix}/devis`;
            case 'COMMANDE CLIENT':
                return `${ventePrefix}/commande-client`;
            case 'BON DE SORTIE':
                return `${ventePrefix}/bon-sortie`;
            case 'BON DE LIVRAISON':
                return `${ventePrefix}/bon-livraison`;
            case 'FACTURE':
                return `${ventePrefix}/facture`;
            case 'AVOIR':
                return `${ventePrefix}/avoir`;
            case 'AVOIR FOURNISSEUR':
                return '/achat/avoir-fournisseur';
            case 'COMMANDE FOURNISSEUR':
                return '/achat/commande-fournisseur';
            case 'BON RECEPTION':
                return '/achat/bon-reception';
            case 'FACTURE FOURNISSEUR':
                return '/achat/facture-fournisseur';
            case 'RETOUR FOURNISSEUR':
                return '/achat/retour-fournisseur';
            case 'INVENTAIRE':
                return '/inventaire';
            case 'TRANSFERT':
                return '/transfert-entrepot';
            case 'BON TRANSFERT':
                return (environment as { currentModule?: string }).currentModule === 'gestion_stock'
                    ? '/transfert-entrepot'
                    : '/bon-transfert';
            case 'PV ECART':
                return '/stock/pv-ecart';
            default:
                return '/vente/devis';
        }
    }

    public getDocumentType(): string {
        const route = this.router.url;
        if (route.includes('/devis/')) {
            return 'Devis';
        }
        if (route.includes('/facture/')) {
            return 'Facture';
        }
        if (route.includes('/bon-livraison/')) {
            return 'Bon de livraison';
        }
        if (route.includes('/bon-sortie/')) {
            return 'Bon de sortie';
        }
        if (route.includes('/bon-reception/')) {
            return 'Bon de réception';
        }
        if (route.includes('/commande-client/')) {
            return 'Commande client';
        }
        if (route.includes('/commande-fournisseur/')) {
            return 'Commande fournisseur';
        }
        if (route.includes('/avoir/')) {
            return 'Avoir';
        }
        return 'Document';
    }
    private getTimbreFiscalEffective(): number {
        if (this.isAvoirDocument()) {
            return 0;
        }
        return Number(this.totals.timbreFiscal ?? 0);
    }
    toggleReadonly(field: string) {
        if (field === 'date') {
            this.isDateReadonly = !this.isDateReadonly;
        } else if (field === 'entrepot') {
            this.isEntrepotReadonly = !this.isEntrepotReadonly;
        } else if (field === 'entrepotInitial') {
            this.isEntrepotInitialReadonly = !this.isEntrepotInitialReadonly;
        } else if (field === 'entrepotDestination') {
            this.isEntrepotDestinationReadonly = !this.isEntrepotDestinationReadonly;
        } else if (field === 'dateLiv') {
            this.isDateLivReadonly = !this.isDateLivReadonly;
        } else if (field === 'refExterne') {
            // Règle générale : la référence ne se modifie jamais.
            this.isReferenceReadonly = true;
        } else if (field === 'project') {
            this.isProjectReadonly = !this.isProjectReadonly;
        } else if (field === 'categorie') {
            this.isCategorieReadonly = !this.isCategorieReadonly;
        } else if (field === 'note') {
            this.isNoteReadonly = !this.isNoteReadonly;
        }
        else if (field === 'nomClient') {
            this.isNameClientReadonly = !this.isNameClientReadonly;
        }
        else if (field === 'identifiant') {
            this.isIdentifiantReadonly = !this.isIdentifiantReadonly;
        }
        else if (field === 'adresse') {
            this.isAdressReadonly = !this.isAdressReadonly;
        }
        else if (field === 'telephone') {
            this.isTelephoneReadonly = !this.isTelephoneReadonly;
        }
        else if (field === 'email') {
            this.isEmailReadonly = !this.isEmailReadonly;
        }

        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
        if (field === 'date' || field === 'dateLiv') {
            this.syncFlatpickrReadonlyOnInstances();
        }
    }

    toggleTitleVisibility(): void {
        this.isTitleVisible = !this.isTitleVisible;
        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
    }
    private getDocumentTypeFromConversionLabel(label: string): string {
        const map: { [key: string]: string } = {
            Commande: 'COMMANDE CLIENT',
            'Bon de livraison': 'BON DE LIVRAISON',
            'Bon de sortie': 'BON DE SORTIE',
            'Bon de transfert': 'BON TRANSFERT',
            Facture: 'FACTURE',
            'Bon de réception': 'BON RECEPTION',
            'Facture fournisseur': 'FACTURE FOURNISSEUR',
            'Retour fournisseur': 'RETOUR FOURNISSEUR',
            Avoir: 'FACTURE'
        };
        if (label && map[label]) {
            return map[label];
        }
        const norm = String(label || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        if (norm.includes('bon de sortie') || norm === 'bon sortie') {
            return 'BON DE SORTIE';
        }
        if (norm.includes('bon de transfert')) {
            return 'BON TRANSFERT';
        }
        if (norm.includes('bon de livraison')) {
            return 'BON DE LIVRAISON';
        }
        if (norm.includes('bon de reception')) {
            return 'BON RECEPTION';
        }
        if (norm.includes('retour') && norm.includes('fournisseur')) {
            return 'RETOUR FOURNISSEUR';
        }
        return this.getTypeFromId(0) || 'DEVIS';
    }

    /** Bon de sortie (route, type libellé ou type_document_id 9). */
    public isBonSortieDocument(): boolean {
        if (this.isBonTransfertOrEntrepotTransfert()) {
            return false;
        }
        if (this.documentType === 'BON DE SORTIE') {
            return true;
        }
        const url = String(this.router.url || '').toLowerCase();
        if (url.includes('/bon-sortie/')) {
            return true;
        }
        const fromMap =
            this.documentType === 'BON DE SORTIE'
                ? this.typeDocumentIdMap['BON DE SORTIE']
                : this.typeDocumentIdMap[this.documentType];
        const typeId = Number(
            this.currentTypeDocumentId ??
                this.conversionFromRef?.typeDocumentId ??
                fromMap
        );
        return Number.isFinite(typeId) && typeId === 9;
    }

    /** Bon de livraison (route, type libellé ou type_document_id 10). */
    public isBonLivraisonDocument(): boolean {
        if (this.documentType === 'BON DE LIVRAISON') {
            return true;
        }
        const url = String(this.router.url || '').toLowerCase();
        if (url.includes('/bon-livraison/')) {
            return true;
        }
        const fromMap =
            this.documentType === 'BON DE LIVRAISON'
                ? this.typeDocumentIdMap['BON DE LIVRAISON']
                : this.typeDocumentIdMap[this.documentType];
        const typeId = Number(
            this.currentTypeDocumentId ??
                this.conversionFromRef?.typeDocumentId ??
                fromMap
        );
        return Number.isFinite(typeId) && typeId === 10;
    }

    private resolveAvoirDocumentTypeFromConversion(conversionFrom: any): 'AVOIR' | 'AVOIR FOURNISSEUR' {
        const url = String(this.router.url || '').toLowerCase();
        if (url.includes('avoir-fournisseur') || url.includes('/achat/facture-fournisseur')) {
            return 'AVOIR FOURNISSEUR';
        }
        const src = conversionFrom?.sourceDocument;
        const titre = String(
            src?.typeDocument?.titre || src?.type_document?.titre || conversionFrom?.newType || ''
        )
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        if (titre.includes('FOURNISSEUR')) {
            return 'AVOIR FOURNISSEUR';
        }
        return 'AVOIR';
    }

    private loadFormFromConversion(conversionFrom: any): void {
        this.mode = 'add';
        this.isEditing = false;
        this.documentId = null;
        this.isPendingConversion = true;
        this.conversionFromRef = {
            sourceId: conversionFrom.sourceId,
            newType: conversionFrom.newType,
            typeDocumentId: conversionFrom.typeDocumentId,
            statutId: conversionFrom.statutId,
            isAvoir: conversionFrom.isAvoir,
            totalsAvoir: conversionFrom.totalsAvoir,
            documentOriginalId: conversionFrom.documentOriginalId,
            workflowStep: conversionFrom.workflowStep
        };
        this.documentOriginalId =
            conversionFrom.documentOriginalId ?? conversionFrom.sourceId ?? null;

        const documentTypeOverride = conversionFrom.isAvoir
            ? this.resolveAvoirDocumentTypeFromConversion(conversionFrom)
            : this.getDocumentTypeFromConversionLabel(conversionFrom.newType);
        if (documentTypeOverride) {
            this.documentType = documentTypeOverride;
        }
        this.updateHeaderConfig();
        this.loadDocumentForDuplicate(conversionFrom.sourceId, {
            doc: conversionFrom.sourceDocument,
            documentType: documentTypeOverride,
            isAvoir: conversionFrom.isAvoir,
            totalsAvoir: conversionFrom.totalsAvoir
        });
        if (conversionFrom.isAvoir) {
            this.applySourceWarehouseFromDoc(conversionFrom.sourceDocument);
        } else if (documentTypeOverride === 'BON DE SORTIE') {
            this.applyBonSortieEntrepotsFromDoc(conversionFrom.sourceDocument);
            this.selectedClient = null;
            this.selectedClientId = null;
            this.clientId = null;
            this.modifiedClientFields = {
                nomClient: false,
                identifiant: false,
                numeroIdentification: false,
                adresse: false,
                email: false
            };
        }
        if (this.shouldShowClient() && !this.clients.length) {
            this.loadClients();
        }
        if (this.shouldShowFournisseur() && !this.fournisseurs.length) {
            this.loadFournisseurs();
        }
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    /** Facture vente ERP préremplie depuis tickets caisse (ligne financière ou lignes produits). */
    private loadFormFromTicketFacture(payload: any): void {
        this.isLoadingEdit = true;
        this.isEditing = false;
        this.documentType = 'FACTURE';
        this.stationId = getStationIdFromLocalStorage() || this.stationId;
        const preferEtabId =
            Number(payload?.etablissementId) > 0 ? Number(payload.etablissementId) : null;
        if (payload?.etablissementLibelle) {
            this.stationName = String(payload.etablissementLibelle).trim();
        }
        this.refreshAvailableEtablissements(preferEtabId);
        this.loadStationData();
        this.loadCurrentTypeDocumentPrefixFromApi(this.typeDocumentIdMap['FACTURE']);

        // Mémorise la liaison tickets → facture à enregistrer après sauvegarde (les deux modes).
        // Par défaut markConsolide = true (transfert tické → consolidé).
        this.ticketFactureLink = Array.isArray(payload.ticketIds) && payload.ticketIds.length
            ? {
                  ticketIds: payload.ticketIds.map((x: any) => Number(x)).filter((n: number) => n > 0),
                  ticketCodes: Array.isArray(payload.ticketCodes) ? payload.ticketCodes : [],
                  markConsolide: payload.markConsolide !== false,
              }
            : null;

        const recette = payload.recetteProduct || {};
        const totalHt = Number(payload.total_ht) || 0;
        const tvaRate = Number(payload.tva_rate) || 19;
        const recetteLigne = {
            libelle: recette.nom || 'Recette',
            ref_interne: recette.ref_interne || 'LC_RECETTE',
            product_id: recette.id || null,
            qnt: 1,
            prix_ht: totalHt,
            prix_vente: totalHt,
            result_ht: totalHt,
            total_ht: totalHt,
            tva: tvaRate,
            tva_id: payload.tva19Id ?? recette.tva_id ?? null,
            remise: 0,
        };
        // Mode « lignes produits » : reprend le détail des tickets ; sinon ligne financière unique.
        const lignesToApply =
            payload.mode === 'product_lines' &&
            Array.isArray(payload.lignesProduits) &&
            payload.lignesProduits.length
                ? payload.lignesProduits
                : [recetteLigne];

        // Entrepôt des tickets (distinct de l'établissement POS).
        const ticketEntrepotId =
            payload?.entrepotId != null && Number(payload.entrepotId) > 0
                ? Number(payload.entrepotId)
                : null;
        this.loadWarehouses(ticketEntrepotId);

        // Uniquement les APIs nécessaires à la facture ticket (évite catégories/taxes/types redondants).
        forkJoin({
            clients: this.fetchAllActiveErpClientsForDocument(),
            caisse: this.fetchCaisseClientsForDocument(),
            products: this.fetchAllActiveProductsByStation(this.stationId),
            projects: this.projetService.getProjectsByIdStation(this.stationId),
            tva: this.tvaService.getTvaList(this.stationId),
        }).subscribe({
            next: ({ clients, caisse, products, projects, tva }: any) => {
                this.zone.run(() => {
                    this.clients = this.mergeErpClientsWithCaisse(
                        Array.isArray(clients) ? clients : clients?.data || [],
                        caisse || []
                    );
                    this.refreshClientsForSelect();
                    this.isLoadingClients = false;
                    const productsList = (Array.isArray(products) ? products : products?.data || []).map((p: any) =>
                        this.mapApiProductForDocumentSelect(p)
                    );
                    const recetteId = recette.id;
                    if (recetteId && !productsList.some((p: any) => Number(p.id) === Number(recetteId))) {
                        productsList.unshift({
                            ...recette,
                            prix_unitaires: totalHt,
                            valeur_unitaire: totalHt,
                        });
                    }
                    this.products = productsList;
                    this.isLoadingProducts = false;
                    this.projects = Array.isArray(projects) ? projects : projects?.projectsListe || [];
                    this.isLoadingProjects = false;
                    this.fournisseurs = [];
                    this.isLoadingFournisseurs = false;
                    this.tvaRates = tva?.tvaListe || [];
                    this.categories = [];
                    this.isLoadingCategories = false;
                    this.taxes = [];
                    this.documentReference = '';
                    // Note laissée vide : ne pas afficher le contenu repris du ticket.
                    this.note = '';
                    if (ticketEntrepotId != null) {
                        this.selectedWarehouseId = ticketEntrepotId;
                    }
                    this.applyItemsData(lignesToApply);
                    this.calculateTotals();
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.toastr.error('Impossible de préparer la facture depuis les tickets.', 'Erreur');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
            },
        });
    }

    /**
     * Enregistre la liaison tickets caisse → facture ERP après création (référence + consolidé).
     * S'exécute uniquement si la facture provient d'un transfert de tickets (les deux modes).
     */
    private linkTicketsToErpFactureIfNeeded(erpFactureId: any, res: any): void {
        this.linkTicketsToErpFactureIfNeeded$(erpFactureId, res).subscribe();
    }

    private linkTicketsToErpFactureIfNeeded$(erpFactureId: any, res: any): Observable<unknown> {
        const link = this.ticketFactureLink;
        this.ticketFactureLink = null;
        if (!link || !link.ticketIds.length) {
            return of(null);
        }
        const erpCode =
            (this.documentReference || '').trim() ||
            (this.refExterne || '').trim() ||
            res?.data?.document?.ref_externe ||
            res?.data?.ref_externe ||
            res?.data?.code_document ||
            res?.data?.document?.code_document ||
            res?.data?.code ||
            res?.data?.document?.code ||
            res?.data?.reference ||
            res?.data?.document?.reference ||
            null;
        return this.lcTicketService
            .linkTicketsToErpFacture(link.ticketIds, {
                erpFactureId: Number(erpFactureId) || null,
                erpFactureCode: erpCode,
                markConsolide: link.markConsolide !== false,
            })
            .pipe(
                tap(() => {
                    this.toastr.success('Tickets caisse consolidés et liés à la facture.', 'Consolidation');
                }),
                catchError(() => {
                    this.toastr.warning(
                        'Facture créée, mais la liaison avec les tickets caisse n\'a pas pu être enregistrée.',
                        'Tickets caisse'
                    );
                    return of(null);
                })
            );
    }

    private loadDocumentForDuplicate(id: number, options?: { doc?: any; documentType?: string; isAvoir?: boolean; totalsAvoir?: any }): void {
        this.isLoadingEdit = true;
        this.isEditing = false;
        this.isLoadingFournisseurs = true;
        this.isLoadingClients = true;
        this.isLoadingProducts = true;
        this.isLoadingProjects = true;
        this.isLoadingCategories = true;
        this.isLoadingWarehouses = true;

        const applyDoc = (doc: any) => {
            if (!doc) {
                this.toastr.error('Document introuvable pour la duplication');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
                return;
            }

            let docToApply = doc;
            if (options?.isAvoir && options?.doc) {
                const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                const negatedLignes = lignes.map((l: any) => ({
                    ...l,
                    qnt: -(Number(l.qnt) || 0),
                    prix_ht: -(Number(l.prix_ht) || Number(l.result_ht) || 0),
                    result_ht: -(Number(l.result_ht) || Number(l.prix_ht) || 0),
                    valeur_unitaire: -(Number(l.valeur_unitaire) || Number(l.result_ht) || Number(l.prix_ht) || 0)
                }));
                docToApply = {
                    ...doc,
                    lignesDocument: negatedLignes,
                    total_ht: -(Number(doc.total_ht) || 0),
                    total_tva: -(Number(doc.total_tva) || 0),
                    total_ttc: -(Number(doc.total_ttc) || 0),
                    net_payer: -(Number(doc.net_payer) || Number(doc.total_ttc) || 0)
                };
            }

            forkJoin([
                    this.fetchAllActiveErpClientsForDocument(),
                    this.fetchAllActiveProductsByStation(this.stationId),
                    this.projetService.getProjectsByIdStation(this.stationId),
                    this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100),
                    this.tvaService.getTvaList(this.stationId),
                    this.categorieService.getCategoriePerStation(this.stationId),
                    this.taxeService.getTaxeList(this.stationId),
                    this.documentService.getTypeDocuments().pipe(catchError(() => of(null))),
                    this.fetchCaisseClientsForDocument()
                ]).subscribe({
                    next: ([clientsRes, productsRes, projectsRes, fournisseursRes, tvaRes, categoriesRes, taxesRes, typesRes, caisseClients]: any[]) => {
                        this.zone.run(() => {
                            if (typesRes) {
                                this.applyTypeDocumentsFromApi(typesRes);
                            }
                            const doc = docToApply;
                            this.clients = this.mergeErpClientsWithCaisse(
                                Array.isArray(clientsRes) ? clientsRes : clientsRes?.data || [],
                                caisseClients || []
                            );
                            this.refreshClientsForSelect();
                            this.isLoadingClients = false;
                            this.products = (Array.isArray(productsRes) ? productsRes : productsRes?.data || []).map((p: any) =>
                                this.mapApiProductForDocumentSelect(p)
                            );
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                            this.isLoadingProducts = false;
                            this.preloadStockQuantitiesForAllProducts();
                            this.projects = Array.isArray(projectsRes) ? projectsRes : projectsRes?.projectsListe || [];
                            this.isLoadingProjects = false;
                            this.fournisseurs = fournisseursRes?.data || [];
                            this.isLoadingFournisseurs = false;
                            this.tvaRates = tvaRes?.tvaListe || [];
                            this.categories = categoriesRes || [];
                            this.isLoadingCategories = false;
                            const taxList = taxesRes?.taxes || taxesRes?.data || taxesRes?.tvaListe || [];
                            if (Array.isArray(taxList)) {
                                this.taxes = taxList;
                                const fodecTax = this.taxes.find((t: any) =>
                                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                    this.isTaxActiveForDocument(t)
                                );
                                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                            } else {
                                this.taxes = [];
                                this.fodecRate = 0;
                            }
                            const conversionTargetType =
                                options?.documentType ||
                                (this.conversionFromRef?.typeDocumentId
                                    ? this.getTypeFromId(Number(this.conversionFromRef.typeDocumentId))
                                    : null);
                            const routeIsBonSortie = String(this.router.url || '')
                                .toLowerCase()
                                .includes('/bon-sortie/');
                            const keepBonSortie =
                                this.documentType === 'BON DE SORTIE' ||
                                conversionTargetType === 'BON DE SORTIE' ||
                                routeIsBonSortie ||
                                this.isBonSortieDocument();
                            this.documentType =
                                conversionTargetType ||
                                (keepBonSortie ? 'BON DE SORTIE' : null) ||
                                this.getTypeFromId(docToApply.type_document_id);
                            if (this.isBonSortieDocument()) {
                                this.currentTypeDocumentId =
                                    this.typeDocumentIdMap['BON DE SORTIE'] ?? 9;
                            }
                            this.loadCurrentTypeDocumentPrefixFromApi(
                                this.isBonSortieDocument()
                                    ? this.typeDocumentIdMap['BON DE SORTIE']
                                    : options?.documentType
                                    ? this.typeDocumentIdMap[this.documentType]
                                    : docToApply.type_document_id
                            );
                            this.documentReference = '';
                            this.documentDate = this.getTodayLocal();
                            this.dateLivraison = this.getTodayLocal();
                            this.note = docToApply.note || '';
                            if (options?.isAvoir && this.conversionFromRef) {
                                const tidAvoir = this.typeDocumentIdMap[this.documentType];
                                if (tidAvoir != null && !Number.isNaN(Number(tidAvoir))) {
                                    this.conversionFromRef = {
                                        ...this.conversionFromRef,
                                        typeDocumentId: Number(tidAvoir)
                                    };
                                }
                            }
                            const isAchat = this.isAchatDocument();
                            if (options?.isAvoir) {
                                this.assignProvisionalRefExterneForType();
                                this.applySourceWarehouseFromDoc(docToApply);
                            }
                            const clientOrFournisseurId = isAchat 
                                ? (docToApply.fournisseur_id || docToApply.fournisseur_data?.fournisseur_id || docToApply.fournisseurs?.[0]?.fournisseur_id || docToApply.fornisseurs?.[0]?.fournisseur_id || docToApply.fournisseur?.fournisseur_id || docToApply.fournisseurs?.[0]?.id || docToApply.fornisseurs?.[0]?.id || docToApply.fournisseur_data?.id)
                                : (docToApply.clients?.[0]?.id || docToApply.client_data?.id || docToApply.client_data?.client_id);

                            if (clientOrFournisseurId) {
                                this.clientId = clientOrFournisseurId;
                            }
                            this.loadWarehouses();
                            setTimeout(() => {
                                    if (this.usesDualEntrepotSelection()) {
                                        if (this.documentType === 'PV ECART') {
                                            this.applyPvEcartEntrepotsFromDoc(doc);
                                        } else {
                                        if (this.isBonSortieDocument()) {
                                            this.applyBonSortieEtablissementsFromDoc(doc);
                                        }
                                        const entrepotInitialId = doc.entrepot_id || doc.entrepot?.id;
                                        const entrepotDestinationId = doc.entrepot_dest_id || doc.entrepot_destination?.id || doc.entrepot_destination_id;
                                        
                                        if (entrepotInitialId) {
                                            this.selectedWarehouseInitialId = entrepotInitialId;
                                            if (!doc.entrepot && entrepotInitialId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotInitialId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },

                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseInitialId = null;
                                        }
                                        
                                        if (entrepotDestinationId) {
                                            this.selectedWarehouseDestinationId = entrepotDestinationId;
                                            if (!doc.entrepot_destination && entrepotDestinationId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotDestinationId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },
                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseDestinationId = null;
                                        }
                                    if (this.isBonSortieDocument()) {
                                        this.applyBonSortieEntrepotsFromDoc(doc);
                                    } else {
                                        this.refreshWarehouseDestinationPanel();
                                    }
                                        }
                                    } else {
                                        const entrepotId = doc.entrepot_id || doc.entrepot?.id;
                                        
                                        if (entrepotId) {
                                            this.selectedWarehouseId = entrepotId;
                                            if (!doc.entrepot && entrepotId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },

                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseId = null;
                                        }
                                    }
                                }, 500);
                            if (isAchat) {
                                const apiFournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur || doc.fournisseur_data;
                                const fournisseurId = doc.fournisseur_id ?? apiFournisseur?.fournisseur_id ?? apiFournisseur?.id;
                                if (fournisseurId) {
                                    this.clientId = fournisseurId;
                                    this.fournisseurService.getFournisseurById(fournisseurId).subscribe({
                                        next: (fournisseurComplet) => {
                                            const fournisseurWithExtras = {
                                                ...fournisseurComplet,
                                                responsable: (fournisseurComplet as any).responsable || (fournisseurComplet as any).contact || '',
                                                phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                                            };
                                            const found = this.fournisseurs.find(f => f.id === fournisseurComplet.id);
                                            if (found) {
                                                this.selectedFournisseur = {...found, ...fournisseurWithExtras} as Fournisseur;
                                            } else {
                                                this.fournisseurs = [...this.fournisseurs, fournisseurWithExtras as Fournisseur];
                                                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurComplet.id;
                                            this.clientId = fournisseurComplet.id;
                                            this.updateApproveButtonState();
                                            this.cdr.detectChanges();
                                        },
                                        error: (err) => {
                                            const found = this.fournisseurs.find(f => f.id === fournisseurId);
                                            if (found) {
                                                this.selectedFournisseur = found;
                                                this.selectedFournisseurId = fournisseurId;
                                                this.clientId = fournisseurId;
                                                this.updateApproveButtonState();
                                                this.cdr.detectChanges();
                                            }
                                        }
                                    });
                                }
                            } else {
                                const apiClient = doc.clients?.[0] || doc.client_data;
                                if (apiClient && (apiClient.id || apiClient.client_id)) {
                                    const clientId =
                                        apiClient.client_id != null && Number(apiClient.client_id) > 0
                                            ? Number(apiClient.client_id)
                                            : apiClient.id;
                                    const clientFromDocument: Partial<Client> = {
                                        id: clientId,
                                        nom_prenom: apiClient.nom_client || apiClient.nom_prenom || '',
                                        identifiant_unique: apiClient.identifiant_unique || '',
                                        adresses: apiClient.adresse && apiClient.adresse !== 'Adresse non renseignée' 
                                            ? [{
                                                adresse: apiClient.adresse,
                                                code_postal: '',
                                                region: '',
                                                pays: ''
                                            } as Address]
                                            : [],
                                        emails: apiClient.email 
                                            ? [{
                                                email: apiClient.email,
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Email]
                                            : [],
                                        telephones: apiClient.telephone 
                                            ? [{
                                                num_tel: apiClient.telephone.replace(/^\+216/, '') || apiClient.telephone,
                                                code_pays: apiClient.telephone.startsWith('+216') ? '+216' : '+216',
                                                type: 'mobile',
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Telephone]
                                            : []
                                    };
                                    
                                    const found = this.clients.find(
                                        (c) => c.id === clientId || c.id === apiClient.id
                                    );
                                    if (found) {
                                        this.selectedClient = {
                                            ...found,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        };
                                    } else {
                                        this.clients = [clientFromDocument as Client, ...this.clients];
                                        this.refreshClientsForSelect();
                                        this.selectedClient = {
                                            ...clientFromDocument,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        } as Client;
                                    }
                                    
                                    this.selectedClientId = clientId;
                                    this.clientId = clientId;
                                    this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
                                    this.modifiedClientFields = {
                                        nomClient: false,
                                        identifiant: false,
                                        adresse: false,
                                        email: false
                                    };
                                    this.modifiedFournisseurFields = {
                                        nomEntreprise: false,
                                        numeroIdentification: false,
                                        responsable: false,
                                        telephone: false,
                                        adresse: false
                                    };
                                    
                                    setTimeout(() => {
                                        this.initializeFeatherIcons();
                                    }, 250);
                                }
                            }
                            const apiProjet = doc.projets?.[0];
                            if (apiProjet) {
                                const found = this.projects.find(p => p.id === (apiProjet.id || apiProjet.projet_id));
                                this.selectedProject = found?.libelle || apiProjet.titre || apiProjet.libelle || '';
                            } else {
                                this.selectedProject = '';
                            }
                            const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                            this.applyItemsData(lignes);
                            this.enrichStockLcDocumentLinesAfterLoad(doc);
                            this.updateApproveButtonState();
                            if (this.taxes && this.taxes.length > 0) {
                                this.items.forEach((item, i) => {
                                    if (item.product_id && item.type === 'product') {
                                        const descriptionFromLine = this.productDescriptions[i] || '';
                                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                                            next: (p: any) => {
                                                const productData = p.data || p;
                                                this.applyStockLcUnitPriceToItemFromProduct(i, productData);
                                                this.applyProductTaxes(productData, i, true);
                                                
                                                if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                    this.productDescriptions[i] = productData.description || '';
                                                } else {
                                                    this.productDescriptions[i] = descriptionFromLine;
                                                }
                                                this.cdr.detectChanges();
                                            },
                                            error: (err) => {
                                                if (this.productDescriptions[i] === undefined) {
                                                    this.productDescriptions[i] = descriptionFromLine || '';
                                                }
                                            }
                                        });
                                    }
                                });
                            }

                            const parametrageDoc = doc.parametrage_doc || {};
                            this.applyTaxStatutDocumentFromParametrage(parametrageDoc.taxe_statut_document);
                            const fodecAfterParametrage = this.taxes.find((t: any) =>
                                (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                this.isTaxActiveForDocument(t)
                            );
                            this.fodecRate = fodecAfterParametrage ? parseFloat(fodecAfterParametrage.valeur) : 0;
                            if (parametrageDoc.aff_montant_ttc !== undefined || doc.aff_montant_ttc !== undefined) {
                                const value = parametrageDoc.aff_montant_ttc ?? doc.aff_montant_ttc;
                                this.documentColumnSettings.aff_montant_ttc = value;
                                this.documentColumnSettings.afficherMontantsTTC = value;
                            }
                            if (parametrageDoc.aff_code_bar !== undefined || doc.aff_code_bar !== undefined) {
                                const value = parametrageDoc.aff_code_bar ?? doc.aff_code_bar;
                                this.documentColumnSettings.aff_code_bar = value;
                                this.documentColumnSettings.afficherCodeBarres = value;
                            }
                            if (parametrageDoc.aff_date_echeance !== undefined || parametrageDoc.aff_date_échéance !== undefined || doc.aff_date_echeance !== undefined || doc.aff_date_échéance !== undefined) {
                                const value = parametrageDoc.aff_date_echeance ?? parametrageDoc.aff_date_échéance ?? doc.aff_date_echeance ?? doc.aff_date_échéance;
                                this.documentColumnSettings.aff_date_echeance = value;
                                this.documentColumnSettings.afficherDateEcheance = value;
                            }
                            if (parametrageDoc.aff_date_liv !== undefined || doc.aff_date_liv !== undefined) {
                                const value = parametrageDoc.aff_date_liv ?? doc.aff_date_liv;
                                this.documentColumnSettings.aff_date_liv = value;
                                this.documentColumnSettings.afficherDateLivraison = value;
                            }
                            if (parametrageDoc.aff_montant_total !== undefined || doc.aff_montant_total !== undefined) {
                                const value = parametrageDoc.aff_montant_total ?? doc.aff_montant_total;
                                this.documentColumnSettings.aff_montant_total = value;
                                this.documentColumnSettings.afficherMontantTotal = value;
                            }
                            if (parametrageDoc.aff_coordonnees !== undefined || parametrageDoc.aff_coordonnées !== undefined || doc.aff_coordonnees !== undefined || doc.aff_coordonnées !== undefined) {
                                const value = parametrageDoc.aff_coordonnees ?? parametrageDoc.aff_coordonnées ?? doc.aff_coordonnees ?? doc.aff_coordonnées;
                                this.documentColumnSettings.aff_coordonnees = value;
                                this.documentColumnSettings.afficherCoordonneesClients = value;
                            }
                            if (parametrageDoc.reference !== undefined || parametrageDoc.référence !== undefined || doc.reference !== undefined || doc.référence !== undefined) {
                                const value = parametrageDoc.reference ?? parametrageDoc.référence ?? doc.reference ?? doc.référence;
                                this.documentColumnSettings.reference = value;
                            }
                            if (parametrageDoc.quantite !== undefined || parametrageDoc.quantité !== undefined || doc.quantite !== undefined || doc.quantité !== undefined) {
                                const value = parametrageDoc.quantite ?? parametrageDoc.quantité ?? doc.quantite ?? doc.quantité;
                                this.documentColumnSettings.quantite = value;
                            }
                            if (parametrageDoc.unite !== undefined || parametrageDoc.unité !== undefined || doc.unite !== undefined || doc.unité !== undefined) {
                                const value = parametrageDoc.unite ?? parametrageDoc.unité ?? doc.unite ?? doc.unité;
                                this.documentColumnSettings.unite = value;
                            }
                            if (parametrageDoc.prix_unitaire !== undefined || doc.prix_unitaire !== undefined) {
                                const value = parametrageDoc.prix_unitaire ?? doc.prix_unitaire;
                                this.documentColumnSettings.prix_unitaire = value;
                                this.documentColumnSettings.prixUnitaire = value;
                            }
                            if (parametrageDoc.tva !== undefined || doc.tva !== undefined) {
                                this.documentColumnSettings.tva = parametrageDoc.tva ?? doc.tva;
                            }
                            if (parametrageDoc.remise !== undefined || doc.remise !== undefined) {
                                this.documentColumnSettings.remise = parametrageDoc.remise ?? doc.remise;
                            }
                            const defaultClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            
                            const defaultFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                            
                            let parsedClientFields: any = null;
                            if (doc.hidden_client_fields) {
                                if (typeof doc.hidden_client_fields === 'string') {
                                    try {
                                        parsedClientFields = JSON.parse(doc.hidden_client_fields);
                                    } catch (e) {
                                        parsedClientFields = null;
                                    }
                                } else if (typeof doc.hidden_client_fields === 'object') {
                                    parsedClientFields = doc.hidden_client_fields;
                                }
                            }
                            
                            if (parsedClientFields && typeof parsedClientFields === 'object') {
                                this.modifiedClientFields = { ...defaultClientFields, ...parsedClientFields };
                            } else {
                                this.modifiedClientFields = { ...defaultClientFields };
                            }
                            
                            let parsedFournisseurFields: any = null;
                            if (doc.hidden_fournisseur_fields) {
                                if (typeof doc.hidden_fournisseur_fields === 'string') {
                                    try {
                                        parsedFournisseurFields = JSON.parse(doc.hidden_fournisseur_fields);
                                    } catch (e) {
                                        parsedFournisseurFields = null;
                                    }
                                } else if (typeof doc.hidden_fournisseur_fields === 'object') {
                                    parsedFournisseurFields = doc.hidden_fournisseur_fields;
                                }
                            }
                            
                            if (parsedFournisseurFields && typeof parsedFournisseurFields === 'object') {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...parsedFournisseurFields };
                            } else {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields };
                            }
                            this.applyBonSortieTransportFromDoc(doc);
                            this.loadStationData();
                            this.calculateTotals();
                            this.updateApproveButtonState();
                            localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
                            this.documentColumnSettings = {...this.documentColumnSettings};

                            this.updateHeaderConfig();
                            this.loadVenteAchatParamForCurrentDocumentType();

                            setTimeout(() => {
                                this.cdr.detectChanges();
                                this.isLoadingEdit = false;
                                this.isLoadingClients = false;
                                this.isLoadingFournisseurs = false;
                                this.isLoadingProducts = false;
                                this.isLoadingProjects = false;
                                this.isLoadingCategories = false;
                                this.isLoadingWarehouses = false;
                                
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }, 200);
                        });
                    },
                    error: (err) => {
                        this.toastr.error('Erreur lors du chargement des données pour la duplication');
                        this.isLoadingEdit = false;
                        this.cdr.detectChanges();
                    }
                });
        };
        if (options?.doc) {
            applyDoc(options.doc);
        } else {
            this.documentService.getDocumentById(id).subscribe({
                next: (response) => {
                    const doc = response?.data?.document ?? response?.data ?? response;
                    applyDoc(doc);
                },
                error: () => {
                    this.toastr.error('Document introuvable pour la duplication');
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                }
            });
        }
    }

    private loadDocumentForEdit(id: number): void {
        this.isLoadingEdit = true;
        this.documentReferenceHeaderPending = true;
        this.documentReference = '';
        this.refExterne = '';
        this.isEditing = true;
        this.isLoadingFournisseurs = true;
        this.isLoadingClients = true;
        this.isLoadingProducts = true;
        this.isLoadingProjects = true;
        this.isLoadingCategories = true;
        this.isLoadingWarehouses = true;

        this.documentService.getDocumentById(id).subscribe({
            next: (response) => {
                const doc = response?.data?.document;
                if (!doc) {
                    this.toastr.error('Document introuvable');
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                    return;
                }
                this.currentStatutId = doc.statut_id || 1;
                this.currentDocumentUserId = doc.user_id != null ? Number(doc.user_id) : null;
                this.currentTypeDocumentId = doc.type_document_id != null ? Number(doc.type_document_id) : null;
                this.documentTypeInitialId =
                    doc.type_initial != null ? Number(doc.type_initial) : null;
                this.loadedDocumentNote = String(doc.note ?? '').trim();
                const routeUrl = (this.router.url || '').toLowerCase();
                if (routeUrl.includes('/achat/bon-reception/')) {
                    this.documentType = 'BON RECEPTION';
                } else {
                    this.documentType = this.getTypeFromId(doc.type_document_id);
                }
                if (this.documentType === 'BON RECEPTION') {
                    const brSid = Number(doc.statut_id);
                    const isBrouillon =
                        brSid === this.statutIdMap['Brouillon'] || brSid === 1;
                    const lcConsultation = isBonReceptionDocumentFromLogicielCaisse(doc);
                    if (lcConsultation || !isBrouillon) {
                        this.isLoadingEdit = false;
                        const queryParams: Record<string, string> = { id: String(id) };
                        const ret = this.route.snapshot.queryParams['return'];
                        if (typeof ret === 'string' && ret.trim()) {
                            queryParams['return'] = ret.trim();
                        }
                        if (lcConsultation) {
                            queryParams['readonly'] = '1';
                        }
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                            queryParams,
                        });
                        return;
                    }
                }
                // Facture / FF : Non payé / Annulé / Crée → approve-vente
                // CC : Annulé / Crée → approve-vente (pas l’éditeur document)
                if (
                    this.documentType === 'FACTURE' ||
                    this.documentType === 'FACTURE FOURNISSEUR' ||
                    this.documentType === 'COMMANDE CLIENT'
                ) {
                    const sid = Number(doc.statut_id);
                    const isNonPaye = sid === this.statutIdMap['Non payé'];
                    const isAnnule = sid === this.statutIdMap['Annulé'];
                    const isCree =
                        sid === this.statutIdMap['Crée'] || sid === this.statutIdMap['Créé'];
                    const shouldGoApprove =
                        isAnnule ||
                        isCree ||
                        ((this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR') &&
                            isNonPaye);
                    if (shouldGoApprove) {
                        this.isLoadingEdit = false;
                        if (
                            isCree &&
                            (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR')
                        ) {
                            this.documentService.updateStatus(id, this.statutIdMap['Non payé']).subscribe({
                                error: () => { }
                            });
                        }
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                            queryParams: { id }
                        });
                        return;
                    }
                }
                forkJoin([
                    this.fetchAllActiveErpClientsForDocument(),
                    this.fetchAllActiveProductsByStation(this.stationId),
                    this.projetService.getProjectsByIdStation(this.stationId),
                    this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100),
                    this.tvaService.getTvaList(this.stationId),
                    this.categorieService.getCategoriePerStation(this.stationId),
                    this.taxeService.getTaxeList(this.stationId),
                    this.documentService.getTypeDocuments().pipe(catchError(() => of(null))),
                    this.fetchCaisseClientsForDocument()
                ]).subscribe({
                    next: ([clientsRes, productsRes, projectsRes, fournisseursRes, tvaRes, categoriesRes, taxesRes, typesRes, caisseClients]: any[]) => {
                        this.zone.run(() => {
                            if (typesRes) {
                                this.applyTypeDocumentsFromApi(typesRes);
                            }
                            this.clients = this.mergeErpClientsWithCaisse(
                                Array.isArray(clientsRes) ? clientsRes : clientsRes?.data || [],
                                caisseClients || []
                            );
                            this.refreshClientsForSelect();
                            this.isLoadingClients = false;
                            this.products = (Array.isArray(productsRes) ? productsRes : productsRes?.data || []).map((p: any) =>
                                this.mapApiProductForDocumentSelect(p)
                            );
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                            if (this.pendingClientId !== undefined) {
                                const finalClient = this.clients.find(c => c.id === this.pendingClientId);
                                if (finalClient) {
                                    this.selectedClient = finalClient;
                                    this.selectedClientId = this.pendingClientId;
                                    this.clientId = this.pendingClientId;
                                    this.cdr.detectChanges();
                                    setTimeout(() => {
                                        this.initializeFeatherIcons();
                                    }, 200);
                                } else {
                                    if (this.selectedClient && this.selectedClient.id) {
                                        this.selectedClientId = this.selectedClient.id;
                                        this.clientId = this.selectedClient.id;
                                        setTimeout(() => {
                                            this.initializeFeatherIcons();
                                        }, 200);
                                    }
                                }
                                this.pendingClientId = undefined;
                            } else if (this.selectedClient && this.selectedClient.id && !this.selectedClientId) {
                                this.selectedClientId = this.selectedClient.id;
                                this.clientId = this.selectedClient.id;
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }
                            this.isLoadingProducts = false;

                            this.preloadStockQuantitiesForAllProducts();
                            this.projects = Array.isArray(projectsRes) ? projectsRes : projectsRes?.projectsListe || [];
                            this.isLoadingProjects = false;
                            this.fournisseurs = fournisseursRes?.data || [];
                            this.isLoadingFournisseurs = false;
                            this.tvaRates = tvaRes?.tvaListe || [];
                            this.categories = categoriesRes || [];
                            this.isLoadingCategories = false;
                            const taxList = taxesRes?.taxes || taxesRes?.data || taxesRes?.tvaListe || [];
                            if (Array.isArray(taxList)) {
                                this.taxes = taxList;
                                const fodecTax = this.taxes.find((t: any) =>
                                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                    this.isTaxActiveForDocument(t)
                                );
                                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                            } else {
                                this.taxes = [];
                                this.fodecRate = 0;
                            }
                            const routeUrlFill = (this.router.url || '').toLowerCase();
                            if (routeUrlFill.includes('/achat/bon-reception/')) {
                                this.documentType = 'BON RECEPTION';
                            } else {
                            this.documentType = this.getTypeFromId(doc.type_document_id);
                            }
                            this.loadCurrentTypeDocumentPrefixFromApi(
                                this.documentType === 'BON RECEPTION'
                                    ? this.typeDocumentIdMap['BON RECEPTION']
                                    : doc.type_document_id
                            );
                            if (this.isAvoirWarehouseLocked()) {
                                this.applySourceWarehouseFromDoc(doc);
                            }
                            this.documentReference = doc.ref_externe || '';
                            this.refExterne = doc.ref_externe || this.refExterne || '';
                            this.documentReferenceHeaderPending = false;
                            this.isReferenceReadonly = true;
                            this.referenceModelType = (doc as any).reference_model_type ?? null;
                            this.documentOriginalId = doc.document_original_id ?? (doc as any).document_original_id ?? null;
                            this.loadWarehouses();
                            setTimeout(() => {
                                if (this.usesDualEntrepotSelection()) {
                                    if (this.documentType === 'PV ECART') {
                                        this.applyPvEcartEntrepotsFromDoc(doc);
                                    } else {
                                    if (this.isBonSortieDocument()) {
                                        this.applyBonSortieEtablissementsFromDoc(doc);
                                    }
                                    const entrepotInitialId = doc.entrepot_id || doc.entrepot?.id;
                                    const entrepotDestinationId = doc.entrepot_dest_id || doc.entrepot_destination?.id;
                                    
                                    if (entrepotInitialId) {
                                        this.selectedWarehouseInitialId = entrepotInitialId;
                                        if (!doc.entrepot && entrepotInitialId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotInitialId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseInitialId = null;
                                    }
                                    
                                    if (entrepotDestinationId) {
                                        this.selectedWarehouseDestinationId = entrepotDestinationId;
                                        if (!doc.entrepot_destination && entrepotDestinationId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotDestinationId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseDestinationId = null;
                                    }
                                    if (this.isBonSortieDocument()) {
                                        this.applyBonSortieEntrepotsFromDoc(doc);
                                    } else {
                                        this.refreshWarehouseDestinationPanel();
                                    }
                                    }
                                } else {
                                    const entrepotId = doc.entrepot_id || doc.entrepot?.id;
                                    
                                    if (entrepotId) {
                                        this.selectedWarehouseId = entrepotId;
                                        if (!doc.entrepot && entrepotId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseId = null;
                                    }
                                }
                            }, 500);
                            this.loadStationData();
                            this.refreshAvailableEtablissements();
                            const entrepriseApi = doc.entreprises?.[0];
                            if (entrepriseApi && (!this.entreprise.nom || this.entreprise.nom === '--')) {
                                this.entreprise = {
                                    nom: entrepriseApi.nom_entreprise || 'Shopi',
                                    adresse: entrepriseApi.adresse || 'Adresse non définie',
                                    ville: entrepriseApi.ville || '',
                                    pays: entrepriseApi.pays || '',
                                    matricule_fiscal: entrepriseApi.matricule_fiscale || '--'
                                };
                            } else if (!this.entreprise.nom || this.entreprise.nom === '--') {
                                this.entreprise = {
                                    nom: 'Shopi',
                                    adresse: 'Adresse non définie',
                                    ville: '',
                                    pays: '',
                                    matricule_fiscal: '--'
                                };
                            }

                            const banqueApi = doc.coordonneesBancaires?.[0];
                            if (banqueApi) {
                                this.banque = {
                                    nom_banque: banqueApi.banque || banqueApi.nom || 'Banque non définie',
                                    rib: banqueApi.rib || '--',
                                    agence: banqueApi.agence || null,
                                };
                            } else {
                                this.banque = {nom_banque: 'Banque non définie', rib: '--'};
                            }
                            this.loadBanquesForDocument(banqueApi?.rib || null);

                            const isAchat = this.isAchatDocument();
                            if (isAchat) {
                                const apiFournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur || doc.fournisseur_data;
                                const fournisseurId = doc.fournisseur_id ?? apiFournisseur?.fournisseur_id ?? apiFournisseur?.id;
                                if (fournisseurId) {
                                    this.clientId = fournisseurId;
                                    this.fournisseurService.getFournisseurById(fournisseurId).subscribe({
                                        next: (fournisseurComplet) => {
                                            const fournisseurWithExtras = {
                                                ...fournisseurComplet,
                                                responsable: (fournisseurComplet as any).responsable || (fournisseurComplet as any).contact || '',
                                                phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                                            };
                                            const found = this.fournisseurs.find(f => f.id === fournisseurComplet.id);
                                            if (found) {
                                                this.selectedFournisseur = {...found, ...fournisseurWithExtras} as Fournisseur;
                                            } else {
                                                this.fournisseurs = [...this.fournisseurs, fournisseurWithExtras as Fournisseur];
                                                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurComplet.id;
                                            this.clientId = fournisseurComplet.id;
                                            this.cdr.detectChanges();
                                            setTimeout(() => {
                                                this.cdr.detectChanges();
                                                this.initializeFeatherIcons();
                                            }, 250);
                                        },
                                        error: (err) => {
                                            const found = this.fournisseurs.find(f => f.id === fournisseurId);
                                            if (found) {
                                                this.selectedFournisseur = found;
                                            } else if (apiFournisseur) {
                                                const temp: Partial<Fournisseur> = {
                                                    id: fournisseurId,
                                                    nom_entreprise: apiFournisseur.nom_entreprise || '--',
                                                    numero_identification_fiscale: apiFournisseur.numero_identification_fiscale || '',
                                                    telephones: apiFournisseur.telephones || [],
                                                    adresses: apiFournisseur.adresses || [],
                                                    emails: apiFournisseur.emails || [],
                                                    responsable: (apiFournisseur as any).responsable || (apiFournisseur as any).contact || '',
                                                    phone: this.getTelephoneString(apiFournisseur.telephones) || ''
                                                } as any;
                                                this.fournisseurs = [...this.fournisseurs, temp as Fournisseur];
                                                this.selectedFournisseur = temp as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurId;
                                            this.clientId = fournisseurId;
                                            this.cdr.detectChanges();
                                            setTimeout(() => {
                                                this.cdr.detectChanges();
                                                this.initializeFeatherIcons();
                                            }, 250);
                                        }
                                    });
                                }
                            } else {
                                const apiClient = doc.clients?.[0] || doc.client_data;
                                if (apiClient && (apiClient.id || apiClient.client_id)) {
                                    const clientId = apiClient.client_id || apiClient.id;
                                    const clientFromDocument: Partial<Client> = {
                                            id: clientId,
                                        nom_prenom: apiClient.nom_client || apiClient.nom_prenom || '',
                                            identifiant_unique: apiClient.identifiant_unique || '',
                                        adresses: apiClient.adresse && apiClient.adresse !== 'Adresse non renseignée' 
                                            ? [{
                                                adresse: apiClient.adresse,
                                                code_postal: '',
                                                region: '',
                                                pays: ''
                                            } as Address]
                                            : [],
                                        emails: apiClient.email 
                                            ? [{
                                                email: apiClient.email,
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Email]
                                            : [],
                                        telephones: apiClient.telephone 
                                            ? [{
                                                num_tel: apiClient.telephone.replace(/^\+216/, '') || apiClient.telephone,
                                                code_pays: apiClient.telephone.startsWith('+216') ? '+216' : '+216',
                                                type: 'mobile',
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Telephone]
                                            : []
                                    };
                                    const found = this.clients.find(
                                        (c) => c.id === clientId || c.id === apiClient.id
                                    );
                                    if (found) {
                                        found.nom_prenom = clientFromDocument.nom_prenom || found.nom_prenom;
                                        found.identifiant_unique = clientFromDocument.identifiant_unique || found.identifiant_unique;
                                        if (clientFromDocument.adresses && clientFromDocument.adresses.length > 0) {
                                            found.adresses = clientFromDocument.adresses;
                                        }
                                        if (clientFromDocument.emails && clientFromDocument.emails.length > 0) {
                                            found.emails = clientFromDocument.emails;
                                        }
                                        if (clientFromDocument.telephones && clientFromDocument.telephones.length > 0) {
                                            found.telephones = clientFromDocument.telephones;
                                        }
                                        this.selectedClient = {
                                            ...found,
                                            adresses: [...(found.adresses || [])],
                                            telephones: [...(found.telephones || [])],
                                            emails: [...(found.emails || [])]
                                        };
                                    } else {
                                        this.clients = [clientFromDocument as Client, ...this.clients];
                                        this.refreshClientsForSelect();
                                        this.selectedClient = {
                                            ...clientFromDocument,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        } as Client;
                                    }
                                    
                                    this.selectedClientId = clientId;
                                    this.clientId = clientId;
                                    this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
                                    this.cdr.markForCheck();
                                    this.cdr.detectChanges();
                                    setTimeout(() => {
                                        this.cdr.detectChanges();
                                        this.initializeFeatherIcons();
                                    }, 250);
                                }
                            }

                            const apiProjet = doc.projets?.[0];
                            if (apiProjet) {
                                this.originalProjectId = apiProjet.id ?? apiProjet.projet_id ?? null;
                                const found = this.projects.find(p => p.id === this.originalProjectId);
                                this.selectedProject = found?.libelle || apiProjet.titre || apiProjet.libelle || '';
                            } else {
                                this.originalProjectId = null;
                                this.selectedProject = '';
                            }

                            this.documentDate = this.formatDateToLocalString(doc.date || null);
                            this.dateLivraison = this.formatDateToLocalString(doc.date_livraison || doc.date || null);
                            this.syncFlatpickrDateConfigs();
                            this.syncFlatpickrReadonlyOnInstances();
                            this.note = doc.note || '';
                            this.documentId = doc.id;

                            const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                            this.applyItemsData(lignes);
                            this.enrichStockLcDocumentLinesAfterLoad(doc);
                            if (this.documentOriginalId != null && (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR')) {
                                this.ensureAvoirLinesNegated();
                            }

                            if (this.taxes && this.taxes.length > 0) {
                                this.items.forEach((item, i) => {
                                    if (item.product_id && item.type === 'product') {
                                        const descriptionFromLine = this.productDescriptions[i] || '';
                                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                                            next: (p: any) => {
                                                const productData = p.data || p;
                                                this.applyStockLcUnitPriceToItemFromProduct(i, productData);
                                                this.applyProductTaxes(productData, i, true);
                                                if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                    this.productDescriptions[i] = productData.description || '';
                                                } else {
                                                    this.productDescriptions[i] = descriptionFromLine;
                                                }
                                                this.cdr.detectChanges();
                                            },
                                            error: (err) => {
                                                if (this.productDescriptions[i] === undefined) {
                                                    this.productDescriptions[i] = descriptionFromLine || '';
                                                }
                                            }
                                        });
                                    }
                                });
                            } else {
                                this.loadTaxes();
                                setTimeout(() => {
                                    this.items.forEach((item, i) => {
                                        if (item.product_id && item.type === 'product') {
                                            const descriptionFromLine = this.productDescriptions[i] || '';
                                            this.productsService.getDetailsProduct(item.product_id).subscribe({
                                                next: (p: any) => {
                                                    const productData = p.data || p;
                                                    this.applyProductTaxes(productData, i, true);
                                                    if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                        this.productDescriptions[i] = productData.description || '';
                                                    } else {
                                                        this.productDescriptions[i] = descriptionFromLine;
                                                    }
                                                    this.cdr.detectChanges();
                                                },
                                                error: (err) => {
                                                    if (this.productDescriptions[i] === undefined) {
                                                        this.productDescriptions[i] = descriptionFromLine || '';
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }, 500);
                            }

                            const Total_TTC = parseFloat(doc.total_ttc) || 0;
                            const Base_RS = Total_TTC;
                            const Taux_RS = doc.Taux_RS || '0';
                            const tauxRSDecimal = parseFloat(Taux_RS) / 100;
                            const RS = Base_RS * tauxRSDecimal;
                            const Net_à_payer = Total_TTC - RS;
                            const timbreFiscal = this.isAvoirDocument()
                                ? 0
                                : (doc.timbre_fiscal != null && doc.timbre_fiscal !== ''
                                    ? parseFloat(doc.timbre_fiscal)
                                    : 0);
                            
                            this.totals = {
                                totalHT: parseFloat(doc.total_ht) || 0,
                                totalTVA: parseFloat(doc.total_tva) || 0,
                                totalTTC: Total_TTC,
                                totalRemise: parseFloat(doc.total_remise) || 0,
                                totalTaxesAvantTVA: 0,
                                totalBaseTVA: parseFloat(doc.total_ht) || 0,
                                totalTaxesApresTVA: 0,
                                retenueSource: RS,
                                netAPayer: Net_à_payer + timbreFiscal,
                                timbreFiscal: timbreFiscal,
                                Base_RS: Base_RS,
                                Taux_RS: Taux_RS,
                                RS: RS,
                                Net_à_payer: Net_à_payer,
                                documentLevelTaxLines: [],
                                documentLevelTaxesTotal: 0,
                                taxesAfterHT: [],
                                taxesAfterTTC: [],
                                taxesAfterTimbre: []
                            };

                            const parametrageDoc = doc.parametrage_doc || {};
                            this.applyTaxStatutDocumentFromParametrage(parametrageDoc.taxe_statut_document);
                            const fodecAfterParametrageEdit = this.taxes.find((t: any) =>
                                (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                this.isTaxActiveForDocument(t)
                            );
                            this.fodecRate = fodecAfterParametrageEdit ? parseFloat(fodecAfterParametrageEdit.valeur) : 0;

                            if (parametrageDoc.aff_montant_ttc !== undefined || doc.aff_montant_ttc !== undefined) {
                                const value = parametrageDoc.aff_montant_ttc ?? doc.aff_montant_ttc;
                                this.documentColumnSettings.aff_montant_ttc = value;
                                this.documentColumnSettings.afficherMontantsTTC = value;
                            }
                            if (parametrageDoc.aff_code_bar !== undefined || doc.aff_code_bar !== undefined) {
                                const value = parametrageDoc.aff_code_bar ?? doc.aff_code_bar;
                                this.documentColumnSettings.aff_code_bar = value;
                                this.documentColumnSettings.afficherCodeBarres = value;
                            }
                            if (parametrageDoc.aff_date_echeance !== undefined || parametrageDoc.aff_date_échéance !== undefined || doc.aff_date_echeance !== undefined || doc.aff_date_échéance !== undefined) {
                                const value = parametrageDoc.aff_date_echeance ?? parametrageDoc.aff_date_échéance ?? doc.aff_date_echeance ?? doc.aff_date_échéance;
                                this.documentColumnSettings.aff_date_echeance = value;
                                this.documentColumnSettings.afficherDateEcheance = value;
                            }
                            if (parametrageDoc.aff_date_liv !== undefined || doc.aff_date_liv !== undefined) {
                                const value = parametrageDoc.aff_date_liv ?? doc.aff_date_liv;
                                this.documentColumnSettings.aff_date_liv = value;
                                this.documentColumnSettings.afficherDateLivraison = value;
                            }
                            if (parametrageDoc.aff_montant_total !== undefined || doc.aff_montant_total !== undefined) {
                                const value = parametrageDoc.aff_montant_total ?? doc.aff_montant_total;
                                this.documentColumnSettings.aff_montant_total = value;
                                this.documentColumnSettings.afficherMontantTotal = value;
                            }
                            if (parametrageDoc.aff_coordonnees !== undefined || parametrageDoc.aff_coordonnées !== undefined || doc.aff_coordonnees !== undefined || doc.aff_coordonnées !== undefined) {
                                const value = parametrageDoc.aff_coordonnees ?? parametrageDoc.aff_coordonnées ?? doc.aff_coordonnees ?? doc.aff_coordonnées;
                                this.documentColumnSettings.aff_coordonnees = value;
                                this.documentColumnSettings.afficherCoordonneesClients = value;
                            }
                            if (parametrageDoc.reference !== undefined || parametrageDoc.référence !== undefined || doc.reference !== undefined || doc.référence !== undefined) {
                                const value = parametrageDoc.reference ?? parametrageDoc.référence ?? doc.reference ?? doc.référence;
                                this.documentColumnSettings.reference = value;
                            }
                            if (parametrageDoc.quantite !== undefined || parametrageDoc.quantité !== undefined || doc.quantite !== undefined || doc.quantité !== undefined) {
                                const value = parametrageDoc.quantite ?? parametrageDoc.quantité ?? doc.quantite ?? doc.quantité;
                                this.documentColumnSettings.quantite = value;
                            }
                            if (parametrageDoc.unite !== undefined || parametrageDoc.unité !== undefined || doc.unite !== undefined || doc.unité !== undefined) {
                                const value = parametrageDoc.unite ?? parametrageDoc.unité ?? doc.unite ?? doc.unité;
                                this.documentColumnSettings.unite = value;
                            }
                            if (parametrageDoc.prix_unitaire !== undefined || doc.prix_unitaire !== undefined) {
                                const value = parametrageDoc.prix_unitaire ?? doc.prix_unitaire;
                                this.documentColumnSettings.prix_unitaire = value;
                                this.documentColumnSettings.prixUnitaire = value;
                            }
                            if (parametrageDoc.tva !== undefined || doc.tva !== undefined) {
                                this.documentColumnSettings.tva = parametrageDoc.tva ?? doc.tva;
                            }
                            if (parametrageDoc.remise !== undefined || doc.remise !== undefined) {
                                this.documentColumnSettings.remise = parametrageDoc.remise ?? doc.remise;
                            }
                            const defaultClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            
                            const defaultFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                            let parsedClientFields: any = null;
                            if (doc.hidden_client_fields) {
                                if (typeof doc.hidden_client_fields === 'string') {
                                    try {
                                        parsedClientFields = JSON.parse(doc.hidden_client_fields);
                                    } catch (e) {
                                        parsedClientFields = null;
                                    }
                                } else if (typeof doc.hidden_client_fields === 'object') {
                                    parsedClientFields = doc.hidden_client_fields;
                                }
                            }
                            
                            if (parsedClientFields && typeof parsedClientFields === 'object') {
                                this.modifiedClientFields = { ...defaultClientFields, ...parsedClientFields };

                            } else {
                                this.modifiedClientFields = { ...defaultClientFields };
                            }
                            let parsedFournisseurFields: any = null;
                            if (doc.hidden_fournisseur_fields) {
                                if (typeof doc.hidden_fournisseur_fields === 'string') {
                                    try {
                                        parsedFournisseurFields = JSON.parse(doc.hidden_fournisseur_fields);
                                    } catch (e) {
                                        parsedFournisseurFields = null;
                                    }
                                } else if (typeof doc.hidden_fournisseur_fields === 'object') {
                                    parsedFournisseurFields = doc.hidden_fournisseur_fields;
                                }
                            }
                            
                            if (parsedFournisseurFields && typeof parsedFournisseurFields === 'object') {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...parsedFournisseurFields };
                            } else {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields };
                            }
                            this.saveModifiedFields();
                            this.cdr.markForCheck();
                            this.cdr.detectChanges();
                            localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
                            this.documentColumnSettings = {...this.documentColumnSettings};

                            this.updateHeaderConfig();
                            this.calculateTotals();
                            this.updateApproveButtonState();
                            this.loadVenteAchatParamForCurrentDocumentType();
                            if (this.isBonSortieDocument() && this.documentId) {
                                this.refreshBonSortieLinkedDocuments(doc);
                            }

                            setTimeout(() => {
                                this.cdr.detectChanges();
                                this.isLoadingEdit = false;
                                this.isLoadingClients = false;
                                this.isLoadingFournisseurs = false;
                                this.isLoadingProducts = false;
                                this.isLoadingProjects = false;
                                this.isLoadingCategories = false;
                                this.isLoadingWarehouses = false;

                                this.cdr.markForCheck();
                                this.cdr.detectChanges();
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }, 200);
                        });

                    },

                    error: (err) => {
                        this.toastr.error('Erreur lors du chargement des données');
                        this.isLoadingEdit = false;
                        this.cdr.detectChanges();
                    }
                });
            },
            error: (err) => {
                this.toastr.error('Impossible de contacter le serveur');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
            }
        });
    }

    private getTypeFromId(id: number): string {
        const fromApi = this.typeIdToDocumentTypeFromApi[id];
        if (fromApi) {
            return fromApi;
        }
        const map: { [key: number]: string } = {
            7: 'DEVIS',
            8: 'COMMANDE CLIENT',
            9: 'BON DE SORTIE',
            10: 'BON DE LIVRAISON',
            11: 'FACTURE',
            12: 'COMMANDE FOURNISSEUR',
            13: 'BON RECEPTION',
            14: 'FACTURE FOURNISSEUR',
            15: 'INVENTAIRE',
            16: 'BON TRANSFERT',
            18: 'RETOUR FOURNISSEUR',
            19: 'AVOIR FOURNISSEUR'
        };
        return map[id] || 'DEVIS';
    }
    private isAvoirDocument(): boolean {
        const url = this.router.url.toLowerCase();
        if (this.documentType === 'AVOIR' || this.documentType === 'AVOIR FOURNISSEUR') {
            return true;
        }
        if (url.includes('/vente/avoir/') || url.includes('/achat/avoir-fournisseur/')) {
            return true;
        }
        // Ne pas traiter une FACTURE liée (document_original_id) comme un avoir :
        // sinon Approuver envoie statut « Non utilisé » au lieu de « Non payé ».
        return false;
    }

    private validateClientAndProject(): boolean {
        if (!this.shouldShowClient()) {
            return true;
        }
        if (!this.selectedClient) {
            this.toastr.warning('Veuillez sélectionner un client.', 'Client requis');
            return false;
        }
        return true;
    }

    getAdresseString(adresses?: Address[] | any[]): string {
        if (!adresses || adresses.length === 0) {
            return 'Adresse non renseignée';
        }
        
        const a = adresses[0];
        if (!a) {
            return 'Adresse non renseignée';
        }
        const parts: string[] = [];
        
        if (a.adresse) {
            parts.push(a.adresse);
        }
        
        if (a.code_postal) {
            parts.push(a.code_postal);
        }
        
        if (a.ville) {
            parts.push(a.ville);
        }
        
        if (a.region) {
            parts.push(a.region);
        }
        
        if (a.pays) {
            parts.push(a.pays);
        }
        const adresseFormatee = parts.join(', ').trim();
        
        return adresseFormatee || 'Adresse non renseignée';
    }

    getEmailString(emails?: Email[]): string {
        return emails?.[0]?.email || 'email@exemple.com';
    }

    getTelephoneString(telephones?: Telephone[]): string {
        if (!telephones || telephones.length === 0) {
            return '--';
        }
        const t = telephones[0];
        return `${t.code_pays || '+216'}${t.num_tel || '00000000'}`;
    }

    getResponsableFournisseur(fournisseur: Fournisseur | null): string {
        if (!fournisseur) {
            return 'Non renseigné';
        }
        return (fournisseur as any).responsable || 
               (fournisseur as any).contact || 
               (fournisseur as any).nom_contact ||
               'Non renseigné';
    }

    private normalizeString(str: string | null | undefined): string {
        if (!str) {
            return '';
        }
        return str.trim().toLowerCase();
    }

    getClientIdentifiant(): string {
        if (!this.selectedClient) {
            return '--';
        }

        const found = this.clients.find(c =>
            this.normalizeString(c.nom_prenom) === this.normalizeString(this.selectedClient?.nom_prenom || '')
        );

        return found?.identifiant_unique ||
            (found as any)?.identifiant_client ||
            found?.id?.toString() ||
            '--';
    }

    private buildPreviewData(): any {
        const clientData = this.selectedClient ? {
            id: this.resolveDocumentClientId(this.selectedClient),
            client_id: this.resolveDocumentClientId(this.selectedClient),
            nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
            identifiant_unique: this.getClientIdentifiant(),
            email: this.getEmailString(this.selectedClient.emails),
            adresse: this.getAdresseString(this.selectedClient.adresses),
            telephone: this.getTelephoneString(this.selectedClient.telephones)
        } : null;

        return {
            user_id: this.currentUser.id,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 9,
            typeDocument: {titre: this.documentType},
            reference: this.documentReference,
            date_document: this.documentDate,
            client_data: clientData,
            projets: this.selectedProject ? [{libelle: this.selectedProject}] : [],
            note: this.note || '--',
            lignes_document: this.items
                .map((i, idx) => ({ i, idx }))
                .filter(({ i }) => i.type === 'product' && i.designation)
                .map(({ i, idx }) => {
                    const a = this.buildLigneDocumentAttributsProduit(i, this.barcodePickerModel[idx]);
                    return {
                    libelle: i.designation,
                    qnt: i.quantity,
                    prix_ht: i.priceHT,
                    tva: i.tva || 19,
                    total_ht: i.totalHT,
                    product_id: i.product_id || null,
                    code_bar: a.code_bar,
                    ref_interne: a.ref_interne,
                    couleur: a.couleur,
                    taille: a.taille,
                    ajout_ligne: i.ajout_ligne && i.ajout_ligne.length > 0 ? i.ajout_ligne.map((ligne: any) => ({
                        contenu_text: ligne.contenu_text || '',
                        rubrique: ligne.rubrique || '',
                        separateur: ligne.separateur || false,
                        sous_total: Number(ligne.sous_total) || 0,
                        order: Number(ligne.order) || 0
                    })) : undefined
                    };
                })
        };
    }

    private buildPreviewDataFromApi(doc: any): any {
        const client = doc.clients?.[0] || doc.client_data;
        const fournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur_data;
        const projet = doc.projets?.[0];

        return {
            id: doc.id,
            typeDocument: {titre: this.getTypeFromId(doc.type_document_id)},
            reference: doc.ref_externe,
            date_document: doc.date,

            client_data: client ? {
                nom_client: client.nom_prenom || client.nom_client || '--',
                identifiant_unique: client.identifiant_unique || '--',
                numero_identification_fiscale: client.numero_identification_fiscale || '--',
                email: client.email || '--',
                adresse: this.formatAdresse(client.adresses?.[0]) || '--',
                telephone: this.getTelephoneString(client.telephones)
            } : null,

            fournisseur_data: fournisseur ? {
                nom_entreprise: fournisseur.nom_entreprise || '--',
                numero_identification_fiscale: fournisseur.numero_identification_fiscale || '--',
                responsable: fournisseur.responsable || (fournisseur as any).contact || '--',
                phone: this.getTelephoneString(fournisseur.telephones) || '--',
                adresse: this.formatAdresse(fournisseur.adresses?.[0]) || '--',
                email: this.getEmailString(fournisseur.emails) || '--',
                telephone: this.getTelephoneString(fournisseur.telephones) || '--'
            } : null,

            projets: projet ? [{libelle: projet.titre || projet.libelle || '--'}] : [],
            note: doc.note || '--',

            lignes_document: (doc.lignesDocument || doc.lignes_document || []).map((l: any) => {
                const prixHT = parseFloat(l.result_ht) || parseFloat(l.prix_ht) || 0;
                return {
                    libelle: l.libelle,
                    qnt: parseFloat(l.qnt),
                    prix_ht: prixHT,
                    tva: parseFloat(l.tva) || 19,
                    total_ht: prixHT * parseFloat(l.qnt),
                    product_id: l.product_id || null,
                    code_bar: l.code_bar ?? l.code_barre ?? null,
                    ref_interne: l.ref_interne ?? l.reference ?? null,
                    ref_fabricant: l.ref_fabricant ?? l.ref_fabriquant ?? null,
                    couleur: l.couleur ?? null,
                    taille: l.taille ?? null,
                    ajout_ligne: l.ajout_ligne && Array.isArray(l.ajout_ligne) ? l.ajout_ligne.map((al: any) => ({
                        contenu_text: al.contenu_text || '',
                        rubrique: al.rubrique || '',
                        separateur: al.separateur || false,
                        sous_total: Number(al.sous_total) || 0,
                        order: Number(al.order) || 0
                    })) : undefined
                };
            })
        };
    }

    private formatAdresse(addr: any): string {
        if (!addr) {
            return 'Adresse non renseignée';
        }
        return `${addr.adresse || ''}, ${addr.code_postal || ''} ${addr.region || ''}, ${addr.pays || ''}`.trim();
    }

    updateDocument(customStatutId?: number): Observable<any> {
        if (!this.documentId) {
            this.toastr.error('ID du document manquant.');
            return throwError(() => new Error('ID du document manquant.'));
        }
        if (!this.currentUser?.id || !this.stationId) {
            this.toastr.error('Utilisateur ou station non chargé.');
            return throwError(() => new Error('Utilisateur ou station non chargé.'));
        }
        if (this.mode === 'edit' && !this.currentStatutId && !customStatutId) {
            return this.documentService.getDocumentById(this.documentId).pipe(
                catchError((error) => {
                    return throwError(() => error);
                }),
                switchMap((response: any) => {
                    const doc = response?.data?.document || response?.data || response;
                    if (doc && doc.statut_id) {
                        this.currentStatutId = doc.statut_id;
                    }
                    return this.performUpdateDocument(customStatutId);
                })
            );
        } else {
            return this.performUpdateDocument(customStatutId);
        }
    }

    private performUpdateDocument(customStatutId?: number): Observable<any> {

        const isAchat = this.isAchatDocument();
        let clientDataPayload: any = undefined;
        let fournisseurDataPayload: any = undefined;
        let projetPivot: ProjetPivot | null = null;
        const projetIdToSend = this.getProjetId();
        if (projetIdToSend) {
            const found = this.projects.find(p => p.id === projetIdToSend);
            if (found) {
                projetPivot = {
                    id_projet: String(found.id),
                    titre: found.libelle || 'Projet sans nom'
                };
            }
        } else if (this.originalProjectId) {
            const found = this.projects.find(p => p.id === this.originalProjectId);
            if (found) {
                projetPivot = {
                    id_projet: String(found.id),
                    titre: found.libelle || 'Projet sans nom'
                };
            }
        }
        if (!isAchat && this.selectedClient) {
            const clientActif = this.clients.find(c => c.id === this.selectedClient!.id);
            clientDataPayload = {
                client_id: clientActif ? this.resolveDocumentClientId(this.selectedClient) : null,
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            };
            if (!clientActif) {
                this.toastr.warning('Client inactif : envoi avec client_id = null');
            }
        }
        if (isAchat && this.selectedFournisseur) {
            const fournisseurActif = this.fournisseurs.find(f => f.id === this.selectedFournisseur!.id);
            fournisseurDataPayload = {
                fournisseur_id: fournisseurActif ? this.selectedFournisseur.id : null,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '',
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            };
        }
        let statutIdToUse: number;
        if (customStatutId !== undefined) {
            statutIdToUse = customStatutId;
        } else if (this.currentStatutId) {
            statutIdToUse = this.currentStatutId;
        } else if (this.mode === 'edit' && this.documentId) {
            statutIdToUse = 1;
        } else {
            statutIdToUse = this.getApproveStatutId();
        }
        const userId = this.mode === 'edit' && this.currentDocumentUserId != null
            ? this.currentDocumentUserId
            : (this.currentUser?.id ?? 0);
        const typeDocumentId = this.mode === 'edit' && this.currentTypeDocumentId != null
            ? this.currentTypeDocumentId
            : (this.typeDocumentIdMap[this.documentType] ?? 0);

        const payload: DocumentPayload = {
            user_id: userId,
            station_id: this.stationId,
            etablissement_id: this.resolvePayloadEtablissementId(),
            type_document_id: typeDocumentId,
            statut_id: statutIdToUse,
            ...this.documentRefPayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note,
            total_ht: this.totals.totalHT.toFixed(3),
            total_tva: this.totals.totalTVA.toFixed(3),
            total_ttc: this.totals.totalTTC.toFixed(3),
            timbre_fiscal: this.getTimbreFiscalEffective().toFixed(3),
            net_payer: this.totals.netAPayer.toFixed(3),
            entrepot_id: this.usesDualEntrepotSelection() 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.usesDualEntrepotSelection() && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),
            ...(this.documentOriginalId != null && { document_original_id: this.documentOriginalId }),
            ...this.referenceModelTypePayloadSpread(),
            client_data: clientDataPayload,
            fornisseur_data: fournisseurDataPayload,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            parametrage_doc: (() => {
                const parametrageDoc = this.buildParametrageDoc();
                return parametrageDoc;
            })(),

            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },

            date_echeance: '',
            nbr_date: 0,
            color: '#134AD3',

            lignes_document: this.prepareLignesDocumentForSave()
        };

        const cleanedPayload = this.cleanPayload(payload);
        if (!this.documentId) {
            return throwError(() => new Error('ID du document manquant'));
        }
        
        return this.documentService.update(this.documentId, cleanedPayload).pipe(
            catchError((error) => {
                throw error;
            })
        );
    }

    saveDocument(): void {
        if (!this.validateClientAndProject()) {
            return;
        }
        if (this.isApproveButtonDisabled) {
            return;
        }
        if (this.isSubmitting) return;
        this.syncSessionFromStorage();
        const sessionUserId = Number(this.currentUser?.id) || 0;
        const sessionStationId = this.stationId;
        if (!sessionUserId || !sessionStationId || sessionStationId <= 0) {
            this.toastr.error(
                'Les champs station_id et user_id sont obligatoires (session invalide). Reconnectez-vous.',
                'Erreur'
            );
            return;
        }
        if (this.mode === 'edit' && this.documentId) {
            this.setDocumentSubmitting(true);
            this.toastr.info('Mise à jour du document en cours...', '', { timeOut: 5000 });
            
            this.recalculateAll();
            this.updateDocument().subscribe({
                next: () => {
                    this.toastr.success('Document mis à jour avec succès !');
                    this.setDocumentSubmitting(false);
                    if (this.documentType === 'INVENTAIRE') {
                        this.router.navigate(['/inventaire/action/validation'], {queryParams: {id: this.documentId}});
                    } else if (this.isErpBonTransfertDocument()) {
                        this.router.navigate(['/bon-transfert/action/validation'], {queryParams: {id: this.documentId}});
                    } else if (this.isLogicielCaisseEntrepotTransfert()) {
                        this.router.navigate(['/transfert-entrepot/action/validation'], {
                            queryParams: { id: this.documentId, return: '/transfert-entrepot/tous' },
                        });
                    } else {
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], {queryParams: {id: this.documentId}});
                    }
                },
                error: (err) => {
                    this.setDocumentSubmitting(false);
                    this.toastr.error(err?.error?.message || 'Erreur lors de la mise à jour');
                }
            });
            return;
        }
        this.setDocumentSubmitting(true);
        this.updateHeaderConfig();
        this.cdr.detectChanges();
        this.calculateTotals();
        const isAchat = this.isAchatDocument();
        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const projet = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (projet) {
                projetPivot = {
                    id_projet: String(projet.id),
                    titre: projet.libelle || 'Projet sans titre'
                };
            }
        }

        // --- CLIENT / FOURNISSEUR ---
        const clientDataPayload = !isAchat && this.selectedClient ? {
            client_id: this.resolveDocumentClientId(this.selectedClient),
            nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
            identifiant_unique: this.selectedClient.identifiant_unique || null,
            numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
            adresse: this.getAdresseString(this.selectedClient.adresses),
            email: this.getEmailString(this.selectedClient.emails),
            telephone: this.getTelephoneString(this.selectedClient.telephones)
        } : null;

        const fournisseurDataPayload = isAchat && this.selectedFournisseur ? {
            fournisseur_id: this.selectedFournisseur.id,
            nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
            numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
            phone: this.getTelephoneString(this.selectedFournisseur.telephones),
            adresse: this.getAdresseString(this.selectedFournisseur.adresses),
            email: this.getEmailString(this.selectedFournisseur.emails)
        } : null;

        const f = (n: number) => n.toFixed(3);
        const parametrageDoc = this.buildParametrageDoc();
        const payload: any = {
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,

            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            etablissement_id: this.resolvePayloadEtablissementId(),
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: this.getApproveStatutId(),
            entrepot_id: this.usesDualEntrepotSelection() 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.usesDualEntrepotSelection() && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),
            ...(this.documentOriginalId != null && { document_original_id: this.documentOriginalId }),

            client_data: clientDataPayload,
            fornisseur_data: fournisseurDataPayload,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            parametrage_doc: parametrageDoc,
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },

            lignes_document: this.prepareLignesDocumentForSave()
        };

        const entrepotIdValue = this.usesDualEntrepotSelection()
            ? (this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined 
                ? this.selectedWarehouseInitialId 
                : payload.entrepot_id)
            : (this.selectedWarehouseId !== null && this.selectedWarehouseId !== undefined 
                ? this.selectedWarehouseId 
                : payload.entrepot_id);
        
        const entrepotDestIdValue = this.usesDualEntrepotSelection()
            ? (this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined 
                ? this.selectedWarehouseDestinationId 
                : payload.entrepot_dest_id)
            : null;
        payload.user_id = sessionUserId;
        payload.station_id = sessionStationId;

        Object.keys(payload).forEach(key => {
            if (key === 'user_id' || key === 'station_id') {
                return;
            }
            if (key !== 'entrepot_id' && key !== 'entrepot_dest_id' && key !== 'hidden_client_fields' && key !== 'hidden_fournisseur_fields' && key !== 'parametrage_doc') {
            if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
                delete payload[key];
                }
            }
        });

        if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }

        if (entrepotIdValue !== null && entrepotIdValue !== undefined && entrepotIdValue !== '') {
            payload.entrepot_id = entrepotIdValue;
        } else {
            delete payload.entrepot_id;
        }

        if (this.usesDualEntrepotSelection() && entrepotDestIdValue !== null && entrepotDestIdValue !== undefined && entrepotDestIdValue !== '') {
            payload.entrepot_dest_id = entrepotDestIdValue;
        } else if (this.usesDualEntrepotSelection()) {
            delete payload.entrepot_dest_id;
        }

        this.applyLogicielCaisseEntrepotToPayload(payload);

        if (payload.lignes_document && Array.isArray(payload.lignes_document)) {
            payload.lignes_document.forEach((ligne: any, idx: number) => {
                if (ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne)) {
                }
            });
        }
        if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }
        if (!payload.hasOwnProperty('parametrage_doc') || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }

        const onCreateSuccess = (res: any, pairedBonLivraisonId?: number | null) => {
            const id = res?.data?.id || res?.data?.document?.id || res?.id;
            if (id) {
                this.applyAllocatedReferenceFromCreateResponse(res);
            }
            this.currentStatutId = this.getApproveStatutId();
            const afterCreateCommon = () => {
                this.runPostCreateStockUpdates(id, () => this.schedulePostDocumentStockAlerts(), pairedBonLivraisonId);
                if (this.documentType === 'FACTURE FOURNISSEUR') {
                    this.updateProductsValeurUnitaireForFactureFournisseur();
                }
                this.toastr.success(
                    pairedBonLivraisonId
                        ? 'Facture et bon de livraison créés avec succès !'
                        : 'Document créé avec succès !'
                );
                const goAfterLink = () => {
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    this.router.navigate([this.getBasePath(), 'action', 'validation'], {queryParams: {id}});
                };
                this.linkTicketsToErpFactureIfNeeded$(id, res).subscribe({
                    next: () => goAfterLink(),
                    error: () => goAfterLink()
                });
            };

            afterCreateCommon();
        };
        const onCreateError = (err: any) => {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.cdr.detectChanges();
            const errorMessage = err?.error?.message || err?.message || 'Erreur lors de la création';
            this.toastr.error(errorMessage, 'Erreur de sauvegarde');
        };

        if (this.isBonTransfertOrEntrepotTransfert()) {
            this.documentService.create(payload).subscribe({
                next: onCreateSuccess,
                error: (err) => {
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    this.cdr.detectChanges();
                    this.toastr.error(err?.error?.message || err?.message || 'Erreur lors de la création', 'Erreur de sauvegarde');
                }
            });
        } else if (this.documentType === 'FACTURE') {
            this.createFactureWithOptionalBonLivraison$().subscribe({
                next: ({ res, pairedBlId }) => onCreateSuccess(res, pairedBlId),
                error: onCreateError
            });
        } else {
            this.documentService.create(payload).subscribe({
                next: (res) => onCreateSuccess(res),
                error: onCreateError
            });
        }
    }
    private buildParametrageDoc(): any {
        const parametrageDoc = {
            aff_montant_ttc: this.documentColumnSettings.aff_montant_ttc !== undefined 
                ? this.documentColumnSettings.aff_montant_ttc 
                : (this.documentColumnSettings.afficherMontantsTTC !== undefined ? this.documentColumnSettings.afficherMontantsTTC : false),
            aff_code_bar: this.documentColumnSettings.aff_code_bar !== undefined 
                ? this.documentColumnSettings.aff_code_bar 
                : (this.documentColumnSettings.afficherCodeBarres !== undefined ? this.documentColumnSettings.afficherCodeBarres : true),
            aff_date_echeance: this.documentColumnSettings.aff_date_echeance !== undefined 
                ? this.documentColumnSettings.aff_date_echeance 
                : (this.documentColumnSettings.afficherDateEcheance !== undefined ? this.documentColumnSettings.afficherDateEcheance : false),
            aff_date_liv: this.documentColumnSettings.aff_date_liv !== undefined 
                ? this.documentColumnSettings.aff_date_liv 
                : (this.documentColumnSettings.afficherDateLivraison !== undefined ? this.documentColumnSettings.afficherDateLivraison : true),
            aff_montant_total: this.documentColumnSettings.aff_montant_total !== undefined 
                ? this.documentColumnSettings.aff_montant_total 
                : (this.documentColumnSettings.afficherMontantTotal !== undefined ? this.documentColumnSettings.afficherMontantTotal : true),
            aff_coordonnees: this.documentColumnSettings.aff_coordonnees !== undefined 
                ? this.documentColumnSettings.aff_coordonnees 
                : (this.documentColumnSettings.afficherCoordonneesClients !== undefined ? this.documentColumnSettings.afficherCoordonneesClients : true),
            reference: this.documentColumnSettings.reference !== undefined 
                ? this.documentColumnSettings.reference 
                : false,
            quantite: this.documentColumnSettings.quantite !== undefined
                ? this.documentColumnSettings.quantite
                : (this.documentColumnSettings.quantité !== undefined ? this.documentColumnSettings.quantité : true),
            unité: this.documentColumnSettings.unité !== undefined 
                ? this.documentColumnSettings.unité 
                : (this.documentColumnSettings.unite !== undefined ? this.documentColumnSettings.unite : false),
            prix_unitaire: this.documentColumnSettings.prix_unitaire !== undefined 
                ? this.documentColumnSettings.prix_unitaire 
                : (this.documentColumnSettings.prixUnitaire !== undefined ? this.documentColumnSettings.prixUnitaire : true),
            tva: this.documentColumnSettings.tva !== undefined ? this.documentColumnSettings.tva : true,
            remise: this.documentColumnSettings.remise !== undefined ? this.documentColumnSettings.remise : false,
            color: this.primaryColor || '#134AD3',
            label: this.documentLabel || '',
            date_echeance: this.dateFrequency || 'jours',
            nbr_date: this.nbrDate || 1,
            ...(Object.keys(this.documentTaxStatutOverrides).length > 0
                ? { taxe_statut_document: { ...this.documentTaxStatutOverrides } }
                : {})
        };
        return parametrageDoc;
    }

    private cleanPayload(payload: DocumentPayload): DocumentPayload {
        const cleaned: any = {...payload};
        const required = ['user_id', 'type_document_id', 'statut_id', 'station_id'];
        const parametrageDocAttribute = ['parametrage_doc'];
        const hiddenFieldsAttributes = [
            'hidden_client_fields', 'hidden_fournisseur_fields'
        ];
        const entrepotIdValue = cleaned.entrepot_id;
        const entrepotDestIdValue = cleaned.entrepot_dest_id;

        Object.keys(cleaned).forEach(key => {
            if (required.includes(key) || parametrageDocAttribute.includes(key) || hiddenFieldsAttributes.includes(key)) {
                return;
            }
            if (key === 'lignes_document') {
                return;
            }
            if (key === 'entrepot_id') {
                return;
            }
            if (key === 'entrepot_dest_id') {
                return;
            }
            if (key === 'parametrage_doc') {
                return;
            }
            const value = cleaned[key];
            if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
                delete cleaned[key];
            }
        });
        if (entrepotIdValue !== null && entrepotIdValue !== undefined && entrepotIdValue !== '') {
            cleaned.entrepot_id = entrepotIdValue;
        } else {
            delete cleaned.entrepot_id;
        }
        if (entrepotDestIdValue !== null && entrepotDestIdValue !== undefined && entrepotDestIdValue !== '') {
            cleaned.entrepot_dest_id = entrepotDestIdValue;
        } else {
            delete cleaned.entrepot_dest_id;
        }
        if (!cleaned.lignes_document) {
            cleaned.lignes_document = [];
        }
        if (cleaned.lignes_document && Array.isArray(cleaned.lignes_document)) {
            cleaned.lignes_document.forEach((ligne: any, idx: number) => {
                if (!ligne.hasOwnProperty('ajout_ligne')) {
                    ligne.ajout_ligne = [];
                } else if (ligne.ajout_ligne === undefined || ligne.ajout_ligne === null) {
                    ligne.ajout_ligne = [];
                }

            });
        }
        if (!cleaned.parametrage_doc || cleaned.parametrage_doc === null || cleaned.parametrage_doc === undefined) {
            cleaned.parametrage_doc = this.buildParametrageDoc();
        }
        
        return cleaned as DocumentPayload;
    }

    private getProjetId(): number | null {
        const projet = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
        return projet?.id || null;
    }

    onDocumentSettingsChange(settings: any) {
        if (settings.reference !== undefined) {
            this.documentColumnSettings.reference = settings.reference;
            this.documentColumnSettings.référence = settings.reference;
        }
        if (settings.quantite !== undefined) {
            this.documentColumnSettings.quantite = settings.quantite;
            this.documentColumnSettings.quantité = settings.quantite;
        }
        if (settings.unite !== undefined) {
            this.documentColumnSettings.unite = settings.unite;
            this.documentColumnSettings.unité = settings.unite;
        }
        if (settings.prixUnitaire !== undefined) {
            this.documentColumnSettings.prixUnitaire = settings.prixUnitaire;
            this.documentColumnSettings.prix_unitaire = settings.prixUnitaire;
        }
        if (settings.tva !== undefined) {
            this.documentColumnSettings.tva = settings.tva;
        }
        if (settings.remise !== undefined) {
            this.documentColumnSettings.remise = settings.remise;
        }
        if (settings.afficherMontantsTTC !== undefined) {
            this.documentColumnSettings.afficherMontantsTTC = settings.afficherMontantsTTC;
            this.documentColumnSettings.aff_montant_ttc = settings.afficherMontantsTTC;
        }
        if (settings.afficherCodeBarres !== undefined) {
            this.documentColumnSettings.afficherCodeBarres = settings.afficherCodeBarres;
            this.documentColumnSettings.aff_code_bar = settings.afficherCodeBarres;
        }
        if (settings.afficherDateEcheance !== undefined) {
            this.documentColumnSettings.afficherDateEcheance = settings.afficherDateEcheance;
            this.documentColumnSettings.aff_date_echeance = settings.afficherDateEcheance;
        }
        if (settings.afficherDateLivraison !== undefined) {
            this.documentColumnSettings.afficherDateLivraison = settings.afficherDateLivraison;
            this.documentColumnSettings.aff_date_liv = settings.afficherDateLivraison;
        }
        if (settings.afficherMontantTotal !== undefined) {
            this.documentColumnSettings.afficherMontantTotal = settings.afficherMontantTotal;
            this.documentColumnSettings.aff_montant_total = settings.afficherMontantTotal;
        }
        if (settings.afficherCoordonneesClients !== undefined) {
            this.documentColumnSettings.afficherCoordonneesClients = settings.afficherCoordonneesClients;
            this.documentColumnSettings.aff_coordonnees = settings.afficherCoordonneesClients;
        }
        if (settings.afficherProduitsMatriciel !== undefined) {
            this.paramDocAffProduitMatriciel = isTruthyTinyInt(settings.afficherProduitsMatriciel);
        }
        if (settings.parametrage_doc) {
            if (settings.parametrage_doc.color !== undefined) {
                this.primaryColor = settings.parametrage_doc.color;
            }
            if (settings.parametrage_doc.label !== undefined && settings.parametrage_doc.label !== '') {
                this.documentLabel = settings.parametrage_doc.label;
            }
            if (settings.parametrage_doc.date_echeance !== undefined) {
                this.dateFrequency = settings.parametrage_doc.date_echeance;
            }
            if (settings.parametrage_doc.nbr_date !== undefined) {
                this.nbrDate = settings.parametrage_doc.nbr_date;
            }
        }

        this.documentColumnSettings = {...this.documentColumnSettings};

        this.cdr.detectChanges();
    }

    onDocumentSettingsPersist(event: {
        settings: any;
        complete: (result: { success: boolean; message?: string }) => void;
    }): void {
        const { settings, complete } = event;
        setTimeout(() => {
            this.onDocumentSettingsChange(settings);
            if (!this.documentId) {
                this.persistDocumentSettingsAtStationLevel(complete);
                return;
            }
            this.persistDocumentParametrageOnly(complete);
        }, 0);
    }

    private invokeDocumentSettingsPersistComplete(
        onComplete: ((result: { success: boolean; message?: string }) => void) | undefined,
        result: { success: boolean; message?: string },
        done: { called: boolean }
    ): void {
        if (done.called || !onComplete) {
            return;
        }
        done.called = true;
        onComplete(result);
    }

    /** Nouveau document achat (ex. add commande fournisseur) : PUT paramètres station + type document. */
    private persistDocumentSettingsAtStationLevel(
        onComplete?: (result: { success: boolean; message?: string }) => void
    ): void {
        const done = { called: false };
        const sid = Number(this.stationId) || getStationIdFromLocalStorage();
        if (!Number.isFinite(sid) || sid <= 0) {
            this.invokeDocumentSettingsPersistComplete(onComplete, {
                success: false,
                message: 'Station introuvable pour enregistrer les paramètres.',
            }, done);
            return;
        }
        const typeId = this.typeDocumentIdMap[this.documentType];
        if (!typeId) {
            this.invokeDocumentSettingsPersistComplete(onComplete, { success: true }, done);
            return;
        }
        this.parametreDocumentSettingsService.getByStation(sid).subscribe({
            next: (bundle) => {
                const pd = bundle?.parametre_document ?? {};
                const category: 'vente' | 'achat' = this.isAchatDocument() ? 'achat' : 'vente';
                const venteAchat = [...(bundle?.vente_achat ?? [])];
                const idx = venteAchat.findIndex(
                    (r) => Number(r.type_document_id) === Number(typeId)
                );
                const rowPatch: Partial<VenteAchatParametreRow> = {
                    type_document_id: typeId,
                    document_category: category,
                    couleur: this.primaryColor || '#134AD3',
                    label: this.documentLabel || this.documentType || '',
                    date_paiement: (this.dateFrequency as VenteAchatParametreRow['date_paiement']) ?? 'jours',
                    nb_date: this.nbrDate ?? 1,
                };
                if (idx >= 0) {
                    venteAchat[idx] = { ...venteAchat[idx], ...rowPatch };
                } else {
                    venteAchat.push({
                        ...rowPatch,
                        aff_montant_totaux: 1,
                        aff_inf_contact: 1,
                        aff_courte_desp: 0,
                        aff_num_bn_liv: 0,
                        note: null,
                        insr_orig_artcl: 0,
                        insr_qr_cd: 0,
                    } as VenteAchatParametreRow);
                }
                const modeleRef =
                    pd.modele_reference != null && Number.isFinite(Number(pd.modele_reference))
                        ? Math.floor(Number(pd.modele_reference))
                        : null;
                const body: ParametreDocumentPutBody = {
                    active_bon_liv: isTruthyTinyInt(pd.active_bon_liv ?? false),
                    modele_reference: modeleRef,
                    aff_produit_matriciel: isTruthyTinyInt(this.paramDocAffProduitMatriciel),
                    vente_achat: venteAchat.map((r) => normalizeVenteAchatRow(r)),
                };
                this.parametreDocumentSettingsService
                    .update(sid, body)
                    .pipe(
                        catchError((err) => {
                            const status = err?.status;
                            if (status === 404 || status === 405) {
                                return this.parametreDocumentSettingsService.create(sid, {
                                    ...body,
                                    active_bon_liv: body.active_bon_liv ?? false,
                                });
                            }
                            return throwError(() => err);
                        }),
                        finalize(() => this.cdr.markForCheck())
                    )
                    .subscribe({
                        next: () => {
                            try {
                                localStorage.setItem(
                                    'documentColumnSettings',
                                    JSON.stringify(this.documentColumnSettings)
                                );
                            } catch {
                                /* ignore */
                            }
                            this.invokeDocumentSettingsPersistComplete(
                                onComplete,
                                { success: true },
                                done
                            );
                        },
                        error: (err) => {
                            const apiMsg =
                                err?.error?.message ||
                                (Array.isArray(err?.error?.errors)
                                    ? err.error.errors.join(', ')
                                    : null) ||
                                err?.message;
                            this.invokeDocumentSettingsPersistComplete(
                                onComplete,
                                {
                                    success: false,
                                    message:
                                        apiMsg ||
                                        'Erreur lors de l\'enregistrement des paramètres du document.',
                                },
                                done
                            );
                        },
                    });
            },
            error: () => {
                this.invokeDocumentSettingsPersistComplete(
                    onComplete,
                    {
                        success: false,
                        message: 'Impossible de charger les paramètres document de la station.',
                    },
                    done
                );
            },
        });
    }

    private persistDocumentParametrageOnly(
        onComplete?: (result: { success: boolean; message?: string }) => void
    ): void {
        const done = { called: false };
        if (!this.documentId) {
            this.invokeDocumentSettingsPersistComplete(
                onComplete,
                { success: false, message: 'Document introuvable.' },
                done
            );
            return;
        }
        const isAchat = this.isAchatDocument();
        const payload: any = {
            user_id: this.currentUser?.id,
            station_id: this.stationId,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: this.currentStatutId,
            parametrage_doc: this.buildParametrageDoc(),
        };
        if (isAchat && this.selectedFournisseur?.id) {
            payload.fournisseur_id = this.selectedFournisseur.id;
        } else if (!isAchat && this.selectedClient?.id) {
            payload.client_id = this.resolveDocumentClientId(this.selectedClient);
        }
        this.documentService
            .update(this.documentId, payload)
            .pipe(finalize(() => this.cdr.markForCheck()))
            .subscribe({
                next: () =>
                    this.invokeDocumentSettingsPersistComplete(
                        onComplete,
                        { success: true },
                        done
                    ),
                error: (err) => {
                    const apiMsg =
                        err?.error?.message ||
                        (Array.isArray(err?.error?.errors) ? err.error.errors.join(', ') : null) ||
                        err?.message;
                    this.invokeDocumentSettingsPersistComplete(
                        onComplete,
                        {
                            success: false,
                            message:
                                apiMsg ||
                                'Erreur lors de l\'enregistrement des paramètres du document.',
                        },
                        done
                    );
                },
            });
    }

    onTaxesUpdated(): void {
        this.loadTaxes();
        this.cdr.detectChanges();
    }

    getUniteLibelle(item: any): string {
        if (item.unite_libelle) {
            return item.unite_libelle;
        }

        if (item.product_id) {
            const cached = this.products.find(p => p.id === item.product_id);
            if (cached?.unite?.libelle) {
                item.unite_libelle = cached.unite.libelle;
                return item.unite_libelle;
            }
        }

        return '--';
    }

    openAddWarehouseModal(target: 'single' | 'initial' | 'destination' = 'single'): void {
        this.warehouseModalTarget = target;
        this.editWarehouseModal.warehouseData = null;
        this.editWarehouseModal.openModal();
    }
    openViewWarehouseInitialModal(): void {
        if (this.selectedWarehouseInitialId == null) {
            this.toastr.warning('Veuillez sélectionner un entrepôt initial', 'Entrepôt initial');
            return;
        }
        const warehouse = this.warehouses?.find((w: any) => w.id === this.selectedWarehouseInitialId);
        if (!warehouse) {
            this.toastr.warning('Entrepôt initial introuvable', 'Entrepôt initial');
            return;
        }
        this.editWarehouseModal.warehouseData = {
            id: warehouse.id,
            nom: warehouse.nom,
            adresse: warehouse.adresse,
            ville: warehouse.ville,
            code_postal: warehouse.code_postal,
            pays: warehouse.pays
        };
        this.editWarehouseModal.openModal();
    }

    openAddProduct():void{
        if (!this.warehouses?.length) {
            this.loadWarehouses();
        }
        this.addProductModal.openModal();
    }

    onWarehouseSaved(apiResponse?: any): void {
        const newId = this.extractWarehouseIdFromSaveResponse(apiResponse);
        this.loadWarehouses(newId);
    }

    onDualEntrepotInitialChange(): void {
        if (this.isBonSortieDocument()) {
            this.reloadStockQuantitiesForAllProducts();
        }
        this.onWarehouseChange();
    }

    onWarehouseChange(): void {
        if (this.shouldFilterStockByEntrepot()) {
            if (
                this.isLogicielCaisseEntrepotTransfert() &&
                this.logicielCaisseTransfertEditId &&
                !(Number(this.selectedWarehouseInitialId) > 0)
            ) {
                this.updateApproveButtonState();
                this.cdr.detectChanges();
                return;
            }
            console.log(`🔄 [onWarehouseChange] Entrepôt changé pour ${this.documentType}, rechargement des quantités de stock...`);
            this.stockQuantitiesCache.clear();
            this.selectOptionStockByCacheKey.clear();
            this.selectOptionStockLoadingKeys.clear();
            this.items.forEach(item => {
                if (item && item.type === 'product') {
                    (item as Item).availableQuantity = undefined;
                    (item as Item).stockResolved = false;
                }
            });
            this.products.forEach(p => {
                (p as any).availableQuantity = undefined;
            });
            this.reloadStockQuantitiesForAllProducts();
            if (this.products.length > 0) {
                this.preloadStockQuantitiesForAllProducts();
            }
            this.preloadSelectStockTotalsForDocumentOptions();
        }
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    getColspan(): number {
        return Math.max(1, this.getProductTableColumnCount() - 1);
    }

    getActiveTaxesForProduct(item: any): any[] {
        if (!item.product_id || !this.taxes?.length) {
            return [];
        }
        return this.taxes.filter((taxe: any) => {
            const appliqueTva = taxe.applique_tva === true || taxe.applique_tva === 1 || taxe.applique_a_la_tva === true || taxe.applique_a_la_tva === 1;
            const taxeSurProduits = taxe.taxe_applique_sur_produits === true || taxe.taxe_applique_sur_produits === 1 || taxe.taxe_applique_sur_produits === '1' || taxe.taxe_applique_sur_produits === 'true';
            return this.isTaxActiveForDocument(taxe) && !appliqueTva && taxeSurProduits;
        });
    }

    isTaxeAssignedToProduct(item: any, taxe: any): boolean {
        return (item['taxesProduit'] || []).some((t: any) =>
            t.id === taxe.id || (t.taxes_id != null && t.taxes_id === taxe.id)
        );
    }
    toggleTaxeForLine(lineIndex: number, taxe: any): void {
        const item = this.items[lineIndex];
        if (!item || item.type !== 'product') return;
        const list = (item['taxesProduit'] || []) as any[];
        const isAssigned = list.some((t: any) => t.id === taxe.id || (t.taxes_id != null && t.taxes_id === taxe.id));
        if (isAssigned) {
            item['taxesProduit'] = list.filter((t: any) => t.id !== taxe.id && t.taxes_id !== taxe.id);
        } else {
            const toAdd = this.taxes?.find((t: any) => t.id === taxe.id) || { ...taxe, id: taxe.id };
            item['taxesProduit'] = [...list, toAdd];
        }
        item['fodecApplique'] = (item['taxesProduit'] || []).some((tax: any) =>
            tax.nom?.toLowerCase().includes('fodec') || tax.label?.toLowerCase().includes('fodec')
        );
        this.calculateLine(lineIndex);
        this.calculateTotals();
        this.cdr.detectChanges();
        if (this.documentId && (this.mode === 'edit' || this.isEditing)) {
            this.updateDocument().subscribe({
                next: () => this.toastr.success('Taxe mise à jour'),
                error: (err) => this.toastr.error(err?.error?.message || 'Erreur lors de la mise à jour de la taxe')
            });
        }
    }

    private saveAndExecute(action: () => void): void {
        if (this.mode !== 'edit' || !this.documentId) {
            action();
            return;
        }
        if (!this.currentStatutId && this.documentId) {
            this.documentService.getDocumentById(this.documentId).subscribe({
                next: (response) => {
                    const doc = response?.data?.document || response?.data || response;
                    if (doc && doc.statut_id) {
                        this.currentStatutId = doc.statut_id;
                    }
                    this.performSaveAndExecute(action);
                },
                error: () => {
                    this.performSaveAndExecute(action);
                }
            });
        } else {
            this.performSaveAndExecute(action);
        }
    }

    private performSaveAndExecute(action: () => void): void {
        this.setDocumentSubmitting(true);

        this.recalculateAll();

        const statutToUse = this.currentStatutId || undefined;
        this.updateDocument(statutToUse).subscribe({
            next: () => {
                this.toastr.success('Modifications sauvegardées !');
                this.setDocumentSubmitting(false);
                action();
            },
            error: () => {
                this.setDocumentSubmitting(false);
                this.toastr.error('Erreur de sauvegarde');
                if (confirm('Continuer sans sauvegarder ?')) action();
            }
        });
    }

    private changeStatutAndSave(newStatutId: number): void {
        if (this.isSubmitting) {
            return;
        }
        const targetStatutId = Number(newStatutId);
        if (!Number.isFinite(targetStatutId) || targetStatutId <= 0) {
            this.toastr.error('Statut cible invalide — rechargement des statuts requis.', 'Document');
            return;
        }
        if (!this.documentId || !this.stationId) {
            this.toastr.error('ID du document ou station manquant.');
            return;
        }
        // BR « Reçu » / BL « Livré » : entrepôt ERP requis avant mouvement stock.
        if (
            ((this.documentType === 'BON RECEPTION' && targetStatutId === this.statutIdMap['Reçu']) ||
                (this.documentType === 'BON DE LIVRAISON' && targetStatutId === this.statutIdMap['Livré'])) &&
            !this.selectedWarehouseId
        ) {
            this.toastr.error(
                'Sélectionnez un entrepôt ERP avant de continuer (le stock sera mis à jour sur cet entrepôt).',
                'Entrepôt requis'
            );
            return;
        }

        this.setDocumentSubmitting(true);
        this.recalculateAll();
        this.updateDocument(targetStatutId).subscribe({
            next: () => {
                this.currentStatutId = targetStatutId;
                const docId = this.documentId;
                this.toastr.success('Document mis à jour !');
                const isBrRecu =
                    this.documentType === 'BON RECEPTION' &&
                    targetStatutId === this.statutIdMap['Reçu'] &&
                    docId != null;
                const isBlLivre =
                    this.documentType === 'BON DE LIVRAISON' &&
                    targetStatutId === this.statutIdMap['Livré'] &&
                    docId != null;
                if (isBrRecu || isBlLivre) {
                    this.updateStockForDocument(docId, () => {
                        this.schedulePostDocumentStockAlerts();
                        this.setDocumentSubmitting(false);
                        this.retour();
                    });
                } else if (
                    this.documentType === 'BON RECEPTION' &&
                    targetStatutId === this.statutIdMap['Annulé']
                ) {
                    this.setDocumentSubmitting(false);
                    this.retour();
                } else if (
                    this.documentType === 'RETOUR FOURNISSEUR' &&
                    targetStatutId === this.statutIdMap['Retourné'] &&
                    docId != null
                ) {
                    this.applyLcRetourFournisseurPhysiqueStock(docId, () => {
                        this.setDocumentSubmitting(false);
                        void this.router.navigate(['/achat/retour-fournisseur/tous']);
                    });
                } else if (
                    this.documentType === 'RETOUR FOURNISSEUR' &&
                    targetStatutId === this.statutIdMap['Annulé'] &&
                    docId != null
                ) {
                    this.applyLcRetourFournisseurAnnulerDisponibleStock(docId, () => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        this.cdr.markForCheck();
                    });
                } else if (targetStatutId === this.statutIdMap['Annulé'] && docId != null) {
                    this.setDocumentSubmitting(false);
                    this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                        queryParams: { id: docId }
                    });
                } else if (this.documentType === 'PV ECART') {
                    // Soumis, En traitement, Clôturé, etc. : rester sur add-pv-ecart (Validé → validatePvEcartFromEnTraitement).
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    this.cdr.markForCheck();
                } else if (
                    this.documentType === 'BON TRANSFERT' &&
                    this.isBonTransfertFromPvEcart() &&
                    (targetStatutId === this.statutIdMap['Crée'] ||
                        targetStatutId === this.statutIdMap['Créé']) &&
                    docId != null
                ) {
                    this.runPostCreateStockUpdates(docId, () => {
                        this.schedulePostDocumentStockAlerts();
                        this.setDocumentSubmitting(false);
                        void this.router.navigate(['/stock/bon-transfert/add-bon-transfert'], {
                            queryParams: { id: docId, return: '/stock/pv-ecart/valide' },
                        });
                    });
                } else {
                    this.setDocumentSubmitting(false);
                    this.retour();
                }
            },
            error: () => {
                this.setDocumentSubmitting(false);
                this.toastr.error('Erreur lors de la mise à jour');
            }
        });
    }

    /** Depuis Annulé : repasse en Brouillon et reste sur l’écran document (édition). */
    private remettreEnBrouillonFromAnnule(): void {
        if (this.documentType === 'BON RECEPTION') {
            this.toastr.warning(
                'Un bon de réception ne peut pas être remis en brouillon.',
                'Action impossible'
            );
            return;
        }
        if (this.isSubmitting) {
            return;
        }
        this.setDocumentSubmitting(true);
        this.recalculateAll();
        const brouillonId = this.statutIdMap['Brouillon'];
        this.updateDocument(brouillonId).subscribe({
            next: () => {
                this.currentStatutId = brouillonId;
                this.mode = 'edit';
                this.isEditing = true;
                this.updateHeaderConfig();
                this.toastr.success('Document remis en brouillon');
                this.setDocumentSubmitting(false);
                this.cdr.detectChanges();
            },
            error: () => {
                this.setDocumentSubmitting(false);
                this.toastr.error('Erreur lors de la remise en brouillon');
            }
        });
    }

    private recalculateAll(): void {
        this.items.forEach((item, index) => {
            if (item.type === 'product') {
                this.calculateTotal(index);
            }
        });
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    getLineTotalHT(item: any): number {
        if (!item || item.type !== 'product') {
            return 0;
        }
        const prixHT = this.resolveProductLineUnitPrice(item);
        const quantite =
            item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        const remisePourcent = Number(item.remise) || 0;
        let htApresRemise = prixHT * quantite;
        if (remisePourcent > 0) {
            htApresRemise = htApresRemise * (1 - remisePourcent / 100);
        }
        const taxesAvant = Number(item.taxesAvantTVA);
        const extraTaxes = Number.isFinite(taxesAvant) ? taxesAvant : 0;
        return Number((htApresRemise + extraTaxes).toFixed(3));
    }

    onProductAdded(event: any): void {
        if (event.success && event.product) {
            this.products.unshift(event.product);
            this.rebuildProductsForDocumentSelect();
            const lastItem = this.items[this.items.length - 1];
            if (lastItem && lastItem.type === 'product' && !lastItem.designation) {
                this.onProductSelect(this.items.length - 1, event.product);
            }
        }
    }

    getLineTotalTTC(item: any): number {
        if (!item || item.type !== 'product') {
            return 0;
        }

        if (item.ttcLigne !== undefined) {
            return Number(item.ttcLigne);
        }

        const quantity = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        const priceHT = (this.isStockLcDocumentType())
            ? (Number(item.valeur_unitaire) || 0)
            : (Number(item.priceHT) || 0);
        const remisePourcent = Number(item.remise || 0);

        let htBrut = priceHT * quantity;
        let htApresRemise = htBrut * (1 - remisePourcent / 100);

        let totalTaxesAvantTVA = 0;
        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const taux = parseFloat(taxe.valeur || '0');
            if (isNaN(taux) || taux === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (appliqueAvantTVA) {
                totalTaxesAvantTVA += htApresRemise * (taux / 100);
            }
        });

        const baseTVA = htApresRemise + totalTaxesAvantTVA;
        const tauxTVA = Number(item.tva || 0);
        const montantTVA = baseTVA * (tauxTVA / 100);

        let totalTaxesApresTVA = 0;
        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const taux = parseFloat(taxe.valeur || '0');
            if (isNaN(taux) || taux === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (!appliqueAvantTVA) {
                const baseApres = baseTVA + montantTVA;
                totalTaxesApresTVA += baseApres * (taux / 100);
            }
        });

        const ttc = baseTVA + montantTVA + totalTaxesApresTVA;
        return Number(ttc.toFixed(3));
    }

    deselectClient() {
        this.selectedClient = null;
        this.selectedClientId = null;
        this.clientId = null;
        this.editMode = {
            nomClient: false,
            identifiant: false,
            numeroIdentification: false,
            adresse: false,
            email: false
        };
        this.cdr.detectChanges();
    }

    deselectFournisseur() {
        this.selectedFournisseur = null;
        this.selectedFournisseurId = null;
        this.clientId = null;
        this.editModeFournisseur = {
            nomEntreprise: false,
            numeroIdentification: false,
            responsable: false,
            telephone: false,
            adresse: false
        };
        this.cdr.detectChanges();
    }

    toggleEdit(field: 'nomClient' | 'identifiant' | 'numeroIdentification' | 'adresse' | 'email'): void {
        this.modifiedClientFields[field] = !this.modifiedClientFields[field];
        this.saveModifiedFields();
        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
    }

    
    private updateFeatherIconForClickedButton(element: HTMLElement, field: 'nomClient' | 'identifiant' | 'adresse' | 'email'): void {
        if (this.isInitializingIcons) {
            return;
        }
        let button = element.closest('button');
        if (!button && element.tagName === 'BUTTON') {
            button = element as HTMLButtonElement;
        }
        if (!button) return;
        
        const icon = button.querySelector('i[data-feather]') as HTMLElement;
        if (!icon) return;
        const isHidden = this.modifiedClientFields[field] === true;
        const newIconName = isHidden ? 'eye-off' : 'eye';
        icon.setAttribute('data-feather', newIconName);
        requestAnimationFrame(() => {
            const svgs = button!.querySelectorAll('svg');
            svgs.forEach(svg => svg.remove());
            setTimeout(() => {
                feather.replace();
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            }, 10);
        });
    }
    
    private updateFeatherIconForField(field: 'nomClient' | 'identifiant' | 'adresse' | 'email'): void {
        if (this.isInitializingIcons) {
            return;
        }
        requestAnimationFrame(() => {
            const container = document.querySelector('app-document');
            if (!container) {
                return;
            }
            setTimeout(() => {
                const allIcons = container.querySelectorAll('.btn-icon-eye i[data-feather]');

                if (allIcons.length > 0) {
                    const buttons = container.querySelectorAll('.btn-icon-eye');
                    buttons.forEach(btn => {
                        const svgs = btn.querySelectorAll('svg');
                        svgs.forEach(svg => svg.remove());
                    });
                    setTimeout(() => {
                        feather.replace();
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }, 20);
                }
            }, 50);
        });
    }

    private refreshEyeIconsOnly(): void {
        this.initializeFeatherIcons();
    }

    prepareAndToggle(field: 'adresse' | 'email'): void {

        if (field === 'adresse' && !this.editMode.adresse) {
            const adresseString = this.getAdresseString(this.selectedClient?.adresses) || '';
            this.tempAdresse = adresseString;
        }
        if (field === 'email' && !this.editMode.email) {
            const emailString = this.getEmailString(this.selectedClient?.emails) || '';
            this.tempEmail = emailString;
        }

        this.toggleEdit(field);
    }

    saveAdresse(): void {
        if (!this.selectedClient || !this.tempAdresse.trim()) return;

        const parts = this.tempAdresse.split(',').map(p => p.trim());
        const adresseObj: Partial<Address> = {
            adresse: parts[0] || '',
            code_postal: parts[1] || '',
            region: parts[2] || '',
            pays: parts[3] || ''
        };

        if (!this.selectedClient.adresses || this.selectedClient.adresses.length === 0) {
            this.selectedClient.adresses = [adresseObj as Address];
        } else {
            this.selectedClient.adresses[0] = { ...this.selectedClient.adresses[0], ...adresseObj };
        }
        this.modifiedClientFields['adresse'] = true;
        this.saveModifiedFields();
    }

    saveEmail(): void {
        if (!this.selectedClient || !this.tempEmail.trim()) return;

        const emailObj: Partial<Email> = { email: this.tempEmail.trim() };

        if (!this.selectedClient.emails || this.selectedClient.emails.length === 0) {
            this.selectedClient.emails = [emailObj as Email];
        } else {
            this.selectedClient.emails[0] = emailObj as Email;
        }
        this.modifiedClientFields['email'] = true;
        this.saveModifiedFields();
    }
    toggleEditFournisseur(field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse', _event?: Event): void {
        this.modifiedFournisseurFields[field] = !this.modifiedFournisseurFields[field];
        this.saveModifiedFields();
        this.cdr.detectChanges();
        this.cdr.markForCheck();
        this.replaceFeatherIconsNow();
    }

    private updateFeatherIconForClickedButtonFournisseur(element: HTMLElement, field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse'): void {
        if (this.isInitializingIcons) {
            return;
        }
        let button = element.closest('button');
        if (!button && element.tagName === 'BUTTON') {
            button = element as HTMLButtonElement;
        }
        if (!button) return;

        const icon = button.querySelector('i[data-feather]') as HTMLElement;
        if (!icon) return;
        const isHidden = this.modifiedFournisseurFields[field] === true;
        const newIconName = isHidden ? 'eye-off' : 'eye';
        icon.setAttribute('data-feather', newIconName);
        requestAnimationFrame(() => {
            const svgs = button!.querySelectorAll('svg');
            svgs.forEach(svg => svg.remove());
            setTimeout(() => {
                feather.replace();
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            }, 10);
        });
    }

    private updateFeatherIconForFournisseurField(field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse'): void {
        if (this.isInitializingIcons) {
            return;
        }
        requestAnimationFrame(() => {
            const container = document.querySelector('app-document');
            if (!container) {
                return;
            }
            setTimeout(() => {
                const allIcons = container.querySelectorAll('.btn-icon-eye i[data-feather]');

                if (allIcons.length > 0) {
                    const buttons = container.querySelectorAll('.btn-icon-eye');
                    buttons.forEach(btn => {
                        const svgs = btn.querySelectorAll('svg');
                        svgs.forEach(svg => svg.remove());
                    });
                    setTimeout(() => {
                        feather.replace();
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }, 20);
                }
            }, 50);
        });
    }

    prepareAndToggleFournisseur(field: 'adresse' | 'telephone'): void {
        if (field === 'adresse' && !this.editModeFournisseur.adresse) {
            this.tempAdresseFournisseur = this.getAdresseString(this.selectedFournisseur?.adresses) || '';
        }
        if (field === 'telephone' && !this.editModeFournisseur.telephone) {
            this.tempTelephoneFournisseur = this.getTelephoneString(this.selectedFournisseur?.telephones) || '';
        }
        this.toggleEditFournisseur(field);
    }

    saveAdresseFournisseur(): void {
        if (!this.selectedFournisseur || !this.tempAdresseFournisseur.trim()) return;

        const parts = this.tempAdresseFournisseur.split(',').map(p => p.trim());
        const adresseObj: Partial<Address> = {
            adresse: parts[0] || '',
            code_postal: parts[1] || '',
            region: parts[2] || '',
            pays: parts[3] || ''
        };

        if (!this.selectedFournisseur.adresses || this.selectedFournisseur.adresses.length === 0) {
            this.selectedFournisseur.adresses = [adresseObj as Address];
        } else {
            this.selectedFournisseur.adresses[0] = { ...this.selectedFournisseur.adresses[0], ...adresseObj };
        }

        this.modifiedFournisseurFields['adresse'] = true;
        this.saveModifiedFields();
    }

    updateResponsableFournisseur(event: any): void {
        if (this.selectedFournisseur) {
            (this.selectedFournisseur as any).responsable = event.target.value;
            this.modifiedFournisseurFields['responsable'] = true;
            this.saveModifiedFields();
        }
    }
    private saveModifiedFields(): void {
        const key = this.documentId 
            ? `modifiedFields_doc_${this.documentId}` 
            : `modifiedFields_temp_${this.selectedClientId || this.selectedFournisseurId || 'new'}`;
        
        const data = {
            clientFields: this.modifiedClientFields,
            fournisseurFields: this.modifiedFournisseurFields,
            documentId: this.documentId,
            timestamp: new Date().toISOString()
        };
        
        localStorage.setItem(key, JSON.stringify(data));
    }

    private loadModifiedFields(): void {
        // Valeurs par défaut (tous les champs affichés)
        const defaultClientFields = {
            nomClient: false,
            identifiant: false,
            numeroIdentification: false,
            adresse: false,
            email: false
        };
        
        const defaultFournisseurFields = {
            nomEntreprise: false,
            numeroIdentification: false,
            responsable: false,
            telephone: false,
            adresse: false
        };
        if (this.documentId) {
            const key = `modifiedFields_doc_${this.documentId}`;
            const saved = localStorage.getItem(key);
            
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }
                    
                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés:', e);
                }
            }
        }
        const clientId = this.selectedClientId || this.selectedClient?.id;
        const fournisseurId = this.selectedFournisseurId || this.selectedFournisseur?.id;
        
        if (clientId) {
            const key = `modifiedFields_temp_${clientId}`;
            const saved = localStorage.getItem(key);
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }

                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés (temp):', e);
                }
            }
        }
        
        if (fournisseurId) {
            const key = `modifiedFields_temp_${fournisseurId}`;
            const saved = localStorage.getItem(key);
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }

                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés (temp):', e);
                }
            }
        }
        this.modifiedClientFields = { ...defaultClientFields };
        this.modifiedFournisseurFields = { ...defaultFournisseurFields };
    }

    isClientFieldModified(field: string): boolean {
        if (!this.modifiedClientFields || !(field in this.modifiedClientFields)) {
            return false;
        }
        return this.modifiedClientFields[field] === true;
    }

    isFournisseurFieldModified(field: string): boolean {
        if (!this.modifiedFournisseurFields || !(field in this.modifiedFournisseurFields)) {
            return false;
        }
        return this.modifiedFournisseurFields[field] === true;
    }

    toggleProductDescription(index: number): void {
        const item = this.items[index];
        if (!item || !item.product_id) {
            return;
        }

        this.showProductDescription[index] = !this.showProductDescription[index];
        if (this.showProductDescription[index] && (this.productDescriptions[index] === '' || this.productDescriptions[index] === undefined)) {
            this.loadProductDescription(index);
        } else {
            this.cdr.detectChanges();
        }
    }

    private loadProductDescription(index: number): void {
        const item = this.items[index];
        if (!item || !item.product_id) {
            return;
        }

        const product = this.products.find(p => p.id === item.product_id);
        if (product && product.description) {
            this.productDescriptions[index] = product.description || '';
            this.showProductDescription[index] = true;
            this.cdr.detectChanges();
            return;
        }

        this.productsService.getDetailsProduct(item.product_id).subscribe({
            next: (res: any) => {
                const productData = res.data || res;
                this.productDescriptions[index] = productData.description || '';
                this.showProductDescription[index] = true;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.productDescriptions[index] = '';
                this.showProductDescription[index] = true;
                this.cdr.detectChanges();
            }
        });
    }

    private normalizeWarehouseLabelForErp(s: string): string {
        return String(s ?? '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
    }

    private findErpEntrepotIdByLibelle(
        rows: Array<{ id?: number; libelle?: string; nom?: string }>,
        labelFromDocument: string
    ): number | null {
        const target = this.normalizeWarehouseLabelForErp(labelFromDocument);
        if (!target) {
            return null;
        }
        const row = rows.find((r) => {
            const l = r.libelle ?? r.nom ?? '';
            return this.normalizeWarehouseLabelForErp(l) === target;
        });
        const id = row?.id;
        return id != null && Number.isFinite(Number(id)) ? Number(id) : null;
    }

    /** Description courte ligne document → stock_transfert_ligne_document.note (LC). */
    private getProductLineNoteForStockTransfert(itemIndex: number): string | undefined {
        const raw = this.productDescriptions[itemIndex];
        if (raw == null) {
            return undefined;
        }
        const trimmed = String(raw).trim();
        return trimmed !== '' ? trimmed : undefined;
    }

    private buildStockTransfertsPayloadForBonTransfert(
        entrepot_id_depart: number,
        entrepot_id_reception: number
    ): {
        user_id: number;
        station_id: number;
        date_transfert: string;
        entrepot_id_depart: number;
        entrepot_id_reception: number;
        origine: string;
        note: string;
        lignes: Array<{
            libelle_article: string;
            reference: string;
            note?: string;
            allocations: Array<{
                quantite: number;
                product_id: number;
                code_barre: string;
                note?: string;
            }>;
        }>;
    } | null {
        if (this.documentType !== 'BON TRANSFERT') {
            return null;
        }
        if (!Number.isFinite(entrepot_id_depart) || !Number.isFinite(entrepot_id_reception)) {
            return null;
        }
        const dateRaw = (this.documentDate || this.getTodayLocal()).trim();
        let d: Date;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateRaw)) {
            d = new Date(`${dateRaw}T12:00:00`);
        } else {
            d = new Date(dateRaw);
        }
        const date_transfert = !isNaN(d.getTime()) ? d.toISOString() : new Date().toISOString();

        const lignes: Array<{
            libelle_article: string;
            reference: string;
            note?: string;
            allocations: Array<{
                quantite: number;
                product_id: number;
                code_barre: string;
                note?: string;
            }>;
        }> = [];

        for (let itemIndex = 0; itemIndex < this.items.length; itemIndex++) {
            const it = this.items[itemIndex];
            if (it.type !== 'product' || !it.designation?.trim() || it.product_id == null) {
                continue;
            }
            const q = Number(it.quantity);
            if (!Number.isFinite(q) || q <= 0) {
                continue;
            }
            const pid = Number(it.product_id);
            if (!Number.isFinite(pid) || pid <= 0) {
                continue;
            }
            const refLine =
                it.reference != null && String(it.reference).trim() !== ''
                    ? String(it.reference).trim()
                    : '-';
            const cb = String(it.code_barre ?? '').trim();
            const lineNote = this.getProductLineNoteForStockTransfert(itemIndex);
            lignes.push({
                libelle_article: it.designation.trim(),
                reference: refLine,
                ...(lineNote ? { note: lineNote } : {}),
                allocations: [
                    {
                        quantite: q,
                        product_id: pid,
                        code_barre: cb,
                        ...(lineNote ? { note: lineNote } : {}),
                    }
                ]
            });
        }

        if (lignes.length === 0) {
            return null;
        }

        return {
            user_id: 1,
            station_id: 1,
            date_transfert,
            entrepot_id_depart,
            entrepot_id_reception,
            origine: 'manuelle',
            note: (this.note ?? '').trim(),
            lignes
        };
    }

    private postStockTransfertsApiForBonTransfert(): Observable<unknown> {
        const depSel = this.selectedWarehouseInitialId;
        const recSel = this.selectedWarehouseDestinationId;
        if (depSel == null || recSel == null || Number.isNaN(Number(depSel)) || Number.isNaN(Number(recSel))) {
            return of(null);
        }
        const whDep = this.warehouses.find((w: any) => Number(w?.id) === Number(depSel));
        const whRec = this.warehouses.find((w: any) => Number(w?.id) === Number(recSel));
        const nomDep = String(whDep?.nom ?? '').trim();
        const nomRec = String(whRec?.nom ?? '').trim();
        if (!nomDep || !nomRec) {

            return of(null);
        }
        return this.warehouseService.getAllEntrepotsErpForStockTransfert().pipe(
            switchMap((rows) => {
                const idDep = this.findErpEntrepotIdByLibelle(rows, nomDep);
                const idRec = this.findErpEntrepotIdByLibelle(rows, nomRec);
                if (idDep == null || idRec == null) {

                    return of(null);
                }
                const payload = this.buildStockTransfertsPayloadForBonTransfert(idDep, idRec);
                if (!payload) {
                    return of(null);
                }
                return this.stockService.createStockTransfert(payload);
            })
        );
    }

    /** Réédition transfert LC : éviter quantités dispo figées (ex. 0 après annulation). */
    private resetStockDisplayStateForLcTransfertEdit(): void {
        for (const it of this.items) {
            if (it?.type !== 'product') {
                continue;
            }
            it.availableQuantity = undefined;
            it.stockResolved = false;
        }
        this.stockQuantitiesCache.clear();
        this.selectOptionStockByCacheKey.clear();
        this.selectOptionStockLoadingKeys.clear();
        (this.products || []).forEach((p) => {
            (p as { availableQuantity?: number }).availableQuantity = undefined;
        });
    }

    private applyLcTransfertDetailLinesToItems(detail: {
        lignes?: Array<{
            libelle_article?: string;
            reference?: string;
            description?: string | null;
            note?: string | null;
            barcodes?: Array<{
                quantite?: number;
                code_barre?: string;
                product_id?: number | null;
                description?: string | null;
                note?: string | null;
            }>;
        }>;
    }): void {
        this.items = [];
        this.productDescriptions = {};
        this.showProductDescription = {};
        for (const lg of detail.lignes || []) {
            for (const bc of lg.barcodes || []) {
                const q = Math.trunc(Number(bc.quantite) || 0);
                if (q === 0) {
                    continue;
                }
                if (q < 0 && !this.logicielCaisseTransfertFromPvEcart) {
                    continue;
                }
                const itemIndex = this.items.length;
                this.items.push({
                    type: 'product',
                    designation: String(lg.libelle_article ?? '').trim(),
                    quantity: q,
                    reference: String(lg.reference ?? '').trim() || '-',
                    code_barre: String(bc.code_barre ?? '').trim(),
                    priceHT: 0,
                    tva: '0',
                    totalHT: 0,
                    product_id: bc.product_id ?? null,
                } as Item);
                const descRaw = bc.note ?? bc.description ?? lg.note ?? lg.description;
                const desc = descRaw != null ? String(descRaw).trim() : '';
                if (desc) {
                    this.productDescriptions[itemIndex] = desc;
                    this.showProductDescription[itemIndex] = this.isVenteAchatAffCourteDesp();
                }
            }
        }
        if (this.items.length === 0) {
            this.items.push(this.createEmptyProductLineItem());
        }
    }

    private loadLogicielCaisseTransfertForDocumentEdit(lcId: number): void {
        this.lcStockTransfert.getById(lcId).subscribe({
            next: (detail) => {
                const dep = Number(detail.entrepot_id_depart);
                const rec = Number(detail.entrepot_id_reception);
                this.pendingLcTransfertWarehouseDepId =
                    Number.isFinite(dep) && dep > 0 ? dep : null;
                const entrepotsFromPvEcart =
                    this.logicielCaisseTransfertFromPvEcart &&
                    this.pvEcartSourceDocumentId != null &&
                    this.pvEcartSourceDocumentId > 0;
                if (entrepotsFromPvEcart) {
                    this.pendingLcTransfertWarehouseDestId = null;
                } else {
                    this.pendingLcTransfertWarehouseDestId =
                        Number.isFinite(rec) && rec > 0 ? rec : null;
                    this.selectedWarehouseInitialId = this.pendingLcTransfertWarehouseDepId;
                    this.selectedWarehouseDestinationId = this.pendingLcTransfertWarehouseDestId;
                }
                this.note = detail.note ?? '';
                if (detail.date_transfert) {
                    const d = new Date(detail.date_transfert);
                    if (!isNaN(d.getTime())) {
                        this.documentDate = d.toISOString().slice(0, 10);
                    }
                }
                if (detail.num_document) {
                    this.documentReferencePrefetchGen++;
                    const numDoc = String(detail.num_document).trim();
                    this.documentReference = numDoc;
                    this.refExterne = numDoc;
                    this.numericReference = this.getNumericReferenceFromRefString(numDoc);
                    this.finishDocumentReferenceHeaderPrefetch();
                    if (this.logicielCaisseTransfertFromPvEcart) {
                        this.pvEcartLinkedTransfertRefDisplay = numDoc;
                        this.pvEcartLinkedTransfertRefPending = false;
                    }
                }
                const finishLcTransfertEditLoad = () => {
                    this.resetStockDisplayStateForLcTransfertEdit();
                    this.reconcileStockLcLineProductIdsFromCatalog();
                    this.calculateTotals();
                    this.updateHeaderConfig();
                    this.syncBarcodePickerModelForVisibleProductLines();
                    if (entrepotsFromPvEcart) {
                        if (this.lastLoadedPvEcartDoc) {
                            this.applyPvEcartEntrepotsFromPvDocument(this.lastLoadedPvEcartDoc);
                        } else {
                            this.loadTransfertEntrepotsFromPvEcartSource();
                        }
                    } else {
                        this.applyPendingLcTransfertWarehouseSelection();
                    }
                    this.enrichStockLcDocumentLinesAfterLoad();
                    this.scheduleLcTransfertEditStockRefresh(200);
                    this.cdr.detectChanges();
                };

                if (entrepotsFromPvEcart) {
                    const num = String(detail.num_document ?? '').trim();
                    const mergedDetail$ = num
                        ? this.lcStockTransfert
                              .getDetailForTransfertEntrepotModal(num, { id: lcId })
                              .pipe(catchError(() => of(detail as StockTransfertDetail)))
                        : of(detail as StockTransfertDetail);
                    mergedDetail$.pipe(take(1)).subscribe((mergedDetail) => {
                        this.applyPvEcartTransfertFullLinesFromLcDetail(mergedDetail);
                        const pvId = this.pvEcartSourceDocumentId;
                        if (pvId != null && pvId > 0) {
                            this.documentService
                                .getDocumentById(pvId)
                                .pipe(take(1))
                                .subscribe({
                                    next: (res) => {
                                        const pvDoc = (res?.data?.document ??
                                            res?.data ??
                                            res) as Record<string, unknown>;
                                        if (pvDoc) {
                                            this.lastLoadedPvEcartDoc = pvDoc;
                                        }
                                        this.refreshPvEcartLinkedTransfertHeaderReference(pvDoc);
                                        finishLcTransfertEditLoad();
                                    },
                                    error: () => {
                                        this.refreshPvEcartLinkedTransfertHeaderReference(null);
                                        finishLcTransfertEditLoad();
                                    },
                                });
                        } else {
                            this.refreshPvEcartLinkedTransfertHeaderReference(null);
                            finishLcTransfertEditLoad();
                        }
                    });
                    return;
                }

                this.applyLcTransfertDetailLinesToItems(detail);
                finishLcTransfertEditLoad();
            },
            error: () => {
                this.toastr.error('Impossible de charger le transfert pour modification.', 'Transfert');
            },
        });
    }

    /** Corps PUT LC : toutes les lignes affichées (breakdown envoyée / reçue / écart). */
    private buildLcBodyForPvEcartApproveReplace(
        dep: number,
        rec: number
    ): StockTransfertCreateBody | null {
        const rows: Array<{
            item: {
                type?: string;
                designation?: string;
                quantity?: number;
                code_barre?: string | null;
                reference?: string | null;
                product_id?: number | null;
                couleur?: string | null;
                taille?: string | null;
            };
            breakdown?: PvEcartQtyBreakdownRow | null;
        }> = [];
        (this.items || []).forEach((item, index) => {
            if (item.type !== 'product' || !String(item.designation ?? '').trim()) {
                return;
            }
            rows.push({
                item: {
                    type: item.type,
                    designation: item.designation,
                    quantity: item.quantity,
                    code_barre: item.code_barre ?? null,
                    reference: item.reference ?? null,
                    product_id: item.product_id ?? null,
                    couleur: (item as { couleur?: string | null }).couleur ?? null,
                    taille: (item as { taille?: string | null }).taille ?? null,
                },
                breakdown: this.pvEcartQtyBreakdownByItemIndex.get(index) ?? null,
            });
        });
        return buildLcPvEcartTransfertBodyFromUiFullBreakdown(dep, rec, rows, this.note);
    }

    /** PUT pv-ecart-transfert-approuve-disponible : delta écart (reçu − envoyé) par ligne. */
    private buildPvEcartApprouveDisponibleStockPayload(
        entrepotDepartLc: number,
        referenceDocument: string
    ): ReturnType<typeof buildPvEcartApprouveDisponiblePayloadFromEcartBreakdown> {
        const ecartLines: Array<{
            ecartSigned: number;
            product_id?: number | null;
            code_barre?: string | null;
            reference?: string | null;
            designation?: string | null;
            ref_fabricant?: string | null;
        }> = [];
        this.items.forEach((item, index) => {
            if (item.type !== 'product' || !String(item.designation ?? '').trim()) {
                return;
            }
            const row = this.pvEcartQtyBreakdownByItemIndex.get(index);
            if (!row || !Number.isFinite(row.ecartSigned)) {
                return;
            }
            const ecart = Math.trunc(row.ecartSigned);
            if (ecart === 0) {
                return;
            }
            ecartLines.push({
                ecartSigned: ecart,
                product_id: item.product_id ?? null,
                code_barre: item.code_barre ?? null,
                reference: item.reference ?? null,
                designation: item.designation ?? null,
                ref_fabricant:
                    (item as { ref_fabricant?: string | null }).ref_fabricant ?? null,
            });
        });
        return buildPvEcartApprouveDisponiblePayloadFromEcartBreakdown({
            entrepotDepartLc,
            referenceDocument,
            lines: ecartLines,
        });
    }

    /**
     * Gestion stock : création uniquement via API logiciel caisse
     * (même écran document que la facture, sans document ERP).
     */
    private createBonTransfertViaLogicielCaisseOnly(): void {
        const entrepotMapErr = this.validateErpEntrepotMappingForDocumentSave({});
        if (entrepotMapErr) {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.cdr.detectChanges();
            this.toastr.error(entrepotMapErr, 'Entrepôt', { timeOut: 12000 });
            return;
        }

        const dep = Number(this.selectedWarehouseInitialId);
        const rec = Number(this.selectedWarehouseDestinationId);
        if (!Number.isFinite(dep) || dep <= 0 || !Number.isFinite(rec) || rec <= 0) {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.toastr.error('Sélectionnez l’entrepôt de départ et de destination.', 'Transfert');
            return;
        }
        if (dep === rec) {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.toastr.error('Les entrepôts départ et destination doivent être différents.', 'Transfert');
            return;
        }

        const pvEcartApproveByEcartBreakdown =
            this.logicielCaisseTransfertFromPvEcart &&
            this.pvEcartQtyBreakdownByItemIndex.size > 0;

        if (!pvEcartApproveByEcartBreakdown && this.findProductLinesWithNegativeQuantity().length > 0) {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.toastr.error('Les quantités ne peuvent pas être négatives.', 'Transfert');
            return;
        }

        if (!pvEcartApproveByEcartBreakdown) {
            const overQty = this.findLogicielCaisseTransfertQuantityOverAvailable();
            if (overQty.length > 0) {
                this.setDocumentSubmitting(false);
                this.updateHeaderConfig();
                this.cdr.detectChanges();
                this.toastLogicielCaisseTransfertQuantityInsufficient(overQty);
                return;
            }
        }

        const lcBodyForPvApprove =
            pvEcartApproveByEcartBreakdown
                ? this.buildLcBodyForPvEcartApproveReplace(dep, rec)
                : null;
        const lcBody = lcBodyForPvApprove ?? this.buildLogicielCaisseTransfertSaveBody(false);
        if (!lcBody || lcBody.lignes.length === 0) {
            this.setDocumentSubmitting(false);
            this.updateHeaderConfig();
            this.toastr.error('Ajoutez au moins une ligne produit avec quantité.', 'Transfert');
            return;
        }

        const returnList = '/transfert-entrepot/tous';
        const existingLcId = this.logicielCaisseTransfertEditId;
        const linkedErpId = this.logicielCaisseTransfertFromPvEcart
            ? null
            : this.linkedErpBonTransfertDocumentId;

        if (!linkedErpId) {
            const dryPayload = this.buildCreatePayload() as Record<string, unknown>;
            this.applyLogicielCaisseEntrepotToPayload(dryPayload);
            const prepBeforeLc = this.prepareBonTransfertErpCreatePayload(dryPayload, 0);
            if (prepBeforeLc) {
                this.setDocumentSubmitting(false);
                this.updateHeaderConfig();
                this.cdr.detectChanges();
                this.toastr.error(prepBeforeLc, 'Transfert', { timeOut: 12000 });
                return;
            }
        }

        const lcSave$ = existingLcId
            ? this.lcStockTransfert.replace(existingLcId, lcBody).pipe(
                  map((res) => {
                      const t = res.transfert as { id?: number; num_document?: string } | undefined;
                      return {
                          id: existingLcId,
                          num_document: t?.num_document ?? this.documentReference,
                      };
                  })
              )
            : this.lcStockTransfert.create(lcBody);

        if (this.logicielCaisseTransfertFromPvEcart) {
            const lcIdForApprove = Number(existingLcId);
            if (!Number.isFinite(lcIdForApprove) || lcIdForApprove <= 0) {
                this.setDocumentSubmitting(false);
                this.updateHeaderConfig();
                this.toastr.error(
                    'Transfert entrepôt LC introuvable — rouvrez le transfert depuis le PV validé.',
                    'PV d\'écart'
                );
                return;
            }

            this.lcAuth
                .ensureAuthenticatedSession()
                .pipe(
                    take(1),
                    switchMap((ok) => {
                        if (!ok) {
                            return throwError(
                                () =>
                                    new Error(
                                        'Connectez le module logiciel caisse pour approuver le transfert.'
                                    )
                            );
                        }
                        return this.lcStockTransfert.getById(lcIdForApprove).pipe(
                            map((detail) => ({
                                id: lcIdForApprove,
                                num_document: String(
                                    detail?.num_document ?? this.documentReference ?? ''
                                ).trim(),
                            })),
                            catchError(() =>
                                of({
                                    id: lcIdForApprove,
                                    num_document: String(this.documentReference ?? '').trim(),
                                })
                            )
                        );
                    }),
                    switchMap((lcRes) => {
                        const refDoc = String(lcRes.num_document ?? '').trim();
                        if (!refDoc) {
                            return throwError(
                                () =>
                                    new Error(
                                        'Numéro du transfert logiciel caisse introuvable — correction stock impossible.'
                                    )
                            );
                        }
                        const stockPayload = this.buildPvEcartApprouveDisponibleStockPayload(
                            dep,
                            refDoc
                        );
                        if (!stockPayload) {
                            return throwError(
                                () =>
                                    new Error(
                                        'Écarts invalides — correction stock entrepôt initial impossible (vérifiez codes-barres / produits).'
                                    )
                            );
                        }
                        const detailLignes =
                            pvEcartApproveByEcartBreakdown && lcBody
                                ? flattenLcStockTransfertBodyToPvApproveDetailLignes(lcBody)
                                : [];
                        return this.lcStockReception
                            .pvEcartTransfertApprouveDisponible({
                                ...stockPayload,
                                transfert_id: lcIdForApprove,
                                ...(detailLignes.length
                                    ? { detail_lignes: detailLignes }
                                    : {}),
                            })
                            .pipe(map((stockRes) => ({ lcRes, stockRes })));
                    }),
                    switchMap(({ lcRes, stockRes }) =>
                        this.closeLinkedPvEcartOnTransfertApprove$().pipe(
                            map(() => ({ lcRes, stockRes }))
                        )
                    )
                )
                .subscribe({
                    next: ({ lcRes, stockRes }) => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        const num = lcRes.num_document ? ` ${lcRes.num_document}` : '';
                        if (stockRes.already_applied) {
                            this.toastr.info(
                                `Transfert${num} — stock disponible déjà corrigé.`,
                                'PV d\'écart'
                            );
                        } else if (stockRes.updated > 0) {
                            this.toastr.success(
                                `Transfert${num} approuvé — stock disponible corrigé (${stockRes.updated} ligne(s)).`,
                                'PV d\'écart',
                                { timeOut: 10000 }
                            );
                        } else {
                            this.toastr.warning(
                                `Transfert${num} — aucune ligne de stock modifiée.`,
                                'PV d\'écart'
                            );
                            return;
                        }
                        this.resetStockDisplayStateForLcTransfertEdit();
                        this.lcStockTransfert.notifyListRefresh();
                        this.stockQuantitiesCache.clear();
                        setTimeout(() => this.reloadStockQuantitiesForAllProducts(), 400);
                        this.navigateAfterPvEcartTransfertStockApprove(
                            Number(lcRes.id),
                            returnList
                        );
                    },
                    error: (err) => {
                        this.setDocumentSubmitting(false);
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(
                            this.extractDocumentApiErrorMessage(err) ||
                                (err instanceof Error ? err.message : 'Échec approbation transfert PV.'),
                            'PV d\'écart',
                            { timeOut: 12000 }
                        );
                    },
                });
            return;
        }

        lcSave$
            .pipe(
                switchMap((lcRes) => {
                    const statutCree = this.getApproveStatutId();
                    if (linkedErpId && statutCree != null) {
                        return this.documentService
                            .updateStatut(linkedErpId, {
                                statut_id: statutCree,
                                station_id: this.stationId,
                            })
                            .pipe(map((erpRes) => ({ lcRes, erpRes: { data: { id: linkedErpId }, raw: erpRes } })));
                    }
                    const payload = this.buildCreatePayload() as Record<string, unknown>;
                    const prepErr = this.prepareBonTransfertErpCreatePayload(payload, lcRes.id);
                    if (prepErr) {
                        return throwError(() => ({
                            userMessage: prepErr,
                            lcTransfertCreated: true,
                            lcTransfertId: lcRes.id,
                        }));
                    }
                    return this.documentService.create(payload as unknown as DocumentPayload).pipe(
                        map((erpRes) => ({ lcRes, erpRes }))
                    );
                })
            )
            .subscribe({
                next: ({ lcRes, erpRes }) => {
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    const erpId =
                        erpRes?.data?.id ||
                        erpRes?.data?.document?.id ||
                        erpRes?.id ||
                        erpRes?.document?.id;
                    if (!erpId) {
                        this.toastr.error('Bon de transfert ERP créé sans identifiant.', 'Transfert');
                        return;
                    }
                    this.toastr.success(
                        lcRes.num_document
                            ? `Transfert ${lcRes.num_document} approuvé (Créé).`
                            : 'Transfert approuvé (Créé).',
                        'Transfert'
                    );
                    this.resetStockDisplayStateForLcTransfertEdit();
                    this.lcStockTransfert.notifyListRefresh();
                    this.navigateToLcTransfertApproveVente(lcRes.id, Number(erpId), returnList);
                },
                error: (err: { userMessage?: string; lcTransfertCreated?: boolean; lcTransfertId?: number }) => {
                    this.setDocumentSubmitting(false);
                    this.updateHeaderConfig();
                    this.cdr.detectChanges();
                    const msg =
                        err?.userMessage ||
                        this.extractDocumentApiErrorMessage(err);
                    if (err?.lcTransfertCreated && err?.lcTransfertId) {
                        this.toastr.warning(
                            `Le transfert logiciel caisse (#${err.lcTransfertId}) a été enregistré, mais le bon de transfert ERP n'a pas pu être créé : ${msg}`,
                            'Transfert',
                            { timeOut: 12000 }
                        );
                        this.navigateToLcTransfertApproveVente(
                            err.lcTransfertId,
                            null,
                            '/transfert-entrepot/tous'
                        );
                        return;
                    }
                    this.toastr.error(msg, 'Transfert', { timeOut: 10000 });
                },
            });
    }

    /** PV d’écart lié → statut Clôturé après approbation / correction stock du transfert entrepôt. */
    private closeLinkedPvEcartOnTransfertApprove$(): Observable<void> {
        const pvId = this.pvEcartSourceDocumentId;
        const stationId = this.stationId;
        if (pvId == null || pvId <= 0 || stationId == null) {
            return of(undefined);
        }
        return this.resolvePvEcartWorkflowStatutId$('Clôturé').pipe(
            switchMap((clotureId) =>
                this.documentService.updateStatut(pvId, {
                    statut_id: clotureId,
                    station_id: stationId,
                })
            ),
            map(() => undefined)
        );
    }

    /** Après correction stock LC (PV → transfert entrepôt) : page approve-vente en consultation. */
    private navigateAfterPvEcartTransfertStockApprove(
        lcTransfertId: number,
        returnList: string
    ): void {
        const lcId = Number(lcTransfertId);
        if (!Number.isFinite(lcId) || lcId <= 0) {
            void this.router.navigate([returnList || '/transfert-entrepot/tous'], {
                replaceUrl: true,
            });
            return;
        }
        this.navigateToLcTransfertApproveVente(lcId, null, returnList, {
            pvEcartStockCorrected: true,
        });
    }

    /** Écran validation approve-vente (transfert LC), comme un ajout transfert entrepôt classique. */
    private navigateToLcTransfertApproveVente(
        lcTransfertId: number,
        erpBonTransfertId: number | null | undefined,
        returnList: string,
        options?: { pvEcartStockCorrected?: boolean }
    ): void {
        const lcId = Number(lcTransfertId);
        if (!Number.isFinite(lcId) || lcId <= 0) {
            return;
        }
        const erpId = Number(erpBonTransfertId);
        const queryParams: Record<string, string> = {
            source: 'lc',
            return: returnList || '/transfert-entrepot/tous',
        };
        if (options?.pvEcartStockCorrected) {
            queryParams.pv_ecart_stock_corrected = '1';
            queryParams.id = String(lcId);
        } else if (Number.isFinite(erpId) && erpId > 0) {
            queryParams.id = String(erpId);
            queryParams.lcTransfertId = String(lcId);
        } else {
            queryParams.id = String(lcId);
        }
        void this.router.navigate(['/stock/bon-transfert/action/validation'], {
            queryParams,
            replaceUrl: true,
        });
    }

    private readonly documentImportTvaLogPrefix = '[Document import XLSX · TVA]';

    private getDocumentProductImportOwnerUserId(): number {
        const raw = this.currentUser?.id ?? (this.currentUser as any)?.user_id;
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : 0;
    }

    private getDocumentProductImportStationId(): number {
        const fromComp = Number(this.stationId);
        if (Number.isFinite(fromComp) && fromComp > 0) {
            return fromComp;
        }
        const fromLs = Number(getStationIdFromLocalStorage());
        return Number.isFinite(fromLs) && fromLs > 0 ? fromLs : 0;
    }

    triggerDocumentProductImport(): void {
        const hasClient =
            (this.selectedClientId !== null && this.selectedClientId !== undefined) ||
            (this.selectedClient !== null && this.selectedClient !== undefined);
        const hasFournisseur =
            (this.selectedFournisseurId !== null && this.selectedFournisseurId !== undefined) ||
            (this.selectedFournisseur !== null && this.selectedFournisseur !== undefined);
        const isStockDocument = this.isStockLcDocumentType();
        if (!hasClient && !hasFournisseur && !isStockDocument) {
            this.modalRef = this.modalService.open(this.warningModal, {
                ariaLabelledBy: 'modal-warning-title',
                centered: true,
                size: 'sm',
                windowClass: 'warning-modal-centered'
            });
            return;
        }
        const el = this.documentProductImportInput?.nativeElement;
        if (el) {
            el.value = '';
            el.click();
        }
    }

    onDocumentProductImportFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }
        if (file.size > 1024 * 1024) {
            this.toastr.error('Fichier trop volumineux (max 1 Mo)', 'Import');
            input.value = '';
            return;
        }
        if (!file.name.toLowerCase().endsWith('.xlsx')) {
            this.toastr.error('Seuls les fichiers .xlsx sont autorisés', 'Import');
            input.value = '';
            return;
        }
        const ownerId = this.getDocumentProductImportOwnerUserId();
        const stId = this.getDocumentProductImportStationId();
        if (!ownerId || !stId) {
            this.toastr.error('Utilisateur ou station non valide.', 'Import');
            input.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            const buf = e.target?.result;
            if (!(buf instanceof ArrayBuffer)) {
                this.zone.run(() => this.toastr.error('Lecture du fichier impossible.', 'Import'));
                return;
            }
            this.zone.run(() => this.runDocumentProductImportFromArrayBuffer(buf));
        };
        reader.onerror = () => {
            this.zone.run(() => this.toastr.error('Erreur de lecture du fichier', 'Import'));
        };
        reader.readAsArrayBuffer(file);
        input.value = '';
    }

    private runDocumentProductImportFromArrayBuffer(arrayBuffer: ArrayBuffer): void {
        const parsed = parseProductXlsxImportSheet(arrayBuffer);
        if ('error' in parsed && (parsed as { error: string }).error) {
            this.toastr.error(String((parsed as { error: string }).error), 'Import XLSX');
            return;
        }
        const pr = parsed as { headerMap: Record<string, number>; dataRows: any[][]; missingLabels: string[] };
        if (pr.missingLabels?.length > 0) {
            this.toastr.error(
                'Colonnes obligatoires manquantes : ' +
                    pr.missingLabels.join(', ') +
                    '. (nom, type, prix unitaire, ref_interne)',
                'Import XLSX'
            );
            return;
        }
        const { headerMap, dataRows } = pr;
        if (!dataRows?.length) {
            this.toastr.warning('Aucune ligne de données dans le fichier.', 'Import XLSX');
            return;
        }

        const stationIdNum = this.getDocumentProductImportStationId();
        const clientIdNum = this.getDocumentProductImportOwnerUserId();
        if (!stationIdNum || !clientIdNum) {
            this.toastr.error('Utilisateur ou station non valide.', 'Import');
            return;
        }

        forkJoin({
            tvaListe: this.tvaService.getTvaList(stationIdNum).pipe(
                map((r) => r?.tvaListe || []),
                catchError(() => of([] as Tva[]))
            ),
            taxes: this.taxeService.getTaxeList(stationIdNum).pipe(
                map((r: any) => r?.taxes || []),
                catchError(() => of([] as Taxe[]))
            ),
            categories: this.categorieService.getCategoriePerStation(stationIdNum).pipe(
                catchError(() => of([] as Categorie[]))
            ),
            marques: this.marqueService.getMarquePerStation(stationIdNum).pipe(
                catchError(() => of([] as Marque[]))
            ),
            unites: this.uniteService.getUnitePerStation(stationIdNum).pipe(
                catchError(() => of([] as Unite[]))
            )
        }).subscribe({
            next: async (refs) => {
                const tvaCache = [...refs.tvaListe];
                const taxeCache = [...refs.taxes];
                const catCache = [...refs.categories];
                const marqueCache = [...refs.marques];
                const uniteCache = [...refs.unites];

                const lineErrors: string[] = [];
                let successCount = 0;

                for (let i = 0; i < dataRows.length; i++) {
                    const row = dataRows[i];
                    const lineNo = i + 2;
                    try {
                        const cellStr = (key: string): string | null => {
                            return readImportCellTrimmed(row, headerMap, key);
                        };
                        const cellNum = (key: string): number | null => {
                            const s = cellStr(key);
                            if (s == null || s === '') {
                                return null;
                            }
                            const n = parseFloat(s.replace(',', '.'));
                            return isNaN(n) ? null : n;
                        };

                        const nom =
                            headerMap.nom >= 0 && row[headerMap.nom] != null
                                ? String(row[headerMap.nom]).trim()
                                : '';
                        const type =
                            headerMap.type >= 0 && row[headerMap.type] != null
                                ? String(row[headerMap.type]).trim().toLowerCase()
                                : 'matériel';
                        const prix_unitaire =
                            headerMap.prix >= 0 && row[headerMap.prix] != null
                                ? parseFloat(String(row[headerMap.prix]).replace(',', '.'))
                                : 0;
                        const ref_interne =
                            headerMap.ref_interne >= 0 && row[headerMap.ref_interne] != null
                                ? String(row[headerMap.ref_interne]).trim()
                                : '';
                        const description =
                            headerMap.description >= 0 && row[headerMap.description] != null
                                ? String(row[headerMap.description]).trim()
                                : null;

                        if (!nom) {
                            lineErrors.push(`Ligne ${lineNo} : le nom est obligatoire`);
                            continue;
                        }

                        const codeBarreImport = cellStr('code_barre');
                        if (this.isBarcodeEmptyOrZeroForSelect({ code_barre: codeBarreImport ?? '' })) {
                            continue;
                        }

                        const resultTtc = cellNum('result_ttc');
                        const resultHt = cellNum('result_ht');

                        const product: Record<string, any> = {
                            type,
                            nom,
                            station_id: stationIdNum,
                            client_id: clientIdNum,
                            ...(prix_unitaire > 0 && { prix_unitaires: prix_unitaire }),
                            ...(ref_interne && { ref_interne: ref_interne }),
                            ...(cellStr('ref_fabricant') && { ref_fabricant: cellStr('ref_fabricant') }),
                            ...(description && { description }),
                            ...(cellStr('code_barre') && { code_barre: cellStr('code_barre') }),
                            ...(cellStr('couleur') && { couleur: cellStr('couleur') }),
                            ...(cellStr('taille') && { taille: cellStr('taille') }),
                            ...(cellStr('rayon') && { rayon: cellStr('rayon') }),
                            ...(cellStr('famille') && { famille: cellStr('famille') }),
                            ...(cellStr('sous_famille') && { sous_famille: cellStr('sous_famille') }),
                            ...(resultTtc != null && { result_ttc: resultTtc }),
                            ...(resultHt != null && { result_ht: resultHt })
                        };

                        const tvaCell = readImportCellTrimmed(row, headerMap, 'tva');
                        if (tvaCell != null && tvaCell !== '') {
                            const idTva = await this.rxFirst(
                                this.resolveDocImportedProductTvaId(
                                    tvaCell,
                                    tvaCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                            const idNum = Number(idTva);
                            if (!Number.isFinite(idNum) || idNum <= 0) {
                                throw new Error(
                                    `TVA non résolue pour « ${tvaCell} » (vérifiez la valeur et l’API by-valeur).`
                                );
                            }
                            product.tva_id = idNum;
                        }

                        if (cellStr('taxe')) {
                            product.taxe_id = await this.rxFirst(
                                this.resolveOrCreateDocTaxeId(
                                    cellStr('taxe')!,
                                    taxeCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('categorie')) {
                            product.categories_id = await this.rxFirst(
                                this.resolveOrCreateDocCategorieId(
                                    cellStr('categorie')!,
                                    catCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('marque')) {
                            product.marque_id = await this.rxFirst(
                                this.resolveOrCreateDocMarqueId(
                                    cellStr('marque')!,
                                    marqueCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('unite')) {
                            product.unite_id = await this.rxFirst(
                                this.resolveOrCreateDocUniteId(
                                    cellStr('unite')!,
                                    uniteCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }

                        for (let p = 1; p <= 12; p++) {
                            const pk = `param${p}`;
                            const pv = cellStr(pk);
                            if (pv) {
                                product[pk] = pv;
                            }
                        }

                        applyDocumentImportProductApiShape(product, clientIdNum, stationIdNum);

                        let catalog = this.findCatalogProductForDocImport(product);
                        if (!catalog) {
                            const body = this.stripDocProductImportMeta(product);
                            const addRes = await this.rxFirst(
                                this.productsService.addProduct(stationIdNum, body).pipe(
                                    catchError((err) => {
                                        throw new Error(this.extractDocImportErrorMessage(err));
                                    })
                                )
                            );
                            const newId = this.extractProductIdFromAddResponse(addRes);
                            if (newId == null) {
                                throw new Error('Création produit : id non reçu.');
                            }
                            const detailRes: any = await this.rxFirst(
                                this.productsService.getDetailsProduct(newId).pipe(
                                    catchError(() => of(null))
                                )
                            );
                            const rawPd = detailRes?.data ?? detailRes;
                            if (!rawPd || typeof rawPd !== 'object') {
                                throw new Error('Impossible de recharger le produit créé.');
                            }
                            catalog = this.mapLoadedApiProductToProduct(rawPd);
                            this.products.unshift(catalog);
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                        }

                        const qRaw = readImportCellTrimmed(row, headerMap, 'quantite');
                        let qty = 1;
                        if (qRaw != null && qRaw !== '') {
                            const n = parseFloat(String(qRaw).replace(',', '.'));
                            if (Number.isFinite(n) && n > 0) {
                                qty = n;
                            }
                        }

                        this.items.push(this.createEmptyProductLineItem());
                        const idx = this.items.length - 1;
                        this.applyProductSelectionToLine(idx, catalog, qty);
                        successCount++;
                    } catch (rowErr: any) {
                        lineErrors.push(`Ligne ${lineNo} : ${rowErr?.message || String(rowErr)}`);
                    }
                }

                this.syncBarcodePickerModelForVisibleProductLines();
                this.calculateTotals();
                this.updateTvaSummary();
                this.reloadStockQuantitiesForAllProducts();
                this.updateApproveButtonState();
                this.applyVenteAchatProductDescriptionDefaults();
                this.cdr.detectChanges();
                this.refreshFeatherIcons();

                if (successCount === 0) {
                    const msg =
                        lineErrors.length > 5
                            ? lineErrors.slice(0, 5).join(' ; ') + ` … (+${lineErrors.length - 5})`
                            : lineErrors.join(' ; ');
                    this.toastr.error(msg || 'Aucune ligne importée.', 'Import XLSX');
                } else if (lineErrors.length > 0) {
                    this.toastr.warning(
                        `${successCount} ligne(s) ajoutée(s). ${lineErrors.length} erreur(s).`,
                        'Import XLSX',
                        { timeOut: 10000 }
                    );
                } else {
                    this.toastr.success(
                        `${successCount} ligne(s) produit ajoutée(s) depuis le fichier.`,
                        'Import XLSX'
                    );
                }
            },
            error: () => {
                this.toastr.error(
                    'Impossible de charger les référentiels (TVA, taxes, catégories, marques, unités).',
                    'Import XLSX'
                );
            }
        });
    }

    private rxFirst<T>(source: Observable<T>): Promise<T> {
        return source.pipe(take(1)).toPromise() as Promise<T>;
    }

    private stripDocProductImportMeta(p: Record<string, any>): Record<string, any> {
        const { __importLine, ...rest } = p;
        return rest;
    }

    private extractDocImportErrorMessage(err: any): string {
        if (err?.error?.errors && Array.isArray(err.error.errors)) {
            return err.error.errors.map((e: any) => e.message || e).join(', ');
        }
        if (err?.error?.message) {
            return String(err.error.message);
        }
        return err?.message ? String(err.message) : 'Erreur API produit';
    }

    /** Message lisible pour toasts (POST/PATCH /api/documents, etc.). */
    private extractDocumentApiErrorMessage(err: unknown): string {
        const e = err as {
            error?: { message?: string; error?: string; errors?: Array<{ message?: string } | string> };
            message?: string;
        };
        if (e?.error?.errors && Array.isArray(e.error.errors)) {
            const joined = e.error.errors
                .map((item) => (typeof item === 'string' ? item : item?.message || ''))
                .filter(Boolean)
                .join(', ');
            if (joined) {
                return joined;
            }
        }
        if (e?.error?.message) {
            return String(e.error.message);
        }
        if (e?.error?.error) {
            return String(e.error.error);
        }
        const raw = e?.message ? String(e.message) : '';
        if (raw && !raw.includes('Http failure response')) {
            return raw;
        }
        return 'Erreur lors de la communication avec le serveur.';
    }

    /**
     * Payload POST ERP pour bon de transfert lié au transfert LC (entrepôts ERP + IDs LC cachés).
     * @returns message d’erreur utilisateur ou null si le payload est prêt.
     */
    private prepareBonTransfertErpCreatePayload(
        payload: Record<string, unknown>,
        lcTransfertId: number
    ): string | null {
        if (!payload.parametrage_doc) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }
        this.applyLogicielCaisseEntrepotToPayload(payload);

        const typeBt = this.typeDocumentIdMap['BON TRANSFERT'];
        if (typeBt == null || !Number.isFinite(Number(typeBt))) {
            return 'Type de document « Bon de transfert » introuvable.';
        }
        payload.type_document_id = typeBt;

        const statutCree = this.getApproveStatutId();
        if (statutCree == null || !Number.isFinite(Number(statutCree)) || Number(statutCree) <= 0) {
            return 'Statut « Créé » introuvable. Rechargez la page ou vérifiez la configuration des statuts.';
        }
        payload.statut_id = statutCree;

        const entrepotMapErr = this.validateErpEntrepotMappingForDocumentSave(payload);
        if (entrepotMapErr) {
            return entrepotMapErr;
        }

        const dest = payload.entrepot_dest_id;
        if (dest == null || !Number.isFinite(Number(dest)) || Number(dest) <= 0) {
            return (
                "L'entrepôt de destination n'est pas rattaché à un entrepôt ERP. " +
                'Vérifiez le lien établissement / entrepôt dans le logiciel caisse.'
            );
        }
        const srcErp = Number(payload.entrepot_id);
        const destErp = Number(dest);
        if (!this.isKnownErpEntrepotId(srcErp)) {
            return (
                `L'entrepôt de départ (id ${srcErp}) n'existe pas dans les entrepôts ERP. ` +
                'Choisissez un entrepôt stock ERP (Paramètres : création ERP + caisse).'
            );
        }
        if (!this.isKnownErpEntrepotId(destErp)) {
            return (
                `L'entrepôt de destination (id ${destErp}) n'existe pas dans les entrepôts ERP. ` +
                'Choisissez un entrepôt stock ERP (Paramètres : création ERP + caisse).'
            );
        }

        const lignes = payload.lignes_document;
        if (!Array.isArray(lignes) || lignes.length === 0) {
            return 'Ajoutez au moins une ligne produit avec quantité.';
        }

        let hidden =
            payload.hidden_client_fields && typeof payload.hidden_client_fields === 'object'
                ? { ...(payload.hidden_client_fields as Record<string, unknown>) }
                : {};
        hidden.logiciel_caisse_transfert_id = lcTransfertId;
        hidden.stock_transfert_id = lcTransfertId;
        if (this.pvEcartSourceDocumentId != null && this.pvEcartSourceDocumentId > 0) {
            payload.document_original_id = this.pvEcartSourceDocumentId;
            payload.type_initial = STOCK_TRANSFER_WORKFLOW_TYPE_IDS.PV_ECART;
            hidden.pv_ecart_document_id = this.pvEcartSourceDocumentId;
        }
        payload.hidden_client_fields = hidden;

        return null;
    }

    private extractProductIdFromAddResponse(res: any): number | null {
        const raw = res?.data?.id ?? res?.data?.product?.id ?? res?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    private mapLoadedApiProductToProduct(apiProduct: any): Product {
        const prixUnitairesBrut = apiProduct.prix_unitaires;
        const valeurUnitaireBrut = apiProduct.valeur_unitaire;
        const prixUnitairesParse = parseFloat(prixUnitairesBrut) || 0;
        const valeurUnitaireParse = parseFloat(valeurUnitaireBrut) || 0;
        return {
            ...apiProduct,
            prix_unitaires: prixUnitairesParse,
            valeur_unitaire: valeurUnitaireParse,
            liste_prix: apiProduct.liste_prix?.length > 0 ? apiProduct.liste_prix[0] : null,
            informations_logistique: apiProduct.informations_logistique || []
        } as Product;
    }

    private findCatalogProductForDocImport(payload: Record<string, any>): Product | undefined {
        const ref = payload.ref_interne != null ? String(payload.ref_interne).trim() : '';
        const cbRaw = payload.code_barre != null ? String(payload.code_barre).trim() : '';
        const cb = cbRaw.replace(/\s/g, '');
        if (ref) {
            const byRef = this.products.find(
                (p) => p.ref_interne != null && String(p.ref_interne).trim() === ref
            );
            if (byRef) {
                return byRef;
            }
        }
        if (cb && cb !== '0') {
            const byCb = this.products.find((p) => {
                const c = p.code_barre != null ? String(p.code_barre).replace(/\s/g, '').trim() : '';
                return c === cb;
            });
            if (byCb) {
                return byCb;
            }
        }
        return undefined;
    }

    private docImportLabelEquals(a: string, b: string): boolean {
        return normalizeImportHeaderLabel(a) === normalizeImportHeaderLabel(b);
    }

    private tvaListeEntryMatchesCellDoc(t: Tva, parsedFile: number | null, rawTrimmed: string): boolean {
        const apiNum = Number(t.valeur);
        if (parsedFile !== null && !isNaN(apiNum)) {
            return Math.abs(apiNum - parsedFile) < 1e-4;
        }
        const norm = (v: unknown) =>
            String(v ?? '')
                .trim()
                .replace(/%/g, '')
                .replace(/\s/g, '')
                .replace(',', '.');
        return norm(t.valeur) === norm(rawTrimmed);
    }

    private extractTvaIdFromByValeurResponseDoc(res: any): number | null {
        if (res == null || typeof res === 'string') {
            return null;
        }

        const toId = (v: unknown): number | null => {
            if (v == null || v === '') {
                return null;
            }
            const n = Number(v);
            return Number.isFinite(n) && n > 0 ? n : null;
        };

        const envelope =
            res?.data != null && typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : res;
        if (envelope?.success === true && Array.isArray(envelope.tvaListe) && envelope.tvaListe.length > 0) {
            const first = envelope.tvaListe[0];
            const rid = toId(first?.id);
            if (rid != null) {
                return rid;
            }
        }

        const fromObj = (o: any): number | null => {
            if (!o || typeof o !== 'object') {
                return null;
            }
            return toId(o.id) ?? toId(o.tva_id) ?? toId((o as any).ID) ?? null;
        };

        let id = fromObj(res);
        if (id != null) {
            return id;
        }

        id =
            fromObj(res.tva) ??
            fromObj(res.data) ??
            fromObj(res.result) ??
            fromObj(res.payload) ??
            fromObj(res.record);
        if (id != null) {
            return id;
        }

        if (typeof res.tva_id === 'number' || (typeof res.tva_id === 'string' && res.tva_id !== '')) {
            return toId(res.tva_id);
        }

        if (Array.isArray(res)) {
            id = fromObj(res[0]);
            if (id != null) {
                return id;
            }
        }

        const liste = res.tvaListe ?? res.tvas ?? res.data?.tvaListe;
        if (Array.isArray(liste) && liste.length > 0) {
            id = fromObj(liste[0]);
            if (id != null) {
                return id;
            }
        }

        if (res.id != null && (res.valeur !== undefined || res.type !== undefined || res.statut !== undefined)) {
            return toId(res.id);
        }

        const attrId = res?.data?.attributes?.id ?? res?.data?.id ?? res?.attributes?.id;
        if (attrId != null) {
            return toId(attrId);
        }

        return null;
    }

    private getTvaIdFromByValeurApiDoc(stationId: number, valeurNumeric: number): Observable<number | null> {
        return this.tvaService.getTvaByValeur(stationId, valeurNumeric).pipe(
            map((res) => this.extractTvaIdFromByValeurResponseDoc(res)),
            catchError(() => of(null as number | null))
        );
    }

    private resolveDocImportedProductTvaId(
        raw: string,
        cache: Tva[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const trimmed = raw.trim();
        const parsedFile = parseTvaImportValue(trimmed);

        const lookupFromByValeur$ =
            parsedFile !== null
                ? this.getTvaIdFromByValeurApiDoc(stationId, parsedFile)
                : of(null as number | null);

        return lookupFromByValeur$.pipe(
            switchMap((idFromApi) => {
                const idNum = idFromApi != null ? Number(idFromApi) : NaN;
                if (Number.isFinite(idNum) && idNum > 0) {
                    return of(idNum);
                }
                const byListe = cache.find((t) =>
                    this.tvaListeEntryMatchesCellDoc(t, parsedFile, trimmed)
                );
                if (byListe?.id != null) {
                    return of(Number(byListe.id));
                }
                const valeur = parsedFile !== null ? parsedFile : 0;
                const body: Tva = {
                    client_id: clientId,
                    station_id: stationId,
                    valeur,
                    type: '+',
                    restriction: 'Pourcentage',
                    statut: true
                };
                return this.tvaService.createTva(body, stationId).pipe(
                    map((res) => {
                        const t = res?.tva;
                        if (t?.id != null) {
                            cache.push(t);
                            return Number(t.id);
                        }
                        throw new Error('Réponse TVA invalide');
                    })
                );
            })
        );
    }

    private resolveOrCreateDocTaxeId(
        raw: string,
        cache: Taxe[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const t = raw.trim();
        const found = cache.find(
            (x) =>
                (x.nom && this.docImportLabelEquals(x.nom, t)) ||
                (x.label && this.docImportLabelEquals(x.label, t))
        );
        if (found?.id) {
            return of(found.id);
        }
        const newTaxe: Taxe = {
            id: 0,
            client_id: clientId,
            station_id: stationId,
            nom: t,
            label: t,
            valeur: 0,
            valeur_fixe: false,
            valeur_pourcentage: true,
            applique_avant_tva: false,
            applique_apres_tva: true,
            taxe_applique_sur_produits: true,
            type: '+',
            applique_sur_product: true,
            applique_sur_tous_document: false,
            statut: true
        };
        return this.taxeService.createTaxe(newTaxe, stationId).pipe(
            map((res) => {
                const tx = res?.taxe;
                if (tx?.id) {
                    cache.push(tx);
                    return tx.id;
                }
                throw new Error('Réponse taxe invalide');
            })
        );
    }

    private resolveOrCreateDocCategorieId(
        raw: string,
        cache: Categorie[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((c) => c.libelle && this.docImportLabelEquals(c.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const cat: Categorie = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.categorieService.addCategorie(cat).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateDocMarqueId(
        raw: string,
        cache: Marque[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((m) => m.libelle && this.docImportLabelEquals(m.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const marque: Marque = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.marqueService.addMarque(marque).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateDocUniteId(
        raw: string,
        cache: Unite[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((u) => u.libelle && this.docImportLabelEquals(u.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const unite: Unite = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.uniteService.addUnite(unite).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    openEmailModal(): void {
        if (this.emailComposeComponent) {
            this.emailComposeComponent.openModal();
        }
    }

    getFormattedTotal(): string {
        const total = this.totals.netAPayer || this.totals.totalTTC || 0;
        return `${total.toFixed(3)} TND`;
    }
}
